{
  "accessibility": {
    "contact_avatar": "Contact avatar",
    "contact_support_information": "Contact support information",
    "current_profile_picture": "Current profile picture",
    "entity_logo": "{name} logo",
    "help_center_contact_information": "Help center contact information",
    "image_preview": "Image preview",
    "instagram_post_image": "Instagram post image",
    "origin": "Origin:",
    "profile_picture_for": "{name} profile picture",
    "remove_uploaded_image": "Remove uploaded image",
    "selected_image_preview": "Selected image preview",
    "selected_profile_picture_preview": "Selected profile picture preview",
    "selected_thumbnail_preview": "Selected thumbnail preview",
    "thumbnail_option": "Thumbnail option {index}",
    "uploaded_image_preview": "Uploaded image preview"
  },
  "account_form": {
    "email": "Email",
    "first_name": "First Name",
    "last_name": "Last Name",
    "mobile_number": "Mobile Number",
    "team": "Team"
  },
  "account_form_page": {
    "error_update_alert": "Error updating Account details",
    "update_alert": "Account details updated!"
  },
  "account_tabs": {
    "preferences_tab": "Preferences",
    "security_tab": "Security"
  },
  "account_type_radio_selector": {
    "accounts": "Accounts",
    "all_accounts": "All Accounts",
    "verified_accounts": "Verified Accounts"
  },
  "actionsheet": {
    "action_sheet_title": "Action",
    "confirm_mention_exclusion": "The item will be excluded from your {streamLabel}",
    "curated_email_report": "Curated Email Report",
    "download_pdf": "Download PDF",
    "edit_external_item": "Edit External Item",
    "edit_in_crm": "Edit in Admin CRM",
    "email_or_share": "Email or Share",
    "errors": {
      "duplicate_media_item": "There was an error checking for duplicate Media Items",
      "duplicate_transcript_request": "There was an error checking for duplicate Transcript Requests",
      "revert_to_original_clip": "There was an error reverting to the original clip"
    },
    "flag_for_review": "Flag Mention for Review",
    "instant_edit_media_item": "Instant-edit Media Item",
    "instant_edit_transcript": "Instant-edit Transcript",
    "open_mention_detail_modal": "Open Mention Detail modal",
    "push_to_team": "Push to Team",
    "remove_excluded_mention": "Remove Excluded Mention",
    "remove_from": "Remove from {streamLabel}",
    "remove_from_folder": "Remove from Folder",
    "replace_archived_clip": "Replace archived clip",
    "request_media_item": "Request Media Item",
    "request_transcript": "Request Transcript",
    "revert_to_original_clip": "Revert to the original clip",
    "revert_to_original_clip_modal": {
      "expired_content": "This content has expired. By removing the archived clip you will lose access to the original content.{newline}<strong>Are you sure?</strong>",
      "valid_content": "TVEyes content will expire within 28 days of publication. By removing the archived clip you may lose access to the original content after it expires.{newline}<strong>Are you sure?</strong>"
    },
    "see_full_text": "See Full Text",
    "share": "Share",
    "share_mention": {
      "article": "{keywords} mentioned online ({source_name}) on the {date} around {time}",
      "blog_post": "{keywords} mentioned on a blog post on the {date} around {time}",
      "bluesky_post": "{keywords} mentioned on a bluesky post on the {date} around {time}",
      "exorde_reddit_post": "{keywords} mentioned on an Exorde Reddit post on the {date} around {time}",
      "exorde_reddit_post_comment": "{keywords} mentioned on an Exorde Reddit comment on the {date} around {time}",
      "facebook_post": "{keywords} mentioned on a Facebook post on the {date} around {time}",
      "forum_post": "{keywords} mentioned on a forum post on the {date} around {time}",
      "instagram_comment": "{keywords} mentioned on an Instagram comment on the {date} around {time}",
      "instagram_post": "{keywords} mentioned on an Instagram post on the {date} around {time}",
      "linkedin_comment": "{keywords} mentioned on a LinkedIn comment on the {date} around {time}",
      "linkedin_post": "{keywords} mentioned on a LinkedIn post on the {date} around {time}",
      "magazine_article": "{keywords} mentioned in print ({source_name}) on the {date} around {time}",
      "paper_article": "{keywords} mentioned in print ({source_name}) on the {date} around {time}",
      "podcast_episode": "{keywords} mentioned on a podcast episode on the {date} around {time}",
      "radio_clip": "{keywords} mentioned on a radio station {source_name} ({source_location}) on the {date} around {time}",
      "reddit_post": "{keywords} mentioned on a Reddit post on the {date} around {time}",
      "reddit_post_comment": "{keywords} mentioned on a Reddit comment on the {date} around {time}",
      "tiktok_comment": "{keywords} mentioned on a TikTok comment on the {date} around {time}",
      "tiktok_video": "{keywords} mentioned on a TikTok video on the {date} around {time}",
      "tv_caption": "{keywords} mentioned on TV channel {source_name} ({source_location}) on the {date} around {time}",
      "tv_logo_appearance": "{keywords} mentioned on TV channel {source_name} ({source_location}) on the {date} around {time}",
      "tv_super": "{keywords} mentioned on TV channel {source_name} ({source_location}) on the {date} around {time}",
      "tweet": "{keywords} mentioned on a tweet on the {date} around {time}",
      "youtube_video": "{keywords} mentioned on a YouTube video on the {date} around {time}"
    },
    "share_mention_archived_content": {
      "radio_clip": "Mention archived from radio station {source_name} ({source_location}) on the {date} around {time}",
      "tv_caption": "Mention archived from TV channel {source_name} ({source_location}) on the {date} around {time}"
    },
    "show_debug_info": "Show debug info",
    "show_menu": "Show menu",
    "show_menu_for": "Show menu for {item}",
    "similar_mentions": "Similar Mentions",
    "success": {
      "revert_to_original_clip": "Clip reverted successfully!"
    },
    "tag": "Tag",
    "tag_media_item": "Tag Media Item",
    "tag_social_item": "Tag Social Item",
    "tooltips": {
      "exclude_mention": "If the item is incorrect or irrelevant this will prevent it from appearing in this {streamLabel} or any report built from it. {newline} This can be reviewed and undone via the general tab in Edit {streamLabel} {editIcon}."
    },
    "translate_to_english": "Translate to English",
    "unable_to_share": "Unable to share",
    "view_archived_media_item": "View Media Item",
    "view_article_pdf": "View Article PDF",
    "view_full_article": "View Full Article",
    "view_full_media_item": "View Full Media Item",
    "view_similar_mentions": "View Similar Mentions"
  },
  "advertising_value_widget": {
    "advertising_value_equivalency": "Advertising Value Equivalency = {ave}",
    "label": "Advertising Value Equivalency",
    "short_label": "AVE",
    "tooltip_info": "A data multiplier of {value}x was added to {multiplier} by {lastUpdatedBy}."
  },
  "ai_assistant": {
    "content_analysis_message": "Here is your coverage",
    "error_has_occurred": "Sorry! We didn’t get that response right. Would you mind trying again?",
    "just_a_moment": "Just a moment...",
    "rate_limit_reached": "Rate limit reached for today. Please try again tomorrow!",
    "upgrade_contact_details": "Contact your {accountManager} for more information."
  },
  "ai_assistant_chat_input_options": {
    "custom_date_range": "Click here for custom date range",
    "date_range_options": "Date range options",
    "focus_area": "Click here for custom focus area",
    "media_types": "All media types | 1 media type selected | {count} media types selected",
    "no_results_found": "No results found",
    "search_sources_placeholder": "Search for source",
    "search_streams_placeholder": "Search your Mention Stream",
    "sources_filter_failed": "Failed to filter source",
    "stream_not_found": "Mention Stream not found"
  },
  "ai_assistant_panel": {
    "aria_label": "AI Assistant",
    "ask_me_anything": "Ask me anything",
    "footer_text": "{aiAssistant} is here to assist, but can make mistakes. Please review all responses before use.",
    "hello_message": "Hello {name}! How can I help you today?",
    "help_message": "Hi, I am your {platformName} Assistant! Get started by choosing one of the prompts below.",
    "help_tooltip": "Help",
    "hide_suggestions": "Hide suggestions",
    "history_tooltip": "History",
    "just_a_moment": "Just a moment…",
    "load_streams_limit_reached_error": "Error loading Streams Limit",
    "menu_label": "{aiAssistant} menu",
    "monitoring": "Monitoring",
    "more_suggestions": "More suggestions",
    "options": {
      "adjust_media_outreach": "Adjust my Media Outreach",
      "adjust_social_post": "Adjust my Social Post",
      "analyse_my_content": "Analyse my Coverage",
      "create_boolean_query": "Create a Boolean Query",
      "create_mention_streams": "Create Mention Streams",
      "how_should_i_choose": "How should I choose contacts for my Media Outreach?",
      "suggested_contacts": "Suggest Journalists and Outlets",
      "summarise_mention_stream": "Summarise my Mention Stream",
      "when_should_i_post": "When should I post my Social Content?",
      "when_should_i_send": "When should I send my Media Outreach?",
      "write_media_outreach": "Write my Media Outreach",
      "write_social_post": "Write my Social Post"
    },
    "outreach": "Outreach",
    "prompt_tips": {
      "option": "Tip: Edit placeholder by clicking the chip to search for existing Mention Stream.",
      "source": "Tip: Type {'@'} to begin search for existing Source.",
      "stream": "Tip: Type # to begin search for existing Mention Stream."
    },
    "quick_access": "Quick Access:",
    "social": "Social",
    "user_context": "Focus Profile",
    "user_context_alert_message": "<strong>Profile Saved</strong> - {aiAssistant} will tailor responses to your Focus Profile.",
    "user_context_alert_message_removed": "<strong>Profile Removed</strong> - {aiAssistant} will not tailor responses to your Focus Profile."
  },
  "ai_base_panel": {
    "focus_profile_tooltip": "Focus Profile Applied",
    "home": "Home",
    "maximise": "Maximise",
    "minimise": "Minimise",
    "move_left": "Move to left",
    "move_right": "Move to right"
  },
  "ai_boolean_creator_chat_history": {
    "delete_dialog": {
      "message": "By clicking the Confirm button, this chat will be removed from the chat history and will not be able to be restored.",
      "title": "Delete Chat"
    },
    "fail_to_delete": "Fail to delete chat.",
    "fail_to_load_chat_history": "Fail to fetch chat history.",
    "fail_to_load_history": "Fail to load history list for user.",
    "fail_to_parse_chat_history": "Fail to parse chat history.",
    "invalid_message_format": "Invalid message format",
    "later": "Later",
    "mention_stream_title": "Summary for the Mention Stream {title}",
    "newer": "Newer",
    "relative_date": {
      "older": "Older",
      "one_day_ago": "1 day ago",
      "past_month": "Past 30 days",
      "past_week": "Past week",
      "today": "Today",
      "two_days_ago": "2 days ago"
    },
    "title": "History",
    "unknown_prompt": "Unknown prompt"
  },
  "ai_boolean_creator_options": {
    "boolean_mention_stream_creator": "Boolean Mention Stream Creator",
    "title": "AI Assistant"
  },
  "ai_boolean_creator_panel": {
    "error_setting_refinement": "There was an error setting the refinement option",
    "suggestions": {
      "ask_anything": "Ask Me Anything",
      "ask_anything_tooltip": "Select Ask me Anything for a brief description of what the Boolean Creator can do.",
      "brand_focus": "Create a Brand-Focused Boolean Query",
      "brand_focus_tooltip": "Create a boolean query to track mentions of your brand, including, products, subsidiaries, competitors or key spokespeople that are worth monitoring.",
      "fix": "Fix My Boolean Query",
      "fix_tooltip": "Review and adjust your boolean query to correct syntax errors and operator usage.",
      "industry": "Create an Industry Focused Boolean Query",
      "industry_tooltip": "Create a boolean query to monitor mentions of industry terms including topics, issues, keywords or phrases related to the industry.",
      "key_person": "Write me a Key Person Focused Boolean Query",
      "key_person_tooltip": "Help",
      "media_outreach": "Create a Boolean Query from Media Outreach",
      "media_outreach_tooltip": "Provide Media Outreach text, such as Pitches or Media Releases, to generate a boolean query tailored to its content.",
      "organisation": "Write me an Organisation Focused Boolean Query",
      "organisation_tooltip": "Help",
      "teach_me": "Teach Me About Boolean Operators",
      "teach_me_tooltip": "Learn about different Boolean Operators and how to use them.",
      "topic": "Write me a Topic Focused Boolean Query",
      "topic_tooltip": "Help"
    },
    "toolbar_center_text": "Boolean Creator"
  },
  "ai_chat_history_message": {
    "boolean_query_aria_label": "AI-generated boolean query"
  },
  "ai_content_analysis_panel": {
    "option_prompt": "Certainly! I'd be happy to help you with analysing your coverage. Select one of the options below or type in a prompt in the chat to get started.",
    "suggestions": {
      "coverage_spike": "When did [focus area] coverage spike over the [last X days], and why?",
      "general_overview": "Give me a general overview of [focus area] in the [last X days]",
      "highest_potential_audience_reach": "Review potential audience reach for [focus area] in the [last X days]",
      "sentiment": "How is sentiment performing for [focus area] in [last X days]?",
      "top_content": "Analyse coverage volume for [focus area] in the [last X days]"
    },
    "title": "Analyse my Coverage",
    "upgrade_button": "Get in touch",
    "upgrade_description": "Get a comprehensive coverage analysis featuring an overview, top media content, performance insights, spike analysis and more for your selected coverage.",
    "upgrade_title": "Upgrade to unlock more features"
  },
  "ai_content_analysis_pr_suggestions": {
    "social": "Combine your traditional and social media monitoring in one platform with {platformName} Social and {platformName} Social Engage. You can track the landscape with the Listen tool before taking direct action through Engage, where you can manage your owned social accounts to post content and report on your results."
  },
  "ai_content_analysis_progress": {
    "agents": {
      "content_analysis_agent": "Planning Analysis",
      "content_analysis_chart_selector_agent": "Selecting Chart",
      "content_analysis_comms_agent": "Drafting Communications",
      "content_analysis_coverage_area_analyser_agent": "Analysing Focus Area",
      "content_analysis_coverage_volume_metrics_agent": "Calculating Coverage Volume",
      "content_analysis_filter_analyser_agent": "Analysing Filters",
      "content_analysis_follow_up_agent": "Preparing Follow-up Questions",
      "content_analysis_general_overview_metrics_agent": "Retrieving Metric Overview",
      "content_analysis_mention_spike_agent": "Detecting Mention Spikes",
      "content_analysis_mention_stream_builder_agent": "Building Mention Stream",
      "content_analysis_mentions_agent": "Retrieving & Analysing Mentions",
      "content_analysis_potential_audience_reach_agent": "Calculating Potential Audience Reach",
      "content_analysis_sentiment_metrics_agent": "Analysing Sentiment",
      "content_analysis_suggestions_agent": "Generating Suggestions",
      "content_analysis_summarisation_agent": "Summarising Coverage"
    },
    "show_thinking": "Show thinking",
    "title": "Generating your coverage analysis"
  },
  "ai_content_analysis_response": {
    "analysis": "Analysis",
    "chart": "Chart",
    "follow_up_questions": "Follow-up Questions",
    "mention_stream_view": "Mention Stream View",
    "pr_suggestions": "PR Suggestions",
    "summary": "Summary"
  },
  "ai_content_analysis_sentiment": {
    "view_included_articles": "View included articles"
  },
  "ai_feedback": {
    "error_submitting_feedback": "There was an error submitting feedback",
    "feedback_submitted": "Feedback submitted",
    "regenerate": "Regenerate",
    "remove_submitted_feedback": "Remove submitted feedback",
    "tool_tip_helpful": "Helpful",
    "tool_tip_not_helpful": "Not Helpful",
    "tool_tip_regenerate": "Regenerate suggestions"
  },
  "ai_feedback_modal": {
    "submit": "Submit",
    "tell_us_more": "Tell us more",
    "thumbs_down_reason": {
      "bias_or_offensive_content": "Bias or Offensive Content",
      "lack_of_contextual_understanding": "Lack of Contextual Understanding",
      "poor_grammar_or_typos": "Poor Grammar or Typos",
      "repetitive_or_redundant": "Repetitive or Redundant",
      "too_long_or_overly_wordy": "Too Long or Overly Wordy"
    }
  },
  "ai_general_assistant_button": {
    "label": "Cision AI"
  },
  "ai_mention_streams_assistant_panel": {
    "create_mention_stream_option": "Create a Single Mention Stream",
    "create_mention_stream_option_tooltip": "Automatically create a Mention Stream with suggested keywords, title, and group.",
    "create_multiple_mention_streams_option": "Create Multiple Mention Streams",
    "create_multiple_mention_streams_option_tooltip": "Automatically create multiple Mention Streams with suggested keywords, titles, and groups.",
    "option_prompt": "Certainly! I'd be happy to help you with creating Mention Streams. Type in a prompt in the chat or select one of the options below to get started.",
    "title": "Create Mention Streams"
  },
  "ai_suggested_contacts_list_selector": {
    "load_contact_lists_error": "Error loading Contact Lists",
    "no_contacts_found": "No contacts found"
  },
  "ai_suggested_contacts_panel": {
    "add_contacts": "Add to this List",
    "add_contacts_error": "Failed to add Contacts",
    "add_recipients": "Add to Recipient List",
    "add_suggested": "Add Suggested to List",
    "add_to_other_list": "Add to other List",
    "chat_result_with_link": "Here are some suggested journalists & outlets for the {link} {type} sorted by relevance. Use filters below to refine the results.",
    "contacts_added": "Contacts added to List",
    "different_list": "Pick a different {type}",
    "journalist_tag": "Journalist",
    "list": "list",
    "list_button": "List",
    "load_contact_list_error": "Failed to fetch Contact List",
    "load_contacts_error": "Failed to fetch Contacts",
    "load_error": "Failed to fetch Contacts",
    "load_media_release_error": "Failed to fetch Media Release",
    "media_release": "media release",
    "media_release_button": "Media Release",
    "no_contacts_prompt": "Your {type} does not contain any contacts, so I'm unable to generate suggestions for it. You can either select a different {type} or start over.",
    "no_valid_contacts_prompt": "Your {type} contains only private contacts, so I'm unable to generate suggestions for it. You can either select a different {type} or start over.",
    "pitch": "pitch",
    "pitch_button": "Pitch",
    "recipients_added": "Recipients added to {type}",
    "restart_prompt": "Would you like me to suggest contacts for another {type}, or would you prefer to start fresh?",
    "select_type_prompt": "Fantastic! Please select a {type} below",
    "start_over": "Start over",
    "title": "Suggested Journalists & Outlets",
    "type_prompt": "Certainly! I'd be happy to help you look for journalists and outlets. Please select what you would want your suggestions to be based on."
  },
  "ai_suggested_media_release_selector": {
    "load_media_releases_error": "Error loading Media Releases",
    "load_pitches_error": "Error loading Pitches",
    "no_recipients_found": "No recipients found"
  },
  "ai_summary": {
    "not_enough_mentions": "There are not enough mentions to generate a summary. Try again once more data is available or increase your date range.",
    "summary_error": "We're experiencing a temporary issue. Please try your request again."
  },
  "ai_summary_assistant_options": {
    "summarise": "Summarise my Mention Stream"
  },
  "ai_summary_assistant_panel": {
    "just_a_moment": "Just a moment…",
    "select_stream_message": "Certainly! I'd be happy to help you with creating a summary for your Mention Stream based on your selected date range. Please select a Mention Stream below:",
    "title": "Summarise"
  },
  "ai_summary_button": {
    "label": "Summarise"
  },
  "ai_summary_card": {
    "expand_button_tooltip": "Open in Assistant"
  },
  "ai_summary_cluster_panel": {
    "back_button": "Summary",
    "description": "The topic cluster summary {clusterTitle} is based on articles below for the Mention Stream {streamLabel}",
    "title": "Selected Articles"
  },
  "ai_summary_panel": {
    "copied": "Copied",
    "home": "Home",
    "return_to_stream": "Return to Stream",
    "summary_complete": "Here is the summary for the Mention Stream {label} based on your selected date range.",
    "summary_loading": "Summarising {label}. Just a moment…",
    "title": "Summarise"
  },
  "ai_summary_stream_response": {
    "view_included_articles": "View included articles"
  },
  "ai_tag": {
    "add_suggestion": "Add keyword suggestion",
    "remove_suggestion": "Remove keyword suggestion"
  },
  "ai_visibility_answers_card": {
    "entities_detected": "Entities detected:",
    "open_source": "Open {title} from {domain} in a new tab",
    "sources": "Sources:",
    "sources_scroll_left": "Scroll sources left",
    "sources_scroll_right": "Scroll sources right"
  },
  "ai_visibility_answers_filters": {
    "entities": "1 Entity | {count} Entities",
    "entity_placeholder": "All entities",
    "filters": "Filters",
    "location_placeholder": "All locations",
    "locations": "1 Location | {count} Locations",
    "sort": "Sort",
    "sort_latest": "Latest",
    "sort_oldest": "Oldest",
    "source_placeholder": "All models",
    "sources": "1 Model | {count} Models"
  },
  "ai_visibility_answers_modal": {
    "title": "AI Visibility Answers"
  },
  "ai_visibility_chart_detail": {
    "answers": "Answers",
    "answers_count": "1 Answer | {count} Answers",
    "answers_description": "Select a prompt to view its answers.",
    "author": "Author",
    "author_share": "Share of authors",
    "distinct_entities": "Entities",
    "distinct_sources": "Sources",
    "domain": "Domain",
    "domain_share": "Share of domains",
    "entities": "Entities",
    "entity": "Entity",
    "industry": "Industry",
    "industry_share": "Share of industries",
    "keyword": "Prompts",
    "mention_count": "Mention count",
    "mentions_total": "1 mention | {count} mentions",
    "not_available": "Not Available",
    "open_answer": "Open answer for {keyword}",
    "published_date": "Published date",
    "select_author": "Please select an Author.",
    "select_domain": "Please select a Domain.",
    "select_entity": "Please select an Entity.",
    "select_outlet": "Please select an Outlet.",
    "sentiment_score": "Sentiment",
    "share": "Share",
    "source": "Source",
    "source_description": "Web sources referenced by LLMs in responses where the selected entity was mentioned.",
    "source_items": {
      "authors": "Authors",
      "domains": "Domains",
      "industries": "Industries",
      "urls": "URLs"
    },
    "source_metric_options": "Source Metric Options",
    "sources_count": "1 Source | {count} Sources",
    "url": "URL",
    "url_share": "Share of urls"
  },
  "ai_visibility_entities": {
    "answers": "Answers",
    "description": "Entities found in LLM responses based on your prompts. Top 5 are pre-selected by relevance.",
    "entities": "Entities",
    "entities_confirm_message": "All applicable charts on this dashboard will be replaced with the selected Entities",
    "entities_confirm_title": "New Entities selected",
    "entities_updated": "Entities updated",
    "entity": "Entity",
    "fetch_description": "We're currently generating your data. You can close this window and you will be notified once complete.",
    "mentions": "Mentions",
    "search_placeholder": "Search entities",
    "sources": "Sources"
  },
  "ai_visibility_locations": {
    "location_count": "{total} of {max}",
    "selector_placeholder": "Select Locations",
    "title": "Location"
  },
  "ai_visibility_notification": {
    "entities_available": "Your AI Visibility data is now ready and the Top 5 entities have been selected.",
    "fetching_entities": "We're currently generating data for your dashboard.",
    "initialization_failed": "AI Visibility initialisation failed.",
    "review_button": "Review"
  },
  "ai_visibility_prompts": {
    "add_edit_button": "Add/Edit prompt",
    "brand_name_description": "Enter the brand you'd like to monitor.",
    "brand_name_title": "Brand Name",
    "generated_prompts_counter": "{total}/{max} prompt selected | {total}/{max} prompts selected",
    "generated_prompts_description": "Generated prompts based on your prompt description. Click Add/Edit to modify your prompts.",
    "generated_prompts_title": "Generated Prompts",
    "prompt_description": "Describe your topic and click Suggest.",
    "prompt_description_title": "Prompt Description",
    "suggest_button": "Suggest"
  },
  "ai_visibility_sources": {
    "counter": "{total} of {max}",
    "placeholder": "Select AI Models",
    "title": "AI Model"
  },
  "alert_dropdown": {
    "view_filter_sets": "Please click {link} to view your filter sets.",
    "view_media_item": "View the item.",
    "view_query_snippets": "Please click {link} to view your keyword snippets.",
    "view_transcript_link": "Please click {link} to view your transcript"
  },
  "alerts": {
    "button_aria_label": "Open alerts",
    "error_message": "Error loading alerts",
    "fields_validation": "Please fill in all fields",
    "instant_insights_dashboard_shared_alert": {
      "alert_text_line_1": "Your colleague {senderName} has shared an Instant Insights Dashboard {dashboardName} with you.",
      "alert_text_line_2": "This will appear in the list of saved Dashboards available for you to open in Instant Insights.",
      "click_to_review": "Click {link} to review and approve.",
      "mobile_text": "To see this dashboard, please sign in to the desktop app."
    },
    "media_request_text": {
      "radio": "Pushed an archived radio media item",
      "tv": "Pushed an archived TV media item"
    },
    "mention_text": {
      "article": "Sent an Online Mention",
      "blog_post": "Sent an Influencer Social Mention",
      "caption": "Sent a TV Mention",
      "exorde_reddit_post": "Sent an Influencer Social Mention",
      "exorde_reddit_post_comment": "Sent an Influencer Social Mention",
      "external_item": "Sent an External Item",
      "facebook_post": "Sent an Influencer Social Mention",
      "forum_post": "Sent an Influencer Social Mention",
      "instagram_post": "Sent an Influencer Social Mention",
      "magazine_article": "Sent a Magazine Mention",
      "paper_article": "Sent an Print Mention",
      "podcast_episode": "Sent a Podcast Mention",
      "radio_article": "Sent a Radio Mention",
      "radio_clip": "Sent a Radio Mention",
      "radio_media_request": "Sent a Radio Mention",
      "radio_segment": "Sent a Radio Mention",
      "reddit_post": "Sent an Influencer Social Mention",
      "reddit_post_comment": "Sent an Influencer Social Mention",
      "social": {
        "blog": "Sent a Blogs Social Mention",
        "bluesky": "Sent a Bluesky Social Mention",
        "facebook": "Sent a Facebook Social Mention",
        "forum": "Sent a Forums Social Mention",
        "instagram": "Sent an Instagram Social Mention",
        "linkedin": "Sent a Linkedin Social Mention",
        "reddit": "Sent a Reddit Social Mention",
        "tiktok": "Sent a TikTok Social Mention",
        "twitter": "Sent an X {'|'} Twitter Social Mention",
        "youtube": "Sent a YouTube Social Mention"
      },
      "tv_caption": "Sent a TV Mention",
      "tv_logo_appearance": "Sent a TV Mention",
      "tv_super": "Sent a TV Mention",
      "tweet": "Sent an Influencer Social Mention",
      "youtube_video": "Sent an Influencer Social Mention"
    },
    "organisation_social_integration_alert": {
      "manage": "Please click {link} to manage your integration."
    },
    "report_ready_alert": {
      "click_to_download": "Please click {link} to download your Report."
    },
    "scheduled_report_specififcation_shared_alert": {
      "alert_text_line_1": "Your colleague {senderName} has shared a Scheduled Report {reportName} with you.",
      "alert_text_line_2": "This will appear in the list of saved Scheduled Reports available for you to open in Scheduled Reports.",
      "click_to_review": "Click {link} to review.",
      "mobile_text": "To see this report, please sign in to the desktop app."
    },
    "social_engage_alert": {
      "click_to_review": "Click {link} to review.",
      "click_to_review_and_approve": "Click {link} to review and approve.",
      "mobile_review": "To review this request, please sign in to the desktop app.",
      "mobile_review_and_approve": "To review and approve this request, please sign in to the desktop app.",
      "notification_text": {
        "delete": "{senderName} has requested your approval to delete a social post",
        "publish": "{senderName} has requested your approval to publish a social post",
        "remove": "{senderName} has requested your approval to remove a social post {text}"
      }
    },
    "stream_alert": {
      "expired_stream_hidden": "Once expired, the Mention Stream will be hidden from your account.",
      "expires_at": "Your Mention Stream \"{streamName}\" will expire on {expiryDate} at {expiryTime}.",
      "expires_today": "Your Mention Stream \"{streamName}\" will expire today at {expiryTime}.",
      "expires_tomorrow": "Your Mention Stream \"{streamName}\" will expire tomorrow at {expiryTime}.",
      "expiry_extended": "Mention Stream Expiry Extended",
      "expiry_extended_by_3_days": "The expiry of {streamlabel} has been extended by 3 days.",
      "extend_expiry": "Click here to extend the expiry by 3 days.",
      "extended_expires_at": "Your Mention Stream \"{streamName}\" expiry has been changed and will expire on {expiryDate} at {expiryTime}.",
      "extended_expires_today": "Your Mention Stream \"{streamName}\" expiry has been changed and will expire today at {expiryTime}.",
      "extended_expires_tomorrow": "Your Mention Stream \"{streamName}\" expiry has been changed and will expire tomorrow at {expiryTime}.",
      "extended_has_expired": "Your Mention Stream \"{streamName}\" expiry has been changed and has expired on {expiryDate} at {expiryTime}.",
      "extended_never_expire": "Your Mention Stream \"{streamName}\" expiry has been changed and will never expire.",
      "has_expired": "Your Mention Stream \"{streamName}\" expired on {expiryDate} at {expiryTime}.",
      "never_expire": "Your Mention Stream \"{streamName}\" will never expire."
    }
  },
  "article_preview": {
    "current_front_page_position": "Current position #{currentRank} from {date}",
    "data_for_source": "Data for {sourceName}",
    "front_page": "FRONT PAGE",
    "no_tweets_found": "No Tweets found for this Article",
    "read_more": "Read more",
    "social": "SOCIAL",
    "tooltips": {
      "change_data_source": "Change social and front page data source",
      "front_page_rank": "Currently on the Front Page, in position #{rank} since {date}",
      "read_full_article": "Read full article",
      "view_syndications": "View Syndications"
    },
    "tweet_not_found": "Tweet not found",
    "tweets_about_article": "Tweets about this Article",
    "word_count": "{wordCount} words",
    "word_count_and_page_number": "{wordCount} words on page {pageNumber}"
  },
  "article_sentiment_view": {
    "overall_article_sentiment": "Overall article sentiment"
  },
  "audience_data_supplier_dropdown": {
    "select_supplier": "Select Audience Data Supplier"
  },
  "audience_reports_table": {
    "action": "Actions",
    "delete_report": "Delete report",
    "delete_report_title": "Permanently delete this report?",
    "from": "From",
    "requested": "Requested",
    "status": "Status",
    "to": "To"
  },
  "authors_expandable": {
    "comma_separated": "Comma Separated",
    "handle": "Handle"
  },
  "autocomplete_list": {
    "no_available_options": "No available options"
  },
  "automated_sentiment_widget": {
    "sentiment": "{sentimentLabel} sentiment"
  },
  "ave_disclaimer": "Potential Audience data and Advertising Value Equivalency (AVE) data is provided by {platformName} through third-party suppliers including Nielsen, OzTAM, GfK and Publisher/Broadcaster Rate Card information. {platformName} is not responsible for the accuracy of this data and the data cannot be amended under the contractual terms of its provision by these third-parties. The data is provided on an \"as is\" basis and may only be used in its existing form.",
  "base_add_chart_dropdown": {
    "no_results": "No results",
    "select_chart": "Select Chart"
  },
  "base_checkbox_selector": {
    "no_results_found": "No results found for \"{itemSearch}\"",
    "search_item": "Search {itemName}"
  },
  "base_insights_table": {
    "all_dashboards": "All Dashboards",
    "loading": "Loading...",
    "no_results": "No results.",
    "sort": "Sort:",
    "total": "{start} - {end} of {total}"
  },
  "bookmark_stream_actions": {
    "error_message": "There was an error searching or creating a bookmark",
    "select_deselect_placeholder": "Select/Deselect or Create New",
    "tag": "Tag",
    "tag_social_item": "Tag Social Item"
  },
  "bookmark_stream_form": {
    "add_label": "Add a label",
    "existing_group": "Existing Group",
    "group_label": "Group Label",
    "label": "Label",
    "new_group": "New Group"
  },
  "bookmark_stream_group_form": {
    "add_label": "Add a label",
    "group_color": "Group Color",
    "group_label": "Group Label",
    "label": "Label",
    "mention_stream_color": "Mention Stream Color"
  },
  "bookmark_streams": {
    "add_tagged_folders_subtext": "Click ‘Tag Media Item’ in a Mention's dropdown menu to add one.",
    "edit_tagged_folder": "Edit Tagged Folder",
    "no_tagged_folders": "You currently have no Tagged Folders."
  },
  "boolean_creator": {
    "ai_button_label": "Boolean Creator",
    "ai_button_tooltip": "Try AI Boolean Creator"
  },
  "boolean_creator_assistant_options": {
    "create_boolean_query": "Create a Boolean Query"
  },
  "boolean_creator_boolean_query": {
    "add_refinements": "Would you like to add any of these refinements, or are you happy to proceed with the current query?",
    "expand_label": "Expand",
    "expand_tooltip": "Expand the query by adding relevant terms to improve search accuracy and coverage.",
    "learn_more": "Learn More",
    "query_aria_label": "AI suggested boolean query",
    "refine_label": "Refine",
    "refine_tooltip": "Refine the query by adding relevant terms to improve search accuracy and coverage.",
    "restart_message": "Restarting the Boolean Creator will close the current session and start fresh within this chat. Do you want to continue?",
    "restart_title": "Start Over Boolean Creator",
    "start_over": "Start Over",
    "use_boolean_query_message": "Using the new boolean query will replace the current one. Are you sure you want to proceed?",
    "use_boolean_query_title": "Use the Boolean Query",
    "use_the_boolean_query": "Use the Boolean Query"
  },
  "boolean_creator_chat": {
    "boolean_mention_stream_creator": "Boolean Mention Stream Creator",
    "pre_suggestion_text": "Certainly! I'd be happy to help you with creating a Mention Stream with the Boolean Creator. Please enter your first keyword or select an option below:"
  },
  "boolean_field_select": {
    "additional_operator": "Additional Operator:"
  },
  "boolean_part_categories": {
    "add_categories": "Add categories",
    "cald_only": "CALD Only",
    "mixed": "Mixed",
    "no_cald_content": "No CALD content"
  },
  "boolean_part_editor": {
    "atleast_clause": "The following at least x times:",
    "invalid_atleast_error": "The ATLEAST operator can only have one keyword/phrase. Please remove additional keywords or this query will not work as expected.",
    "mixed_operator_error": "Error, mixed operators. Query may behave unexpectedly. Clause will be auto-corrected to {operator} on apply. Change operator to confirm and clear error before apply.",
    "set_operator_and": "All of the following",
    "set_operator_or": "Any of the following",
    "set_operator_or_colon": "Any of the following:"
  },
  "boolean_part_keywords": {
    "add_keyword": "Add keyword",
    "case_sensitive": "Case Sensitive",
    "convert_to": "Convert to",
    "insert_query_snippet": "Insert Query Snippet",
    "keyword_is_duplicated": "Keyword is duplicated",
    "keyword_looks_like_operator": "Keyword looks like an operator and may also lead to too many matches",
    "keywords": "Keywords",
    "new_window": "Open Snippet in new window",
    "punctuation_characters_unecessary": "Some punctuation characters are unnecessary and may cause problems in NEAR/ONEAR/FIRST/ATLEAST operators. For best results, replace them with spaces instead.",
    "query_snippet": "Query Snippet #{id}: {label}",
    "remove_field": "Remove Field",
    "remove_keyword": "Remove keyword",
    "sort": "Sort",
    "tv_super": "TV Super",
    "variation_with_s_unecessery": "Keyword variation with 's is unnecessary"
  },
  "boolean_part_location_key": {
    "locations_count": "({locationCount} selected)",
    "select_medium_locations": "Select {mediumLabel} locations:"
  },
  "boolean_part_program": {
    "add_radio_program": "Add Radio Program",
    "add_tv_program": "Add TV Program",
    "no_search_radio": "Couldn't search Radio Programs",
    "no_search_tv": "Couldn't search TV Programs"
  },
  "boolean_part_source_group": {
    "add_source_group": "Add source group"
  },
  "boolean_part_source_key": {
    "loading_source_names_error": "Error loading source names"
  },
  "boolean_part_source_tier": {
    "tier": "Tier {number}"
  },
  "boolean_placeholder": "(Economy AND \"interest rates\") OR (Samsung AND Apple)",
  "boolean_recursive_group": {
    "add_additional_operator": "Add Additional Operator",
    "add_note": "Add Note",
    "add_operator": "Add Operator",
    "cancel_remove": "Cancel Remove",
    "clause": "Clause",
    "confirm_remove": "Confirm Remove",
    "group_all": "Group All",
    "operator_clause": "{operator} Clause",
    "remove_group": "Remove Group",
    "string_index": "String {index}",
    "ungroup": "Ungroup"
  },
  "boolean_wizard": {
    "apply_boolean": "Apply Boolean",
    "boolean_query_preview": "Boolean query preview",
    "click_to_show_boolean": "Click to show boolean re-built from groups",
    "hide_rebuilt_query": "Hide rebuilt query / Show groups",
    "show_boolean_wizard": "Show Boolean Wizard",
    "show_query_editor": "Show Query Editor"
  },
  "boot_alert": {
    "dialog_title": "Your session has expired. Please sign in again"
  },
  "brand_profile_action_sheet": {
    "brand_profile_default_notification": "Brand Profile set as default!",
    "confirm_delete_message": "This Brand Profile will be permanently deleted. Brand Profile: {brandProfileName}",
    "confirm_delete_title": "Delete Brand Profile?",
    "default_brand_profile": "Set Default Brand Profile",
    "delete_brand_profile": "Delete Brand Profile",
    "deleted_error_message": "Brand Profile deleted!",
    "deleted_success_message": "There was an error deleting the Brand Profile.",
    "duplicate_brand_profile": "Duplicate Brand Profile",
    "duplicated_error_message": "There was an error duplicating the Brand Profile.",
    "duplicated_success_message": "Brand Profile successfully duplicated!",
    "edit_brand_profile": "Edit Brand Profile",
    "label": "Toggle dropdown",
    "outreach_type": "Outreach",
    "reports_type": "Reports",
    "set_brand_profile_default_error": "There was an error setting the Brand Profile as default."
  },
  "brand_profile_dropdown": {
    "label": "Brand Profile",
    "logo_alt": "{name} brand logo"
  },
  "brand_profile_edit": {
    "confirm_cancel_create_title": "Cancel Creating New Brand Profile",
    "confirm_cancel_edit_title": "Cancel Editing Brand Profile",
    "confirm_cancel_message": "Any edits made to the Brand Profile will not be saved.",
    "confirm_delete_message": "This Brand Profile will be permanently deleted.",
    "confirm_delete_title": "Delete Brand Profile?",
    "created_notification": "Brand Profile has been successfully created",
    "delete_notification_message": "Brand Profile deleted",
    "dismiss_button": "Dismiss",
    "load_brand_error": "There was an error loading the Brand Profile",
    "save_error": "There was an error saving this Brand Profile.",
    "updated_notification": "Brand Profile has been successfully updated"
  },
  "brand_profile_form": {
    "advanced_colours_label": "Advanced Colour Customisation",
    "appear_in_campaigns": "Your Brand Profile will appear in campaigns sent using the Outreach tool.",
    "appear_in_reports": "Your default Brand Profile will appear in Mention Stream Reports, Instant Insights Reports and Scheduled Reports. Your Teammates can select a preferred profile for Curated Email Reports.",
    "background_color_label": "Background",
    "coverage_headline_color_label": "Coverage Headline",
    "coverage_summary_text_color_label": "Coverage Summary Text",
    "data_text_color_label": "Data",
    "date_color_label": "Date",
    "disclaimer_heading": "Disclaimer (optional)",
    "disclaimer_tooltip": "Pre-set a disclaimer which {newline} appears at the bottom of {newline} your Curated Email Report.",
    "folder_text_color_label": "Folder Text",
    "font_campaign_tooltip": "Select a font for your {newline} Outreach campaigns.",
    "font_label": "Font",
    "font_report_tooltip": "Select a font for your {newline} Curated Email Report & {newline} Scheduled Report.",
    "footer_image_heading": "Footer Image",
    "footer_image_subtext": "Min 600px wide (recommended size 1200px) with any height eg. 300 or 400px",
    "footer_image_tooltip": "Select a footer image to {newline} appear at the bottom of your {newline} Outreach campaigns.",
    "header_image_label": "Header Image (optional)",
    "header_image_subtext": "Min 600px wide (recommended size 1200px) with any height eg. 300 or 400px",
    "header_image_tooltip": "Insert a header image to {newline} customise your Curated {newline} Email Report & Scheduled {newline} Report.",
    "hyperlink_text_color_label": "Hyperlink Text",
    "item_body_text_color_label": "Item Body",
    "keyword_highlight_text_color_label": "Keyword Highlight",
    "logo_label": "Logo (optional)",
    "logo_subtext": "Min 400 x 400 pixels",
    "logo_tooltip": "Personalise your Curated {newline} Email Report & Scheduled {newline} Report with your logo.",
    "name_aria_label": "Name of Brand Profile",
    "name_placeholder": "Enter Brand Profile name",
    "organisation_fields": "These fields will be used for {organisationName}'s Curated Email Report and Scheduled Report Brand Profiles.",
    "outreach_header_image": "Header Image",
    "outreach_header_subtext": "Min 600px wide (recommended size 1200px) with any height eg. 300 or 400px",
    "outreach_header_tooltip": "Select a header image to {newline} appear at the top of your {newline} Outreach campaigns.",
    "report_details_heading": "Curated Email Report & Scheduled Report Details",
    "report_header": "Curated Email Report Details",
    "report_title_heading": "Report Title (optional)",
    "report_title_placeholder": "Enter a title for the report",
    "report_title_tooltip": "Add a title to your Curated {newline} Email Report.",
    "subject_date_format_adby": "Monday 1 November 2021",
    "subject_date_format_aoby": "Monday 1st November 2021",
    "subject_date_format_bdy": "November 1 2021",
    "subject_date_format_boy": "November 1st 2021",
    "subject_date_heading": "Email Subject Date Format (optional)",
    "subject_date_tooltip": "Pre-set the date format {newline} which appears in your {newline} Curated Email Report's {newline} subject line.",
    "subject_heading": "Email Subject Title (optional)",
    "subject_placeholder": "Enter an email subject title",
    "subject_subtext": "Preview: {transformDateFormat}",
    "subject_tooltip": "Pre-set your Curated Email {newline} Report's subject line.",
    "theme_color_label": "Theme Colour",
    "theme_color_tooltip": "Personalise your Curated {newline} Email Report & {newline} Scheduled Report with a {newline} key colour."
  },
  "brand_profile_selector": {
    "heading": "Brand Profile Logo"
  },
  "brand_profile_types": {
    "OrganisationBrandOutreach": "Outreach",
    "OrganisationBrandReporting": "Reporting"
  },
  "brand_profiles": {
    "load_organisation_brands_error": "There was an error loading Organisation Brands.",
    "outreach_label": "Outreach",
    "outreach_tab_description": "Your Brand Profile will appear in campaigns sent using the Outreach tool.",
    "reports_label": "Reports",
    "reports_tab_description": "You can customise reports generated in {platformName} by adding your logo, header image and colour. You cannot delete your default Brand Profile."
  },
  "brand_selector": {
    "create_brand_profile": "Create Brand Profile",
    "create_brand_profile_button": "Create Brand Profile",
    "select_brand_profile": "Please select a brand",
    "toggle_show_all_label": "Show all",
    "toggle_show_less_label": "Show less"
  },
  "brand_selector_button": {
    "condensed": "Condensed",
    "default": "Default",
    "deleted": "deleted",
    "regular": "Regular"
  },
  "broadcast_audience_widget": {
    "local_time": "{location} Local Time ({shortTimezone})",
    "no_data": "No data",
    "potential_audience": "Potential Audience",
    "short_label": "Audience"
  },
  "broadcast_mention_card": {
    "expired_content": "The original broadcast has expired.",
    "view_broadcast": "View Full Broadcast"
  },
  "broadcast_story_mention_transcript": {
    "speaker": "Speaker"
  },
  "business_register": "ABN/ACN",
  "category_checkbox_selector": {
    "category": "Category",
    "select_at_least_one_category": "Please select at least one category."
  },
  "chart_container_widget": {
    "comparative_description_mentions": "Once exported, Instant Insights will contain comparative results from selected Mention Streams.",
    "comparative_description_social_mentions": "Once exported, Social Analyse will contain comparative results from selected Social Streams.",
    "date_text": "Date Range: {dateRange}",
    "generate_report": "Generate report",
    "interactive_description": "This chart is interactive. Click on chart elements to view related coverage.",
    "table_view": "Table view"
  },
  "chart_selector": {
    "chart_has_been_deselected": "The \"{chartTitle}\" chart has been deselected. Please scroll down to find it.",
    "chart_has_been_selected": "The \"{chartTitle}\" chart has been selected. Please scroll up to reorder.",
    "chart_name": "Chart Name",
    "order": "Order"
  },
  "chart_selector_dropdown": {
    "add_remove_charts": "Add/Remove Charts",
    "cancel": "Cancel",
    "chart_selected": "1 Chart selected | {count} Charts selected",
    "click_to_reorder": "Click and drag to re-order charts.",
    "confirm": "Confirm",
    "disabled_description": "Please select at least one chart.",
    "select_and_reorder": "Select & Reorder Charts"
  },
  "chart_setting_action_sheet_widget": {
    "chart_options": "Chart options",
    "chart_options_for": "Chart options for {title}",
    "define_key_messages": "Define Key Messages",
    "delete_chart": "Delete chart",
    "edit_chart": "Edit chart",
    "generate_pdf": "Generate PDF",
    "generate_pdf_notification": "Exporting {chartTitle}",
    "generate_xlsx": "Generate XLSX",
    "select_linked_stream": "Select Linked Stream",
    "select_mention_streams": "Select Mention Streams",
    "select_social_streams": "Select Social Stream",
    "select_stock_symbol": "Select Stock Symbol"
  },
  "chart_settings_key_messages_form": {
    "add_key_messages": "Add Key Messages",
    "boolean_query": "Boolean Query",
    "can_save_tooltip": "Please add at least 1 Key Message for each Mention Stream",
    "can_save_tooltip_selected": "Please add at least 1 Key Message",
    "defined": "{count}/{total} defined",
    "existing_keyword_found": "Existing keyword found",
    "existing_label_found": "Existing label found",
    "key_messages": "Key Messages",
    "key_messages_defined": "({count}) Key Messages defined",
    "key_messages_description": "Select Mention Stream and define up to {number} Key Messages through Keywords and/or Boolean Queries",
    "key_messages_title": "Define Key Messages",
    "keyword": "Keyword",
    "keyword_limit_of": "Keyword limit of {number} reached",
    "max_key_messages": "Define up to {number} Key Messages for {localSelectedStream} through Keywords and/or Boolean Queries",
    "mention_stream": "Mention Stream",
    "mention_stream_description": "Select the stream you would like to configure.",
    "no_key_messages_defined": "No Key Messages defined",
    "select_stream": "Select a Mention Stream",
    "type_boolean_placeholder": "Type a boolean query",
    "type_keyword_placeholder": "Type a keyword"
  },
  "chart_settings_media_releases_form": {
    "error_loading_media_outreach": "There was an error loading Media Outreach"
  },
  "chart_settings_select_linked_stream_form": {
    "clear_selection": "Clear Selection",
    "mention_stream": "Mention Stream",
    "no_results_found_for": "No results found for '{search}'",
    "search_streams": "Search for {streamType}",
    "select_stream": "Select {streamType}",
    "select_stream_description": "Select 1 to compare against {selectedStreamLabel}. This will only apply to the {chart} chart.",
    "select_stream_to_configure": "Select the stream you would like to configure.",
    "social_stream": "Social Stream"
  },
  "chart_settings_select_mention_streams_form": {
    "apply_to_chart_label": "Apply to {similarChartTitle}",
    "no_results_found_for": "No results found for '{search}'",
    "search_mention_streams": "Search Mention Streams",
    "select_at_least_one_mention_stream": "Please select at least one Mention Stream",
    "select_mention_streams": "Select Mention Streams",
    "select_up_to": "Select up to {maximumSelectedStreams} to compare your Mention Streams by volume"
  },
  "chart_settings_stock_symbol_form": {
    "select_stock_exchange": "Select Stock Exchange",
    "select_stock_exchange_description": "Select a Stock Exchange to appear within the chart",
    "select_stock_symbol": "Select Stock Symbol",
    "select_stock_symbol_description": "Select a Stock Symbol to appear within the chart",
    "stock_exchange": "Stock Exchange",
    "stock_symbol": "Stock Symbol"
  },
  "chart_settings_with_export_options_form": {
    "title": "Include when exporting"
  },
  "client_management": {
    "contact_account_manager": "To add or update your client list, please contact your dedicated Account Manager at {email}",
    "contact_customer_success_team": "To add or update your client list, contact our customer success team between 9am-5pm on weekdays at {email}",
    "contact_dedicated_support_team": "To add or update your client list, please contact your Dedicated Support team at {email}",
    "load_clients_error": "There was an error loading Clients"
  },
  "color_picker": {
    "clear_formatting": "Clear Formatting",
    "color_grid_tab": "Color Grid",
    "color_picker_tab": "Color Picker",
    "default_label": "Colour",
    "hex_input": "HEX",
    "hue_slider": "Colour Hue",
    "rgb_blue": "Blue",
    "rgb_green": "Green",
    "rgb_red": "Red",
    "rgb_sliders_tab": "RGB Sliders",
    "select_color": "Select colour with Eye Dropper",
    "select_color_name": "Select {color}",
    "toggle_picker": "Toggle colour picker"
  },
  "combined_stream_picker": {
    "select_comparison_streams": "Select at least {count} Streams to compare.",
    "select_min_streams": "Please select at least {count} Stream | Please select at least {count} Streams",
    "social_streams": "Social Streams",
    "streams": "Mention Streams"
  },
  "constants": {
    "index": {
      "insights": "Insights",
      "mentions": "Mentions",
      "social_analyse": "Social Analytics",
      "social_mentions": "Social Stream"
    },
    "languages": {
      "aa": "Afar",
      "af": "Afrikaans",
      "am": "Amharic",
      "an": "Aragonese",
      "ar": "Arabic",
      "as": "Assamese",
      "av": "Avaric",
      "az": "Azerbaijani",
      "ba": "Bashkir",
      "be": "Belarusian",
      "bg": "Bulgarian",
      "bh": "Bihari",
      "bn": "Bengali",
      "bo": "Tibetan",
      "br": "Breton",
      "bs": "Bosnian",
      "ca": "Catalan",
      "ce": "Chechen",
      "co": "Corsican",
      "cs": "Czech",
      "cv": "Chuvash",
      "cy": "Welsh",
      "da": "Danish",
      "de": "German",
      "dv": "Divehi",
      "el": "Greek",
      "en": "English",
      "eo": "Esperanto",
      "es": "Spanish",
      "et": "Estonian",
      "eu": "Basque",
      "fa": "Persian",
      "fi": "Finnish",
      "fr": "French",
      "fy": "Frisian",
      "ga": "Irish",
      "gd": "Scottish Gaelic",
      "gl": "Galician",
      "gn": "Guarani",
      "gu": "Gujarati",
      "gv": "Manx",
      "ha": "Hausa",
      "he": "Hebrew",
      "hi": "Hindi",
      "hr": "Croatian",
      "ht": "Haitian Creole",
      "hu": "Hungarian",
      "hy": "Armenian",
      "ia": "Interlingua",
      "id": "Indonesian",
      "ie": "Interlingue",
      "ig": "Igbo",
      "ii": "Yi",
      "io": "Ido",
      "is": "Icelandic",
      "it": "Italian",
      "iu": "Inuktitut",
      "ja": "Japanese",
      "jv": "Javanese",
      "ka": "Georgian",
      "kk": "Kazakh",
      "km": "Khmer",
      "kn": "Kannada",
      "ko": "Korean",
      "ku": "Kurdish",
      "kv": "Komi",
      "kw": "Cornish",
      "ky": "Kyrgyz",
      "la": "Latin",
      "lb": "Luxembourgish",
      "li": "Limburgish",
      "lo": "Lao",
      "lt": "Lithuanian",
      "lv": "Latvian",
      "mg": "Malagasy",
      "mi": "Maori",
      "mk": "Macedonian",
      "ml": "Malayalam",
      "mn": "Mongolian",
      "mr": "Marathi",
      "ms": "Malay",
      "mt": "Maltese",
      "my": "Burmese",
      "na": "Nauru",
      "nb": "Norwegian Bokmål",
      "ne": "Nepali",
      "nl": "Dutch",
      "nn": "Norwegian Nynorsk",
      "no": "Norwegian",
      "ny": "Chichewa",
      "oc": "Occitan",
      "om": "Oromo",
      "or": "Odia",
      "os": "Ossetian",
      "pa": "Punjabi",
      "pl": "Polish",
      "ps": "Pashto",
      "pt": "Portuguese",
      "qu": "Quechua",
      "rm": "Romansh",
      "ro": "Romanian",
      "ru": "Russian",
      "rw": "Kinyarwanda",
      "sa": "Sanskrit",
      "sc": "Sardinian",
      "sd": "Sindhi",
      "se": "Northern Sami",
      "si": "Sinhala",
      "sk": "Slovak",
      "sl": "Slovenian",
      "sm": "Samoan",
      "sn": "Shona",
      "so": "Somali",
      "sq": "Albanian",
      "sr": "Serbian",
      "st": "Southern Sotho",
      "su": "Sundanese",
      "sv": "Swedish",
      "sw": "Swahili",
      "ta": "Tamil",
      "te": "Telugu",
      "tg": "Tajik",
      "th": "Thai",
      "tk": "Turkmen",
      "tl": "Tagalog",
      "tr": "Turkish",
      "tt": "Tatar",
      "ug": "Uyghur",
      "uk": "Ukrainian",
      "ur": "Urdu",
      "uz": "Uzbek",
      "vi": "Vietnamese",
      "vo": "Volapük",
      "wa": "Walloon",
      "xh": "Xhosa",
      "yo": "Yoruba",
      "zh": "Chinese",
      "zu": "Zulu"
    }
  },
  "contact_menu": {
    "account_manager_picture": "Account manager picture",
    "after_hours_contact_links": "Contact our team directly at {contactEmail} {phoneNumber}",
    "after_hours_contact_links_or_call": "or call",
    "after_hours_description": "Need support out of regular office hours?",
    "after_hours_weekend_support": "After hours and weekend support",
    "best_practice": "Best Practice?",
    "button_aria_label": "Help menu",
    "cision_knowledge_base_link": "{link} to access our {knowledgeBase} or {contact} our Support team.",
    "cision_knowledge_base_link_click_here": "Click here",
    "cision_knowledge_base_url": "https://help.cision.one/",
    "cision_one_academy_link": "Learn with self-paced courses and get certified in {link}.",
    "cision_one_academy_link_text": "CisionOne Academy",
    "contact": "contact",
    "contact_account_manager": "Contact {organisationName}'s dedicated Account Manager | Contact {organisationName}'s dedicated Account Managers",
    "contact_customer_success_team": "Contact our Customer Success Team",
    "contact_customer_success_team_link": "Contact our customer success team {contactHours} at {link}",
    "customer_success_contact_hours": "between 9AM-5PM on weekdays",
    "dedicated_support_contact_hours": "Contact our Dedicated Support team between 12AM-9PM on weekdays and 9AM-5PM on weekends",
    "interactive_onboarding_guide": "interactive onboarding guide",
    "interactive_onboarding_guide_link": "Access our {onboardingGuideLink} to read about best practice in onboarding and setting up {platformName} for success in your organisation.",
    "knowledge_base": "knowledge base",
    "live_chat": "Live Chat",
    "live_chat_description": "Reach the {platformName} support team 24/7 by starting a conversation - we respond in less than 5 minutes",
    "need_help": "Need Help?",
    "need_support": "Need support?",
    "read_help_articles": "Read and Learn from our {link}.",
    "read_help_articles_link_text": "interactive help articles and videos",
    "resource_centre": "Resource Centre",
    "start_live_chat": "Start live chat"
  },
  "contact_popup": {
    "account_manager_picture": "Account manager picture",
    "contact_team": "Contact the team at {contactLabel}",
    "help_centre": "help centre",
    "need_help": "Need help?",
    "popup_subtext": "Contact your dedicated Account Manager directly, chat to the team at {contactEmail}, or visit our {helpCentre}. | Contact your dedicated Account Managers directly, chat to the team at {contactEmail}, or visit our {helpCentre}."
  },
  "contacts_search_input": {
    "cant_find": "Can't find what you're looking for?",
    "journalists": "Journalists",
    "no_contacts": "No contacts matching filter",
    "no_options": "No available options",
    "outlets": "Outlets",
    "search_for_journalist": "Search for a Journalist or Outlet",
    "see_all": "See all"
  },
  "content_editor": {
    "definition": {
      "align_center": "Align Center",
      "align_justify": "Align Justify",
      "align_left": "Align Left",
      "align_right": "Align Right",
      "background_color": "Background Colour",
      "blockquote": "Blockquote",
      "bold": "Bold",
      "bullet_list": "Bullet List",
      "clear_formatting": "Clear Formatting",
      "enter_url": "Enter a URL",
      "enter_url_placeholder": "Enter a URL",
      "font_color": "Font Colour",
      "font_size": "Font Size",
      "heading_1": "Heading 1",
      "heading_2": "Heading 2",
      "heading_3": "Heading 3",
      "horizontal_rule": "Horizontal Rule",
      "indent": "Indent",
      "insert_image": "Insert Image",
      "italic": "Italic",
      "link": "Link",
      "ordered_list": "Ordered List",
      "outdent": "Outdent",
      "redo": "Redo",
      "strike": "Strike",
      "task_list": "Task List",
      "underline": "Underline",
      "undo": "Undo",
      "update_url": "Update a URL"
    },
    "max_content_message": "{contentLength} / {maxContentLength} characters"
  },
  "content_editor_font_size": {
    "decrease_font_size": "Decrease font size",
    "font_size": "Font Size",
    "increase_font_size": "Increase font size"
  },
  "content_expandable": {
    "comma_separated": "Comma separated",
    "exclude_keywords": "Exclude Keywords",
    "excluded_keywords": "Excluded Keywords",
    "external_items": "External Items",
    "filter_since_last_saved": "Filter since Last Saved",
    "from_date_to": "From {afterLabel} To {beforeLabel}",
    "hide_mentions_already_included": "Hide Mentions already included",
    "include_newswire_content": "Display Newswire Content",
    "keywords": "Keywords",
    "max": "Max",
    "min": "Min",
    "only_external_items": "Only show External Items",
    "page_number": "Page Number",
    "word_count": "Word Count"
  },
  "content_range_selector": {
    "custom": "Custom",
    "days": "Days",
    "hours": "Hours",
    "minutes": "Minutes",
    "range_options": {
      "12_hours": "12 hours",
      "14_days": "14 days",
      "24_hours": "24 hours",
      "3_days": "3 days",
      "6_hours": "6 hours",
      "7_days": "7 days"
    },
    "select_range": "Please select a range",
    "set_content_range": "Set content range"
  },
  "content_teaser_notification": {
    "additional_mention": "Additional {mention} across {totalGroupMentions} Mention Stream. {findOutMore}. | Additional {mention} across {totalGroupMention} Mention Streams. {findOutMore}.",
    "find_out_more": "Find out more",
    "mentions": "{totalMentions} Mention | {totalMentions} Mentions"
  },
  "content_teasers": {
    "cald": {
      "description": "Monitor diverse community discussion with {platformName}'s CALD service.",
      "title": "CALD"
    },
    "international": {
      "description": "Monitor International news with {platformName}.",
      "title": "International"
    },
    "magazine": {
      "description": "Magazine monitoring made easy with {platformName}.",
      "title": "Magazines"
    },
    "nz_content": {
      "description": "Get the full picture by adding NZ coverage to your media monitoring.",
      "title": "NZ Content"
    },
    "podcast": {
      "description": "Monitor mentions in Podcasts instantly with {platformName}.",
      "title": "Podcasts"
    },
    "social": {
      "description": "Track what influencers are saying about your organisation on social.",
      "title": "Influencer Social"
    }
  },
  "csl_product_name": "CSL",
  "currency": "AUD",
  "currency_dropdown": {
    "label": "Currency",
    "placeholder": "Select a currency"
  },
  "currency_symbol": "{'$'}",
  "daily_highlight_detail_page": {
    "australian_government_link": "official Australian Government information",
    "coronavirus_link": "Coronavirus data",
    "read_view_description": "Read {info} or view the latest {data}."
  },
  "daily_highlights_digests": {
    "digest": "Digests",
    "news_summaries": "News Summaries"
  },
  "daily_highlights_page": {
    "add_notification": "Add notification",
    "notification_error": "Error updating notification",
    "notification_updated": "Notification updated"
  },
  "dashboard": {
    "create_stream_button": "Create Stream",
    "loading_error": "There was a problem loading the dashboard. Please try again.",
    "media_items_chart_subtitle": "Media items {range}",
    "no_streams_message": "You don't have any mention streams to view. Create a stream to see your mentions here.",
    "no_streams_title": "No Mention Streams Available",
    "share_of_voice_title": "Share of Voice",
    "vs_market_title": "{streamLabel} vs. Market"
  },
  "dashboard_featured_article": {
    "tv_thumbnails": "TV thumbnails"
  },
  "date": {
    "duration": {
      "min": "1 min | {minutes} mins",
      "mins_secs": "{secs} | {mins} {secs} | {mins} {secs}",
      "sec": "1 sec | {seconds} secs"
    },
    "format": "yyyy-MM-dd",
    "from_now": {
      "days": "1 day ago | {days} days ago",
      "hours": "1 hour ago | {hours} hours ago",
      "minutes": "1 minute ago | {minutes} minutes ago",
      "seconds": "A few seconds ago",
      "yesterday": "Yesterday {hours}"
    },
    "pretty_ranges": {
      "default": "last {rangeText}",
      "half_yearly": "half yearly",
      "last_24_hours": "last 24 hours",
      "last_day": "24 hrs",
      "last_days": "{span} days",
      "last_hours": "{span} hrs",
      "last_minutes": "{span} min",
      "last_month": "last 30 days",
      "last_quarter": "last quarter",
      "last_year": "last year",
      "last_years": "{span} years",
      "range": "{after} to {before}",
      "this_month": "last {days} days",
      "today_yesterday": "last 24 hours"
    },
    "ranges": {
      "content_date_cap": "Content Start Date",
      "half_yearly": "Half Yearly",
      "last_14_days": "Last 14 Days",
      "last_180_days": "Last 6 Months",
      "last_24_hours": "Last 24 Hours",
      "last_30_days": "Last 30 Days",
      "last_3_days": "Last 3 Days",
      "last_7_days": "Last 7 Days",
      "last_90_days": "Last 90 Days",
      "last_month": "Last Month",
      "last_quarter": "Last Quarter",
      "last_year": "Last 365 Days",
      "this_month": "This Month",
      "today": "Today",
      "yesterday": "Yesterday"
    },
    "regex": "^[0-9]{4}-[0-9]{2}-[0-9]{2}$",
    "time_ago": {
      "hours_ago": "{diffHours}h ago",
      "minute": "a minute ago",
      "minutes_ago": "{diffMinutes}m ago",
      "on_day": "on {date}",
      "seconds": "a few seconds ago",
      "seconds_ago": "{diffSeconds}s ago"
    },
    "time_until": {
      "days": "1 day | {days} days",
      "expired": "expired",
      "hours": "1 hour | {hours} hours",
      "less_than_a_minute": "less than a minute",
      "minutes": "1 minute | {minutes} minutes",
      "months": "1 month | {months} months"
    },
    "timecode": "{minutes}m {seconds}s | {hours}h {minutes}m {seconds}s | {hours}h {minutes}m {seconds}s"
  },
  "days_of_week_selector": {
    "every": "Every",
    "long": {
      "friday": "Friday",
      "monday": "Monday",
      "saturday": "Saturday",
      "sunday": "Sunday",
      "thursday": "Thursday",
      "tuesday": "Tuesday",
      "wednesday": "Wednesday"
    },
    "short": {
      "friday": "Fri",
      "monday": "Mon",
      "saturday": "Sat",
      "sunday": "Sun",
      "thursday": "Thu",
      "tuesday": "Tue",
      "wednesday": "Wed"
    }
  },
  "debug_mention_modal": {
    "copy_debug": "Copy debug info to Clipboard",
    "debug_info": "Debug info"
  },
  "default_layout": {
    "platform_logo": "{platformName} logo",
    "sign_out": "Sign out",
    "toggle_menu": "Toggle menu"
  },
  "digests": {
    "australia_back_pages": "AU - Back Pages",
    "australia_front_pages": "AU - Front Pages",
    "automotive": "Automotive",
    "cost_of_living": "Cost of Living",
    "daily_news": "Daily News",
    "energy": "Energy",
    "esg": "ESG",
    "financial": "Financial",
    "government": "Government",
    "health": "Healthcare",
    "new_zealand_back_pages": "NZ - Back Pages",
    "new_zealand_front_pages": "NZ - Front Pages",
    "pr_and_comms": "PR & Comms",
    "retail": "Retail",
    "russia_ukraine": "Russia-Ukraine",
    "technology": "Technology",
    "travel": "Travel"
  },
  "distributed_email_input": {
    "clear_all_recipients": "Clear all recipients",
    "distribution_dropdown_label": "Add from distribution list",
    "load_distribution_lists_error": "Unable to load distribution lists",
    "please_select_recipient": "Please select a recipient",
    "recipient_subtext": "and {listRecipientsLength} more...",
    "restricted_label": "Restricted",
    "search_input_placeholder": "Search by name or recipients"
  },
  "distribution_list_form": {
    "recipients": "Recipients",
    "save_distribution_list_error": "There was an error saving the Distribution List"
  },
  "distribution_lists": {
    "delete_distribution_lists_dialog_subtext": "Are you sure you want to delete the Distribution List?",
    "delete_distribution_lists_dialog_title": "Permanently Delete Distribution List"
  },
  "distribution_lists_overview": {
    "add_distribution_list_button": "Add Distribution List",
    "create_first_distribution_list": "Create your first distribution list",
    "distribution_created": "Distribution List created",
    "distribution_lists": "Distribution Lists",
    "distribution_updated": "Distribution List updated",
    "error_loading_data": "Error loading distribution lists.",
    "no_distribution_lists": "No distribution lists. {createFirst}.",
    "no_match_for_filter": "No distribution lists matching the filter `{filter}`.",
    "successfull_creation_message": "Distribution list created",
    "successfull_update_message": "Distribution list updated",
    "table": {
      "distribution_name": "Distribution Name",
      "recipient_count": "{count} Recipient |{count} Recipients",
      "recipients": "Recipients",
      "team": "Team"
    },
    "update_restriction_error": "There was an error updating the restriction of this distributed list"
  },
  "domain_authority_widget": {
    "label": "Domain Authority",
    "tooltip": "Domain Authority predicts the 'strength' of a website and how it compares to other websites. The scores range from one to 100, with higher scores corresponding to a greater likelihood of ranking. Domain Authority is provided by Moz."
  },
  "domain_management": {
    "add_domain": "Add Email Domain",
    "add_domain_text": "We use your domain to send emails. That means emails will appear to come directly from your own domain.",
    "add_domain_title": "What's your sending domain?",
    "add_email": "Add Email",
    "allowed_email_addresses": "Allowed Sender Email Addresses",
    "allowed_email_addresses_description": "Add the details of the email addresses you want your organisation to send from. Only email addresses that are whitelisted will be available for you to select when sending an email.",
    "authenticate_domain_message": "Authenticate and verify an email sending domain to add an additional layer of authentication to your emails. Once complete, you will be able to send emails using your organisation's email domain.",
    "cname": "CNAME",
    "dkim": "DKIM",
    "dkim_tooltip": "This DKIM key has not been verified. Please add the TXT record provided under the \"Value\" column wherever you manage your DNS and click on \"Verify Domain\" when completed.",
    "dns_records_header_text": "Add CNAME, DKIM and SPF records to your domain registrar and verify your domain so that we can send emails on your behalf. Once complete, you will be able to send emails using your organisation's email domain.",
    "domain_details_title": "Managing {domain_name}",
    "domain_placeholder": "domain.com",
    "domain_updated": "Domain updated",
    "email_address": "Email Address",
    "how_to_add_domains": "How to add domains",
    "improve_deliverability": "Improve deliverability",
    "label": "Label",
    "more_information": "For more information on what you need to know before you get started {link}.",
    "mx": "MX",
    "priority": "Priority",
    "remove_domain_error": "Unable to remove domain",
    "remove_domain_title": "Are you sure you want to remove this domain?",
    "remove_email_address_label": "Remove email address",
    "sending_domain": "Sending Domain",
    "spf": "SPF",
    "status": "Status",
    "team_selector_message": "Domain will only be visible to the selected team",
    "type": "Type",
    "value": "Value",
    "verify_domain": "Verify Domain"
  },
  "domain_management_table": {
    "manage_domain": "Manage Domain",
    "settings": "Settings",
    "status": "Status",
    "status_active": "Active",
    "status_active_tooltip": "This domain is active.",
    "status_unknown": "Unverified",
    "status_unknown_tooltip": "This record needs to be verified via DNS.",
    "status_unverified": "Unverified",
    "status_unverified_tooltip": "This domain needs to be verified via DNS.",
    "status_valid": "Valid"
  },
  "dropdown_bookmark_mentions": {
    "add_tags": "Add tags to categorise, group and save for later",
    "all": "All",
    "create_a_new_tag": "Create a new tag",
    "create_new_tag": "Create a new tag for '{tagName}'",
    "first_mentions": "First {totalMentions} mentions",
    "loading_bookmarks_error": "There was an error loading your bookmarks. Please, try again.",
    "mentions_added_to": "{totalMentions} mentions added to \"{selectedBookmarkStream}\"",
    "mentions_removed_from": "{totalMentions} mentions removed from \"{bookmarkStreamLabel}\"",
    "search_or_create_tag": "Search existing tags or create a new tag",
    "search_tags": "Search tags",
    "tab_placeholder": "Tag Label",
    "tag_media_items": "Tag Media Items",
    "tag_mention": "Tag Mention",
    "tag_mentions": "Tag {totalMentions} Mention | Tag {totalMentions} Mentions",
    "this_page": "This page ({pageNumber})",
    "unable_to_add_mentions": "Unable to add mentions to \"{bookmarkStreamLabel}\"",
    "unable_to_remove_mentions": "Unable to remove mentions from \"{bookmarkStreamLabel}\""
  },
  "dropdown_react_score_expandable": {
    "react_score": "React Score"
  },
  "dropdown_tags": {
    "exclude_tags_error": "Excluded tags not available when tags are selected.",
    "excluded_tags": "Excluded Tags",
    "tags": "Tags",
    "tags_error": "Tags not available when excluded tags are selected."
  },
  "duration_item_request": {
    "duration": "Duration:",
    "duration_limit": "The duration can't be over 01:30:00"
  },
  "editor": {
    "au_back_page_summaries": "Australia Back Page Summaries",
    "au_front_page_summaries": "Australia Front Page Summaries",
    "front_page_summaries": "Front and Back Page Summaries",
    "front_pages": "Front Pages",
    "image_upload_error": "There was an error uploading the image",
    "leading_news_stories": "Leading News Stories",
    "loading": "Loading...",
    "nz_back_page_summaries": "New Zealand Back Page Summaries",
    "nz_front_page_summaries": "New Zealand Front Page Summaries",
    "share_prices": "Share prices",
    "stock_prices": "Stock Prices",
    "stock_prices_table_headings": {
      "dollars_variance": "@:currency_symbol +/-",
      "last": "Last",
      "percentage_variance": "% +/-",
      "stock": "Stock",
      "volume": "Volume"
    },
    "top_trends_table_headings": {
      "online": "Online",
      "print": "Print",
      "radio": "Radio",
      "story": "Story",
      "total": "Total",
      "tv": "TV"
    },
    "twitter_trends": "X {'|'} Twitter Trends",
    "twitter_trends_table_headings": {
      "trending": "Trending on X {'|'} Twitter"
    },
    "view_front_pages": "Click Front page to view full-size"
  },
  "election_why_choose_stream": {
    "video_title": "Why Choose Streem video"
  },
  "email_events_line_chart": {
    "chart_labels": {
      "email_opens": "Email Opens",
      "item_views": "Item Views"
    },
    "email_opens": "Email Opens:",
    "engaging_now": "Engaging Now",
    "item_views": "Item Views:",
    "tooltip": "If Email Opens appear significantly lower than Item Views, this may be because your Organisation's servers block email open data from being collected. Item Views will always be correct as they are monitored by {platformName}"
  },
  "email_events_log_table": {
    "click_amount": "Click Amount",
    "email_address": "Email Address",
    "open_amount": "Open Amount",
    "search_for_recipient": "Search for a recipient"
  },
  "email_field": {
    "add_email": "Add email",
    "clear_all_recipients": "Clear All Recipients",
    "copy_recipients_to_clipboard": "Copy recipients to clipboard",
    "export_recipients_to_csv": "Export Recipients to CSV",
    "filter_recipients": "Filter Recipients",
    "recipient_tag_text": "{name} (Distribution List) - [{recipientsCount} recipients]",
    "remove_recipient": "Remove recipient",
    "remove_recipient_error": "There was an error removing this recipient. Please try again"
  },
  "entity_sentiment_list": {
    "filter_all": "All",
    "heading": "Mentioned in this {mentionType}",
    "search_label": "Mentioned in this article",
    "search_placeholder": "Search",
    "sort_by_label": "Sort by:",
    "sort_most_negative": "Most negative first",
    "sort_most_positive": "Most positive first",
    "sort_sentiment_label": "Sentiment"
  },
  "example_source": "ABC Sydney",
  "expandable_filters": {
    "advanced_keyword_filters": "Advanced Keyword Filters",
    "advanced_keywords_applied": "Advanced keywords applied",
    "all_tags": "All tags",
    "apply": "Apply",
    "author": "Author",
    "authors": "authors",
    "categories": "categories",
    "content": "Content",
    "date": "date",
    "exclude": "Excluding",
    "excluded_keywords": "excluded keywords",
    "excluded_sources": "excluded sources",
    "excluded_tags": "Excluded Tags",
    "external_items": "external items",
    "filter_sets": "Filter Sets",
    "filtering_by": "Filtering by",
    "handle": "Handle",
    "included_mentions": "included mentions",
    "included_sources": "Included Sources",
    "keywords": "keywords",
    "last_saved": "last saved",
    "location": "Locations",
    "minimum_followers": "Minimum Followers",
    "react_score": "React Score",
    "react_score_average": "React Score Average",
    "reset": "Reset",
    "risk_categories": "risk categories",
    "select_date_range": "Select Date Range",
    "sentiment": "sentiment",
    "social_platform": "Social Platforms",
    "sort": "Sort",
    "sorting_by": "Sorting by",
    "source": "Sources",
    "sources": "sources",
    "tag": "Tags",
    "tags": "tags",
    "tiers": "tiers",
    "title": "Mention Stream Filters",
    "verified": "Verified",
    "word_count": "word count"
  },
  "external_item_edit": {
    "add_external_item": "Add External Item",
    "changes_not_saved": "Changes you made so far will not be saved.",
    "delete_external_item_error": "There was an error deleting the External Item.",
    "delete_external_item_message": "This External Item will be permanently deleted from the Mention Stream.",
    "delete_external_item_title": "Delete External Item?",
    "edit_external_item": "Edit External Item",
    "external_item_added": "The External Item \"{externalItem}\" has been added to the Mention Stream \"{firstStreamName}\" | The External Item \"{externalItem}\" has been added to the Mention Stream \"{firstStreamName}\" and {length} other | The External Item \"{externalItem}\" has been added to the Mention Stream \"{firstStreamName}\" and {length} others",
    "external_item_deleted": "External Item deleted",
    "external_item_updated": "Your External Item {externalItem} has been updated",
    "leave_this_page": "Do you want to leave this page?",
    "load_external_item_error": "There was an error loading the External Item",
    "save_external_item_error": "There was an error saving this External Item."
  },
  "external_item_form": {
    "add_source": "Add source",
    "add_source_aria": "source of External Item",
    "add_title": "Add Title",
    "add_title_aria": "Title of External Item",
    "add_url": "Add URL",
    "add_url_aria": "URL of External Item",
    "ave": "AVE (Optional)",
    "ave_tooltip": "Please note that the Advertising Value Equivalency figure you input will impact your organisation's reporting, including Mention Stream and Instant Insights reports.",
    "copy_paste": "Copy and paste a web link associated with item",
    "declaration_must_be_checked": "Declaration must be checked before adding an external item",
    "description": "Add an External Item to one or more Mention Streams and make this content available across all reporting functions. This item will only be visible to others users within your organisation, but not to anyone else on {platformName} who is not in your organisation.",
    "enter_advertisement_rate_aria": "advertisement rate of External Item",
    "enter_amount": "Enter amount in numbers only",
    "enter_amount_aria": "audience of External Item",
    "media_type": "Media Type",
    "mention_streams": "Mention Streams",
    "potential_audience": "Potential Audience (Optional)",
    "potential_audience_tooltip": "Please note that the Potential Audience Reach {lineBreak} figure you input will impact your organisation’s {lineBreak} reporting, including Mention Stream Reports and Instant Insights Reports",
    "publication_date": "Publication Date",
    "select_media_type": "Select a media type",
    "select_mention_streams": "Select mention streams",
    "select_sentiment": "Select sentiment",
    "sentiment": "Sentiment (Optional)",
    "sentiment_tooltip": "Please note that the Sentiment you input will impact your organisation's reporting, including Mention Stream and Instant Insights reports.",
    "source": "Source (Optional)",
    "stream_selected": "Stream selected | Streams selected",
    "summary": "Summary (Optional)",
    "summary_aria": "summary of External Item",
    "terms": "By uploading this content, you/{organisationName} represent and warrant that {organisationName} has all necessary rights and licenses to provide {platformName} with access to this content, and to use it in connection with the services {platformName} provides to you/{organisationName}. {platformName} does not warrant or guarantee the content is covered by any copyright or licensing agreement in effect between {organisationName} and {platformName}. Further, you/ {organisationName} will indemnify {platformName} against any claim of copyright infringement by any third party as it relates to the content you upload. {platformName} is not responsible for any errors or omissions contained within the content, or for the results obtained from the use of the content. It is your responsibility to verify any of the content before relying on it. Finally, you agree not to post, share, email or otherwise distribute this content outside your organisation, including to Facebook, X {'|'} Twitter, LinkedIn or any other social or public network.",
    "url": "URL",
    "validate_maximum_audience_number": "Potential Audience Reach cannot exceed 2 billion.",
    "validate_maximum_ave_number": "AVE cannot exceed 20 million."
  },
  "external_item_manual_add_modal": {
    "title": "Manually Add Mention"
  },
  "external_item_mention_card": {
    "added_by": "Added by {createdBy} at {createdAt} {displayedTimezone}",
    "external": "External",
    "external_item": "External Item",
    "label": "External Item",
    "view_external_item": "VIEW EXTERNAL ITEM"
  },
  "external_item_select_action_modal": {
    "bulk_add_button": "Bulk Add URLs",
    "explanation": "If you're unsure whether the item(s) are already included in our coverage, we recommend checking the link to confirm.",
    "header": "How would you upload/add your item(s)?",
    "manual_add_button": "Manually Add Mention",
    "title": "Add Mentions"
  },
  "external_items_add_workflow": {
    "saving_error": {
      "bulk_add": "Error occurred when adding mentions",
      "manual_add": "Error occurred when saving External Item"
    }
  },
  "external_items_bulk_add_modal": {
    "article_urls_description": "Paste one URL per line. Only valid URLs to supported content can be added.",
    "article_urls_header": "Article URLs",
    "cannot_be_added_details": {
      "duplicated_url": "Can't be added: Duplicated",
      "invalid_url": "Invalid URL",
      "licensing": "Can't be added: Licensing",
      "social_media_link": "Can't be added: Social media links"
    },
    "edit_urls_button": "Edit URLs",
    "no_verification_results": "Server failed to send all the results.",
    "possible_delay_info": "It may take a few minutes for articles to show up in our system. For help, check the docs or contact support.",
    "title": "Bulk Add URLs",
    "total": {
      "already_added": "{urlsCount} in database",
      "can_be_added": "{urlsCount} can be manually added to database",
      "cannot_be_added_plural": "{urlsCount} errors",
      "cannot_be_added_singular": "{urlsCount} error"
    },
    "total_tooltip": {
      "already_added": "Good news! We already have this article in the database.",
      "can_be_added": "This article isn’t in the database yet. You can add it now so we can start tracking it.",
      "cannot_be_added": "We couldn’t process this link. It may be unsupported. If it’s a valid article, contact support for help."
    },
    "urls_limit_already_reached_warning": "Cannot add more URLs.",
    "urls_limit_would_be_exceeded_warning": "Too many URLs ({actualUrlsCount}/{maxUrlsCount}). Ignoring the excessive ones.",
    "verification_error": "Error occurred when checking URLs",
    "verify_button": {
      "in_progress": "Checking",
      "start": "Check"
    }
  },
  "external_playback": {
    "open_full_player_new_tab": "Open Full Player in New Tab"
  },
  "feature_teasers": {
    "has_instant_edit_media_item": {
      "background_color": "#131B62",
      "title": "Instant-Edit Media Item"
    },
    "has_instant_edit_transcript": {
      "background_color": "#131B62",
      "title": "Instant-Edit Transcript"
    },
    "has_social_platform": {
      "background_color": "#9254DE",
      "title": "{platformName} Social"
    },
    "share_online_broadcast": {
      "background_color": "#131B62",
      "title": "Share or Email"
    }
  },
  "file_upload": {
    "file_exceeds_limit_size": "The file {fileName} exceeds the {maxSizeForFile} limit.",
    "no_attachments": "No Attachments",
    "not_accepted_type": "The file {fileName} is not an accepted type.",
    "total_exceeds_limit_size": "Total attachment size would exceed the {maxTotalSize} limit."
  },
  "filter_set_content_preview": {
    "authors_label": "Author ({inclusionType})",
    "content_types_label": "Content Types",
    "excluded": "Excluded",
    "included": "Included",
    "language_label": "Language ({inclusionType})",
    "license": {
      "cla": "CLA",
      "nla": "NLA"
    },
    "page_count_label": "Page Count",
    "range": {
      "from_min": "From {minLabel}",
      "to_max": "To {maxLabel}"
    },
    "tag_label": "Tag ({inclusionType})",
    "title": "Content",
    "word_count_label": "Word Count"
  },
  "filter_set_input_select": {
    "load_filter_set_error": "There was an error loading filter set details",
    "load_filter_sets_error": "There was an error loading filter sets",
    "loading_filter_set_details": "Loading filter set details...",
    "select_filter_set_placeholder": "Select a Filter Set"
  },
  "filter_set_keywords_preview": {
    "boolean_query": "Boolean Query",
    "excluded_keywords": "Excluded Keywords",
    "keywords": "Keywords",
    "must_not_subtitle": "these keywords",
    "must_not_title": "Not",
    "must_subtitle": "of these keywords",
    "must_title": "Must include all",
    "should_subtitle": "of these keywords",
    "should_title": "And any",
    "simple_boolean_error": "Invalid Boolean Query"
  },
  "filter_set_media_items_preview": {
    "accounts_label": "Accounts",
    "all_locations": "All Locations",
    "cald": {
      "all_sources": "All Sources",
      "excluded": "Excluded",
      "label": "CALD",
      "only_cald": "Only CALD"
    },
    "category_label": "Category",
    "domain_authority_label": "Domain Authority",
    "excluded_location_label": "Excluded Location",
    "international_plus_excluded": "Exclude InternationalPlus Sources",
    "international_plus_included": "Include InternationalPlus Sources",
    "location_label": "Location",
    "location_loading_error": "There was an error loading locations",
    "range": {
      "from_min": "From {minLabel}",
      "to_max": "To {maxLabel}"
    },
    "selected_online_content": "Selected Online Content",
    "selected_social_content": "Selected Social Content",
    "selected_tv_content": "Selected TV Content",
    "social_all_accounts": "All Accounts",
    "social_impact_threshold": "Impact Threshold",
    "social_only_verified": "Verified Accounts",
    "view_less": "View Less",
    "view_more": "View More"
  },
  "filter_set_metrics_preview": {
    "advertising_value_equivalency_label": "Advertising Value Equivalency",
    "audience_label": "Potential Audience Reach",
    "desktop_label": "Desktop",
    "impact_score_label": "Impact Score",
    "mobile_label": "Mobile",
    "range": {
      "from_min": "From {minLabel}",
      "to_max": "To {maxLabel}"
    },
    "react_score": {
      "average_label": "Average",
      "controversy_label": "Controversy",
      "emotionality_label": "Emotionality",
      "harm_label": "Harm",
      "label": "React Score",
      "spam_label": "Spam"
    },
    "sentiment_label": "Sentiment",
    "title": "Metrics"
  },
  "filter_set_other_preview": {
    "exclude_external_items": "Exclude External Items",
    "include_external_items": "Include External Items",
    "include_newswire_content": "Display Newswire Content",
    "only_external_items": "Only show External Items",
    "title": "Other"
  },
  "filter_set_preview": {
    "description_label": "Description",
    "go_back": "Go back",
    "group_label": "Group",
    "search_selection_placeholder": "Search in Selection"
  },
  "filter_set_sources_preview": {
    "title": "Sources",
    "view_more": "View More"
  },
  "filter_sets": {
    "add_filter": "Add Filter",
    "banner_description": "With Filter Sets, you can easily create, manage and share your custom filters.",
    "create_filter_set_error": "There was an error creating the filter set",
    "filter_set_applied": "\"{filterSetLabel}\" has been applied to Mention Streams",
    "filter_set_applied_error": "There was an error applying the filter set to Mention Streams",
    "filter_set_created": "\"{filterSetLabel}\" has been created.",
    "filter_set_deleted": "\"{filterSetLabel}\" has been deleted.",
    "filter_set_deleted_error": "There was an error deleting the filter set",
    "filter_set_duplicated": "\"{filterSetLabel}\" has been duplicated.",
    "filter_set_duplicated_error": "There was an error duplicating the filter set",
    "filter_set_removed": "\"{filterSetLabel}\" has been removed from your filter sets.",
    "filter_set_removed_error": "There was an error removing the filter set",
    "filter_set_shared": "\"{filterSetLabel}\" has been shared.",
    "filter_set_updated": "\"{filterSetLabel}\" has been updated.",
    "filters_applied": "Filter Set Applied",
    "label": "Filter set",
    "load_filter_set_error": "There was an error loading filter set details",
    "load_filter_sets_error": "There was an error loading filter sets",
    "loading_filter_set_details": "Loading filter set details...",
    "merge_filters": "Merge",
    "new_filter_set": "New Filter Set",
    "no_query_snippets": "There can be no keyword snippets applied when creating/editing a filter set",
    "replace_filter_set_confirmation": "Do you want to replace them with the selected filter set '{filterSetName}'?",
    "replace_filter_set_message": "{streamCount} of Mention Stream(s) currently have a filter set applied.",
    "replace_filter_set_title": "Replace Filter Set",
    "share_filter_set": "Share {filterSetName}",
    "sort_by_label": "Sort by:",
    "sort_label": "Sort",
    "update_filter_set_error": "There was an error updating the filter set"
  },
  "filter_sets_group": {
    "existing_group": "Existing Group",
    "group_label": "Group Label",
    "label": "Group",
    "load_error": "There was an error loading Filter Set Groups",
    "new_group": "New Group"
  },
  "filter_sets_info": {
    "description": "Description"
  },
  "filter_sets_selection": {
    "applied": "Applied",
    "apply_filter_set_label": "Apply Filter Set",
    "apply_filter_set_warning": "Clicking 'Apply Filter Set' will replace all existing filters in Advanced Filters with the selected filter set.",
    "load_filter_set_error": "There was an error loading filter set details",
    "load_filter_sets_error": "There was an error loading filter sets",
    "loading_filter_set_details": "Loading filter set details...",
    "remove_filter_set_label": "Remove Filter Set",
    "select_filter_set_placeholder": "Select a Filter Set"
  },
  "filter_sets_table": {
    "description_label": "Description",
    "group_label": "Group",
    "mention_streams_label": "Mention Streams",
    "no_results": "No Results",
    "owner_label": "Owner"
  },
  "filter_sets_table_row": {
    "cannot_delete_shared_filter_set_message": "{filterSetLabel} has been shared with {sharedCount} user(s) and hence cannot be deleted. You will have to stop sharing this filter set with other users in order to delete it.",
    "cannot_delete_shared_filter_set_title": "Cannot delete Filter Set",
    "delete_filter_set_label": "Delete filters",
    "delete_filter_set_message": "Deleting this Filter Set will remove it from your list.",
    "delete_filter_set_title": "Delete Filter Set",
    "delete_filter_set_with_streams_error_message": "{filterSetLabel} is currently applied to {streamCount} Stream(s). Please remove the filter set from these Streams before deleting it.",
    "delete_filter_set_with_streams_error_title": "Cannot delete Filter Set",
    "disabled_managed_streams_tooltip": "Filter Sets are unable to be applied to Managed Mention Streams",
    "disabled_view_only_streams_tooltip": "Filter Sets are unable to be applied to Mention Streams shared with view permissions",
    "duplicate_filter_set_label": "Duplicate filters",
    "edit_filter_set_label": "Edit filters",
    "remove_filter_set_message": "Removing this Filter Set will remove it from your list.",
    "remove_filter_set_title": "Remove Filter Set",
    "share_filter_set_label": "Share / Permission",
    "shared_filter_set_status": "Shared filter set",
    "view_filter_set_label": "View filters"
  },
  "filters_autocomplete": {
    "advanced_filters_not_supported": "This Mention Stream does not support Advanced Filters",
    "advanced_filters_tooltip": "Advanced Source Filters",
    "error_fetching_influencers": "Error fetching influencers",
    "no_results_found_for": "No results found for {search}.",
    "source_group": "Source Group",
    "sources_selected": "1 source selected | {count} sources selected",
    "type_at_least": "Type at least {minimumCharacters} characters to search"
  },
  "frontpage_card": {
    "position": "#{position}",
    "since_time": "since {timeInZone}",
    "social_interactions": "social interactions"
  },
  "frontpages": {
    "front_page": "Front Page",
    "fullscreen": "Full screen",
    "select_sources": "Select Sources"
  },
  "frontpages_fullscreen": {
    "close_fullscreen": "Close fullscreen"
  },
  "global": {
    "account_manager": "Account Manager",
    "actions": "Actions",
    "active": "Active",
    "add": "Add",
    "added": "Added",
    "address": "Address",
    "advanced_filters": "Advanced Filters | Advanced Filters (1) | Advanced Filters ({count})",
    "all": "All",
    "analytics": "Analytics",
    "and": "AND",
    "apply": "Apply",
    "approve": "Approve",
    "archive": "Archive",
    "are_you_sure": "Are you sure?",
    "articles": "Articles",
    "ascending": "Ascending",
    "back": "Back",
    "cancel": "Cancel",
    "clear": "Clear",
    "clear_search": "Clear search",
    "click_here": "Click here",
    "close": "Close",
    "close_menu": "Close menu",
    "commented_by": "commented by",
    "confirm": "Confirm",
    "connect": "Connect",
    "contacts": "Contacts",
    "content": "Content",
    "continue": "Continue",
    "copied": "Copied",
    "copy": "Copy",
    "copy_to_clipboard": "Copy to clipboard",
    "create": "Create",
    "date": "Date",
    "date_range": "Date Range",
    "days": {
      "friday": "Friday",
      "monday": "Monday",
      "saturday": "Saturday",
      "sunday": "Sunday",
      "thursday": "Thursday",
      "tuesday": "Tuesday",
      "wednesday": "Wednesday"
    },
    "delete": "Delete",
    "descending": "Descending",
    "description": "Description",
    "discard": "Discard",
    "disconnect": "Disconnect",
    "discover": "Discover",
    "dismiss": "Dismiss",
    "done": "Done",
    "download": "Download",
    "duplicate": "Duplicate",
    "edit": "Edit",
    "email": "Email",
    "enquire": "Enquire",
    "error": "Error",
    "errors": {
      "auth_issue": "Could not authenticate your account. Please try again.",
      "error_loading_data": "Error loading data.",
      "no_accounts_found": "No Accounts found.",
      "something_went_wrong": "Something went wrong. Please try again"
    },
    "filter_sets": "Filter Sets",
    "first_name": "First Name",
    "followers": "Follower | Followers",
    "generate": "Generate",
    "group": "Group",
    "here": "here",
    "insert": "Insert",
    "integrate": "Integrate",
    "integrated": "Integrated",
    "job_title": "Job Title",
    "journalist": "Journalist",
    "journalists": "Journalists",
    "keywords": "Keywords",
    "label": "Label",
    "last_name": "Last Name",
    "learn_more": "Learn more",
    "loading": "Loading...",
    "login": "Login",
    "logo": "Logo",
    "manage": "Manage",
    "max": "Max",
    "media": "Media",
    "media_types": "Media Types",
    "mentioned": "Mentioned",
    "menu": "Menu",
    "min": "Min",
    "name": "Name",
    "new": "New",
    "next": "Next",
    "no": "No",
    "no_data_available": "No Data Available",
    "no_results": "No results",
    "now": "Now",
    "ok": "Okay",
    "or": "OR",
    "outlet": "Outlet",
    "outlets": "Outlets",
    "pdf": "PDF",
    "percentage": "{percentage}%",
    "posted_by": "posted by",
    "posts": "Post | Posts",
    "preview": "Preview",
    "previous": "Previous",
    "privacy": "Privacy",
    "private": "Private",
    "profile": "Profile",
    "profile_picture": "Profile picture",
    "public": "Public",
    "publisher": "Publisher",
    "qr_code": "QR Code",
    "query_snippets": "Keyword Snippets",
    "redo": "Redo",
    "refresh": "Refresh",
    "reject": "Reject",
    "relevance": "Relevance",
    "remove": "Remove",
    "resend": "Resend",
    "reset": "Reset",
    "restricted": "Restricted",
    "retry": "Retry",
    "save": "Save",
    "search": "Search",
    "select": "Select",
    "select_all": "Select all",
    "select_all_total": "Select all ({total})",
    "select_deselect_all": "Select/Deselect all",
    "send": "Send",
    "set": "Set",
    "share": "Share",
    "shared": "Shared",
    "sidebar_collapse": "Collapse Sidebar",
    "sidebar_expand": "Expand Sidebar",
    "sign_in": "Sign in",
    "sms": "SMS",
    "social": "Social",
    "sources": "Sources",
    "submit": "Submit",
    "tagged": "Tagged",
    "tags": "Tags",
    "team": "Team",
    "teams": "Teams",
    "time": "Time",
    "title": "Title",
    "to": "to",
    "today": "Today",
    "total": "Total",
    "total_selected": "{total} Selected",
    "try_again": "Try again",
    "undo": "Undo",
    "update": "Update",
    "upgrade": "Upgrade",
    "upload": "Upload",
    "upload_file": "Upload File",
    "usage": "Usage",
    "user": "User",
    "users": "Users",
    "verified": "Verified",
    "verify": "Verify",
    "view": "View",
    "view_pdf_version": "View PDF Version",
    "warning": "Warning",
    "words": "Words",
    "words_joiner": " and ",
    "words_joiner_ampersand": " & ",
    "words_separator": ", ",
    "yes": "Yes"
  },
  "google_analytics_account_header": {
    "accounts_count": "{count} GA accounts",
    "properties_count": "{count} properties",
    "streams_count": "{count} streams selected",
    "summary_tooltip": "This shows the total number of Google Analytics accounts, properties, and streams you have access to across all your connected accounts."
  },
  "google_analytics_account_item": {
    "load_error": "Failed to load {accountName}.",
    "pill_error": "Error",
    "pill_error_syncing": "Error Syncing",
    "pill_fetch_error": "Error",
    "pill_warning": "Warning",
    "save_error": "Unable to save {accountName}.",
    "sync_error": "Failed to sync {accountName}.",
    "sync_status_synced": "Synced",
    "sync_status_syncing": "Syncing",
    "validation_warning": "{accountName} has a validation error."
  },
  "google_analytics_account_status": {
    "dialog_text": "By clicking disconnect, the connected Google account will be removed from the Integration.",
    "disconnect_account": "Disconnect Account",
    "dropdown_text": "Sign in with Google to authorise read-only access to your Analytics data. You'll briefly leave the platform for OAuth authentication.",
    "dropdown_text_connected": "You're connected as:",
    "dropdown_title": "Google Account",
    "dropdown_title_connected": "Account Connected",
    "oauth_connect_button": "Connect your Google account",
    "oauth_refresh_button": "Re-authenticate",
    "oauth_refresh_message": "Re-authentication needed."
  },
  "google_analytics_accounts_list": {
    "no_personal_accounts": "No accounts found.",
    "no_shared_accounts": "No accounts shared with you.",
    "owned_tab": "Owned",
    "refresh_button": "Refresh",
    "refresh_prompt": "Updated your Google Analytics?",
    "shared_tab": "Shared",
    "sidebar_description_owned": "Owned by you. You can choose which ones are visible to others.",
    "sidebar_description_shared": "Shared with you by other users. Visibility is managed by the owner."
  },
  "google_analytics_activation": {
    "description": "Activate the Google account to manage property and stream selection, and to share access with others.",
    "label": "Activate",
    "tooltip": "Select an account to activate"
  },
  "google_analytics_instructions": {
    "choose_properties_description": "Select which properties and streams you'd like to see from this Google Analytics account.",
    "choose_properties_title": "Choose properties and streams"
  },
  "google_analytics_integration": {
    "dialog_text": "By clicking disconnect, the connected Google account will be removed from the Integration.",
    "disconnect_account": "Disconnect Account",
    "google_analytics": "Google Analytics",
    "google_analytics_subtext": "The Google Analytics integration provides you with website traffic that was driven by PR for all your news coverage that contains backlinks to your website.",
    "logo_alt": "Google Analytics logo",
    "manage_integration_aria_label": "Manage google analytics integration",
    "manage_integration_button": "Manage Integration",
    "modal_title": "Manage Google Analytics Integrations",
    "sidebar_title": "Connected Google Analytics accounts"
  },
  "google_analytics_integration_legacy": {
    "create_integration_error": "Unable to create the Google Analytics Integration",
    "fetch_service_account_error": "Unable to fetch Google Analytics service account",
    "ga4_property": "GA4 Property",
    "google_analytics": "Legacy Google Analytics",
    "google_analytics_logo_alt": "Google Analytics logo",
    "google_analytics_subtext": "This legacy integration is maintained temporarily to support earlier setups. We recommend using the newer Google Analytics integration above for the latest and supported setup.",
    "property_id_label": "Google Analytics Property ID",
    "provide_analytics_ids_subtext": "Next, provide the GA4 Property ID, Stream ID and URL and click ‘Integrate’ to connect your Google Analytics account to {organisationName}.",
    "remove_integration_alert": "Remove Google Analytics Integration?",
    "remove_integration_button": "Remove Integration",
    "remove_integration_error": "There was an error deleting the Integration",
    "set_up_analytics_alert": "{clickHere} to learn how to set up a Google Analytics integration for {organisationName}.",
    "set_up_analytics_subtext": "To set up Google Analytics, add {organisationName} as an authorised user by copying the following email address and adding it as a ‘View-Only’ user in your Google Analytics account.",
    "stream_id": "Stream ID",
    "stream_id_label": "Google Analytics Stream ID",
    "stream_url": "Stream URL",
    "stream_url_label": "Google Analytics Stream URL",
    "stream_url_placeholder": "Enter the website URL the Stream ID corresponds to"
  },
  "google_analytics_integration_modal": {
    "modal_title": "Manage Google Analytics Integrations",
    "sidebar_title": "Connected Google Analytics accounts",
    "success_save_accounts": "Your Google Analytics Accounts have been updated.",
    "unsaved_changes_message": "You have unsaved changes. Are you sure you want to discard them?",
    "unsaved_changes_title": "Unsaved Changes"
  },
  "google_analytics_no_accounts": {
    "message": "Select an account from the left to get started.",
    "title": "Nothing to display yet"
  },
  "google_analytics_no_properties": {
    "no_account_selected_message": "No Google Analytics account selected. Please select an account on the left to continue.",
    "no_properties_message": "No properties found for the selected account. Check your GA permissions or try another account. | No properties found for the {count} selected accounts. Check your GA permissions or try another account."
  },
  "google_analytics_selected_properties": {
    "no_data_streams_tooltip": "No data streams available for this property.",
    "no_properties_for_account": "No properties or streams found for this account.",
    "select_all_properties": "Select all properties",
    "select_all_properties_count": "Select all properties ({count})",
    "tooltip_not_enabled": "Activate {accountName} to select properties and streams"
  },
  "google_analytics_service": {
    "error_save_accounts": "Failed to save the following accounts: {accounts}.",
    "save_error": "Failed to save Google Analytics accounts."
  },
  "google_analytics_store": {
    "error_fetch_all_accounts": "Could not retrieve your Google Analytics accounts.",
    "error_fetch_personal_accounts": "Could not retrieve your own accounts.",
    "error_fetch_properties": "Could not retrieve properties for {accountName}.",
    "error_fetch_shared_accounts": "Could not retrieve shared accounts.",
    "error_no_accounts_with_properties": "No accounts with properties to save.",
    "error_no_active_accounts": "No active accounts to save.",
    "error_no_properties_data": "No properties data for account {accountId}.",
    "error_sync_accounts": "Could not sync Google Analytics accounts."
  },
  "google_analytics_syncing_state": {
    "sync_error_message": "Failed to sync {accountName}. Please close the modal and try again. If the problem persists, please contact support.",
    "syncing_message": "Getting your properties and data streams ready from {accountName}. Once this is done, you'll be ready to manage your account!"
  },
  "google_analytics_team_selector": {
    "assign_team_title": "Assign Team",
    "assign_teams_description": "Select one or more teams that have access to data from this account.",
    "assign_teams_title": "Assign teams",
    "select_teams": "Select teams",
    "teams_selected": "{count} team selected | {count} teams selected",
    "tooltip_no_account": "Select an account to activate",
    "tooltip_not_enabled": "Activate {accountName} to assign to teams",
    "validation_error": "Please select at least one team."
  },
  "help_articles": "View Help Articles",
  "helpers": {
    "action_notifications": {
      "added_to": "Added to {label}",
      "removed_from": "Removed from {label}"
    },
    "array": {
      "on_front_page": "on front page",
      "on_page_with_number": " on page {numbers} | {' '}on pages {numbers}"
    },
    "attachment": {
      "could_not_load_image": "Could not load image."
    },
    "errors": {
      "connection_error_detail": "Please check your device's Internet connection and retry.",
      "connection_error_message": "The server could not be reached",
      "forbidden_message": "You are not authorised to access the requested resource.",
      "server_error_detail": "If the problem persists please contact your Account Manager.",
      "server_error_message": "Oops, something went wrong"
    },
    "mentions": {
      "order_options": {
        "asc": "Ascending",
        "desc": "Descending"
      },
      "sort_options": {
        "advertisement_rate": "Advertising Value Equivalency",
        "audience": "Potential Audience",
        "comment_count": "Comments",
        "domain_authority": "Domain Authority",
        "engagement_count": "Engagement",
        "follower_count": "Follower Count",
        "impact_score": "Impact Score",
        "journalist_author": "Journalist/Author",
        "like_count": "Likes",
        "react_enrichment_aggregate_emotionality": "React Score - Emotionality",
        "react_enrichment_aggregate_fakeness": "React Score - Controversy",
        "react_enrichment_aggregate_harmful": "React Score - Harm",
        "react_enrichment_aggregate_spam": "React Score - Spam",
        "risk_enrichment_react_score": "React Score Average",
        "sentiment": "Sentiment",
        "social_author": "Author",
        "source": "Source",
        "timestamp": "Time",
        "word_count": "Word Count"
      }
    },
    "ordinal_numbers": {
      "few_rule": "rd",
      "one_rule": "st",
      "other_rule": "th",
      "two_rule": "nd"
    },
    "reports": {
      "download_pdf": "Download a copy of the report as a PDF",
      "download_report": "Download report",
      "populate_report_with_language": "This will populate your report in the chosen language",
      "report_created_cancel_label": "Open Reports Tab",
      "report_created_message": "Your report is now building. It will appear in the Reports tab when it is ready.",
      "report_created_title": "Report Saved"
    },
    "sources": {
      "magazine": {
        "label": "Magazine",
        "related_type_magazine_article_app_label": "Magazine Articles",
        "related_type_magazine_article_label": "Magazine Article",
        "source_label": "Magazine"
      },
      "online": {
        "label": "Online",
        "related_type_article_app_label": "Online Articles",
        "related_type_article_label": "Online Article",
        "source_label": "Publisher"
      },
      "platform_labels": {
        "blog": "Blogs",
        "bluesky": "Bluesky",
        "facebook": "Facebook",
        "forum": "Forums",
        "instagram": "Instagram",
        "linkedin": "LinkedIn",
        "reddit": "Reddit",
        "tiktok": "TikTok",
        "twitter": "X {'|'} Twitter",
        "youtube": "YouTube"
      },
      "podcast": {
        "label": "Podcast",
        "related_type_podcast_episode_app_label": "Podcast Episode",
        "related_type_podcast_episode_label": "Podcast Episodes",
        "source_label": "Podcast"
      },
      "print": {
        "label": "Print",
        "related_type_paper_article_app_label": "Print Articles",
        "related_type_paper_article_label": "Print Article",
        "source_label": "Publisher"
      },
      "radio": {
        "label": "Radio",
        "related_type_radio_clip_app_label": "Radio Clip",
        "related_type_radio_clip_label": "Radio Clip",
        "related_type_radio_story_app_label": "Radio Stories",
        "related_type_radio_story_label": "Radio Stories",
        "source_label": "Station"
      },
      "social": {
        "label": "Influencer Social",
        "related_type_blog_post_app_label": "Blog Posts",
        "related_type_blog_post_label": "Blog Post",
        "related_type_bluesky_post_app_label": "Bluesky",
        "related_type_bluesky_post_label": "Bluesky Post",
        "related_type_exorde_reddit_post_app_label": "Reddit Posts",
        "related_type_exorde_reddit_post_comment_app_label": "Reddit Comments",
        "related_type_exorde_reddit_post_comment_label": "Reddit Post Comment",
        "related_type_exorde_reddit_post_label": "Reddit Post",
        "related_type_facebook_post_app_label": "Facebook",
        "related_type_facebook_post_label": "Facebook Post",
        "related_type_forum_post_app_label": "Forum Posts",
        "related_type_forum_post_label": "Forum Post",
        "related_type_instagram_comment_app_label": "Instagram Comments",
        "related_type_instagram_comment_label": "Instagram Comment",
        "related_type_instagram_post_app_label": "Instagram",
        "related_type_instagram_post_label": "Instagram Post",
        "related_type_linkedin_comment_app_label": "LinkedIn Comments",
        "related_type_linkedin_comment_label": "LinkedIn Comment",
        "related_type_linkedin_post_app_label": "LinkedIn",
        "related_type_linkedin_post_label": "LinkedIn Post",
        "related_type_reddit_post_app_label": "Reddit Posts",
        "related_type_reddit_post_comment_app_label": "Reddit Comments",
        "related_type_reddit_post_comment_label": "Reddit Post Comment",
        "related_type_reddit_post_label": "Reddit Post",
        "related_type_tiktok_comment_app_label": "TikTok Comments",
        "related_type_tiktok_comment_label": "TikTok Comment",
        "related_type_tiktok_video_app_label": "TikTok",
        "related_type_tiktok_video_label": "TikTok Post",
        "related_type_tweet_app_label": "Twitter",
        "related_type_tweet_label": "Tweet",
        "related_type_youtube_video_app_label": "YouTube",
        "related_type_youtube_video_label": "YouTube Video",
        "source_label": "Source"
      },
      "tv": {
        "label": "TV",
        "related_type_tv_caption_app_label": "Spoken",
        "related_type_tv_caption_label": "Caption",
        "related_type_tv_logo_appearance_app_label": "On-screen Logos",
        "related_type_tv_logo_appearance_label": "Logo Appearance",
        "related_type_tv_story_app_label": "TV Stories",
        "related_type_tv_story_label": "TV Stories",
        "related_type_tv_super_app_label": "On-screen Text",
        "related_type_tv_super_label": "Super",
        "source_label": "Channel"
      }
    }
  },
  "impact_score_disclaimer": "Impact gives you a quick indicator of an item's significance by using proprietary technology and algorithms to blend together several industry metrics (Sentiment, Potential Audience, Domain Authority, etc) into one clear value.",
  "impact_score_widget": {
    "label": "Impact Score",
    "scores": {
      "high": "High",
      "low": "Low",
      "medium": "Medium"
    }
  },
  "inline_filters": {
    "add_external_item": "Add External Item",
    "advanced_filters": "Advanced Filters",
    "edit_mention_stream": "Edit Mention Stream",
    "edit_tagged_folder": "Edit Tagged Folder",
    "filter_by": "Filter by",
    "generate_report": "Generate Report",
    "react_score": "React Score",
    "remove_filter_set_to_edit_filters": "Remove Filter Set to edit your filters.",
    "reset_filters": "Reset Filters",
    "select_date_range": "Select Date Range",
    "sources": "Sources"
  },
  "inline_player": {
    "forward": "Forward",
    "full_screen": "Full screen",
    "go_back": "Go back",
    "open_request_media_item": "Open request media item",
    "pause": "Pause",
    "play": "Play",
    "play_error": "There was something wrong playing this clip",
    "request_media_item": "Request Media Item",
    "restriction_message": "Due to licensing restrictions imposed on all Media Monitoring Organisations and this program not being of news and current affairs nature, we’ve restricted the duration of content that can be viewed for this item. If you believe this to be an error please request the Media Item and note the issue and we will resolve it immediately. Alternatively please contact your Account Manager directly.",
    "rewind": "Rewind",
    "share_media_item": "Share media item"
  },
  "inline_player_controls": {
    "1_hour": "1 hour",
    "1_minute": "1 minute",
    "5_minutes": "5 minutes",
    "forward_1_hour": "Forward 1 hour",
    "forward_1_minute": "Forward 1 minute",
    "forward_5_minutes": "Forward 5 minutes",
    "rewind_1_hour": "Rewind 1 hour",
    "rewind_1_minute": "Rewind 1 minute",
    "rewind_5_minutes": "Rewind 5 minutes"
  },
  "input_autocomplete": {
    "no_results_found_for": "No results found for {search}.",
    "type_at_least": "Type at least {minimumCharacters} characters to search"
  },
  "input_colored_tags": {
    "label": "Tags",
    "placeholder": "+ Add a tag",
    "search_tags_error": "There was an error searching tags",
    "start_typing_to_select": "Start typing to select or create a tag"
  },
  "input_date": {
    "day": {
      "friday": "Fri",
      "monday": "Mon",
      "saturday": "Sat",
      "sunday": "Sun",
      "thursday": "Thu",
      "tuesday": "Tue",
      "wednesday": "Wed"
    },
    "default_button_label": "Set",
    "from_title": "From",
    "interval_label_with_value": "Interval {interval}",
    "next_label": "Next",
    "previous_interval_label": "Previous Interval",
    "previous_label": "Previous",
    "to_title": "To"
  },
  "input_select": {
    "dropdown_button_label": "Show options",
    "dropdown_button_label_for": "Show options for {label}"
  },
  "input_select_with_checkboxes": {
    "minimum_option_description": "Please select at least {minSelected} option."
  },
  "input_tags": {
    "create_tag": "Create tag"
  },
  "input_validation": {
    "minimum_words_required": "Minimum of {count} words required"
  },
  "insight_chart_popup": {
    "no_mentions_found": "No mentions found"
  },
  "insights_action_menu": {
    "add_to_list": "Add to List",
    "add_to_list_no_outreach_profiles": "No contacts with Outreach profiles are available",
    "ai_visibility_project": "AI Visibility Settings",
    "archive": "Archive",
    "delete": "Delete",
    "duplicate": "Duplicate",
    "duplicate_chart": "Duplicate",
    "edit": "Edit",
    "generate_pdf": "Generate PDF",
    "generate_scheduled_report": "Generate Scheduled Report",
    "generate_xlsx": "Generate XLSX",
    "regenerate": "Regenerate",
    "share": "Share",
    "show": "Show",
    "star": "Star",
    "unarchive": "Unarchive",
    "unstar": "Unstar"
  },
  "insights_actions": {
    "selected_count": "{count} Selected"
  },
  "insights_add_chart_button": {
    "label": "Add Chart"
  },
  "insights_advanced_filters_button": {
    "has_advanced_filters": "Advanced filters have been applied"
  },
  "insights_archived": {
    "description": "Access all your archived reports and dashboards in one place.",
    "most_recent": "Most Recent",
    "title": "Archived"
  },
  "insights_archived_table": {
    "all_archived": "All Archived",
    "archived_date": "Archived Date",
    "mention_streams": "Mentions/Social Streams",
    "most_recent": "@:insights_archived.most_recent"
  },
  "insights_chart": {
    "collapse_chart": "Collapse chart",
    "date_range": "Date Range: {dateRange}",
    "expand_chart": "Expand chart",
    "media_outreach_selected": "({count}) Media Outreach selected"
  },
  "insights_chart_detail_interaction_title": {
    "clear_selection": "Clear Selection"
  },
  "insights_chart_detail_mentions": {
    "generate_csv": "Generate Mention Stream Report as CSV",
    "generate_pdf": "Generate Mention Stream Report as PDF",
    "generate_social_csv": "Generate Social Stream Report as CSV",
    "generate_social_pdf": "Generate Social Stream Report as PDF"
  },
  "insights_chart_detail_monitoring_project": {
    "select_llm_entities": "Select Entities",
    "select_llm_models": "Select AI Models"
  },
  "insights_chart_detail_monitoring_project_empty": {
    "description": "Configure models, locations, and prompts to start tracking how LLMs mention your brand",
    "heading": "Set up your AI Visibility settings"
  },
  "insights_chart_detail_report_created": {
    "cancel_label": "Open Downloads Tab",
    "message": "Your report is now building. It will appear in the Downloads tab when it is ready."
  },
  "insights_chart_detail_settings_widget": {
    "ai_visibility": "AI Visibility",
    "ai_visibility_answers": "AI Visibility Answers",
    "chart": "Chart",
    "chart_settings_key_messages_form": "Key Messages",
    "chart_settings_media_releases_form": "Media Releases",
    "chart_settings_select_social_stream_form": "Social Streams",
    "chart_settings_stock_symbol_form": "Stock Symbol",
    "create_report": "Generate Report",
    "export_options": "Export",
    "generate_csv": "Download CSV",
    "generate_pdf": "Download PDF",
    "labels": "Labels",
    "linked_mention_stream": "Linked Mention Stream",
    "linked_social_stream": "Linked Social Stream",
    "load_mention_ids_error": "There was an error loading mention IDs",
    "media_items": "Media Items",
    "no_geographic_data": "No geographic data available at this level.",
    "no_social_stream_selected": "No social stream selected.",
    "no_stream_selected": "No stream selected.",
    "settings": "Settings",
    "social_items": "Social Items",
    "social_posts": "Social Posts",
    "social_streams": "Social Streams",
    "tag_selected": "Tag Selected"
  },
  "insights_chart_detail_view": {
    "back_to_dashboard": "Back to the dashboard",
    "chart_not_found": "Chart not found",
    "chart_not_found_message": "The chart you are looking for could not be found.",
    "deleting_chart": "Deleting chart...",
    "details": "Details",
    "details_description": "Customise your chart by selecting Mention Stream, Media Types, & other metrics to get tailored results.",
    "details_description_social": "Customise your chart by selecting Social Stream, Platforms, & other metrics to get tailored results.",
    "no_settings_component": "No settings component",
    "notes": "Notes",
    "notes_character_limit_tooltip": "Notes are limited to {limit} characters in PDF reports",
    "notes_exceeded_message": "Only the first {limit} characters will appear in PDF reports",
    "notes_placeholder": "Add notes to this chart"
  },
  "insights_chart_filters_button_dropdown": {
    "advanced_filters_on": "Advanced Filters: On",
    "custom_filters_applied": "Custom Filters Applied",
    "date_range": "Date Range: {dateRange}",
    "media_types": "Media Types: {mediaTypes}",
    "reset_to_default": "Reset to Default",
    "view_by": "View By: {interval}"
  },
  "insights_dashboard": {
    "back_to_dashboards": "Back to Dashboards",
    "confirm_save_label": "Save Dashboard",
    "confirm_save_message": "By clicking save, changes will be applied to all Instant Insights charts",
    "confirm_save_title": "Are you sure?",
    "dashboard_not_found": "Dashboard not found",
    "dashboard_not_found_description": "The dashboard you are looking for could not be found.",
    "delete_chart": "Delete {chart}",
    "delete_chart_error": "Unable to delete chart",
    "delete_chart_loading": "Deleting chart...",
    "delete_chart_message": "By clicking confirm, the selected chart will be removed from the dashboard.",
    "delete_chart_success": "Deleted chart",
    "duplicate_error": "Unable to duplicate dashboard",
    "duplicate_loading": "Duplicating dashboard...",
    "duplicate_success": "Duplicated dashboard",
    "generate_pdf_error": "Error generating PDF for dashboard",
    "generate_pdf_loading": "Generating PDF for dashboard...",
    "generate_scheduled_report_error": "Error generating scheduled report for dashboard",
    "generate_scheduled_report_success": "Scheduled report saved",
    "generate_xlsx_error": "Error generating XLSX for dashboard",
    "generate_xlsx_loading": "Generating XLSX for dashboard...",
    "loading_dashboard": "Loading dashboard...",
    "loading_dashboard_error": "Unable to load dashboard",
    "loading_dashboard_error_description": "The dashboard you are looking for could not be loaded.",
    "loading_media_releases_error": "Unable to load media releases",
    "loading_social_integrations_error": "Unable to load social integrations",
    "loading_source_filters_error": "Unable to load source filters",
    "new_dashboard": "New Dashboard",
    "save_dashboard_error": "Unable to save dashboard",
    "save_dashboard_loading": "Saving dashboard...",
    "save_dashboard_success": "Dashboard saved",
    "share_error": "Unable to share dashboard",
    "share_loading": "Sharing dashboard...",
    "star_error": "Unable to star dashboard",
    "star_loading": "Starring dashboard...",
    "star_success": "Starred dashboard",
    "unstar_error": "Unable to unstar dashboard",
    "unstar_loading": "Unstarring dashboard...",
    "unstar_success": "Unstarred dashboard"
  },
  "insights_dashboard_add_chart_form": {
    "description": "Select a chart to add it to your dashboard.",
    "no_results": "No results found.",
    "title": "Add New Chart"
  },
  "insights_dashboard_empty_state": {
    "description": "Get started by adding a chart or template to your dashboard.",
    "new_badge": "New",
    "new_chart": "Add Chart",
    "templates": "Templates",
    "templates_description": "Choose a template to configure your dashboard",
    "title": "Add your first chart"
  },
  "insights_dashboard_form": {
    "add_chart": "Add Chart",
    "description_placeholder": "Description of dashboard (optional)",
    "filters": "Filters",
    "group_syndications": "Group Syndications",
    "reorder": "Re-order",
    "replace_streams_tooltip": "All charts on this dashboard will be replaced with the selected Mention Stream",
    "select_social_platforms": "Select Social Platforms",
    "select_social_platforms_tooltip": "Select social streams first",
    "select_streams_tooltip": "Select Mention Streams first",
    "stream_picker_context": "Dashboard",
    "title_placeholder": "Untitled Dashboard"
  },
  "insights_dashboard_reorder_charts_form": {
    "delete_all": "Delete all",
    "description": "Click and drag to re-order charts.",
    "no_charts": "No charts to re-order.",
    "title": "Re-order Charts"
  },
  "insights_dashboard_sidebar_actions": {
    "create_dashboard": "Create Dashboard",
    "more_dashboards": "More Dashboards",
    "recent_dashboards": "Recent Dashboards:"
  },
  "insights_dashboard_templates": {
    "ai_visibility": {
      "description": "Understand how your brand appears across leading AI platforms, including visibility, sentiment, share of voice and cited sources. Use these insights to benchmark competitors and strengthen your brand’s presence in AI-generated responses.",
      "disabled_tooltip": "You've reached your AI Visibility allowance limit. Contact your account manager to increase it.",
      "name": "AI Visibility"
    },
    "blank": {
      "description": "Start from scratch. Add widgets as needed.",
      "name": "Blank Template"
    },
    "brand_benchmark": {
      "configure_description": "Configure your dashboard by applying a Mention Stream and date range to your charts. You can adjust these at any time.",
      "description": "Compare and benchmark earned media metrics between you and your competitors.",
      "name": "Brand Benchmark"
    },
    "chart_labels": {
      "sov_audience_reach": "Share of Voice (Potential Audience Reach)",
      "sov_ave": "Share of Voice (AVE)",
      "sov_mentions": "Share of Voice (Total Mentions)",
      "sov_social_shares": "Share of Voice (Social Shares)",
      "sov_timeline_line": "Share of Voice Timeline (Line)",
      "sov_timeline_stacked_bar": "Share of Voice Timeline (Stacked Vertical Bar)",
      "top_articles_advertisement_rate": "Top Articles (AVE)",
      "top_articles_audience": "Top Articles (Audience Reach)"
    },
    "configure": {
      "accounts": "Accounts",
      "description": "To start tracking coverage, choose a Mention Stream, media types, and a date range for your charts. You can adjust these settings anytime.",
      "media_outreach": "Media Outreach",
      "media_outreach_description": "Select up to 12 Media Outreach items",
      "mention_stream": "Mention Stream",
      "mention_stream_description": "Select 1 Mention Stream for all the charts",
      "platforms": "Platforms",
      "posts": "Posts",
      "social_post": "Social Post",
      "social_post_description": "Select a single social post to include in the chart",
      "social_stream": "Social Stream",
      "social_stream_description": "Select 1 Social Stream for all the charts",
      "title": "Define"
    },
    "earned_media_insights": {
      "configure_description": "Configure your dashboard by applying a Mention Stream and date range to your charts. You can adjust these at any time.",
      "description": "A complete snapshot of your earned media coverage measuring key metrics that demonstrate the impact and breadth of your mentions.",
      "name": "Earned Media Insights"
    },
    "earned_social_insights": {
      "configure_description": "Configure your dashboard by applying a Mention Stream, Social Stream, and date range to your charts. You can adjust these at any time.",
      "description": "Unify earned and social into one view with charts and metrics that demonstrate the reach, trends, and shifts in campaigns across media channels.",
      "name": "Earned + Social Insights"
    },
    "modal": {
      "add_template": "Add template",
      "cancel": "Cancel",
      "charts_in_template": "Charts in template",
      "configure_title": "Configure Template (optional)",
      "instruction": "Choose a template below to quickly customise your dashboard.",
      "next": "Next",
      "previous": "Previous",
      "select_template_hint": "Click template to view details",
      "title": "Select Template",
      "upgrade_badge": "Upgrade"
    },
    "outreach_campaign_performance": {
      "configure_description": "Configure your dashboard by applying a Mention Stream, date range, and Media Outreach to your charts. You can adjust these at any time.",
      "description": "Measure how your Media Outreach translates into coverage.",
      "name": "Outreach Campaign Performance"
    },
    "social_campaign_performance": {
      "configure_description": "Configure your dashboard by applying a Social Stream, date range, and Social post to your charts. You can adjust these at any time.",
      "description": "Analyse the engagement and conversations surrounding your social media campaign with charts and metrics that highlight your owned social posts.",
      "name": "Social Campaign Performance"
    },
    "social_insights": {
      "configure_description": "Configure your dashboard by applying a Social Stream and date range to your charts. You can adjust these at any time.",
      "description": "Analyse audience engagement, themes, and sentiment across Social Platforms to uncover emerging trends and brand opportunities.",
      "name": "Social Insights"
    },
    "unified_media_campaign": {
      "configure_description": "Configure your dashboard by applying a Mention Stream, Social Stream, date range, and Media Outreach to your charts. You can adjust these at any time.",
      "description": "An all-in-one campaign template that unifies earned media, outreach, and social metrics into one view providing a comprehensive snapshot of end-to-end campaign performance across media channels.",
      "name": "Unified Media Campaign"
    }
  },
  "insights_dashboard_usage": {
    "credits_error": "Data will not refresh until the allowance resets. Contact your account manager to increase allowance.",
    "credits_refresh": "Last refresh: {date}",
    "credits_reset": "Credit reset: {date}",
    "credits_used": "{usage} ({percentage}) answers",
    "credits_warning": "{percentage} of your answer allowance used. Contact your account manager to avoid interruptions."
  },
  "insights_dashboards": {
    "dashboards_shared": "No dashboards shared | One dashboard shared | {count} dashboards shared",
    "dashboards_shared_with": "with no users | with {count} user | with {count} users",
    "description": "Begin tracking realtime Instant Insights by creating a new dashboard or viewing one of your previously saved and shared dashboards.",
    "greeting": "Hello, {name}",
    "last_edited": "@:insights_dashboards_table.last_edited"
  },
  "insights_dashboards_table": {
    "all_dashboards": "All Dashboards",
    "all_tab": "All",
    "applied_date_range": "Applied Date Range",
    "dashboards": "Dashboards",
    "last_edited": "Last edited",
    "mention_streams": "Mention Streams",
    "monitoring_count": "AI Visibility Usage ({count} of {max})",
    "monitoring_tab": "AI Visibility",
    "owner": "Owner",
    "stream": "Stream"
  },
  "insights_downloads": {
    "description": "Access your history of previously downloaded reports all in one place.",
    "most_recent": "@:insights_downloads_table.most_recent",
    "title": "Downloads"
  },
  "insights_downloads_link_button": {
    "article_tooltip": "View Online",
    "csv_tooltip": "Download CSV",
    "pdf_tooltip": "Download PDF"
  },
  "insights_downloads_table": {
    "all_downloads": "All Downloads",
    "archive": "Archive",
    "download_processing": "Processing",
    "mention_streams": "Mention Streams",
    "most_recent": "Most Recent",
    "regenerate": "Regenerate"
  },
  "insights_errors": {
    "apply_filters_failed": "Failed to apply advanced filters. Please try again.",
    "create_filters_failed": "Failed to create advanced filters configuration",
    "filters_required": "Filters are required",
    "form_data_unavailable": "Form data is not available",
    "load_recent_dashboards": "Unable to load recent dashboards",
    "stream_required": "Stream is required for creating filters"
  },
  "insights_generate_report_button": {
    "generate_scheduled_report": "Scheduled Report",
    "no_charts_available": "Please add at least one chart to generate a report."
  },
  "insights_generating": {
    "generating": "Generating..."
  },
  "insights_landing_page": {
    "archive_error": "Unable to archive {type}",
    "archive_loading": "Archiving {type}...",
    "archive_success": "Archived {type}",
    "archived": "archived item | archived items",
    "confirm_archive_message": "Are you sure you want to archive this {type}? | Are you sure you want to archive these {type}?",
    "confirm_archive_title": "Are you sure?",
    "confirm_delete_label": "Delete",
    "confirm_delete_message": "Are you sure you want to delete this {type}? | Are you sure you want to delete these {type}?",
    "confirm_delete_title": "Are you sure?",
    "dashboards": "dashboard | dashboards",
    "delete_error": "Unable to delete {type}",
    "delete_loading": "Deleting {type}...",
    "delete_success": "Deleted {type}",
    "downloads": "download | downloads",
    "duplicate_error": "Unable to duplicate {type}",
    "duplicate_loading": "Duplicating {type}...",
    "duplicate_success": "Duplicated {type}",
    "error_loading_items": "Unable to load {type}",
    "error_loading_recent_items": "Unable to load recent {type}",
    "generate_pdf_error": "Error generating PDF for {type}",
    "generate_pdf_loading": "Generating PDF for {type}...",
    "generate_xlsx_error": "Error generating XLSX for {type}",
    "generate_xlsx_loading": "Generating XLSX for {type}...",
    "regenerate_error": "Unable to regenerate {type}",
    "regenerate_loading": "Requesting regeneration for {type}...",
    "regenerate_success": "Requested regeneration for {type}",
    "share_error": "Unable to share {type}",
    "share_loading": "Sharing {type}...",
    "shared": "shared item | shared items",
    "star_error": "Unable to star {type}",
    "star_loading": "Starring {type}...",
    "star_success": "Starred {type}",
    "starred": "starred item | starred items",
    "unarchive_error": "Unable to unarchive {type}",
    "unarchive_loading": "Unarchiving {type}...",
    "unarchive_success": "Unarchived {type}",
    "unstar_error": "Unable to unstar {type}",
    "unstar_loading": "Unstarring {type}...",
    "unstar_success": "Unstarred {type}"
  },
  "insights_landing_page_target_tabs": {
    "dashboards": "Dashboards",
    "reports": "Reports"
  },
  "insights_metrics_dropdown": {
    "audience": "Audience Reach",
    "ave": "AVE",
    "clicked_through": "Clicked Through",
    "clicked_through_percentage": "Clicked Through (%)",
    "clicks": "Total Clicks",
    "contacts_targeted": "Contacts Targeted",
    "delivered": "Delivered",
    "delivered_percentage": "Delivered (%)",
    "engagement": "Total Engagement",
    "engagement_rate": "Engagement Rate",
    "impact_score": "Impact Score",
    "impressions": "Impressions",
    "media_outreach": "Media Outreach",
    "mentions": "Total Mentions",
    "opened": "Opened",
    "opened_percentage": "Opened (%)",
    "opens": "Opens",
    "performance": "Total Engagement",
    "placeholder": "Select Metrics",
    "posts": "Total Social Mentions",
    "reach": "Reach",
    "selected": "{selected} selected",
    "sent": "Media Outreach",
    "sentiment": "Sentiment",
    "social_posts": "Social Posts",
    "social_shares": "Total Social Shares",
    "top_emoji": "Top Emoji"
  },
  "insights_new_dashboard_button": {
    "label": "New Dashboard"
  },
  "insights_plus_teaser": {
    "description": "{platformName}’s Insights Plus reporting includes rich and informative visualisations to understand your brand’s media coverage, whilst being specified and compiled to your reporting needs.",
    "dismiss": "Dismiss",
    "find_out_more": "Find out more",
    "title": "Insights Plus Reports",
    "viewed_item_error": "Unable to complete this request."
  },
  "insights_product_name": "Insights",
  "insights_recent_dashboard": {
    "default_summary": "Insights Dashboard.",
    "default_title": "Dashboard",
    "last_edited": "Last edited: {date}"
  },
  "insights_recent_dashboards": {
    "no_dashboards": "No recent dashboards. Create a new dashboard to get started.",
    "title": "Recent Dashboards"
  },
  "insights_scheduled_reports_table": {
    "all_schedules": "All Schedules",
    "confirm_delete_message": "Are you sure you want to delete this schedule?",
    "confirm_delete_title": "Delete schedule?",
    "delete_error": "Unable to delete schedule",
    "delete_success": "Deleted schedule",
    "delivery_days": "Delivery days",
    "delivery_time": "Delivery time",
    "edit_error": "Unable to update schedule",
    "edit_success": "Updated schedule",
    "load_dashboard_error": "Unable to load the dashboard for this schedule",
    "load_edit_error": "Unable to load schedule details",
    "load_error": "Unable to load schedules",
    "mention_streams": "Mention streams",
    "pause": "Pause schedule",
    "pause_error": "Unable to pause schedule",
    "pause_success": "Paused schedule",
    "paused_tooltip": "Resume schedule",
    "recipient_list": "Recipients: {recipients}",
    "recipients": "Recipients",
    "resume_error": "Unable to resume schedule",
    "resume_success": "Resumed schedule",
    "show_inactive_schedules": "Show inactive schedules"
  },
  "insights_schedules": {
    "description": "Manage all your schedules in one place, ready for download and review.",
    "title": "Schedules"
  },
  "insights_shared": {
    "all_shared": "All Shared",
    "description": "Access all your shared dashboards in one place, ready for download and review.",
    "last_edited": "@:insights_dashboards_table.last_edited",
    "shared_with_me": "Shared with me",
    "shared_with_others": "Shared with others",
    "title": "Shared"
  },
  "insights_sidebar_header": {
    "instant_insights": "Instant Insights",
    "navigation_aria_label": "Insights navigation"
  },
  "insights_sov_metric_dropdown": {
    "audience_reach": "Audience Reach",
    "ave": "AVE",
    "description": "Select the metric to display in the chart",
    "mentions": "Mentions",
    "select_metric_type": "Select Metric",
    "social_shares": "Social Shares",
    "social_streams_disabled_tooltip": "This metric is not available when Social Streams are selected",
    "title": "Select Metric"
  },
  "insights_starred": {
    "description": "Access all your starred dashboards and reports in one place, ready for download and review.",
    "most_recent": "@:insights_starred_table.most_recent",
    "title": "Starred"
  },
  "insights_starred_table": {
    "all_starred": "All Starred",
    "mention_streams": "Mention/Social Streams",
    "most_recent": "Most Recent"
  },
  "insights_stream_picker": {
    "clear_mention_stream": "Clear mention stream",
    "mention_streams": "Mention Streams",
    "mention_streams_for": "Mention Streams for {name}",
    "metric_type_disabled_social_streams_tooltip": "Social Streams are not available for the selected metric type",
    "no_streams_found": "No Streams Found.",
    "select_mention_stream": "Select 1 Mention Stream",
    "select_mention_streams": "Select Mention Streams",
    "select_social_stream": "Select 1 Social Stream",
    "select_social_streams": "Select Social Streams",
    "selected_mention_stream": "{count} Mention Stream selected | {count} Mention Streams selected",
    "selected_social_stream": "{count} Social Stream selected | {count} Social Streams selected",
    "shared_streams": "Shared Streams",
    "social_streams": "Social Streams",
    "social_streams_for": "Social Streams for {name}"
  },
  "instant_download_request_preview": {
    "additional_recipients_heading": "Additional Recipients.",
    "channel_heading": "Channel",
    "check_format_audio_media_item_heading": "Audio-based Media Item",
    "check_format_both_audio_heading": "Audio-based Media Item + Transcript (Word, .docx)",
    "check_format_both_video_heading": "Video-based Media Item + Transcript (Word, .docx)",
    "check_format_email_text": "You'll receive an email when this is ready, and can also download this via the Media & Transcripts page.",
    "check_format_title": "Check the format",
    "check_format_transcript_heading": "Transcript (Word, .docx)",
    "check_format_video_media_item_heading": "Video-based Media Item",
    "check_information_title": "Check the information",
    "confirm_button": "Confirm & Download",
    "day_time_heading": "Day & Time",
    "duration_heading": "Duration",
    "keyword_heading": "Keyword",
    "media_item_audio_source_description": "Listen to the Media Item you have edited below, click back to re-edit the item",
    "media_item_source_title": "Check your Media Item",
    "media_item_type": "Media Item",
    "media_item_video_source_description": "Watch the Media Item you have edited below, click back to re-edit the item",
    "mention_stream_heading": "Mention Stream",
    "program_heading": "Program",
    "summary_heading": "Summary",
    "thumbnail_heading": "Thumbnail",
    "thumbnail_image_alt": "Media Request Thumbnail",
    "title_heading": "Title",
    "transcript_request_audio_source_description": "Listen to the Transcript Request you have edited below, click back to re-edit the item",
    "transcript_request_source_title": "Check your Transcript Request",
    "transcript_request_type": "Transcript Request",
    "transcript_request_video_source_description": "Watch the Transcript Request you have edited below, click back to re-edit the item"
  },
  "instant_insights": {
    "activities_toast": "{chartSettingsTitle} - Activities linked",
    "chart_added": "{chartLabel} has been added.",
    "confirm_changes_description": "By clicking confirm, changes will be applied to all Instant Insights charts.",
    "confirm_media_types_changes": "New Media Type(s) selected",
    "confirm_stream_changes": "New Mention Stream(s) selected",
    "copy_name": "Copy of {dashboardName}",
    "dashboard_duplicated": "Dashboard Duplicated!",
    "dashboard_name_updated": "Dashboard name updated: {selectedDashboardName}",
    "dashboard_no_permission": "You don't have permission to share this dashboard.",
    "dashboard_reset": "Dashboard Reset",
    "dashboard_updated": "Dashboard Updated",
    "description": "{chartSettingsTitle} - Description",
    "duplicate": "Duplicate",
    "export_options": "{chartSettingsTitle} - Export Options",
    "generate_pdf": "Generate PDF",
    "generate_report_error": "Unable to export {chartTitle}",
    "generate_report_loading": "Exporting {chartTitle}...",
    "generate_report_success": "{chartTitle} Exported",
    "generate_xlsx_report_confirm_label": "Generate XLSX",
    "generate_xlsx_report_description": "Export your dashboard data to an Excel file",
    "generate_xlsx_report_title": "Generate XLSX",
    "key_message_toast": "{chartSettingsTitle} - Key Messages",
    "load_charts_config_error": "Unable to load chart settings",
    "load_dashboard_error": "Unable to load saved dashboards",
    "media_outreach_toast": "{chartSettingsTitle} - Media Outreach linked",
    "media_types_toast": "{chartSettingsTitle} - Media Types",
    "mention_stream": "Mention Streams",
    "mention_stream_toast": "{chartSettingsTitle} - Mention Streams",
    "mention_streams_and_media_types_toast": "{chartSettingsTitle} - Mention Streams and Media Types",
    "new_dashboard": "New Dashboard",
    "pdf_generating": "{reportTitle} PDF generating",
    "reset": "Reset",
    "save_insights_dashboard_error": "There was a problem saving the Insights Dashboard",
    "saved_dashboard_description": "The \"{selectedDashboardName}\" has been saved",
    "share": "Share",
    "social_stream_toast": "{chartSettingsTitle} - Social Stream linked",
    "stock_symbol_toast": "{chartSettingsTitle} - Stock Symbol",
    "title": "{chartSettingsTitle} - Title",
    "title_and_description": "{chartSettingsTitle} - Title and description",
    "undo": "Undo",
    "unsaved_description": "By leaving this page, any edits made to your insights will not be saved.",
    "unsaved_title": "Unsaved Instant Insights",
    "view": "View",
    "xlsx_generating": "{reportTitle} XLSX generating"
  },
  "instant_insights_add_chart_dropdown": {
    "no_results": "No results",
    "select_chart": "Select Chart",
    "select_chart_description": "Select the chart you wish to add to your Instant Insights dashboard",
    "select_outreach_chart_description": "Select the chart you wish to add to your Outreach dashboard"
  },
  "instant_insights_add_chart_form": {
    "account": "account | accounts",
    "configure_all_streams": "Please configure all selected streams",
    "mention_streams": "Mention Streams",
    "no_chart_selected": "Please select a chart type",
    "no_key_messages_added": "Please add at least one key message",
    "no_media_releases_selected": "Please select at least one media release",
    "no_mention_stream_selected": "No mention stream selected",
    "no_social_stream_selected": "Please select one social stream",
    "post": "post | posts",
    "posts_selected_across_platforms": "{postCount} {postLabel} selected across {platformCount} {platformLabel}",
    "select_activity_types": "Select Activity Types",
    "select_assignees": "Select Assignees",
    "select_combined_streams": "Select Mention & Social Streams",
    "select_combined_streams_description": "Select up to {maximumSelectedStreams} Mention Streams and Social Streams combined to appear within the chart",
    "select_date_range": "Select Date Range",
    "select_date_range_description": "Select a Date Range for this chart",
    "select_insights_metrics": "Select Insights Metrics",
    "select_insights_metrics_description": "Select up to 6 Insights Metrics to appear within the chart",
    "select_max_streams": "Select up to {count} Mention Streams to appear within the chart",
    "select_media_types": "Select Media Types",
    "select_media_types_description": "Select Media Types to appear within the chart",
    "select_media_types_tooltip": "Select Mention Streams first",
    "select_mention_streams": "Select Mention Stream | Select Mention Streams",
    "select_mention_streams_description": "Select Mention Stream to appear within the chart | Select Mention Streams to appear within the chart",
    "select_min_streams": "Please select at least {count} Stream | Please select at least {count} Streams",
    "select_posts": "Posts",
    "select_posts_description": "Select which posts to include in the chart",
    "select_social_accounts": "Accounts",
    "select_social_accounts_description": "Select Social Accounts to filter posts for within the chart",
    "select_social_platforms": "Select Social Platforms",
    "select_social_platforms_description": "Select Social Platforms to appear within the chart",
    "select_social_platforms_tooltip": "Select social streams first",
    "select_social_streams": "Select Social Stream | Select Social Streams",
    "select_social_streams_description": "Select Social Stream to appear within the chart | Select Social Streams to appear within the chart",
    "select_statuses": "Select Statuses",
    "select_stock_symbol": "Select Stock Symbol",
    "select_stock_symbol_description": "Select a Stock Symbol to appear within the chart",
    "select_tags": "Select Tags",
    "show_contacts_only_label": "Only show contacts that match Outreach database",
    "show_contacts_only_tooltip": "Filters the results to show only contacts that are available in Outreach, making it easier to find contacts you can use for outreach.",
    "social_streams": "Social Streams",
    "view_by": "View by",
    "view_by_description": "Select a range to display the axis"
  },
  "instant_insights_add_chart_sidebar": {
    "add_instant_insights_chart": "Add an Instant Insights Chart",
    "add_outreach_analyse_chart": "Add an Outreach Chart",
    "edit_instant_insights_chart": "Edit Instant Insights Chart",
    "edit_outreach_analyse_chart": "Edit Outreach Chart"
  },
  "instant_insights_chart_details_input": {
    "description": "Description (optional)",
    "description_placeholder": "Summary",
    "displayed_at_the_top": "This is displayed at the top of your chart",
    "displayed_while_hovering": "This is displayed while hovering over the information icon next to the chart title and on PDF exports",
    "reset_to_default_description": "Reset to default description",
    "reset_to_default_title": "Reset to default title"
  },
  "instant_insights_chart_google_analytics_account_dropdown": {
    "connect_label": "Connect your Google account",
    "description": "Select Google Analytics Integration for this chart",
    "legacy_integration": "Displaying Legacy Google Analytics Integration data. Select or integrate a newer Google Analytics setup above.",
    "placeholder": "Select an integration",
    "title": "Select a Google Analytics Integration"
  },
  "instant_insights_chart_intervals": {
    "day": "Day",
    "description": "Chart Axis Interval Selection",
    "disabled_reason_month": "The selected date range is too short to display a month interval",
    "disabled_reason_quarter": "The selected date range is too short to display a quarter interval",
    "disabled_reason_week": "The selected date range is too short to display a week interval",
    "disabled_reason_year": "The selected date range is too short to display a year interval",
    "month": "Month",
    "quarter": "Quarter",
    "week": "Week",
    "year": "Year"
  },
  "instant_insights_chart_variant_dropdown": {
    "bar_chart": "Bar Chart",
    "bar_horizontal_chart": "Horizontal Bar Chart",
    "bar_horizontal_stacked_chart": "Stacked Horizontal Bar Chart",
    "bar_stacked_chart": "Stacked Vertical Bar Chart",
    "doughnut_chart": "Doughnut Chart",
    "key_insight_chart": "Insight Chart",
    "line_area_chart": "Line Area Chart",
    "line_chart": "Line Chart",
    "map_chart": "Map Chart",
    "no_results": "No results",
    "pie_chart": "Pie Chart",
    "radar_chart": "Radar Chart",
    "select_chart_type": "Select Chart Type",
    "select_chart_type_description": "Select chart type to appear within the chart",
    "table_chart": "Table Chart",
    "word_cloud_chart": "Word Cloud Chart"
  },
  "instant_insights_charts": {
    "advertising_value_equivalency": {
      "description": "Cumulative Advertising Value Equivalency by media type for the selected coverage period.",
      "title": "Advertising Value Equivalency"
    },
    "automated_sentiment": {
      "description": "Percentage of positive, trending positive, neutral, trending negative and negative coverage as rated by a third party automated sentiment tool.",
      "title": "Automated Sentiment"
    },
    "coverage_by_media_type": {
      "description": "Total mentions by media type over the selected coverage period.",
      "popup_title": "{media} items",
      "title": "Coverage by Media Type"
    },
    "coverage_volume_and_analytics_timeline": {
      "description": "A breakdown of mentions by media type with the Google Analytics Users metric over the selected coverage period.",
      "empty_state": {
        "button_label": "Select Google Analytics Account",
        "description": "No Google Analytics data found"
      },
      "title": "Coverage Volume & Website Traffic Timeline"
    },
    "coverage_volume_and_potential_audience_reach_table": {
      "description": "A breakdown of mentions by media type with cumulative potential audience over the selected coverage period.",
      "title": "Coverage Volume & Potential Audience Reach (Table)"
    },
    "coverage_volume_and_potential_audience_reach_timeline": {
      "description": "A breakdown of mentions by media type with cumulative potential audience over the selected coverage period.",
      "title": "Coverage Volume & Potential Audience Reach Timeline"
    },
    "coverage_volume_and_referral_traffic_timeline": {
      "description": "A breakdown of website traffic referred by online coverage in this Mention Stream.",
      "empty_state": {
        "button_label": "Select Google Analytics Account",
        "description": "No Google Analytics data found"
      },
      "title": "Referral Coverage & Traffic Timeline"
    },
    "coverage_volume_and_stock_price": {
      "description": "A breakdown of coverage volume and stock price over the selected coverage period.",
      "empty_state": {
        "button_label": "Select Stock Symbol",
        "description": "No Stock Symbol selected"
      },
      "title": "Coverage Volume & Stock Price"
    },
    "coverage_volume_breakdown": {
      "description": "Total mentions by platform over the selected coverage period.",
      "popup_title": "{media} items",
      "title": "Mentions By Platform"
    },
    "coverage_volume_timeline": {
      "description": "A breakdown of mentions by media type over the selected coverage period.",
      "title": "Coverage Volume Timeline"
    },
    "desktop_vs_mobile_readership": {
      "description": "A breakdown of desktop and mobile readership of online coverage.",
      "title": "Desktop vs Mobile Readership"
    },
    "domain_authority": {
      "description": "A breakdown of Online coverage using Domain Authority scoring from Moz.",
      "title": "Domain Authority"
    },
    "emoji_count": {
      "description": "Display up to 7 emojis that appeared the most across all mentions for a selected Social Stream.",
      "title": "Emoji Count"
    },
    "error_loading_media_outreach": "There was an error loading Media Outreach",
    "facebook_engagement_metric": {
      "description": "Facebook reactions breakdown over the selected period, showing total likes, love, haha, wow, sad, and angry counts for online coverage.",
      "title": "Facebook Engagement Metric"
    },
    "front_page_online": {
      "description": "Displays the highest position a story reached on a digital front page. Each story is only counted once. ",
      "title": "Volume of Online Coverage by Position"
    },
    "front_page_print": {
      "description": "Displays the position an article reached on a front page. Each story is only counted once. ",
      "title": "Volume of Print Coverage by Page"
    },
    "geographic_spread_city_chart": {
      "description": "Bar chart indicates the volume of coverage within each city. Data excludes state, national and international content up to 8 cities.",
      "title": "Geographic Spread by City (Chart)"
    },
    "geographic_spread_city_map": {
      "description": "Displays content based on the location of the source. Circle size indicates the volume of coverage within that area. Cities data excludes state, national and international content.",
      "title": "Geographic Spread by City (Map)"
    },
    "geographic_spread_country_chart": {
      "description": "Bar chart indicates the volume of coverage within each country.",
      "title": "Geographic Spread by Country (Chart)"
    },
    "geographic_spread_country_map": {
      "description": "Displays content based on the location of each source within each country. Circle size indicates the volume of coverage within each country.",
      "title": "Geographic Spread by Country (Map)"
    },
    "geographic_spread_region_chart": {
      "description": "Bar chart indicates the volume of coverage within each region.",
      "title": "Geographic Spread by Region (Chart)"
    },
    "geographic_spread_region_map": {
      "description": "Displays content based on the location of each source within a region. Circle size indicates the volume of coverage within each region.",
      "title": "Geographic Spread by Region (Map)"
    },
    "geographic_spread_state_chart": {
      "description": "Bar chart indicates the volume of coverage within each state. State data excludes national and international content.",
      "title": "Geographic Spread by State (Chart)"
    },
    "geographic_spread_state_map": {
      "description": "Displays content based on the location of the source. Circle size indicates the volume of coverage within that area. State data excludes national and international content.",
      "title": "Geographic Spread by State (Map)"
    },
    "key_bluesky_influencers": {
      "description": "Bluesky users with the highest followings that appeared in a selected social stream.",
      "title": "Top Bluesky Influencers"
    },
    "key_instagram_influencers": {
      "description": "Instagram users with the highest followings that appeared in a selected social stream.",
      "title": "Top Instagram Influencers"
    },
    "key_messages": {
      "description": "Distribution of specific terms within your coverage.",
      "empty_state": {
        "button_label": "Add Key Messages",
        "description": "No Key Messages defined"
      },
      "title": "Key Messages"
    },
    "key_twitter_influencers": {
      "description": "Twitter users with the highest followings that appeared in a selected social stream.",
      "title": "X | Twitter Influencers"
    },
    "key_youtube_influencers": {
      "description": "YouTube users with the highest followings that appeared in a selected social stream.",
      "title": "Top YouTube Influencers"
    },
    "leading_brands": {
      "description": "The most frequently mentioned organisations within the Mention Stream. Font size indicates the frequency of the keyword by volume. Click on a keyword to display coverage of that keyword in the Mention Stream.",
      "title": "Leading Organisation"
    },
    "leading_hashtags": {
      "description": "Display up to 30 hashtags based on their frequency across all mentions for a selected Social Stream.",
      "title": "Leading Hashtags"
    },
    "leading_online_journalists": {
      "description": "Top 10 Online journalists ranked by volume of content published.",
      "title": "Leading Online Journalists"
    },
    "leading_online_sources": {
      "description": "Top 10 Online sources ranked by volume of mentions.",
      "title": "Leading Online Sources"
    },
    "leading_print_journalists": {
      "description": "Top 10 Print journalists ranked by volume of content published.",
      "title": "Leading Print Journalists"
    },
    "leading_print_sources": {
      "description": "Top 10 Print sources ranked by volume of mentions.",
      "title": "Leading Print Sources"
    },
    "leading_radio_programs": {
      "description": "Top 10 Radio programs ranked by volume of mentions.",
      "title": "Leading Radio Programs"
    },
    "leading_tv_programs": {
      "description": "Top 10 TV programs ranked by volume of mentions.",
      "title": "Leading TV Programs"
    },
    "media_impact_timeline": {
      "description": "Average published or broadcast time by media type over the selected coverage period.",
      "title": "Average Published or Broadcast Time by Media Type"
    },
    "media_items": "{value} Media Item | {value} Media Items",
    "media_items_with_type": "{value} {type} Item | {value} {type} Items",
    "mention_benchmark_timeline": {
      "description": "Compare the current period's volume to the previous period's volume.",
      "title": "Mention Benchmark Timeline"
    },
    "mention_stream_insights_summary": {
      "description": "An insights summary of new mentions in your selected Mention Stream over the defined time period.",
      "title": "Mention Stream Insights Summary"
    },
    "outreach_activity_timeline": {
      "description": "A breakdown of activities made by your organisation over the selected timeframe.",
      "title": "Outreach Activity Timeline"
    },
    "outreach_coverage_timeline": {
      "description": "Coverage associated with Media Outreach coverage over time",
      "empty_state": {
        "button_label": "Select Media Outreach",
        "description": "No linked Media Outreach"
      },
      "title": "Media Outreach & Coverage Timeline"
    },
    "outreach_insights_summary": {
      "description": "An overview of the performance of your finalised pitches and media releases.",
      "title": "Outreach Insights Summary"
    },
    "outreach_performance_table": {
      "description": "Clicks and Open Rates for Media Outreach",
      "empty_state": {
        "button_label": "Select Media Outreach",
        "description": "No linked Media Outreach"
      },
      "title": "Media Outreach Performance"
    },
    "outreach_top_engaged_contacts_table": {
      "description": "Clicks and Open Rates for Media Outreach by Contact",
      "empty_state": {
        "button_label": "Select Media Outreach",
        "description": "No linked Media Outreach"
      },
      "title": "Top Engaged Contacts"
    },
    "potential_audience_reach": {
      "description": "Cumulative Potential Audience Reach by media type for the selected coverage period.",
      "title": "Potential Audience Reach"
    },
    "react_score_breakdown": {
      "description": "Breakdown of mentions for low, moderate and high react scores of your selected mention stream.",
      "empty_state": {
        "button_label": "Select A Mention Stream",
        "description:": "No Mention Stream Found"
      },
      "title": "React Score Breakdown"
    },
    "react_score_timeline": {
      "description": "Chart shows Average React Scores over the selected period of time including Overall React Score, Harm, Controversy, Spam, and Emotionality as calculated by our AI machine learning models.",
      "title": "React Score Timeline"
    },
    "remove_chart_description": "By clicking confirm, the selected chart will be removed from the dashboard.",
    "remove_chart_title": "Remove {chartType} chart",
    "sentiment_benchmark": {
      "description": "Percentage of positive, trending positive, balanced, trending negative and negative coverage.",
      "title": "Sentiment Benchmark"
    },
    "sentiment_breakdown": {
      "description": "Percentage of positive, trending positive, balanced, trending negative and negative coverage.",
      "title": "Sentiment Breakdown"
    },
    "sentiment_timeline": {
      "description": "Fluctuations in negative, trending negative, balanced, trending positive and positive coverage over time.",
      "title": "Sentiment Timeline"
    },
    "setup_google_integration": "Set up a Google Analytics Integration →",
    "share_of_voice": {
      "description": "A comparison of Mention Streams by volume.",
      "empty_state": {
        "button_label": "Select Mention Streams",
        "description": "No Mention Streams to compare"
      },
      "title": "Share of Voice"
    },
    "share_of_voice_timeline": {
      "description": "A comparison of Mention Streams by volume, over the selected coverage period.",
      "empty_state": {
        "button_label": "Select Mention Streams",
        "description": "No Mention Streams to compare"
      },
      "title": "Share of Voice Timeline"
    },
    "shares_by_type": "{value} {type} Shares",
    "social_engage_performance": {
      "description": "A breakdown of the performance of your social engagement over the selected coverage period.",
      "title": "Total Social Engage Performance"
    },
    "social_insights_summary": {
      "description": "An insights summary of new mentions in your selected Social Stream over the defined time period.",
      "title": "Social Insights Summary"
    },
    "social_post_highlight": {
      "description": "Select a post and see its Total Engagement, Engagement Rate, Impressions, Audience Reach, Likes, Comments, Total Clicks, and Shares",
      "empty_state": {
        "button_label": "Select a Social Post",
        "description": "No Social Post Selected"
      },
      "title": "Social Post Highlight"
    },
    "stream_vs_stream": {
      "description": "Comparison of earned and social mentions over time.",
      "empty_state": {
        "no_linked_stream": "No linked Stream",
        "select_linked_stream": "Select Linked Stream"
      },
      "title": "Earned vs Social Media"
    },
    "themes": {
      "description": "The most frequently mentioned keywords found within the Mention Stream. Font size indicates the frequency of the keyword by volume. Click on a keyword to display coverage of that keyword in the Mention Stream.",
      "title": "Themes"
    },
    "top_articles_table": {
      "description": "Top Articles by Advertising Value Equivalency or Potential Audience Reach.",
      "title": "Top Articles"
    },
    "top_bluesky_posts": {
      "description": "Display up to 7 Bluesky posts which have the highest total engagement (likes + replies + reposts).",
      "title": "Top Bluesky Posts"
    },
    "top_facebook_pages": {
      "description": "Facebook Pages with the most page likes that appeared in a selected Social Stream.",
      "title": "Top Facebook Pages"
    },
    "top_facebook_posts": {
      "description": "Display up to 7 Facebook posts which have the highest total engagement (likes + comments + shares).",
      "title": "Top Facebook Posts"
    },
    "top_instagram_posts": {
      "description": "Display up to 7 Instagram posts which have the highest total engagement (likes + comments).",
      "title": "Top Instagram Posts"
    },
    "top_linkedin_posts": {
      "description": "Display up to 7 LinkedIn posts which have the highest total engagement (likes + comments).",
      "title": "Top LinkedIn Posts"
    },
    "top_performing_post": {
      "description": "Your top performing post based on total engagement and reach.",
      "title": "Top Performing Post"
    },
    "top_tiktok_videos": {
      "description": "Display up to 7 TikTok videos which have the highest total engagement (likes + comments + shares).",
      "title": "Top TikTok Videos"
    },
    "top_tweets": {
      "description": "Display up to 7 tweets which have the highest total engagement (likes + replies + retweets).",
      "title": "Top Tweets"
    },
    "top_youtube_videos": {
      "description": "Display up to 7 YouTube videos which have the highest total engagement (likes + comments).",
      "title": "Top YouTube Videos"
    },
    "total_audience_reach": {
      "description": "Total Audience Reach by media type for the selected coverage period.",
      "title": "Total Audience Reach"
    },
    "total_social_shares": {
      "description": "Shows the cumulative number of times traditional media items have been shared across social media platforms.",
      "title": "Total Social Shares"
    },
    "trajaan": {
      "empty_state": {
        "button_label": "Set up AI Visibility",
        "description": "No linked AI Visibility settings"
      }
    },
    "trajaan_sentiment": {
      "title": "LLM Sentiment"
    },
    "trajaan_top_authors": {
      "title": "Top Cited Journalists"
    },
    "trajaan_top_domains": {
      "title": "Top Cited Domains"
    },
    "trajaan_top_outlets": {
      "title": "Top Cited Media Outlets"
    },
    "trajaan_visibility": {
      "title": "AI Visibility Benchmark"
    },
    "trajaan_word_cloud": {
      "title": "LLM Word Cloud"
    },
    "user_rated_sentiment": {
      "description": "Percentage of positive, trending positive, neutral, trending negative and negative coverage as rated by your organisation.",
      "title": "Self Rated Sentiment"
    }
  },
  "instant_insights_dashboard_charts": {
    "add_chart": "Add Chart",
    "chart_name": "Chart Name",
    "delete_all": "Delete all",
    "order": "Order"
  },
  "instant_insights_dashboard_form": {
    "charts_reorder_description": "Click and drag to re-order charts. Click “Bin” to delete charts.",
    "charts_reorder_title": "Re-order or delete charts",
    "dashboard_name_description": "This is displayed at the top of your dashboard"
  },
  "instant_insights_edit_dashboard_sidebar": {
    "dashboard_name_error_tooltip": "Dashboard must have a label",
    "edit_dashboard": "Edit Dashboard"
  },
  "instant_insights_empty_state": {
    "add_chart": "Add Chart",
    "description": "Get started by adding a chart to your dashboard",
    "title": "Add your first chart"
  },
  "instant_insights_errors": {
    "google_analytics": "This chart is not displaying as expected. Please verify your Google Analytics account is set-up correctly as well as ensure your permissions are up to date."
  },
  "instant_insights_export_options": {
    "title": "INCLUDE WHEN EXPORTING"
  },
  "instant_insights_media_releases_dropdown": {
    "no_results": "No results",
    "select_media_outreach": "Select Media Outreach",
    "select_media_outreach_description": "Select up to {count} at a time",
    "select_up_to": "Select up to {count}",
    "selected_media_outreach": "({count}) Media Outreach selected"
  },
  "instant_insights_media_types_dropdown": {
    "placeholder": "Select Media Types",
    "selected_media_types": "1 Media Type selected | {count} Media Types selected"
  },
  "instant_insights_post_selector": {
    "load_posts_error": "There was an error loading posts",
    "no_posts_found": "No posts found for the selected accounts and date range",
    "select_all_info": "Selected posts are locked to this moment in time and won't automatically update if you change the date range",
    "show_selected": "Show Selected"
  },
  "instant_insights_report_tabs": {
    "add_existing": "Add Existing",
    "confirm_dashboard_name": "Confirm dashboard name",
    "create_new": "Create New",
    "edit_dashboard_name": "Edit dashboard name",
    "new_dashboard": "New Dashboard",
    "shared_with_others": "This dashboard is shared with other team members.",
    "shared_with_you": "This dashboard has been shared with you."
  },
  "instant_insights_toolbar": {
    "add_chart": "Add Chart",
    "edit_dashboard": "Edit Dashboard",
    "group_syndication_description": "By selecting this option, all syndicated news coverage will be counted as a single item.",
    "group_syndications": "Group Syndications",
    "selected_media_types": "1 Media Type selected | {count} Media Types selected",
    "unable_to_save_changes": "You are unable to save changes to this shared dashboard."
  },
  "integrations": {
    "outreach": "Outreach",
    "saml": "SAML Single Sign-On",
    "social_integrations": "Social Integrations",
    "team_communications": "Team Communications",
    "website_analytics": "Website Analytics"
  },
  "international_max_radio_selector": {
    "allow_content": "Allow content from InternationalMax sources",
    "exclude": "Exclude",
    "include": "Include"
  },
  "journalist_detail": {
    "latest_media": "Latest Media",
    "no_mentions_found": "No mentions found"
  },
  "journalist_enquiries_form": {
    "add_comment": "Add Comment",
    "add_comment_placeholder": "Add a comment",
    "add_description_placeholder": "Add a description to this enquiry",
    "add_placeholder": "+ Add",
    "add_title_placeholder": "Add a title",
    "assignees_label": "Assignees:",
    "comments_label": "Comments:",
    "created_label": "Created:",
    "delete_enquiry": "Delete Enquiry",
    "delete_enquiry_message": "Enquiries cannot be recovered.",
    "description_label": "Description:",
    "due_date_label": "Due Date:",
    "errors": {
      "add_assignee": "There was an error adding the assignee",
      "add_journalist": "There was an error adding the journalist",
      "add_tag": "There was an error adding the tag",
      "delete_enquiry": "There was an error deleting the enquiry",
      "load_assignees": "There was an error loading the assignees",
      "load_comments": "There was an error loading the comments",
      "load_journalists": "There was an error loading the journalists",
      "load_page": "There was an error loading this page",
      "load_tags": "There was an error loading the tags",
      "remove_assignee": "There was an error removing the assignee",
      "remove_comment": "There was an error removing the comment",
      "remove_journalist": "There was an error removing the journalist",
      "remove_tag": "There was an error removing the tag",
      "save_comment": "There was an error saving the comment",
      "save_enquiry": "There was an error saving the enquiry",
      "search_assignees": "There was an error searching assignees",
      "search_journalists": "There was an error searching journalists",
      "search_tags": "There was an error searching tags"
    },
    "journalist_image_alt": "Journalist image",
    "journalists_label": "Journalists:",
    "priority_high": "High",
    "priority_label": "Priority:",
    "priority_low": "Low",
    "priority_medium": "Medium",
    "search_assignees_placeholder": "Type to find assignees",
    "search_journalists_placeholder": "Type to find journalists",
    "status_closed": "Closed",
    "status_label": "Status:",
    "status_open": "Open",
    "tags_label": "Tags:",
    "title_required": "Title must not be blank"
  },
  "journalist_enquiry_events_list": {
    "item": "item | items"
  },
  "keywords_editor": {
    "case_sensitive_label": "Case-sensitive",
    "keywords_error": "Please enter a keyword before saving.",
    "keywords_exclusion_label": "Keyword/s Exclusions",
    "keywords_exclusion_placeholder": "Inflation, cost of living",
    "keywords_label": "Keyword/s",
    "keywords_placeholder": "Economy, interest rates",
    "keywords_subtext": "You can add multiple comma-separated keyword/s to be tracked as a bundle or individually.",
    "match_coverage_label": "Match coverage that contains",
    "match_coverage_option_all": "All Keyword/s",
    "match_coverage_option_one_or_more": "One or more Keyword/s",
    "use_advanced_operators_warning": "Please select 'Boolean Query' if you'd like to use advanced operators such as 'OR' or 'AND'"
  },
  "language_dropdown": {
    "default": "Default",
    "default_label": "Select Language",
    "default_language_label": "default ({defaultLanguage})",
    "label": "Language",
    "placeholder": "Select a language"
  },
  "launchpad": {
    "add_external_item": "Add External Item",
    "contact_party": "Contact {contactParty} at {linkText} to get setup",
    "create_mention_stream": "Create Mention Stream",
    "current_primary_mention_stream": "Your Primary Mention Stream for your Launchpad",
    "edit_mention_stream": "Edit Mention Stream",
    "edit_social_stream": "Edit Social Stream",
    "edit_tagged_folder": "Edit Tagged Folder",
    "error_setting_primary_mention_stream": "There was an error setting the Primary Mention Stream!",
    "filter_mentions": "Filter Mentions",
    "generate_report": "Generate Report",
    "mention_benchmark": "Mentions Benchmark",
    "no_mentions": "You have no Mention Streams to monitor.",
    "primary_mention_stream": "Your Primary Mention Stream for your Launchpad.",
    "set_as_primary_mention_stream": "Set as your Primary Mention Stream.",
    "set_named_as_primary_mention_stream": "Set {name} as your Primary Mention Stream.",
    "share_of_voice": "Share of Voice",
    "stream_notification_watcher_count": "There is 1 new mention. | There are {mentionCount} new mentions.",
    "toast_title": "{chartSettingsTitle} - Mention Streams",
    "toast_updated_title": "{toastTitle} updated",
    "unable_to_load_settings": "Unable to load Launchpad Settings",
    "unable_to_save_settings": "Unable to save Launchpad Chart Settings",
    "undo": "Undo"
  },
  "launchpad_action_buttons": {
    "add_mention_stream": "Add a Mention Stream",
    "add_social_stream": "Add a Social Stream",
    "build_report": "Build a Report",
    "create_instant_insights": "Create Instant Insights",
    "create_media_release": "Create a Media Release",
    "curate_email_report": "Curate an Email Report",
    "manage_notifications": "Manage Notifications",
    "schedule_social_post": "Schedule a Social Post"
  },
  "launchpad_cer_audience": {
    "email_open": "Email Opens",
    "engaging_now": "Engaging now",
    "header_tooltip": "Audience engagement with all email reports sent.",
    "item_view": "Item Views",
    "label": "Email Audience",
    "load_error": "Error loading data.",
    "no_data": "You currently have no DER Audience metrics"
  },
  "launchpad_cer_delivery_stats": {
    "label": "Daily Email Report Delivery Status",
    "load_error": "Error loading data.",
    "no_data": "You currently have no recent Daily Email Reports",
    "recipients": "The number of recipients of Daily Email Reports.",
    "try_again": "Try again"
  },
  "launchpad_cer_delivery_stats_row": {
    "delayed": "Delayed",
    "delivered": "Delivered",
    "no_subject": "No Subject",
    "on_schedule": "On Schedule",
    "scheduled_at": "Scheduled at",
    "view_online": "View Online"
  },
  "launchpad_dashboard": {
    "collapse_tabs": "Minimise",
    "customise_launchpad": "Customise Launchpad",
    "expand_tabs": "Expand",
    "greeting": "Hello {userFirstName}",
    "unable_to_load_settings": "Unable to load Launchpad Settings",
    "unable_to_save_settings": "Unable to save Launchpad Settings"
  },
  "launchpad_dashboard_contact_account_manager": {
    "account_manager": "Account Manager",
    "description": "{title}Contact your {supportLink} for more information."
  },
  "launchpad_dashboard_date_range_picker": {
    "tooltip": "Select your date range for this widget"
  },
  "launchpad_dashboard_demo_chart": {
    "company_one": "Company One",
    "company_two": "Company Two"
  },
  "launchpad_dashboard_empty_state": {
    "monitoring_description": "Get started by adding a Mention Stream",
    "monitoring_submit_button_label": "Mention Stream",
    "monitoring_title": "Add your first Mention Stream",
    "social_description": "Get started by adding a Social Stream",
    "social_submit_button_label": "Social Stream",
    "social_title": "Add your first Social Stream"
  },
  "launchpad_dashboard_form": {
    "cancel_description": "Cancel changes",
    "date_range_description": "The date range that is set to <strong>all</strong> applicable selected widgets.",
    "form_actions": "Form Actions",
    "group_syndication_description": "By selecting this option, all syndicated news coverage will be counted as a single item.",
    "group_syndications": "Group Syndications",
    "reset_to_default": "Reset to Default",
    "reset_to_default_description": "Reset all settings to default values",
    "save_description": "Save changes",
    "widgets": "Widgets"
  },
  "launchpad_dashboard_form_section": {
    "collapse": "Collapse section",
    "expand": "Expand section"
  },
  "launchpad_dashboard_instant_insights_widget": {
    "instant_insights": "Instant Insights",
    "outreach_analyse": "Outreach Insights"
  },
  "launchpad_dashboard_mention_stream_insights_summary_widget": {
    "audience": "Audience",
    "ave": "Total AVE",
    "mentions": "Mentions",
    "sentiment": "Sentiment",
    "title": "Mention Stream Insights Summary"
  },
  "launchpad_dashboard_outreach_insights_summary_widget": {
    "clicked_through": "Clicked Through",
    "contacts_targeted": "Contacts Targeted",
    "delivered": "Delivered",
    "error_fetching_data": "Error fetching outreach insights summary",
    "opened": "Opened",
    "sent": "Sent",
    "title": "Media Outreach Summary",
    "title_tooltip": "An overview of the performance of your finalised pitches and media releases"
  },
  "launchpad_dashboard_outreach_search_widget": {
    "title": "Journalist or Outlet Name",
    "title_tooltip": "Search for a Journalist or Outlet by name"
  },
  "launchpad_dashboard_pitch_widget": {
    "make_pitch": "Make Pitch",
    "title": "Make an AI Quick Pitch"
  },
  "launchpad_dashboard_product_name": "Launchpad",
  "launchpad_dashboard_sidebar": {
    "form_description": "Customise Launchpad Form",
    "title": "Customise Launchpad"
  },
  "launchpad_dashboard_social_analyse_widget": {
    "social_analyse": "Social Analyse"
  },
  "launchpad_dashboard_social_engage_performance_widget": {
    "title": "Total Social Engage Performance",
    "title_tooltip": "Performance metrics for your social media engagement",
    "total_engagement": "Engagement",
    "total_impressions": "Impressions",
    "total_posts": "Posts"
  },
  "launchpad_dashboard_social_insights_summary_widget": {
    "engagement": "Total Engagement",
    "posts": "Posts",
    "sentiment": "Sentiment",
    "title": "Social Insights Summary",
    "top_emoji": "Top Emoji"
  },
  "launchpad_dashboard_social_streams_widget": {
    "title": "Social Stream",
    "title_tooltip": "Select a Social Stream to view its posts."
  },
  "launchpad_dashboard_stream_options": {
    "example_mention_stream": "Example Mention Stream"
  },
  "launchpad_dashboard_streams_widget": {
    "mock_mention_keywords": "mention",
    "mock_mention_source": "Demo Outlet",
    "mock_mention_text": "This is a fake mention. It shows how mentions appear in your stream with sample text, keywords and metrics.",
    "mock_mention_title": "Demo Mention",
    "title": "Mention Stream"
  },
  "launchpad_dashboard_tabs": {
    "activities": "Activities",
    "analyse": "Analyse",
    "engage": "Engage",
    "insights": "Insights",
    "listen": "Listen",
    "media_release": "Media Release",
    "monitor": "Monitor",
    "monitoring": "Monitoring",
    "new_stream": "New Mention Stream",
    "outreach": "Outreach",
    "pitch": "Pitch",
    "report": "Report",
    "social": "Social"
  },
  "launchpad_dashboard_team_picker": {
    "current_team": "Current selected team",
    "select": "Select team",
    "team": "team"
  },
  "launchpad_dashboard_top_performing_post_widget": {
    "engagement_rate": "Eng Rate",
    "impressions": "Impressions",
    "no_accounts_found": "No Social accounts found.",
    "no_post_found": "No Top Performing Post was found.  Please try a different date range.",
    "title": "Top Performing Post",
    "total_engagement": "Total Eng",
    "unable_to_load_post": "Unable to load Top Performing Post"
  },
  "launchpad_mentions_benchmark": {
    "description": "Understand fluctuations in volume for up to 10 Mention Streams.",
    "label": "Mentions Benchmark"
  },
  "launchpad_share_of_voice_chart": {
    "description": "Compares coverage of your Primary Mention Stream and any competitors configured by {platformName}.",
    "label": "Share Of Voice"
  },
  "launchpad_stream_stats": {
    "apply": "Apply",
    "mention": "Mention | Mentions",
    "mention_stream": "Mention Streams",
    "mention_stream_count_tooltip": "A count of all Mention Streams across your organisation. This excludes Owned Mention Streams.",
    "numbers_tooltip": "A count of all your Mentions for the selected time frame and filters, compared to the equivalent prior time period. Comparison is only available for coverage within the past 12 months.",
    "report": "Reports this Month",
    "reports_count_tooltip": "A total of all Mention Stream Reports, Tagged Mentions Reports, Social Analytics Reports, Engage Performance Reports, and Social Stream Reports.",
    "team_mention_stream_count_tooltip": "A count of all Mention Streams across your team.",
    "team_user_count_tooltip": "The number of {platformName} user accounts in the {teamName} team in your organisation.",
    "user": "Users",
    "user_count_tooltip": "The number of {platformName} user accounts across all teams in your organisation."
  },
  "launchpad_top_mention_streams": {
    "chart_view": "Chart View",
    "header_tooltip": "Top five Mention Streams in the past 24 hours, by volume.",
    "label": "Top Mention Streams",
    "table_view": "Table View"
  },
  "list_view": {
    "add_to_report_folder": "Add to Curated Email Report folder",
    "advertising_value_equivalency": "Advertising Value Equivalency",
    "author": "Author",
    "ave": "AVE",
    "blog_post_type": "Blog Post",
    "bookmark_error_message": "There was an error creating a bookmark",
    "cannot_generate_report": "Users cannot generate a Mention Stream report from bulk selections.",
    "clear_selection": "Clear selection",
    "create_tagged_report": "Try creating a {taggedReport} instead.",
    "domain_authority": "Domain Authority",
    "domain_authority_tooltip": "Domain Authority predicts the ‘strength’ of a website and how it compares to other websites. The scores range from one to 100, with higher scores corresponding to a greater likelihood of ranking. Domain Authority is provided by Moz.",
    "edit_mention_stream_tooltip": "Edit Mention Stream",
    "edit_tagged_folder_tooltip": "Edit Tagged Folder",
    "exclude_from_stream_dialog_message": "The item will be excluded from your Mention Stream | These items will be excluded from your Mention Stream",
    "external_item_cannot_be_removed_tooltip": "External Item can not be removed",
    "forum_post_type": "Forum Post",
    "impact": "Impact",
    "learn_more_tooltip": "Learn more",
    "loading_mentions": "Error loading mentions",
    "media_item": "Media Item",
    "new_mentions": "{count} new mention | {count} new mentions",
    "of_mentions_selected": "of {totalMentions} Mentions selected:",
    "potential_audience": "Potential Audience",
    "potential_audience_support_url": "https://help.streem.com.au/en/articles/4045347-potential-audience-reach",
    "react_score": "React Score",
    "remove_bookmarked_mentions_error": "Unable to remove mentions from \"{streamLabel}\"",
    "remove_bookmarked_mentions_notification": "{total} mentions removed from \"{streamLabel}\"",
    "remove_mention_stream_tooltip": "Remove from Mention Stream",
    "remove_mentions_error": "There was an issue removing the selected mentions. Please try again.",
    "remove_selected_mentions_tooltip": "Remove Selected Mentions from {streamLabel}",
    "selected": "{selected} selected ({total})",
    "sentiment": "Sentiment",
    "sentiment_rating_tooltip": "Sentiment Rating",
    "source": "Source",
    "tagged_report": "Tagged Report",
    "time": "Time",
    "toggle_all_title": "Toggle all mentions in this page",
    "total_mentions": "{total} Mentions",
    "unable_to_refresh_tags": "There was an issue refreshing the selected mentions tags. Please try again.",
    "update_ratings_error": "There was an issue saving these Sentiment Ratings. Please try again.",
    "word_count": "Word Count",
    "word_count_total": "{total} words"
  },
  "load_error": {
    "error": "Something went wrong while trying to view this page."
  },
  "location_checkbox_selector": {
    "item_description": {
      "children_selected": "{totalChildrenSelected} location | {totalChildrenSelected} locations",
      "is_selected": "Nationwide",
      "is_selected_and_children_selected": "Nationwide and {totalChildrenSelected} location | Nationwide and {totalChildrenSelected} locations"
    },
    "location": "Location",
    "select_at_least_one_location": "Please select at least one location."
  },
  "location_selector": {
    "disabled_content_message": "{topLocationName} {medium} Content not enabled for organisation",
    "load_organisation_features_error_message": "{error} - an error occurred whilst loading the organisations features",
    "title": "Filter by location"
  },
  "login": {
    "4_digit_pin": "4 digit PIN",
    "auth_carrier_message": {
      "device": "Enter the two-factor code displayed in your authenticator app",
      "email": "Enter the two-factor authentication code we have just sent to your email",
      "sms": "Enter the two-factor authentication code we have just sent to your phone"
    },
    "contact_dedicated_account_manager": "Contact your dedicated Account Manager for assistance below.",
    "contact_support_team_link_text": "contact our support team here",
    "email_verification_failed": "Email verification failed. Please try again.",
    "email_verification_required": "Email verification required. Please check your inbox and follow the link we sent to verify your email address.",
    "email_verification_success": "Email verified successfully. Please sign in.",
    "enter_valid_email": "Please enter a valid email or phone",
    "find_out_more_link": "find out more",
    "incorrect_mobile_or_email": "Incorrect mobile number or email address",
    "incorrect_pin": "Incorrect PIN",
    "mobile_or_email": "Mobile number or email address",
    "not_customer": "If you aren’t already a customer {findOutMore}",
    "password": "Password",
    "platform_logo": "{platformName} Logo",
    "please_try_again": "Please try again",
    "reset_pin": "Reset your {platformName} PIN",
    "sign_in_failed": "Sign-in failed - {error}",
    "sign_in_failed_message_support_cision": "You can reset your PIN below, otherwise you can {supportLink}.",
    "sign_in_failed_message_support_streem": "You can reset your PIN below, otherwise please contact us on {phoneNumber} or {email}.",
    "sign_in_is_required": "Sign in is required to view licensed content",
    "sign_in_to": "Sign-in to {platformName}",
    "sign_in_with_google": "Sign in with Google",
    "sign_in_with_microsoft": "Sign in with Microsoft",
    "spaces_not_allowed": "Spaces are not allowed",
    "sso_error": "Single Sign-On failed. Try a different account otherwise",
    "sso_error_with_email": "Single Sign-On failed for {email}. Try a different account otherwise",
    "two_factor_auth": "Two-factor authentication",
    "username": "Username"
  },
  "login_sso_buttons": {
    "sign_in_with_microsoft": "Sign in with Microsoft"
  },
  "magazine_article_preview": {
    "pdf_image": "PDF image",
    "view_article_pdf": "View Article PDF"
  },
  "magazine_mention_card": {
    "potential_audience_reach": "{audience} Potential Audience Reach",
    "word_count": "· {wordCount} words {pageNumbers}"
  },
  "main_page": {
    "content_unavailable": "This content is not available"
  },
  "manage_social_connections": {
    "account_added": "Account added successfully.",
    "account_added_error": "There was a problem adding the account. Please try again.",
    "account_added_error_duplicate": "The account has already been added.",
    "account_not_found": "Account not found. Please try again.",
    "account_remove": "Removing an account will not allow you to monitor that account any longer. Are you sure you want to remove the selected account? | Removing accounts will not allow you to monitor those accounts any longer. Are you sure you want to remove the selected accounts?",
    "account_remove_error": "There was a problem removing the account. | There was a problem removing the accounts.",
    "account_removed": "Account removed successfully. | Accounts removed successfully.",
    "accounts": "Accounts",
    "add_new_account": "Add new account",
    "add_new_account_placeholder": "Type username and press enter",
    "add_new_hashtag": "Add new hashtag",
    "add_new_hashtag_placeholder": "Type hashtag and press enter",
    "csv_error": "The format of your CSV is incorrect. Please use the sample file and try again.",
    "csv_success": "Bulk upload successful. You will receive an email once the upload is complete.",
    "error_creating": "Error creating connection.",
    "error_duplicate_account": "Account has already been added.",
    "error_duplicate_hashtag": "Hashtag has already been added.",
    "error_fetching": "Error fetching connections.",
    "get_started_account": "Get started by adding a new Instagram{newline} business account that you want to monitor",
    "get_started_hashtag": "Get started by adding a new Instagram{newline} Hashtag that you want to monitor",
    "hashtag_added": "Hashtag added successfully.",
    "hashtag_added_error": "There was a problem adding the Hashtag. Please try again.",
    "hashtag_added_error_invalid": "Hashtag not found. Please try again.",
    "hashtag_added_error_limit_reached": "You have reached the maximum number of hashtags that can be monitored.",
    "hashtag_added_validation": "The Hashtag is invalid. Please try again.",
    "hashtag_cooling_period": "Removed in: {period}",
    "hashtag_remove": "Due to Instagram restrictions, the hashtag will be associated for 7 days before it is removed however, no new content will be ingested. Are you sure you want to remove the selected hashtag? | Due to Instagram restrictions, the hashtags will be associated for 7 days before it is removed however, no new content will be ingested. Are you sure you want to remove the selected hashtags?",
    "hashtag_remove_error": "There was a problem removing the hashtag. | There was a problem removing the hashtags.",
    "hashtag_removed": "Hashtag removed successfully. | Hashtags removed successfully.",
    "hashtags": "Hashtags",
    "hashtags_exceeded_tooltip": "All available hashtags have been used. Remove hashtags to monitor new ones. Please note a hashtag will be removed 7 days after the action is initiated. This is enforced by Instagram and is not a limitation of the platform.",
    "hashtags_limitation_cooloff_tooltip": "Hashtag will not be monitored any longer however, it will take 7 days to remove it from our system. This is enforced by Instagram and is not a limitation of the platform.",
    "hashtags_limitation_streem_tooltip": "Instagram allows you to monitor only 30 hashtags at a time across various applications with a 7 day rolling archive. Even if you wish to replace a hashtag, you will only be allowed to add a new one after the 7 days. This is enforced by Instagram and it is not a limitation of the platform.",
    "hashtags_used": "{count}/{totalCount} Hashtags Used",
    "integration": "Integration",
    "no_accounts_found": "No accounts matched for {search}.{newline}Please try again.",
    "no_hashtags_found": "No hashtags matched for {search}.{newline}Please try again.",
    "search_accounts": "Search accounts",
    "search_accounts_placeholder": "Search for accounts in your list",
    "search_hashtags": "Search hashtags",
    "search_hashtags_placeholder": "Search for hashtags in your list",
    "title": "Manage Connections",
    "upload_csv": "Upload CSV"
  },
  "manage_social_connections_bulk_upload": {
    "download_sample_file": "Download Sample File",
    "upload_csv_columns": "Upload a CSV containing a single column: account_name."
  },
  "manage_social_integrations": {
    "account_disconnected": "Account disconnected successfully",
    "accounts_updated": "Accounts updated successfully",
    "auth_cancelled": "Authentication cancelled. Please try again.",
    "disconnect_account": "Are you sure you want to disconnect the account?",
    "draft_scheduled_posts_text": "There is {count} associated draft post. Removing this account will remove it from the draft or pending approval post. | There are {count} associated drafts. Removing this account will remove it from the draft or pending approval posts.",
    "error_deleting": "Error deleting integration",
    "error_fetching": "Error fetching integrations",
    "facebook_modal_title": "Manage Facebook Integrations",
    "getting_profiles": "Getting Profiles",
    "instagram_modal_title": "Manage Instagram Integrations",
    "linkedin_modal_title": "Manage LinkedIn Integrations",
    "logging_in": "Logging In",
    "pending_scheduled_posts_text": "There is {count} associated scheduled post. Please remove this account from scheduled posts before deleting. | There are {count} associated scheduled posts. Please remove this account from scheduled posts before deleting.",
    "remove_integration": "Are you sure you want to remove this integration?",
    "remove_monitoring_text": "Disconnecting an integration will not allow you to monitor that account any longer. ",
    "team_updated": "Teams updated",
    "tiktok_modal_title": "Manage TikTok Integrations",
    "twitter_modal_title": "Manage Twitter/X Integrations",
    "update_integrations": "Update Integrations",
    "user_exited_auth": "Exiting Authentication Process"
  },
  "matching_streams": {
    "display_all": "Display all Matching Mention Streams",
    "found_in_mention_stream": "Found in Mention Stream: {streamLabel} | Found in Mention Streams: {streamLabel}"
  },
  "media_carousel": {
    "next_image": "Next image",
    "previous_image": "Previous image"
  },
  "media_not_found_card": {
    "account_manager": "Account Manager.",
    "customer_portal": "Customer Portal",
    "customer_success": "Customer Success.",
    "knowledge_base": "Knowledge base",
    "media_items": "Media Items",
    "mention_stream": "Mention Stream",
    "no_item_found": "No {item} found",
    "no_item_found_subtext": "No {item} matching your {typeOfStream} have been detected in this period of {rangeText}.",
    "social_items": "Social Items",
    "social_stream": "Social Stream"
  },
  "media_not_found_message_social": "Please select a different date range or email {customerSuccessEmailLink}",
  "media_not_found_message_traditional": "Please select a different date range or contact your {accountManagerContactPopup}",
  "media_release_adhoc_recipient_form": {
    "create_error": "Error creating recipient",
    "first_name_placeholder": "First name",
    "heading": "Add custom recipient",
    "last_name_placeholder": "Last name",
    "subtext": "Enter any unique recipients manually by adding their salutation, first name, last name and email address."
  },
  "media_release_analytics_charts": {
    "click_through_rate_percentage": "{percentage}%",
    "click_through_rate_title": "Click Through Rate",
    "click_through_rate_tooltip": "The total number of unique clicks for external links out of the total number of unique email deliveries.",
    "clicked_label": "Clicked",
    "legend_label": "{count} ({percentage}%)",
    "load_analytics_error": "There was an error loading analytics",
    "not_clicked_label": "Not Clicked",
    "not_opened_label": "Not Opened",
    "open_rate_percentage": "{percentage}%",
    "open_rate_title": "Open Rate",
    "open_rate_tooltip": "The total number of unique email opens out of total delivered recipients.",
    "unique_opens_label": "Unique Opens"
  },
  "media_release_analytics_contacts": {
    "clicked_title": "Clicked",
    "delivered_title": "Delivered",
    "email_title": "Email",
    "empty_table_message": "No contacts to display",
    "failed_message": "Undelivered",
    "filters": {
      "clicked": "Clicked",
      "delivered": "Delivered",
      "not_clicked": "Not Clicked",
      "not_delivered": "Not Delivered",
      "not_opened": "Not Opened",
      "opened": "Opened",
      "unsubscribed": "Unsubscribed"
    },
    "header": "Contacts",
    "load_email_events_error": "There was an error loading email events",
    "load_recipients_error": "Error loading media release recipients",
    "opened_title": "Opened",
    "status": "Status",
    "undeliverable_email": "This email isn't a valid address and wasn't sent. Check for mistakes to reverify that it is correct.",
    "unsubscribed_title": "Unsubscribed"
  },
  "media_release_analytics_metrics": {
    "clicks_title": "Clicks",
    "clicks_tooltip": "Total link clicks. This does not include opening an attachment.",
    "delivered_title": "Delivered",
    "delivered_tooltip": "The total number successfully delivered emails.",
    "failed_title": "Failed",
    "failed_tooltip": "Any emails not delivered due to bouncebacks, and other technical failures.",
    "opens_title": "Opens",
    "opens_tooltip": "Total opens for this Media Release.",
    "recipents_title": "Recipients",
    "recipients_tooltip": "The intended number of contacts for this Media Release.",
    "unsubcribes_title": "Unsubscribes"
  },
  "media_release_edit": {
    "campaign_successfully_delivered": "Campaign successfully delivered to all recipients",
    "campaign_successfully_delivered_cancel": "Go back",
    "campaign_successfully_delivered_confirm": "Go to Report Analytics",
    "choose_recipients": "Choose recipients",
    "create_content": "Create content",
    "create_media_release": "Create Media Release",
    "delete_draft": "Delete draft",
    "delete_draft_message": "You are about to permanently delete your draft Media Release. Are you sure?",
    "delete_draft_title": "Delete draft Media Release",
    "delete_media_release_error": "There was an error deleting this Media Release",
    "edit_media_release": "Edit Media Release",
    "load_media_release_error": "There was an error loading this Media Release",
    "load_recipients_error": "There was an error loading the recipients count",
    "media_release_saved": "Media Release saved",
    "save_media_release": "Save Media Release to send test email.",
    "save_media_release_error": "There was an error saving the Media Release",
    "schedule_later": "Schedule Later",
    "scheduled_to_send_at": "This Media Release has been scheduled to send at {scheduledTime}.",
    "send_now": "Send Now",
    "send_test": "Send Test",
    "send_test_mail_before": "Send a test email before sending to all recipients.",
    "send_test_mail_error": "There was an error sending a test email",
    "send_to_recipients": "Are you sure you wish to send this to {totalRecipients} recipient? | Are you sure you wish to send this to {totalRecipients} recipients?",
    "sent_as_test": "This Media Release has been sent as a test to '{firstName} {lastName} ({email})'",
    "unsaved_changes_message": "You have unsaved changes",
    "unsaved_changes_title": "Are you sure?"
  },
  "media_release_preview": {
    "email_preview_title": "Media release email preview",
    "load_error": "Something went wrong when loading this preview. Please try again",
    "not_found_error": "This Media Release could not be found."
  },
  "media_release_recipients_table": {
    "add_all_lists": "Add Contacts, Mailing Lists, or Contact lists.",
    "add_lists": "Add Contacts or Contact lists",
    "custom_recipient": "Custom recipient",
    "desk": "Desk",
    "load_recipients_error": "Error loading media release recipients",
    "no_contacts_prompt": "You need at least one recipient to generate journalist and outlet suggestions. Add one now to get started!",
    "no_recipients": "No recipients to display.",
    "no_valid_contacts_prompt": "Suggestions cannot be provided if your {type} only has private contacts. You need at least one contact to generate journalist and outlet suggestions. Add one now to get started!.",
    "remove_contact": "Remove contact from this Media Release.",
    "review_filters": "Review your search filters to see results.",
    "source_label": "Source",
    "total_recipients": "Total Recipients: {totalRecipients}",
    "undeliverable_email": "This email isn't a deliverable address and we won't send any email to it. Check for mistakes to reverify that it is correct."
  },
  "media_release_select_brand_profile": {
    "description": "Applying a Brand Profile will pre-fill font, header and footer images.",
    "label": "Brand Profile",
    "load_error": "There was an error loading Brand Profiles",
    "logo_alt": "{name} brand logo",
    "tooltip": "You or another super user can add and edit Brand Profiles through the organisation settings."
  },
  "media_release_select_template": {
    "confirm_messge": "Are you sure you want to delete {name}?",
    "delete_error": "There was a problem deleting template: {name}",
    "delete_tooltip": "Delete template",
    "description": "de",
    "label": "Template",
    "load_error": "There was an error loading Templates",
    "tooltip": "We recommend using Templates to ensure your Media Releases consistently reflect your organisation's style guide."
  },
  "media_release_step_content": {
    "add_placeholder_label": "Add Placeholder",
    "add_placeholder_tooltip": "Add a placeholder to insert recipient details into {type}",
    "attachments_heading": "Attachments",
    "attachments_label": "Attach files",
    "attachments_subtext": "10MB per file, 25MB total",
    "body_label": "Body",
    "contact_lists_remove_tooltip": "Remove list from Media Release.",
    "editor_placeholder": "Add {type} content.",
    "first_name_label": "First name",
    "german_greeting": "German Greeting",
    "german_greeting_tooltip": "A gendered German-language greeting for formal communication, e.g. \"Sehr geehrter Herr Smith\"",
    "import_word_document_continue": "Continue",
    "import_word_document_error": "Failed to import document",
    "import_word_document_label": "Import Word Document",
    "import_word_document_overwrite_warning": "Importing a new Word document will overwrite all existing work. Are you sure you want to continue?",
    "preview_label": "Preview",
    "preview_tooltip": "Preview the look and feel of your {type}.",
    "salutation_label": "Salutation",
    "save_template_alert": "Template saved",
    "save_template_error": "There was an error saving the template",
    "save_template_label": "Save template",
    "save_template_tooltip": "Allows other users in your organisation to apply the formatting used above in future {type}.",
    "subject_description": "The Subject line will appear as the title of this {type} in your Activities section.",
    "subject_label": "Subject Line",
    "surname_label": "Surname"
  },
  "media_release_step_recipients": {
    "contact_lists_add_error": "Error adding Contact List",
    "contact_lists_description": "Search for your Organisation's public contact lists, or your private contact lists.",
    "contact_lists_disabled_tooltip": "This Contact List cannot be selected because the Media Release is not owned by you",
    "contact_lists_label": "Contact Lists",
    "contact_lists_load_error": "There was an error loading Contact Lists",
    "contact_lists_placeholder": "Search for a Contact List",
    "contact_lists_private_tooltip": "This Contact List is only visible to you",
    "contact_lists_remove_error": "Error removing Contact List",
    "contact_lists_save_error": "Error saving Contact Mailing List",
    "contacts_count": "{count} contact | {count} contacts",
    "contacts_description": "Search for individual Journalists or Outlets to add to your Media Release.",
    "contacts_label": "Contacts",
    "load_contacts_error": "There was an error loading Contact Lists",
    "mailing_lists_description": "Search for contact lists curated by {platformName}.",
    "mailing_lists_label": "Mailing Lists",
    "mailing_lists_load_error": "There was an error loading Contact Mailing Lists",
    "mailing_lists_placeholder": "Search for a Mailing List",
    "mailing_lists_remove_error": "Error removing Contact Mailing List",
    "mailing_lists_remove_tooltip": "Remove list from Media Release.",
    "recipient_list_add_error": "Error adding Recipient",
    "recipient_list_heading": "Recipient list",
    "recipient_list_remove_error": "Error removing recipient",
    "recipient_list_subtext": "Review and manage all recipients for this Media Release.",
    "recipient_list_validation": "Must add a Contact or Contact List to send a Media Release",
    "recipient_list_validation_error": "Error validating Contacts"
  },
  "media_release_step_send": {
    "contact_lists_load_error": "There was an error loading contact lists",
    "email_domains_load_error": "There was an error loading email domains",
    "notifications_click": "Email me when a recipient opens a link from this {type}",
    "notifications_label": "Notifications",
    "notifications_open": "Email me when a recipient opens this {type}",
    "select_domain": "Select a domain",
    "select_email_address": "Select an email address",
    "send_as_another_user": "Another User",
    "send_as_custom": "Custom",
    "send_as_from": "From",
    "send_as_heading": "Send as",
    "send_as_me": "Me",
    "send_as_organisation_domain": "Organisation Domain",
    "send_as_reply_to": "Reply to",
    "send_as_subtext": "Customise the sent from address and reply to address for your {type}.",
    "tags_heading": "Tags",
    "tags_subtext": "Assign a tag to this {type}.",
    "timing_expired": "Your scheduled date for {scheduledTime} has expired.",
    "timing_label": "Timing",
    "timing_later_label": "Schedule for later",
    "timing_now_label": "Send now",
    "visibility_description": "Public visibility allows other users in your organisation to view and edit {type} and analytics.",
    "visibility_disabled_message": "The visibility cannot be changed as you do not own this {type}.",
    "visibility_disabled_private_message": "The visibility cannot be changed as you have added a private Contact List only visible to you.",
    "visibility_label": "Visibility",
    "visibility_private": "Private",
    "visibility_public": "Public"
  },
  "media_request_card": {
    "cancel_request": "Cancel request",
    "cancel_request_description": "Are you sure you want to cancel this Media Item Request?",
    "cancel_request_title": "Cancel Media Item Request",
    "created_by": "Created by {name}",
    "delete_request_description": "Are you sure you want to delete this Media Item?",
    "delete_request_title": "Delete Media Item?",
    "download": "Download",
    "play_media_request_clip": "Play media request clip",
    "potential_audience": "Potential Audience: {audienceCount}",
    "processing_status": "Status: Processing",
    "requested_by": "Requested by {name}",
    "see_more": "See more",
    "thumbnail": "Thumbnail",
    "unable_to_complete_request": "Unable to complete this request."
  },
  "media_request_card_player": {
    "forward": "Forward",
    "full_screen": "Full screen",
    "pause": "Pause",
    "rewind": "Rewind"
  },
  "media_requests_tab": {
    "export_error": "Export Failed {error}",
    "load_counts_error": "Failed to load media type counts {error}",
    "load_error": "Failed to retrieve media items",
    "no_requested_media_items": "You have no requested Media items.",
    "pagination_label": "{start} - {end} of {totalCount}",
    "remove_error": "Failed to remove media item",
    "results_pagination": "Results {paginationLabel}"
  },
  "media_transcript_requests": {
    "export_failed": "Export Failed {error}",
    "media_items": "Media Items",
    "transcripts": "Transcripts"
  },
  "media_transcript_requests_filter": {
    "export_csv": "Export CSV",
    "export_to_csv": "Export to CSV",
    "exporting": "Exporting ..."
  },
  "media_transcript_requests_media_types_filter": {
    "done": "DONE"
  },
  "media_transcript_requests_mobile_filter": {
    "apply": "APPLY",
    "clear": "CLEAR",
    "filters": "Filters",
    "results_count": "Results: {totalCount}",
    "show_filters": "Show Filters"
  },
  "media_transcript_requests_range_filter": {
    "done": "DONE"
  },
  "media_transcript_requests_sort_by_dropdown": {
    "broadcast_time": "Broadcast Time",
    "requested_time": "Requested Time",
    "sort_by": "Sort by:"
  },
  "mention_card": {
    "high_risk": "High Risk",
    "mention_translated": "Mention translated",
    "select_mention": "Select mention: {title}",
    "select_mention_untitled": "Select mention",
    "sentiment_rating_error": "There was an issue saving this Sentiment Rating. Please try again."
  },
  "mention_card_insights": {
    "next": "Next insights",
    "next_for": "Next insights for {title}",
    "previous": "Previous insights",
    "previous_for": "Previous insights for {title}"
  },
  "mention_detail_action_sheet": {
    "actions": "Actions",
    "curated_email_report": "Curated Email Report",
    "download_pdf": "Download PDF",
    "edit_broadcast": "Edit Broadcast",
    "edit_broadcast_tooltip": {
      "cannot_archive_again": "The clip has already been archived and hence cannot be archived again. Remove your existing archived clip to generate another one.",
      "expiration_warning": "For long-term access to this clip, “Archive” it through the Editor. If not archived, clip access will expire {expirationTimeDays} days after airing."
    },
    "email_or_share": "Email or Share",
    "instant_edit_media_item": "Instant-edit Media Item",
    "instant_edit_transcript": "Instant-edit Transcript",
    "media_insights": "Media Insights",
    "push_to_team": "Push to Team",
    "remove_from_folder": "Remove from Folder",
    "replace_archived_clip": "Replace Archived Clip",
    "request_item_or_transcript": "Request Item or Transcript",
    "request_media_item": "Request Media Item",
    "request_transcript": "Request Transcript",
    "share": "Share",
    "translate_to_english": "Translate to English",
    "view_archived_clip": "View Archived Clip",
    "view_full_article": "View full article",
    "view_full_broadcast": "View Full Broadcast",
    "view_transcript": "View Transcript"
  },
  "mention_detail_article": {
    "current_position": "Current position #{currentRank}",
    "from_date": "From {date}",
    "front_page": "FRONT PAGE",
    "on_page": " on page {pageNumber}",
    "social": "SOCIAL",
    "tweets_about_article": "Tweets about this Article",
    "view_online": "View Online",
    "view_syndications": "View Syndications",
    "word_count": "· {wordCount} words{pageNumber}"
  },
  "mention_detail_blog_post": {
    "see_more": "See more"
  },
  "mention_detail_bluesky_post": {
    "see_more": "See more"
  },
  "mention_detail_broadcast_story": {
    "entity_segment_tab": "Entity Segment",
    "segment_tab": "Segment"
  },
  "mention_detail_facebook_post": {
    "comments_count": "{count} comments",
    "likes": "Likes",
    "shares_count": "{count} shares"
  },
  "mention_detail_forum_post": {
    "see_more": "See more"
  },
  "mention_detail_insights": {
    "desktop_potential_audience": "Desktop Audience",
    "impact_score": "Impact Score",
    "mobile_potential_audience": "Mobile Audience",
    "potential_audience": "Potential Audience",
    "title": "Media Insights"
  },
  "mention_detail_instagram_comment": {
    "likes": "{count} likes"
  },
  "mention_detail_instagram_post": {
    "likes": "{count} likes"
  },
  "mention_detail_layout": {
    "followers": " Followers: ",
    "impact_score": "{impactScore} {impact}%",
    "impact_score_label": " Impact score: ",
    "sentiment": " Sentiment: "
  },
  "mention_detail_linkedin_post": {
    "page": "Page"
  },
  "mention_detail_online": {
    "article_image": "Article image",
    "article_sentiment": "Article sentiment",
    "current_position": "Current position #{rank}",
    "english_version": "English version",
    "from_date": "From {date}",
    "front_page": "Front Page",
    "keywords": "Keywords:",
    "language_version": "{language} version",
    "original": "Original",
    "original_version": "Original version",
    "plain_text": "Plain text",
    "top_tweets": "Top Tweets About this Post",
    "translated_body": "TRANSLATION: {translatedBody}",
    "translated_version": "Translated version",
    "view_article": "View Article"
  },
  "mention_detail_print": {
    "article_sentiment": "Article sentiment",
    "download_pdf_error": "There was an error downloading the Article PDF",
    "english_version": "English version",
    "language_version": "{language} version",
    "original": "Original",
    "original_version": "Original version",
    "pdf_version": "PDF",
    "pdf_version_number": "Version {versionNumber}",
    "plain_text": "Plain text",
    "plain_version": "Plain version",
    "translated_body": "TRANSLATION: {translatedBody}",
    "translated_version": "Translated version"
  },
  "mention_detail_reddit_post": {
    "comments_count": "{count} comment | {count} comments",
    "score_count": "Score {count}"
  },
  "mention_detail_social": {
    "followers": " Followers: ",
    "impact_score": "{impactScore} {impact}%",
    "impact_score_label": " Impact score: ",
    "neutral": "Neutral",
    "sentiment": " Sentiment: ",
    "social_from": "Social from {sourceType}"
  },
  "mention_detail_tiktok_video": {
    "likes": "{count} likes"
  },
  "mention_detail_tv": {
    "back_to_player": "Back to Player",
    "view_full_transcript": "View Full Transcript"
  },
  "mention_detail_tv_radio": {
    "archive_error": "The broadcast could not be archived. The full broadcast is shown instead.",
    "archived": "Archived",
    "archived_clip_player": "Archived broadcast clip player",
    "expired_content": "This item has expired and can no longer be viewed.",
    "external_clip_editor": "Broadcast clip editor",
    "external_clip_player": "Broadcast clip player",
    "playback_error": "The broadcast player could not be loaded. Please try again.",
    "playback_loading": "Loading broadcast player...",
    "playback_unavailable": "This broadcast is currently unavailable.",
    "processing": "Processing...",
    "provider_unavailable": "Playback from this provider is no longer available.",
    "tveyes_clip_editor": "TVEyes clip editor",
    "tveyes_clip_player": "TVEyes clip player"
  },
  "mention_detail_youtube_video": {
    "comments_count": "{count} comment | {count} comments",
    "likes_count": "{count} like | {count} likes",
    "views_count": "{count} view | {count} views"
  },
  "mention_excerpts": {
    "around_time_zone": "around {timeInZone}.",
    "logo_on_screen": "Logo On Screen: ",
    "mentions": "Mentions: ",
    "see_less": "See Less",
    "see_more": "See More",
    "text_on_screen": "Text On Screen: "
  },
  "mention_preview_alert": {
    "access_full_media": "Access full media",
    "magazine_item": "Magazine Item",
    "print_item": "Print Item",
    "radio_media_item": "Radio Media Item",
    "tv_media_item": "TV Media Item",
    "used_credits_text": "{usedCredits} of {totalCredits} {sourceLabel} Items",
    "used_items_text": "{usedItems} {sourceLabel} Items"
  },
  "mention_preview_alert_header": {
    "details": "Details",
    "main_text_default": "This month your organisation has used:"
  },
  "mention_restriction": {
    "message": "This item has been restricted due to licensing and can no longer be viewed. {readMore}.",
    "read_more": "Click here to read more"
  },
  "mention_stream": {
    "add_external_item_button": "Add External Item",
    "edit_mention_stream_button": "Edit Mention Stream",
    "error_loading_mentions": "Error Loading Mentions - Click to Retry",
    "expiry_extended_message": "The expiry of {streamLabel} has been extended by 3 days.",
    "expiry_extended_title": "Mention Stream Expiry Extended",
    "filter_mentions_button": "Filter Mentions",
    "generate_report_button": "Generate Report",
    "no_media_items_found": "No Media Items found",
    "select_date_range": "Select Date Range"
  },
  "mention_stream_builder": {
    "confirm_route_leave_message": "You're about to leave this page. Any unsaved changes will be lost. Are you sure you want to continue?",
    "confirm_route_leave_title": "Confirm Redirect",
    "create_stream": "Create a {streamTypeLabel}",
    "input_keywords": "Input keywords",
    "refine": "Refine",
    "review": "Review",
    "review_coverage": "Review {coverageLabel}"
  },
  "mention_stream_builder_advanced_settings": {
    "accross_media_types": "Across these Media Types",
    "accross_social_platforms": "Across these Social Platforms"
  },
  "mention_stream_builder_create_stream": {
    "add_label_placeholder": "Add a label",
    "back_to_search_button": "Back to search",
    "error_loading_stream_group": "There was an error loading stream groups",
    "find_out_more": "Find out more.",
    "new_stream_created_alert": "New {streamTypeLabel} created",
    "save_stream_button": "Save {streamTypeLabel}",
    "stream_name_label": "{streamTypeLabel} Name",
    "unable_to_save_error": "Unable to save the stream"
  },
  "mention_stream_builder_help": {
    "keywords": "Keywords",
    "keywords_subtext": "Select keywords that relate to your chosen topics of interest.",
    "media_types_subtext": "Filter {coverageLabel} by your preferred Media Type. You can narrow your search to one or more Media Types.",
    "need_help": "Need Help?",
    "social_platforms": "Social Platforms",
    "social_platforms_subtext": "Filter {coverageLabel} by your preferred Social Platform. You can narrow your search to one or more Social Platforms.",
    "sources": "Sources",
    "sources_subtext": "Filter coverage by your preferred Sources or Media Outlets. Simply type the first letters of the Source name and it will autofill, for example ‘{exampleSource}'",
    "still_stuck": {
      "subtext_au": "Read and learn from {link}",
      "subtext_au_link": "our interactive help articles and videos.",
      "subtext_other": "{clickHere} to access our {knowledgeBase}.",
      "subtext_other_contact": "contact",
      "subtext_other_knowledge_base": "knowledge base",
      "title": "Still stuck?"
    }
  },
  "mention_stream_builder_results": {
    "additional_social_posts_alert": "The social posts below are an example of mentions that match this Social Stream. Once created, additional social posts will be hydrated using 30 days of retrospective social posts.",
    "any_results_matching": "We couldn't find any results matching: “{query}“",
    "at_least_label": "At Least {value} Times: {keyword}",
    "author_label": "Author: {keyword}",
    "case_sensitive_label": "Case Sensitive: {keyword}",
    "create_stream_button": "Create a {streamTypeLabel} from this search",
    "display_beyond_30_days": "Creating a Mention Stream will display content beyond 30 days.",
    "first_label": "First {value} Words: {keyword}",
    "latest_30_results": "Showing latest 30 results",
    "medium_label": "Medium ({medium}): {keyword}",
    "mentions": "Mentions",
    "no_results_matching_error": "Unfortunately we could not find results matching your search because of an unexpected error: {errorMessage}",
    "over_30_days": "Over 30 days",
    "platform_label": "Platform ({platform}): {keyword}",
    "review_your_keywords_alert": "Review your Keywords, expand the Media Types or check the Sources.",
    "title_label": "Title: {keyword}",
    "volume": "Volume"
  },
  "mention_stream_builder_search": {
    "advanced_search_options": "Advanced Search Options"
  },
  "mention_stream_builder_settings": {
    "accross_media_types": "Across these Media Types",
    "accross_social_platforms": "Across these Social Platforms",
    "coverage_label": "coverage",
    "keywords": "Keywords",
    "match_coverage_label": "Match coverage that contains",
    "match_coverage_option_all": "All Keyword/s",
    "match_coverage_option_one_or_more": "One or more Keyword/s",
    "match_social_posts_label": "Match social posts that contain",
    "restricted_sources": "Restricted to these Sources",
    "select_media_type": "Please select a Media Type",
    "social_posts_label": "social posts",
    "topics_label": "I'm looking for {coverageLabel} on these topics"
  },
  "mention_stream_expiry_watcher": {
    "dismiss": "Dismiss",
    "expires_in": "Expires in {expiresIn}",
    "extend": "Extend",
    "extend_expiry": "Extend expiry"
  },
  "mention_stream_media_types": {
    "any_souce": "Any {sourceLabel}",
    "filter_coverage": "Filter {choiceLabel} coverage",
    "include_international_plus": "Include InternationalPlus sources",
    "select_media_type": "Please select a Media Type"
  },
  "mention_stream_mention_preview": {
    "unable_to_load_media_item": "Unable to load Media Item"
  },
  "mention_stream_notification_watcher": {
    "media_items_since": "Media Items since {date}.",
    "new_mention_count_button": "{mentionCount} new mentions",
    "new_mention_count_with_duration_button": "{mentionCount} new since {duration}",
    "no_media_items_since": "No Media Items since {date}.",
    "refresh_new_mentions_button": "{mentionCount} new Mentions",
    "search_earlier_content_button": "Search earlier content."
  },
  "mention_stream_report": {
    "additional_filters_heading": "Additional Filters",
    "create_report_error": "There was an error generating the Report",
    "filter_set_applied_tooltip": "Remove Filter Set to edit your filters.",
    "language_dropdown_subtext": "This will populate your PDF in the chosen language.",
    "mention_count_error": "There was an error loading the total mention count",
    "mention_stream_heading": "Mention Stream",
    "options_heading": "Options",
    "reset_filters_label": "Reset Filters",
    "review_mention_error": "Error loading mentions for review",
    "review_mentions_aria_label": "Review and select Mentions",
    "review_mentions_label": "Review and select Mentions ({count}/{totalMentionCount})",
    "review_mentions_tooltip": "Mention count is over {limit}",
    "save_button_label": "Generate {label} Report ({formattedCount}) | Generate Reports ({formattedCount})",
    "select_charts_and_mentions_label": "Display Charts and Mentions",
    "select_charts_only_label": "Display Charts Only",
    "select_mentions_only_label": "Display Mentions Only",
    "sorting_heading": "Sorting",
    "stock_symbol_label": "Select a Symbol",
    "toggle_bundle_broadcast_label": "Bundle broadcast Mentions together",
    "toggle_bundle_broadcast_subtext": "Only one TV or Radio Mention will be displayed when multiple Mentions are close together in the same broadcast program.",
    "toggle_collapse_syndicated_label": "Group syndicated Mentions together",
    "toggle_collapse_syndicated_subtext": "Identical items will be combined into a single Mention when syndicated across multiple sources. Selected Mentions will reset when changing this setting.",
    "toggle_display_filters_label": "Display Filter Options in Report",
    "toggle_display_filters_subtext": "Include the Filter Options used to generate the report in the PDF",
    "toggle_include_stock_price_label": "Display Stock Price Overlay",
    "toggle_include_stock_price_subtext": "Add the stock price for {button} to the Mention Stream chart.",
    "toggle_print_clips_pdf_report_label": "Include Print Clippings",
    "toggle_print_clips_pdf_report_subtext": "Include Print PDF Clippings",
    "toggle_restricted_content_label": "Show Restricted Content",
    "toggle_restricted_content_subtext": "Includes links & any article body text to UK (NLA & CLA) copyrightable material."
  },
  "mention_stream_report_filters": {
    "exclude_tags": "Exclude Tags",
    "tags": "Tags"
  },
  "mention_stream_report_filters_sources": {
    "authors": "Authors",
    "categories": "Categories",
    "exclude_sources": "Exclude Sources",
    "exclude_sources_error": "Excluded sources not available when sources are selected.",
    "exclude_sources_subtext": "Add source names to exclude content from these sources",
    "include_sources": " Include Sources",
    "include_sources_error": "Sources not available when excluded sources are selected.",
    "include_sources_subtext": "Add source names to only display content from these sources",
    "metro_label": "Metro",
    "national_label": "National",
    "regional_label": "Regional",
    "tiers": "Tiers"
  },
  "mention_stream_report_filters_tags": {
    "label": "Tags"
  },
  "mention_stream_reports_table": {
    "action": "Actions",
    "create_report_error": "There was an error creating your report. Please contact your account manager for assistance.",
    "csv_excel": "CSV/Excel",
    "delete_report": "Delete report",
    "delete_report_title": "Permanently delete this report?",
    "error": "Error",
    "from": "From",
    "mention_stream": "Mention Stream",
    "pdf": "PDF",
    "pdf_building": "PDF Building",
    "pdf_failed": "PDF Failed",
    "processing": "Processing",
    "regenerate_report": "Regenerate Report",
    "regenerate_report_admin": "Regenerate report (Only available to Admins)",
    "report": "Report",
    "requested": "Requested",
    "status": "Status",
    "to": "To",
    "view_online": "View Online",
    "xlsx": "XLSX"
  },
  "mention_streams_management": {
    "add_streams_button": "Add Mention Stream",
    "error_loading_stream_type": "There was an error loading {streamType}",
    "mention_streams": "Mention Streams"
  },
  "mention_translation_language": {
    "translated": "TRANSLATED",
    "translated_from": "{translated} from {originalLanguage}"
  },
  "menu": {
    "account": "Account",
    "account_settings": "Account settings",
    "activities": "Activities",
    "add_mention_stream": "Add mention stream",
    "add_social_stream": "Add social stream",
    "admin_toolbar": {
      "beta": "Beta",
      "beta_disable": "Disable Beta Features",
      "beta_enable": "Enable Beta Features",
      "cache_killer_disabled": "Cache Killer disabled",
      "cache_killer_enabled": "Cache Killer active (normal)",
      "customer_view": "Customer View",
      "hide": "Hide Admin Toolbar",
      "hide_full_excerpts": "Hide full excerpts",
      "intercom": "Intercom",
      "show": "Show Admin Toolbar",
      "show_full_excerpts": "Show full excerpt",
      "sign_out": "Logout",
      "viewing_as": "viewing as"
    },
    "alerts": "Alerts",
    "breadcrumb": "Breadcrumb",
    "calendar": "Calendar",
    "campaigns": "Campaigns",
    "closed_enquiries": "Closed Enquiries",
    "create_tagged_report": "Create tagged mentions report",
    "crm": "CRM",
    "csl": "Cision Social Listening",
    "daily_highlights": "Daily Highlights",
    "edit_group": "Edit Group",
    "engage": "Engage",
    "front_pages": "Front Pages",
    "icon_size": "24px",
    "insights": "Insights",
    "instant_insights": "Instant Insights",
    "keyboard_shortcuts": "Keyboard Shortcuts",
    "launchpad": "Launchpad",
    "legal": "Legal",
    "listen": "Listen",
    "lists": "Lists",
    "logo": {
      "instant_insights": "Instant Insights",
      "monitoring": "Monitoring",
      "outreach": "Outreach",
      "social": "Social"
    },
    "managed": "Managed",
    "media_and_transcripts": "Media & Transcripts",
    "mention_stream_link": "{label} mention stream",
    "mention_stream_link_with_count": "{label} mention stream with 1 new mention | {label} mention stream with {total} new mentions",
    "mention_streams": "Mention Streams",
    "notifications": "Notifications",
    "open_enquiries": "Open Enquiries",
    "outreach": "Outreach",
    "owned": "Owned",
    "performance": "Performance",
    "reports": "Reports",
    "search": "Search",
    "search_lists": "Search Lists",
    "search_mention_streams": {
      "no_results": "No results found",
      "placeholder": "Search Mention Streams",
      "social_placeholder": "Search Social Streams"
    },
    "search_no_results": "No results found",
    "search_saved_searches": "Search Saved Searches",
    "section_link": "{title} streams",
    "see_more": "See More",
    "shared": "Shared",
    "shared_tagged": "Shared Tagged",
    "sign_out": "Sign-out",
    "social": "Social",
    "social_analyse": "Analyse",
    "social_stream_link": "{label} social stream",
    "social_stream_link_with_count": "{label} social stream with 1 new mention | {label} social stream with {total} new mentions",
    "stream_groups": {
      "mark_alerts_read": "Mark alerts as read",
      "settings": "Settings",
      "show_options": "Show group options"
    },
    "tagged": "Tagged",
    "tagged_stream_link": "{label} tag",
    "tagged_stream_link_with_count": "{label} tag with 1 tagged mention | {label} tag with {total} tagged mentions",
    "toggle_group": "Toggle {label} group",
    "toggle_outreach_lists": "Toggle Outreach Lists",
    "toggle_outreach_search": "Toggle Outreach Search",
    "toggle_section": "Toggle {title} streams",
    "tooltips": {
      "edit_manage_streams": "These Mention Streams are managed by your Account Manager.",
      "engage_settings": "Engage Settings",
      "owned_mention_streams": "These Mention Streams are created and managed by you",
      "owned_social_streams": "These Social Streams are created and managed by you",
      "refresh_mention_streams": "Refresh all Mention Streams",
      "refresh_social_streams": "Refresh all Social Streams",
      "shared_mention_streams": "These Mention Streams have been shared with you by other users in your organisation.",
      "shared_social_streams": "These Social Streams have been shared with you by other users in your organisation.",
      "shared_tagged": "These Tagged Folders have been shared with you by another user in your organisation",
      "tagged": "These mentions have been tagged by you"
    },
    "user_information": {
      "button_label": "User menu",
      "organisation": "Organisation",
      "team_logo": "Team logo"
    }
  },
  "menu_dropdown": {
    "close_dropdown": "Close publisher dropdown",
    "front_page": "Front Page"
  },
  "metric_editor": {
    "ave_summary": "An estimation of the monetary value of media coverage using an equivalent rate paid for advertising in any given media type.",
    "ave_title": "Advertising Value Equivalency",
    "curated_email_reports": "Curated Email Reports",
    "curated_email_reports_description": "{label} are email reports that include selected media coverage.",
    "default": "Default",
    "description": "Increase or decrease data points to align with your organisation’s standards. {newline} Changes will affect all users.",
    "error_loading": "There was an error loading the Multiplier",
    "error_updating": "There was an error updating the Multiplier",
    "impact_label": "This will impact:",
    "instant_insights": "Instant Insights",
    "instant_insights_description": "{label} is where you can create and save customized dashboards from your selected Mention Streams.",
    "instant_insights_reports": "Instant Insights Reports",
    "instant_insights_reports_description": "{label} are PDFs of your customized dashboards from your selected Mention Streams.",
    "last_updated_info": "Last updated by {user} {when}",
    "mention_stream_data": "Mention Stream Data",
    "mention_stream_data_description": "{label} represent realtime mentions from Print, Online, TV, Radio, Magazine, Podcast, and Social media coverage.",
    "mention_stream_reports": "Mention Stream Reports",
    "mention_stream_reports_description": "{label} are PDFs or CSV/Excel reports that provide all your media coverage and analysis.",
    "par_summary": "A metric used to assess the 'reach' or 'spread' of media coverage by calculating the viewership of coverage across media types.",
    "par_title": "Potential Audience Reach",
    "scheduled_reports": "Scheduled Reports",
    "scheduled_reports_description": "{label} are email reports that include pre-selected media coverage.",
    "title": "Metric Editor",
    "x": "x",
    "you": "you"
  },
  "microsoft_teams_ai_assistant_integration": {
    "microsoft_teams_ai_assistant": "Microsoft Teams",
    "sign_in_description": "Bring {platformName} into Microsoft Teams for instant access to {platformName} AI and real time notification",
    "sign_out_button": "Sign Out",
    "signed_in_description": "You are signed in to {platformName} AI Assistant"
  },
  "microsoft_teams_integration": {
    "copy_token_button_subtext": "Copy and paste this token into the message box in Microsoft Teams when prompted:",
    "enable_updates_description": "Edit your Mention Streams to enable updates to your Microsoft Teams Channels",
    "help_article_url": "https://help.streem.com.au/en/articles/5979838-microsoft-teams-integration",
    "microsoft_teams": "Microsoft Teams",
    "microsoft_teams_integration_suggestion": "Integrate {platformName} into your  Microsoft Teams so that your team never misses a notification",
    "remove_integration_alert": "Remove Microsoft Teams Integration?",
    "remove_integration_button": "Remove Integration",
    "set_up_analytics_alert": "{clickHere} to learn how to set up a Teams integration for {platformName}."
  },
  "mobile_trap": {
    "app_store_image": "App Store",
    "desktop_app_link": "Continue to Desktop App",
    "download_from_store": "Please download the {platformName} app from the App Store or Play Store.",
    "open_app_link": "Open in {platformName} App",
    "play_store_image": "Play Store",
    "require_help": "If you require more help, you can call {platformName} on {phone}"
  },
  "modal_popup": {
    "toggle_button": "Toggle button"
  },
  "modals": {
    "account_modal": {
      "beta_features_heading": "Beta Features",
      "title": "Account",
      "update_alert": "Account details updated!",
      "update_error": "Error updating Account details"
    },
    "add_to_bookmark_stream_modal": {
      "error_message": "There was an error searching or creating a bookmark"
    },
    "add_to_organisation_report_modal": {
      "add_to_report_button": "Add to Report",
      "article_summarisation": "Choose article summarisation",
      "existing_report_tab": "Existing Report",
      "items_count": "{folderLabel} ({itemsCount} items)",
      "load_folders_error": "Error loading folders",
      "long_summary": "Long Summary",
      "mention_saved": "Mention saved in your Daily Email Report!",
      "new_folder_label": "Create a folder to add this mention to | Create a folder to add these mentions to",
      "new_folder_placeholder": "New Folder label",
      "new_report_label": "Create a new Daily Email Report with this mention | Create a new Daily Email Report with these mentions",
      "new_report_tab": "New Report",
      "no_subject": "No Subject",
      "no_summaries": "No Summaries",
      "problem_saving_mention": "There was a problem saving this Mention to your Daily Email Report. Please try again",
      "select_existing_folder_option": "Existing Folder",
      "select_folder_label": "Select Folder to Add this mention to | Select Folder to Add these mentions to",
      "select_new_folder_option": "New Folder",
      "select_report_label": "Select Existing Report",
      "short_summary": "Short Summary",
      "title": "Add to Curated Email Report",
      "toggle_drafts_label": "Drafts Only"
    },
    "advanced_filters_modal": {
      "clear_all_filters": "Clear all filters",
      "clear_source_filters": "Clear all source filters",
      "clear_source_selections": "Clear all source selections",
      "content_label": "Content",
      "create_filter_set": "Create new Filter Set",
      "exclude": "Exclude",
      "filter_sets_label": "Filter Sets",
      "go_back": "Go back",
      "include": "Include",
      "keywords_label": "Keywords",
      "load_sources_error": "Failed to load saved source selections.",
      "menu_label": "Filter categories",
      "metrics_label": "Metrics",
      "no_query_snippets": "There can be no keyword snippets applied when modifying advanced filters.",
      "other_label": "Other",
      "reports_label": "CER/DER",
      "simple_boolean_error": "Invalid Boolean Query",
      "social_platforms_label": "Social Platforms",
      "source_switching": "Switching between Include/Exclude will reset all source selections and filters.",
      "sources_disabled_tooltip": "Sources disabled when only Social Media Type is enabled",
      "sources_label": "Sources",
      "title": "Advanced Filters"
    },
    "advanced_source_filters_modal": {
      "all_results": "All results ({count})",
      "clear_filters_label": "Clear all filters",
      "clear_selection_label": "Clear all selections",
      "expand_search": "Try expanding your filters, or reset your search.",
      "mobile_title": "Sources",
      "results_tab": "Results",
      "results_tab_limit": "Showing the top 10,000 results.{newline}Apply filters for refined results.",
      "results_tab_read_only": " Cannot use filters since the Mention Stream is read-only.",
      "search_empty": "Your search didn't return any results.",
      "search_results_placeholder": "Search in Results",
      "search_selection_placeholder": "Search in Selection",
      "select_filters": "Select filters to apply",
      "selected_sources": "{count} selected",
      "selected_tab": "Selected",
      "show_results": "Select filters to show results",
      "title": "Advanced Source Filters"
    },
    "ai_feedback_modal": {
      "submit": "Submit",
      "tell_us_more": "Tell us more",
      "thumbs_down_reason": {
        "bias_or_offensive_content": "Bias or Offensive Content",
        "lack_of_contextual_understanding": "Lack of Contextual Understanding",
        "poor_grammar_or_typos": "Poor Grammar or Typos",
        "repetitive_or_redundant": "Repetitive or Redundant",
        "too_long_or_overly_wordy": "Too Long or Overly Wordy"
      }
    },
    "ai_user_context_modal": {
      "clear_button": "Clear Focus Profile",
      "confirm_dialog_label": "Discard changes",
      "confirm_dialog_message": "Closing this window will discard your unsaved Focus Profile settings",
      "description": "Help {aiAssistant} provide more tailored responses by providing more context about your role, brand, goals, competitors, and key messages.",
      "fields": {
        "competitors": "Competitors",
        "competitors_placeholder": "E.g., brands, companies, organisations.",
        "first_name": "First Name",
        "goals": "Goals",
        "goals_placeholder": "E.g., track brand reputation, write engaging content, or monitor competitors.",
        "key_messages": "Key Messages",
        "key_messages_placeholder": "What messages or campaigns do you want to focus on?",
        "last_name": "Last Name",
        "organisation_name": "Organisation",
        "role": "Role"
      },
      "loading_error": "Error loading User Context",
      "save_error": "Something went wrong!",
      "save_error_message": "If this persists, please contact your Account Manager for support.",
      "save_successful": "User Context updated",
      "title": "Focus Profile",
      "tone_description": "Choose the response tone that best fits your brand voice and identity when creating social content and media outreach.",
      "tone_options": {
        "confident": "Confident",
        "default": "Default",
        "enthusiastic": "Enthusiastic",
        "formal": "Formal",
        "neutral": "Neutral",
        "persuasive": "Persuasive",
        "supportive": "Supportive",
        "witty_humorous": "Witty/Humorous"
      },
      "tone_title": "Tone",
      "user_context_content_violation_error": "Your input didn't pass our safety guidelines. Please review and adjust your message before continuing.",
      "user_context_error": "Your input cannot be saved because the text does not match what the field is for. Please review and adjust your message before continuing.",
      "user_context_fields_error": "Fields to adjust include: {fields}"
    },
    "ai_visibility_entities_modal": {
      "title": "AI Visibility Settings"
    },
    "ai_visibility_modal": {
      "create_dashboard": "Create Dashboard",
      "create_project": "Create Project",
      "dashboard_title": "{brandName} AI Visibility Dashboard",
      "description": "These settings help your dashboard show relevant data right away. You can also skip this and configure later from your dashboard.",
      "prompt_tips": {
        "introduction": "To craft an effective prompt description, start by clearly defining the purpose of the prompt. Use concise language to convey the main idea.{newline}For example:",
        "tip_1": "\"I want to track how Coca Cola is mentioned in media compared to Pepsi and other beverage competitors.\"",
        "tip_2": "\"I'm interested in tracking how the media portrays Coca Cola compared to Pepsi and other competitors in the beverage industry.\"",
        "tip_3": "\"I want to keep an eye on the media's sentiment towards Coca Cola in relation to Pepsi and other drink rivals.\"",
        "title": "Prompt description tips"
      },
      "steps": {
        "entities": "Entities (optional)",
        "prompts": "Prompt Generation",
        "sources": "Data Sources"
      },
      "title": "New AI Visibility Dashboard",
      "visibility_title": "AI Visibility Settings"
    },
    "audience_report_modal": {
      "confirm_button": "Generate Audience Report",
      "csv_excel_option": "CSV/Excel",
      "description": "Export audience data for the following the report to the following specification",
      "pdf_option": "PDF",
      "report_type_heading": "Report type",
      "title": "Audience Report"
    },
    "brand_profile_default_confirm_modal": {
      "audience_reports": "Audience Reports",
      "brand_profile": "Brand Profile:",
      "curated_email_reports": "Curated Email Reports",
      "heading": "{brandProfile} {brandName}",
      "impact_message": "Setting this Brand Profile as {organisationName}'s default profile will impact:",
      "instant_insights_reports": "Instant insights Reports",
      "scheduled_reports": "Scheduled Reports",
      "social_reports": "Social Reports",
      "tagged_mention_reports": "Tagged Mention Reports",
      "title": "Setting Default Brand Profile",
      "transcript_reports": "Transcript Reports"
    },
    "confirm_instant_insights_dashboard_duplicate_modal": {
      "too_many_dashboards": "Too many Dashboards open",
      "unsaved_warning": "There are unsaved changes, are you sure you want to proceed?",
      "warning_sentence": "The {dashboardName} Dashboard will be closed to make room for the duplicate Dashboard you've created."
    },
    "confirm_modal": {
      "title": "Are you sure?"
    },
    "confirm_notification_toggle_modal": {
      "access_title": "Access",
      "change_title": "The following changes will be applied:",
      "default_type": "Mention Stream",
      "notify_message": "Users removed from a {type} will not be notified",
      "notify_title": "Notify users by",
      "removed_status": "Removed",
      "toggle_email_label": "Email",
      "toggle_mobile_label": "Mobile",
      "user_title": "User"
    },
    "confirm_remove_bookmark_stream_modal": {
      "line_1": "Are you sure you want to remove this Shared {streamTypeLabel}?",
      "line_2": "Removing this {streamTypeLabel} will also remove it for {usersCount} user in your organisation.|Removing this {streamTypeLabel} will also remove it for {usersCount} users in your organisation.",
      "remove_shared_stream": "Remove Shared {streamTypeLabel}"
    },
    "confirm_remove_users_from_team": {
      "alerts": "Alerts",
      "insights": "Insights",
      "mention_streams": "Mention Streams",
      "message": "This will delete all data the users have created in {removedTeams} permanently.{removedItems}",
      "scheduled_reports": "Scheduled Reports",
      "title": "Are you sure you want to remove {removedUsers} from {removedTeams}?",
      "what_will_be_deleted": "What will be deleted:"
    },
    "content_teaser_modal": {
      "additional_content_title": "Additional Content",
      "additional_information_label": "Any additional information or questions:",
      "discover_text": "Click through to discover {platformName}'s extensive content offerings.",
      "get_in_touch_button": "Get in Touch",
      "learn_more": "Click through to learn more.",
      "mention_count": "{count} Mention in the past 30 days | {count} Mentions in the past 30 days",
      "request_access_title": "Request Access",
      "request_error": "Error submitting request.",
      "services_heading": "Which services are you interested in?",
      "success_message": "Your request was submitted successfully. A member of our team will be in touch within two business days.",
      "welcome_title": "Hi {firstName},"
    },
    "content_warning_modal": {
      "default_title": "Additional licensing costs may be incurred",
      "read_more": "Read More",
      "sub_text_available": "made available",
      "text": "{legalName} is obligated to report to our content partners all print articles and web links {subTextAvailable} to our customers (including the NLA and CLA). This is not limited to just the articles you click to access--we also report on articles that are made available to you from the searches you set up. Therefore, the more headlines seen by an individual in search results (as a result of scrolling through the mention stream), the more articles will be counted for reporting.",
      "toggle_warning_label": "I understand premium content may incur charges. Do not show again."
    },
    "copy_organisation_report": {
      "copy_error": "Unable to copy this report.",
      "description": "Copy the report to the following specification:",
      "title": "Copy Report"
    },
    "create_instant_download_confirm_modal": {
      "default_type": "Media Item",
      "text": "Your Instant-edit {type} will {newline} be sent to your inbox in the next {newline} few minutes"
    },
    "create_instant_download_modal": {
      "add_receipients_label": "Add Recipients",
      "channel_mention_type": "Channel",
      "clips_load_error": "Unable to load clips, please try again",
      "confirm_modal_error": "Unable to load clips, please try again",
      "duration_label": "Duration:",
      "end_time_label": "End time:",
      "exceed_minutes_request_text": " or {request}",
      "keyword_heading": "Keyword",
      "max_minutes_label": "Max {durationInMinutes} minutes",
      "media_item_channel_create_text": "To create your Media Item, select the syndicated channel you wish to download the item from.",
      "media_item_confirm_cancel_message": "Any edits made to this Media Item will not be saved.",
      "media_item_confirm_cancel_title": "Cancel Media Item editing",
      "media_item_download_text": "The Media Item can only be downloaded from {syndicationSourceName}, it has been selected automatically.",
      "media_item_edit_duration_text": "The Media Item cannot exceed {durationInMinutes} minutes.",
      "media_item_edit_text": "Adjust the yellow bar to select the start and finish time for your Media Item. {newline} Alternatively, you can select or edit the start and end times to manually capture a specific timeframe.",
      "media_item_edit_title": "Edit the Media Item",
      "media_item_exceed_minutes_text": "The Media Item cannot exceed {durationInMinutes} minutes, please select a shorter time frame{request}.",
      "media_item_format_title": "Media Item Format",
      "media_item_max_minutes_text": "The Media Item cannot exceed {durationInMinutes} minutes.",
      "media_item_modal_radio_title": "Radio Media Item Preview",
      "media_item_modal_title": "Instant-edit Media Item",
      "media_item_modal_tv_title": "TV Media Item Preview",
      "media_item_request_text": "Request a Media Item",
      "media_item_select_and_transcript_audio_option": "Audio-based Media Item + Transcript",
      "media_item_select_and_transcript_credits_description": "You currently don't have enough credits to order an Instant-edit Transcript, please contact your Account Manager.",
      "media_item_select_and_transcript_credits_text": "This instantly-available Transcript is compiled using a combination of technologies. This is subject to the availability of content at the time of generation. Please note, {platformName} offers verbatim, human generated transcription services at an additional cost. Please contact your dedicated Account Manager for more information{request}.",
      "media_item_select_and_transcript_video_option": "Video-based Media Item + Transcript",
      "media_item_select_audio_option": "Audio-based Media Item",
      "media_item_select_description": "You'll receive an email when this is ready, and can also download this via the Media & Transcripts page.",
      "media_item_select_video_option": "Video-based Media Item",
      "media_item_station_create_text": "To create your Media Item, select the syndicated station you wish to download the item from.",
      "media_item_toggle_accept_conditions_label": "You/{organisationName}, agree not to post, share, email or otherwise distribute this TV/Radio Media Item outside of your organisation, including to Facebook, X {'|'} Twitter, LinkedIn or any other social media network. The sharing of content outside your organisation is a breach of copyright and will result in termination of your license agreement and any relevant indemnities provided by {platformName} to {organisationName}",
      "media_item_type": "Media Item",
      "media_item_warning_text": "Unfortunately, a processing error means you can't instant-edit this item. If you'd still like to request this item, click Request Media Item below and our dedicated Account Management team will prepare this item on your behalf.",
      "mention_stream_heading": "Mention Stream",
      "program_heading": "Program",
      "recipients_heading": "Recipients (Optional):",
      "start_time_label": "Start time:",
      "station_mention_type": "Station",
      "summary_label": "Summary",
      "summary_placeholder": "Ex: The Prime Minister discussed the national roll-out of...",
      "syndication_channel_title": "Channel and Program",
      "syndication_select_channel_title": "Select a Channel",
      "syndication_select_station_title": "Select a Station",
      "syndication_station_title": "Station and Program",
      "thumbnail_heading": "Thumbnail",
      "thumbnail_recipients_tv_label": "Select a Thumbnail and Add Recipients",
      "time_heading": "Time",
      "title_label": "Title",
      "title_placeholder": "Ex: The Prime Minister discusses the...",
      "title_summary_title": "Add a Title & Summary",
      "transcript_request_channel_create_text": "To create your Transcript Request, select the syndicated channel you wish to download the item from.",
      "transcript_request_channel_modal_title": "TV Transcript Request Preview",
      "transcript_request_confirm_cancel_message": "Any edits made to this Transcript Request will not be saved.",
      "transcript_request_confirm_cancel_title": "Cancel Transcript Request editing",
      "transcript_request_download_text": "The Transcript Request can only be downloaded from {syndicationSourceName}, it has been selected automatically.",
      "transcript_request_edit_duration_text": "The Transcript Request cannot exceed {durationInMinutes} minutes.",
      "transcript_request_edit_text": "Adjust the yellow bar to select the start and finish time for your Transcript Request. {newline} Alternatively, you can select or edit the start and end times to manually capture a specific timeframe.",
      "transcript_request_edit_title": "Edit the Transcript Request",
      "transcript_request_exceed_minutes_text": "The Transcript Request cannot exceed {durationInMinutes} minutes, please select a shorter time frame{request}.",
      "transcript_request_format_description": "This instantly-available Transcript is compiled using a combination of technologies. This is subject to the availability of content at the time of generation. Please note, {platformName} offers verbatim, human generated transcription services at an additional cost. Please contact your dedicated Account Manager for more information{request}",
      "transcript_request_format_description_request": " or {request}",
      "transcript_request_format_text": "You'll receive an email when this is ready, and can also download this via the Media & Transcripts page.",
      "transcript_request_format_title": "Transcript Format - Word (.docx)",
      "transcript_request_max_minutes_text": "The Transcript Request cannot exceed {durationInMinutes} minutes.",
      "transcript_request_modal_title": "Instant-edit Transcript Request",
      "transcript_request_request_text": "Request a Transcript",
      "transcript_request_station_create_text": "To create your Transcript Request, select the syndicated station you wish to download the item from.",
      "transcript_request_station_modal_title": "Radio Transcript Request Preview",
      "transcript_request_toggle_accept_conditions_label": "You/{organisationName}, agree not to post, share, email or otherwise distribute this TV/Radio Transcript Request outside of your organisation, including to Facebook, X {'|'} Twitter, LinkedIn or any other social media network. The sharing of content outside your organisation is a breach of copyright and will result in termination of your license agreement and any relevant indemnities provided by {platformName} to {organisationName}",
      "transcript_request_type": "Transcript Request",
      "transcript_request_warning_text": "Unfortunately, a processing error means you can't instant-edit this item. If you'd still like to request this item, click Request Transcript Request below and our dedicated Account Management team will prepare this item on your behalf.",
      "unable_to_complete_request": "Unable to complete this request.",
      "warning_contact_text": "Unfortunately this Instant-edit request cannot be completed due to a processing error. If you'd still like to request this item, please refer to the relevant contact details in the help section by clicking the question mark in the top left-hand corner, or email {emailAddress} for further assistance."
    },
    "create_instant_download_process_modal": {
      "media_item_confirm_button": "Request Instant-edit Media Item for {cost}",
      "media_item_message": "Please note, as {organisationName} has exceeded the allowance of Instant-edit Media Items built into the Service level Agreement with {platformName}, you will be charged {cost} according to the Instant-edit Media Item Rate Card for this item",
      "transcript_request_confirm_button": "Request Instant-edit Transcript Request for {cost}",
      "transcript_request_message": "Please note, as {organisationName} has exceeded the allowance of Instant-edit Transcript Request built into the Service level Agreement with {platformName}, you will be charged {cost} according to the Instant-edit Transcript Request Rate Card for this item"
    },
    "daily_highlight_modal": {
      "australian_government_link": "official Australian Government information",
      "coronavirus_link": "Coronavirus data",
      "read_view_description": "Read {info} or view the latest {data}.",
      "title": "Daily Highlight"
    },
    "delete_team_confirmation_modal": {
      "alerts": "Alerts",
      "insights": "Insights",
      "mention_streams": "Mention Streams",
      "message": "This will delete this team and all associated data permanently. {removedItems}",
      "scheduled_reports": "Scheduled Reports",
      "title": "Are you sure you want to delete {teamName}?",
      "what_will_be_deleted": "What will be deleted:"
    },
    "delivered_recipients_modal": {
      "no_undelivered_recipients": "The report was delivered to all recipients.",
      "reason_text": "In most cases, this is due to an incorrect email address or an employee that has left the organisation. Please contact your Account Manager for details.",
      "title": "Curated Email Report: Undelivered Recipients",
      "undelivered_text": "We weren't able to deliver the Curated Email Report to the following recipients."
    },
    "distribution_list_form_modal": {
      "add_title": "Create distribution list",
      "edit_title": "Edit distribution list"
    },
    "duplicate_media_item_transcript_modal": {
      "media_item_create_button": "Create a new Media Item",
      "media_item_message": "A similar Media Item has already been requested for this time period, which you can find under 'Media & Transcripts'.",
      "media_item_title": "Duplicate Media Item",
      "media_item_view_button": "View Media Items",
      "transcript_request_create_button": "Create a new Transcript Request",
      "transcript_request_message": "A similar Transcript Request has already been requested for this time period, which you can find under 'Media & Transcripts'.",
      "transcript_request_title": "Duplicate Transcript Request",
      "transcript_request_view_button": "View Transcript Requests"
    },
    "edit_filter_set_modal": {
      "clear_all_filters": "Clear all filters",
      "clear_source_filters": "Clear all source filters",
      "clear_source_selections": "Clear all source selections",
      "content_label": "Content",
      "empty_group_message": "Please specify a group for your Filter Set.",
      "empty_group_title": "Filter Set Group is required",
      "empty_name_message": "Please enter a name for your Filter Set.",
      "empty_name_title": "Filter Set Name is required",
      "exclude": "Exclude",
      "go_back": "Go back",
      "include": "Include",
      "info_label": "Info",
      "keywords_label": "Keywords",
      "metrics_label": "Metrics",
      "no_filters_message": "Please select at least one filter for your Filter Set.",
      "no_filters_title": "At least one filter is required",
      "other_label": "Other",
      "reports_label": "CER/DER",
      "source_switching": "Switching between Include/Exclude will reset all source selections and filters.",
      "sources_disabled_tooltip": "Sources disabled when only Social Media Type is enabled",
      "sources_label": "Sources",
      "title": "Filter Sets"
    },
    "edit_recipients_modal": {
      "title": "Edit Recipients"
    },
    "edit_tracked_publishers_modal": {
      "description": "Select the Sources you would like to see in your {frontPages} and {trending} views.",
      "front_pages": "Front Pages",
      "region": "Region",
      "regions": {
        "apac": "APAC",
        "au": "Australia",
        "ca": "Canada",
        "dach": "Austria, Germany and Switzerland",
        "fr": "France",
        "international": "International",
        "nordic": "Nordics",
        "nz": "New Zealand",
        "uk": "United Kingdom",
        "us": "United States of America"
      },
      "title": "Tracked Sources",
      "trending": "Trending"
    },
    "email_signature_create_modal": {
      "save_signature_label": "Save signature as",
      "save_signature_placeholder": "Untitled"
    },
    "exclude_mention_modal": {
      "message_multiple": "Are these items incorrect or irrelevant? Let us know why so we can better refine your Media Brief.",
      "message_single": "Is this item incorrect or irrelevant? Let us know why so we can better refine your Media Brief.",
      "reasons": {
        "A": "Source is irrelevant",
        "B": "Content is inaccurate or incorrect",
        "C": "Keyword is no longer relevant to the brief",
        "D": "Contains advertising material",
        "E": "Other"
      },
      "title": "Remove from Mention Stream"
    },
    "excluded_mentions_modal": {
      "add_alert": "This Mention has been added back to this Stream.",
      "add_back_button": "Add Back",
      "add_back_tooltip": "Add back to Stream",
      "load_error": "Unable to load excluded mentions",
      "removed_comment": "Removed comment:",
      "title": "Removed mentions from {streamLabel}"
    },
    "filter_mentions_modal": {
      "impact_threshold_label": "Impact Threshold",
      "title": "Filter {sourceLabel} Mentions",
      "toggle_apply_all_label": "Apply to all Media Types applicable"
    },
    "flag_mention_for_am_review": {
      "comment_heading": "Add a comment",
      "flagged_alert": "Mention flagged for AM review.",
      "notes_placeholder": "Keyword issues (ie needs to be further contextualised, exclusions need to be added), or why sources don't match the spec etc. Any additional info that can help the Account Manager update the brief.",
      "reason_heading": "Select a reason:",
      "reasons": {
        "A": "False mention (keyword picked up mention not relevant to keyword)",
        "B": "Broken keyword (keyword is too vague or not working as intended)",
        "C": "News aggregator, press release site",
        "D": "Irrelevant source (other)",
        "E": "Spam (old article, reposts)"
      },
      "save_error": "Unable to save comment",
      "title": "Flagging a mention for AM Review"
    },
    "insights_generate_scheduled_report_modal": {
      "add_distribution_list": "Add from distribution list",
      "brand_profile_label": "Brand Profile",
      "brand_profile_placeholder": "Select a brand profile",
      "brand_profile_subtext": "This will display your selected logo and theme colour on the cover page",
      "daily_frequency": "Daily",
      "delivery_date_time_label": "Delivery Date and Time",
      "delivery_frequency_label": "Set Delivery Frequency",
      "delivery_time_label": "Delivery Time",
      "discard_changes_message": "You have unsaved changes. If you close this modal, your changes will be lost.",
      "distribution_list_name_with_count": "{name} ({count} recipient) | {name} ({count} recipients)",
      "duplicate_recipient_error": "This recipient has already been added.",
      "edit_title": "Edit Scheduled Report",
      "fortnightly_frequency": "Fortnightly",
      "include_key_insights": "Include Key Insights",
      "language_label": "Language",
      "load_brand_profiles_error": "There was an error loading Brand Profiles. Please try again.",
      "load_distribution_lists_error": "There was an error loading distribution lists. Please try again.",
      "loading_brand_profiles": "Loading Brand Profiles...",
      "loading_schedule": "Loading Schedule...",
      "monthly_custom_day": "Custom",
      "monthly_day_15": "Day 15",
      "monthly_day_label": "Delivery Day",
      "monthly_first_day": "First day",
      "monthly_frequency": "Monthly",
      "monthly_last_day": "Last day",
      "next_delivery_message": "The next report will be delivered on {date} at {time}",
      "no_distribution_list_recipients": "No recipients",
      "no_distribution_lists": "No distribution lists available",
      "once_frequency": "Once",
      "recipients_label": "Recipients",
      "recipients_subtext": "Add recipients from an existing distribution list or manually add emails.",
      "remove_recipient_label": "Remove {recipient}",
      "report_description_label": "Description (optional)",
      "report_name_label": "Report Name",
      "report_period_label": "Report Period",
      "save_and_close": "Save and Close",
      "scheduled_report_title": "Scheduled Report",
      "title": "New Scheduled Report",
      "weekly_days_label": "Set the Days of the Week",
      "weekly_frequency": "Weekly"
    },
    "insights_plus_teaser_modal": {
      "additional_information_label": "Any additional information or questions:",
      "fact_sheet_description": "Read more information about Insights Plus reporting and how these reports could inform your media strategy.",
      "fact_sheet_title": "Product Fact Sheet",
      "find_out_more_title": "Find out more",
      "frequency_heading": "What frequency are you interested in?",
      "frequency_options": {
        "annual": "Annual",
        "half_yearly": "Half Yearly",
        "monthly": "Monthly",
        "quarterly": "Quarterly"
      },
      "get_in_touch_title": "Get in touch",
      "sample_description": "Take a look at a sample monthly report to see how Insights Plus could elevate your regular media reporting.",
      "sample_title": "Sample Insights Plus Report",
      "success_message": "Your request was submitted successfully. A member of our team will be in touch within two business days.",
      "success_title": "Request Submitted"
    },
    "instant_download_warning": {
      "request_media_item": "Request Media Item",
      "request_transcript": "Request Transcript"
    },
    "instant_insights_dashboard_open_modal": {
      "charts_count": "{charts} Chart | {total} Charts",
      "confirm_message_line_1": "{reportName} is shared with other team members.",
      "confirm_message_line_2": "Are you sure you want to delete it?",
      "confirm_message_line_3": "Are you sure you want to delete {reportName}?",
      "delete_error": "There was a problem deleting report: {reportName}",
      "media_types_count": "{mediaTypes} Media Types | {total} Media Types",
      "mention_steams_count": "{streams} Mention Stream | {total} Mention Streams",
      "no_dashboards_text": "No saved dashboard found",
      "save_error": "Error loading saved insights dashboards",
      "search_placeholder": "Find a dashboard",
      "shared_with_team_tooltip": "This dashboard is shared with other team members.",
      "shared_with_you_tooltip": "This dashboard has been shared with you.",
      "title": "Open saved dashboard"
    },
    "instant_insights_dashboard_save_modal": {
      "cancel_message": "Any edits made to this dashboard setup will not be saved.",
      "cancel_title": "Cancel Saving?",
      "chart_validation": "Must select at least one chart",
      "date_picker_label": "From {afterLabel} To {beforeLabel}",
      "group_syndication_heading": "Group Syndications Together",
      "heading": "Save selected dashboard configuration",
      "media_type_validation": "Must select at least one media type",
      "media_types_label": "Media Types:",
      "name_heading": "Name of dashboard",
      "selected_charts_description": "Click and drag to re-order charts.",
      "selected_charts_label": "Selected charts:",
      "stream_validation": "Must select at least one stream",
      "title": "Save Instant Insights Dashboard",
      "toggle_collapse_syndicated_label": "By selecting this option, all syndicated news coverage will be counted as a single item."
    },
    "instant_insights_generate_pdf_modal": {
      "brand_profile_label": "Brand Profile",
      "brand_profile_load_error": "There was a problem loading Brand Profiles.",
      "brand_profile_subtext": "This will display your selected logo and theme colour on the cover page",
      "include_key_insights": "Include Key Insights",
      "include_key_insights_tooltip": "Include Key Insights page in the report",
      "key_insights_date_range": "Select Date Range",
      "key_insights_date_range_custom": "Custom",
      "key_insights_date_range_default": "Default",
      "key_insights_date_range_default_subtext": "Dashboard level date range will be applied to Key Insights",
      "key_insights_date_range_subtext": "Select a date range for Key Insights",
      "key_insights_label": "Key Insights",
      "language_dropdown_subtext": "This will populate your PDF in the chosen language.",
      "language_label": "Language",
      "report_title_label": "Title",
      "report_title_subtext": "This will display on the cover page",
      "summary_label": "Summary (OPTIONAL)",
      "summary_placeholder": "Summary",
      "summary_subtext": "This will display on the second page in the Key Insights section",
      "title": "Generate PDF"
    },
    "media_release_preview_modal": {
      "attachments_heading": "Attachments",
      "body_heading": "Body",
      "no_attachments_subtext": "No Attachments",
      "subject_heading": "Subject",
      "title": "Preview Media Release"
    },
    "media_release_send_test_modal": {
      "email_label": "Email",
      "first_name_label": "First name",
      "last_name_label": "Last name",
      "send_test_button": "Send test",
      "title": "Send Test Email"
    },
    "media_release_template_save_modal": {
      "save_as_heading": "Save As",
      "save_template_button": "Save template",
      "title": "Save Template",
      "title_label": "Title",
      "toggle_existing_template_label": "Existing template",
      "toggle_new_template_label": "New template"
    },
    "mediatrack_international_print_modal": {
      "message": "Full-text access is no longer available through the {platformName} platform for this publication. However, you can still monitor mentions with access to headlines, snippets, and direct links to full articles online. Mentions continue to count within Instant Insights and other reports you create.",
      "title": "Print Item"
    },
    "news_summary_subscription_modal": {
      "delivery_heading": "Delivery",
      "delivery_message": "Send notifications via the following delivery methods",
      "error_message": "Error loading notification settings",
      "title": "Daily Highlight Notification",
      "toggle_email_label": "Email",
      "toggle_mobile_label": "Mobile"
    },
    "organisation_report_external_item_modal": {
      "body_headng": "Body (Optional)",
      "choose_file_button": "Choose a file",
      "folder_label": "Folder",
      "keyword_highlight_label": "Keyword to highlight (Optional)",
      "publication_date_heading": "Publication Date (Optional)",
      "remove_file_button": "Remove {name}",
      "select_date_placeholder": "Select a date",
      "source_label": "Source (Optional)",
      "source_subtext": "External Items must include a URL or file attachment.",
      "title": "Add External Item",
      "title_label": "Title",
      "url_label": "URL"
    },
    "organisation_report_preview_modal": {
      "title": "Curated Email Report Preview"
    },
    "organisation_report_summary_modal": {
      "error": "The item can't be summarised.",
      "financial_times_count": "Financial Times Summarisation Total: {summarisationTotal}",
      "summarising_mention": "Summarising Mention",
      "title": "Mention Summary",
      "word_count": "Word count: {wordCounter}"
    },
    "organisation_team_form_modal": {
      "add_button": "Confirm",
      "add_title": "Add Team",
      "edit_title": "Update Team",
      "load_users_error": "There was an error loading users",
      "search_users_placeholder": "Search Users",
      "update_button": "Update",
      "update_error_title": "There was a problem updating team details",
      "users_label": "Usersload_team_error"
    },
    "outreach_audience_type_modal": {
      "content_types": {
        "consumer": "Consumer",
        "technical_scientific_academic": "Technical / Scientific / Academic",
        "trade": "Trade"
      },
      "title": "Audience Type"
    },
    "outreach_change_request_modal": {
      "contact_missing_text": "If you've noticed that a contact is missing from our database, that contact might be on our {link}.",
      "email_label": "Your Email",
      "global_address_blocklist": "Global Address Blocklist",
      "message_label": "Message",
      "message_subtext": "Please provide as much detail as possible in order to aid us in better processing your request. For new contacts, please provide a minimum of their name and an example of an outlet where their work has been published.",
      "name_label": "Your Name",
      "region_options": [
        [
          "1",
          "Canada"
        ],
        [
          "2",
          "Denmark, Finland, Norway, Sweden"
        ],
        [
          "3",
          "France, Belgium, Luxembourg"
        ],
        [
          "4",
          "Germany, Austria, Switzerland"
        ],
        [
          "5",
          "Latin America"
        ],
        [
          "6",
          "MENA"
        ],
        [
          "7",
          "Netherlands"
        ],
        [
          "8",
          "Portugal"
        ],
        [
          "9",
          "Rest of Europe, Africa, Asia"
        ],
        [
          "10",
          "Spain, Italy"
        ],
        [
          "11",
          "UK / Australia & NZ",
          [
            "au",
            "uk"
          ]
        ],
        [
          "12",
          "USA"
        ]
      ],
      "request_error": "Error when submitting request",
      "request_options": {
        "general": "General Media Data Inquiry",
        "influencer": "Journalist Update",
        "outlet": "Outlet Update"
      },
      "select_region_label": "Your Region",
      "select_region_tooltip": "Our regions are grouped together in a way that allows us to provide you with the best possible service based on your possible native language, while also taking into account the number of requests we receive. If you don't see your region included in our list, please select the most relevant option available.",
      "select_request_type_label": "Request Type",
      "select_request_type_tooltip_general_description": " Use for any other questions to our Media Research team, including questions pertaining to contacts missing from our database.",
      "select_request_type_tooltip_general_heading": "General Media Data Inquiry:",
      "select_request_type_tooltip_journalist_description": "Use when requesting an update to a journalist.",
      "select_request_type_tooltip_journalist_heading": "Journalist Update:",
      "select_request_type_tooltip_outlet_description": "Use when requesting an update to an outlet.",
      "select_request_type_tooltip_outlet_heading": "Outlet Update:",
      "submit_request_text": "Please complete the form below to submit an update request to our Media Research Team.",
      "thankyou_alert": "Thank you! Your update request has been submitted successfully",
      "title": "Request Changes"
    },
    "outreach_contact_add_contacts_modal": {
      "add_button": "Add to List",
      "cancel_button": "Cancel",
      "confirmation_tooltip": "Contacts Added",
      "contacts_search_description": "Search for individual Journalists or Outlets to add to your list",
      "contacts_search_label": "CONTACTS",
      "contacts_search_placeholder": "Search for a Journalist or Outlet",
      "private_contacts_search_description": "Search for private contacts to add to your list",
      "private_contacts_search_label": "PRIVATE CONTACTS",
      "see_all_confirmation_cancel_button": "Cancel",
      "see_all_confirmation_confirm_button": "Confirm",
      "see_all_confirmation_message": "By leaving this page, any selected contacts will not be added to your list.",
      "see_all_confirmation_title": "Are you sure?",
      "selected_contacts_search_description": "Review and manage all contacts that have been selected for this list",
      "selected_contacts_search_label": "SELECTED CONTACTS",
      "selected_contacts_total_contacts": "TOTAL CONTACTS",
      "table_heading_email": "Email",
      "table_heading_source": "Source",
      "table_no_selected_contacts": "No recipients to display",
      "table_source_journalists": "Journalist",
      "table_source_outlets": "Outlet",
      "table_source_private_influencers": "Private Contact",
      "title": "Add Contacts"
    },
    "outreach_contact_add_to_list_modal": {
      "add_contacts_confirm_button": "Create Media Release",
      "add_contacts_confirm_message": "{contacts} have been added to {lists}",
      "add_contacts_confirm_title": "New contacts added",
      "add_contacts_error": "Unable to add Contacts to Lists",
      "build_media_release_error": "Error building Media Release",
      "contacts": "{total} contact | {total} contacts",
      "create_button": "Create New List",
      "create_list_button": "Create New List",
      "create_list_error": "There was an error creating the Contact List",
      "create_list_message": "List {name} has been created",
      "lists": "{total} lists",
      "lists_selected": "{total} List selected | {total} Lists selected",
      "load_contacts_error": "Error loading Contact Lists",
      "private": "Private",
      "title": "Add to list"
    },
    "outreach_contact_added_to_list_modal": {
      "build_media_release_error": "Error building Media Release",
      "build_pitch_error": "Error building Pitch",
      "contacts": "{total} contact | {total} contacts",
      "create_media_release_button": "Create Media Release",
      "create_pitch_button": "Create Pitch",
      "description": "{contacts} has been added to {lists} | {contacts} have been added to {lists}",
      "lists": "{total} lists",
      "title": "New contacts added"
    },
    "outreach_contact_details_modal": {
      "description": "Add private details for Ryan Daws which is visible across your organisation.",
      "title": "Add Private Data"
    },
    "outreach_contact_list_added_to_list_modal": {
      "cancel_button": "Cancel",
      "contacts": "{total} contact | {total} contacts",
      "description": "{contacts} has been added to {lists} | {contacts} have been added to {lists}",
      "go_to_list_button": "Go to List",
      "lists": "{total} selected lists",
      "new_list_title": "New List Created",
      "open_lists_tab_button": "Open Lists Tab",
      "title": "Contacts Added"
    },
    "outreach_contact_list_confirmation_modal": {
      "create_media_release_button": "Create Media Release",
      "create_media_release_error": "Error building Media Release",
      "existing_list_text": "List {contactName} now contains {total} contact. | List {contactName} now contains {total} contacts.",
      "existing_list_title": "Added to {contactName} list",
      "list_created_text": "A new list {contactName} created with {total} contact. | A new list {contactName} created with {total} contacts.",
      "list_created_title": "List Created",
      "view_list_button": "View List"
    },
    "outreach_contact_list_modal": {
      "add_to_list_title": "Add to List",
      "create_list_message": "List {name} has been created",
      "create_list_title": "Create New List",
      "description_label": "Description",
      "edit_list_title": "Edit List",
      "load_folder_error": "Error loading Folder",
      "load_folders_error": "Error loading Folders",
      "load_list_error": "Error loading List",
      "save_list_error": "Error saving List",
      "select_choose_list_label": "Choose List",
      "select_choose_list_placeholder": "Select a list",
      "select_choose_list_validation": "Must select a list",
      "toggle_private_label": "Private",
      "toggle_public_label": "Public",
      "update_list_message": "List {name} has been updated",
      "visibility_restriction_text": "Only {contactListUserName} can edit the details of this list"
    },
    "outreach_contact_list_selection_modal": {
      "created_by_heading": "Created by",
      "list_name_heading": "List Name",
      "load_contact_lists_error": "Error loading Contact Lists",
      "private": "Private",
      "public": "Public",
      "title": "1 list selected | {total} lists selected",
      "visibility_heading": "Visibility"
    },
    "outreach_contact_list_tags_modal": {
      "error_message": "Error adding tags",
      "title": "Add Tags",
      "updated_message": "Contact List updated"
    },
    "outreach_contact_lists_filter_modal": {
      "description": "Select lists to filter contacts by list membership.",
      "load_error": "Error loading lists",
      "no_lists": "No lists found",
      "search_placeholder": "Search lists",
      "title": "Filter by List"
    },
    "outreach_contact_mailing_list_selection_modal": {
      "contacts_heading": "Contacts",
      "list_name_heading": "List Name",
      "load_contact_lists_error": "Error loading Contact Lists",
      "load_contact_mailing_lists_error": "Error loading Contact Lists",
      "title": "1 Mailing list selected | {total} Mailing lists selected"
    },
    "outreach_coverages_modal": {
      "coverages": {
        "international": "International",
        "local": "Local",
        "national": "National",
        "regional": "Regional"
      },
      "title": "News Focus"
    },
    "outreach_database_matches_panel": {
      "back_to_private_contacts": "Go back to Private Contacts",
      "found_matches": "We found {count} potential match in our database. | We found {count} potential matches in our database.",
      "no_matches": "No database matches found",
      "title": "Potential Matches"
    },
    "outreach_dma_modal": {
      "title": "Designated Market Areas"
    },
    "outreach_duplicate_contact_list_modal": {
      "duplicate_name": "Copy of {contactListName}",
      "name_label": "Name of new contact list",
      "name_placeholder": "Enter List name",
      "title": "Duplicate {contactListName}"
    },
    "outreach_frequencies_modal": {
      "frequencies": {
        "annual": "Annual",
        "bi_monthly": "Bi-Monthly",
        "daily": "Daily",
        "monthly": "Monthly",
        "no_frequency_established": "No Frequency Established",
        "quarterly": "Quarterly",
        "semi_annual": "Semi-Annual",
        "semi_monthly": "Semi-Monthly",
        "weekly": "Weekly"
      },
      "title": "Frequencies"
    },
    "outreach_gab_notice_modal": {
      "acknowledge_button": "Acknowledge",
      "text_line_1": "Our Global Address Blocklist, or GAB, is a list of influencers that have opted out of our database. This list is managed and tracked daily. While we pride ourselves in having the most recent and accurate data available, data privacy laws prevent us from being able to display profiles for influencers that have opted out. For the same reasons, we also cannot share which specific influencers have opted out of our database.",
      "text_line_2": "Once an influencer informs us that they no longer wish to be included in our database, all public profile data for that influencer will be removed. This influencer will no longer appear in any search results and will be removed from any lists that you may have added them to. To ensure that nothing slips through the cracks, we also have measures in place to remove blocked email addresses from any email communications you send using our platform.",
      "text_line_3": "Upon downloading any influencer lists, we also have failsafe measures in place to automatically remove any contacts that are on the GAB. All influencer list exports are recommended to be used during the day the list is first downloaded. {legalName} assumes no responsibility for the use or storage of influencer data downloaded from our platform after the day that the list was downloaded.",
      "title": "Global Address Blocklist"
    },
    "outreach_languages_modal": {
      "languages": {
        "Adi": "Adi",
        "Afrikaans": "Afrikaans",
        "Akan": "Akan",
        "Albanian": "Albanian",
        "Amharic": "Amharic",
        "Arabic": "Arabic",
        "Armenian": "Armenian",
        "Assamese": "Assamese",
        "Awadhi": "Awadhi",
        "Azerbaijani": "Azerbaijani",
        "Azeri": "Azeri",
        "Bahasa Indonesia": "Bahasa Indonesia",
        "Bahasa Malaysia": "Bahasa Malaysia",
        "Bangla": "Bangla",
        "Basque": "Basque",
        "Belarusian": "Belarusian",
        "Bengali": "Bengali",
        "Berber": "Berber",
        "Bosnian": "Bosnian",
        "Bulgarian": "Bulgarian",
        "Burmese": "Burmese",
        "Cambodian": "Cambodian",
        "Cantonese": "Cantonese",
        "Catalan": "Catalan",
        "Cebuano": "Cebuano",
        "Chamorro": "Chamorro",
        "Chinese": "Chinese",
        "Cree": "Cree",
        "Creole": "Creole",
        "Croatian": "Croatian",
        "Czech": "Czech",
        "Danish": "Danish",
        "Dari": "Dari",
        "Divehi": "Divehi",
        "Dutch": "Dutch",
        "Dzongkha": "Dzongkha",
        "Efik": "Efik",
        "English": "English",
        "Esperanto": "Esperanto",
        "Estonian": "Estonian",
        "Euskera": "Euskera",
        "Faroese": "Faroese",
        "Farsi (Eastern)": "Farsi (Eastern)",
        "Farsi (Western)": "Farsi (Western)",
        "Fijian": "Fijian",
        "Filipino": "Filipino",
        "Finnish": "Finnish",
        "Flemish": "Flemish",
        "French": "French",
        "French Canadian": "French Canadian",
        "French/Bilingual": "French/Bilingual",
        "Frisian": "Frisian",
        "Gaelic": "Gaelic",
        "Galician": "Galician",
        "Georgian": "Georgian",
        "German": "German",
        "Greek": "Greek",
        "Greenlandic": "Greenlandic",
        "Guarani": "Guarani",
        "Gujarati": "Gujarati",
        "Haryanvi": "Haryanvi",
        "Hausa": "Hausa",
        "Hawaiian": "Hawaiian",
        "Hebrew": "Hebrew",
        "Hiligaynon": "Hiligaynon",
        "Hindi": "Hindi",
        "Hindustani": "Hindustani",
        "Hiri Motu": "Hiri Motu",
        "Hmong": "Hmong",
        "Hungarian": "Hungarian",
        "Icelandic": "Icelandic",
        "Igbo": "Igbo",
        "Indonesian": "Indonesian",
        "Inuktitut": "Inuktitut",
        "Inuttut": "Inuttut",
        "Irish": "Irish",
        "Italian": "Italian",
        "Jaintia": "Jaintia",
        "Japanese": "Japanese",
        "Javanese": "Javanese",
        "Kannada": "Kannada",
        "Kazakh": "Kazakh",
        "Khalka Mongol": "Khalka Mongol",
        "Khmer": "Khmer",
        "Kinyarwanda": "Kinyarwanda",
        "Kirghiz": "Kirghiz",
        "Kirundi": "Kirundi",
        "Kiswahili": "Kiswahili",
        "Korean": "Korean",
        "Kurdish": "Kurdish",
        "Kyrgyz": "Kyrgyz",
        "Lao": "Lao",
        "Latin": "Latin",
        "Latvian": "Latvian",
        "Lithuanian": "Lithuanian",
        "Luganda": "Luganda",
        "Luxembourgish": "Luxembourgish",
        "Macedonian": "Macedonian",
        "Malagasy": "Malagasy",
        "Malay": "Malay",
        "Malayalam": "Malayalam",
        "Maltese": "Maltese",
        "Mandarin": "Mandarin",
        "Marathi": "Marathi",
        "Marshallese": "Marshallese",
        "Ndebele": "Ndebele",
        "Nepali": "Nepali",
        "Niuean": "Niuean",
        "Norwegian": "Norwegian",
        "Oji": "Oji",
        "Ojibway": "Ojibway",
        "Oriya": "Oriya",
        "Pashto (Eastern)": "Pashto (Eastern)",
        "Pashto (Western)": "Pashto (Western)",
        "Persian": "Persian",
        "Pijin": "Pijin",
        "Polish": "Polish",
        "Portuguese": "Portuguese",
        "Punjabi": "Punjabi",
        "Romanian": "Romanian",
        "Romansch": "Romansch",
        "Russian": "Russian",
        "Rwanda": "Rwanda",
        "Saami": "Saami",
        "Samoan": "Samoan",
        "Sanskrit": "Sanskrit",
        "Serbian": "Serbian",
        "Serbo-Croat": "Serbo-Croat",
        "Sesotho": "Sesotho",
        "Shona": "Shona",
        "Sindhi": "Sindhi",
        "Sinhala": "Sinhala",
        "Slovak": "Slovak",
        "Slovene": "Slovene",
        "Slovenian": "Slovenian",
        "Somali": "Somali",
        "Sorbian": "Sorbian",
        "Sotho": "Sotho",
        "Spanish": "Spanish",
        "Spanish/Bilingual": "Spanish/Bilingual",
        "Sunda": "Sunda",
        "Swahili": "Swahili",
        "Swazi": "Swazi",
        "Swedish": "Swedish",
        "Tagalog": "Tagalog",
        "Taiwanese": "Taiwanese",
        "Tajik": "Tajik",
        "Tamil": "Tamil",
        "Tartar": "Tartar",
        "Telugu": "Telugu",
        "Thai": "Thai",
        "Tongan": "Tongan",
        "Turkish": "Turkish",
        "Turkmen": "Turkmen",
        "Tuvaluan": "Tuvaluan",
        "Ukrainian": "Ukrainian",
        "Urdu": "Urdu",
        "Uzbek (Northern)": "Uzbek (Northern)",
        "Venda": "Venda",
        "Vietnamese": "Vietnamese",
        "Welsh": "Welsh",
        "Xhosa": "Xhosa",
        "Yiddish": "Yiddish",
        "Yoruba": "Yoruba",
        "Zulu": "Zulu"
      },
      "title": "Languages"
    },
    "outreach_locations_modal": {
      "search_description": "Show results based on the location of the contact.",
      "search_placeholder": "Search location",
      "title": "Physical Locations"
    },
    "outreach_media_release_analytics_remove_undeliverable_contacts_modal": {
      "email_heading": "Email",
      "filters": {
        "include_undeliverable_contacts": "Include undeliverable contacts",
        "include_unsubscribed_contacts": "Include unsubscribed contacts"
      },
      "list_heading": "List",
      "load_error": "Error loading contacts",
      "no_contacts_found": "No contacts found",
      "remove_button_label": "Remove",
      "remove_confirmation": {
        "cancel_label": "Cancel",
        "confirm_label": "Confirm",
        "contacts": "{amount} contact | {amount} contacts",
        "lists": "{amount} list | {amount} lists",
        "message": "You are about to remove {contacts} from {lists}?{newline}Are you sure? | You are about to remove {contacts} from {lists}?{newline}Are you sure?",
        "title": "Remove Contacts"
      },
      "remove_error": "Error removing contacts",
      "remove_from_all_lists_checkbox_label": "Remove from all lists",
      "remove_from_all_lists_cision_tooltip": "Selecting this option will remove the contact from all lists that it's a part of",
      "remove_from_all_lists_streem_tooltip": "Selecting this option will remove the contact from all lists that it's a part of (except Streem maintained mailing lists)",
      "remove_success": "Contacts removed",
      "search_input_placeholder": "Search by name or email",
      "selected": "{total} selected",
      "title": "Remove Contacts from Lists",
      "type_heading": "Type",
      "undeliverable_contacts_tooltip": "Email bounce backs from the {app} database go to our dedicated Media Research team for further investigation"
    },
    "outreach_private_influencer_bulk_upload_modal": {
      "add_private_contacts": "Add Private Contacts",
      "add_to_list": "Add Private Contacts to Lists (Optional)",
      "csv_success": "Your contacts are being imported. You will receive an email once this is ready.",
      "import_action_label": "Import Private Contacts",
      "import_error": "Error submitting private contacts import",
      "import_validate_error": "Error validating private contacts CSV",
      "incomplete_import_message": "By leaving, any CSV rows will not submitted for import.",
      "incomplete_import_title": "Unfinished import submission",
      "map_fields": "Match CSV columns for: "
    },
    "outreach_private_influencer_modal": {
      "add_title": "Add Private Contacts",
      "address_line1_label": "Address Line 1",
      "address_line2_label": "Address Line 2",
      "address_line3_label": "Address Line 3",
      "bulk_upload_tab": "Bulk Upload",
      "city_label": "City",
      "country_label": "Country",
      "county_label": "County",
      "create_fail_message": "Failed to create private journalist",
      "create_success_message": "Private Contact successfully created.",
      "details_label": "Details",
      "edit_title": "Edit Private Journalist",
      "error_message_heading": "Error Message",
      "import_alert": "Import failed. The file has the following errors:",
      "import_error": "Error uploading private contacts CSV",
      "import_message": "1 private contact successfully imported. | {total} private contacts successfully imported.",
      "import_tooltip": "Upload a valid CSV import file",
      "job_title_label": "Job title",
      "language_label": "Language",
      "last_name_label": "Last Name",
      "linkedin_label": "Linkedin Profile",
      "list_addition_fail_message": "Private contact could not be added to the list | Private contact could not be added to the {total} lists",
      "list_addition_success_message": "Private Contact successfully added to 1 list | Private Contact successfully added to {total} lists",
      "lists_label": "Add to List",
      "load_error_message": "Error loading Private Contact.",
      "manual_entry_tab": "Manual Entry",
      "notes_label": "Notes",
      "phone_label": "Phone",
      "postal_code_label": "Postal Code",
      "private_influencer_details": "Private Contact Details",
      "row_number_heading": "Row Number",
      "salutation_label": "Salutation",
      "state_label": "State",
      "twitter_label": "X Profile",
      "update_fail_message": "Failed to update private journalist",
      "update_success_message": "Private Contact successfully updated."
    },
    "outreach_private_influencer_upload_field_matching": {
      "address_line1_label": "Address Line 1",
      "address_line2_label": "Address Line 2",
      "address_line3_label": "Address Line 3",
      "all_columns_match": "All columns are matched",
      "available_fields": "Available fields",
      "city_label": "City",
      "country_label": "Country",
      "county_label": "County",
      "csv_file_column": "CSV file column",
      "email_label": "Email",
      "first_name_label": "First Name",
      "job_title_label": "Job Title",
      "language_label": "Language",
      "last_name_label": "Last Name",
      "linkedin_profile_label": "Linkedin Profile",
      "note_label": "Note",
      "outlet_label": "Outlet",
      "phone_label": "Phone",
      "postal_code_label": "Postal Code",
      "required_columns": "{fields} field required. | {fields} fields required.",
      "salutation_label": "Salutation",
      "skip_this_column": "Skip this column",
      "state_label": "State",
      "twitter_profile_label": "X Profile",
      "unmatched_columns": "1 column not matched. You can skip or match the column. | {total} columns not matched. You can skip or match the columns."
    },
    "outreach_private_influencer_upload_results": {
      "import_success": "Import successfully submitted. Import results will be available via email."
    },
    "outreach_selection_modal": {
      "contacts_load_error": "Error loading Contacts",
      "email_heading": "Email",
      "journalist_type": "Journalist",
      "outlet_type": "Outlet",
      "private_influencer_type": "Private Contact",
      "title": "1 Record selected | {total} Records selected",
      "type_heading": "Type"
    },
    "outreach_socials_modals": {
      "social_other": "Other",
      "title": "Social Media"
    },
    "outreach_target_areas_modal": {
      "location_dropdown_description": "Show results based on the geographical area media content is available in.",
      "location_placeholder": "Search coverage areas",
      "title": "Coverage Areas"
    },
    "outreach_tiers_modal": {
      "description": "Tiers take into account editorial status, social media footprint and traction among PR clients.",
      "title": "Tiers"
    },
    "outreach_topics_modal": {
      "load_contacts_error": "Error loading Contacts",
      "title": "Sectors"
    },
    "outreach_view_selection_modal": {
      "load_error": "Error loading selection"
    },
    "paper_preview_modal": {
      "afr_button": "Read on AFR with subscription",
      "author_heading": "Author",
      "date_heading": "Date",
      "download_error": "There was an error downloading the Article PDF",
      "load_error": "There was an error loading the article",
      "page_heading": "On Page | On Pages",
      "publication_heading": "Publication",
      "size_heading": "Size",
      "tab_pdf": "PDF Version",
      "tab_text": "Text Version",
      "translation": "TRANSLATION",
      "unauthorised_title": "Unauthorised",
      "word_count_heading": "Word Count"
    },
    "push_to_team_modal": {
      "alert_message": "Alert sent!",
      "external_item_title": "Push External Item Mention",
      "include_note_label": "Include a note (optional)",
      "mention_title": {
        "article": "Push Online Mention",
        "blog_post": "Push Influencer Social Mention",
        "bluesky_post": "Push Influencer Social Mention",
        "exorde_reddit_post": "Push Influencer Social Mention",
        "exorde_reddit_post_comment": "Push Influencer Social Mention",
        "facebook_post": "Push Influencer Social Mention",
        "forum_post": "Push Influencer Social Mention",
        "instagram_comment": "Push Influencer Social Mention",
        "instagram_post": "Push Influencer Social Mention",
        "linkedin_comment": "Push Influencer Social Mention",
        "linkedin_post": "Push Influencer Social Mention",
        "magazine_article": "Push Magazine Mention",
        "paper_article": "Push Print Mention",
        "podcast_episode": "Push Podcast Mention",
        "radio_article": "Push Radio Mention",
        "radio_clip": "Push Radio Mention",
        "radio_media_request": "Push Radio Mention",
        "radio_segment": "Push Radio Mention",
        "reddit_post": "Push Influencer Social Mention",
        "reddit_post_comment": "Push Influencer Social Mention",
        "tiktok_comment": "Push Influencer Social Mention",
        "tiktok_video": "Push Influencer Social Mention",
        "tv_caption": "Push TV Mention",
        "tv_logo_appearance": "Push TV Mention",
        "tv_super": "Push TV Mention",
        "tweet": "Push Influencer Social Mention",
        "youtube_video": "Push Influencer Social Mention"
      },
      "no_teams_warning": "It seems you're not a member of a team at the moment, so there are no teams or users for you to share with. If you think this is incorrect, please reach out to your Account Manager for assistance.",
      "push_button": "Push",
      "select_teams_or_users": "Select which teams and/or users to push {mentionTitle} to.",
      "select_teams_or_users_label": "Team/User"
    },
    "request_media_item_modal": {
      "additional_recipients_heading": "Additional Recipients (Optional)",
      "confirm_button": "Request Media Item",
      "context_duration_label": "Context and duration (Required)",
      "context_duration_label_description": "Please provide a detailed description of the content and context of the requested Media Item. This will assist {platformName} in quickly delivering you a relevant TV or Radio Media Item.",
      "help_text": "You/{organisationName}, agree not to post, share, email or otherwise distribute this TV/Radio Media Item outside of your organisation, including to Facebook, X {'|'} Twitter, LinkedIn or any other social media network. The sharing of content outside your organisation is a breach of copyright and will result in termination of your license agreement and any relevant indemnities provided by {platformName} to {organisationName}",
      "mention_type_channel": "Channel",
      "mention_type_station": "Station",
      "notify_message": "Your request will be processed as soon as possible. We'll send you an email when it reaches your Media Items Folder",
      "program_heading": "Program",
      "required_error": "Required",
      "select_syndication_description": "You may select a different station",
      "starting_time_heading": "Starting Time",
      "title": "Request a Media Item"
    },
    "request_media_transcript_item_confirm_modal": {
      "media_request_confirm_button": "Request Media Item for {cost}",
      "media_request_message": "Please note, as {organisationName} has exceeded the allowance of Media Items built into the Service level Agreement with {platformName}, you will be charged {cost} according to the Media Item Rate Card for this item",
      "transcript_request_confirm_button": "Request Transcript Request for {cost} per minute",
      "transcript_request_message": "As {organisationName} has exceeded the allowance of Transcripts built into the Service level Agreement with {platformName}, you will be charged {cost} per minute of transcribed content.",
      "transcript_request_no_credit_message": "By requesting this Transcript, you understand that {organisationName} will be charged a fee of {cost} per minute of transcribed content."
    },
    "request_transcript_item_modal": {
      "additional_recipients_heading": "Additional Recipients (Optional)",
      "confirm_button": "Request Transcript",
      "context_duration_label": "Context and duration",
      "context_duration_label_description": "Please provide a detailed description of the content and context of the requested Transcript. This will assist {platformName} in quickly delivering you a relevant TV or Radio Transcript.",
      "effort_text": "Every effort is made to ensure accuracy of the content displayed in the Transcript, however {platformName} is not responsible for any omissions contained within the Transcript. It is your responsibility to verify the content before relying on it.",
      "episode_duration_heading": "Episode Duration",
      "mention_type_channel": "Channel",
      "mention_type_podcast": "Podcast Name",
      "mention_type_station": "Station",
      "process_text": "Transcript requests will be processed in accordance with the time schedules outlined in the SLA.",
      "program_heading": "Program",
      "released_heading": "Released",
      "select_syndication_description": "You may select a different station",
      "starting_time_heading": "Starting Time",
      "thankyou_cancel_button": "View Transcript Requests",
      "thankyou_message": "Our Account Management team have received this and will process this as soon as possible. We'll send you an email with a link to access the item when it is ready.",
      "thankyou_title": "Thanks for your Transcript request",
      "title": "Request a Transcript",
      "understand_text": "By requesting this Transcript you understand that a fee will be charged subject to the terms of {organisationName}'s Service Level Agreement (SLA). The Transcript Rate Card outlines the pricing applicable to {organisationName}, or you may contact your Account Manager directly to confirm."
    },
    "review_mentions_modal": {
      "checked_total": "Selected {total} mentions",
      "mentions": "{total} mentions",
      "title": "Review and select mentions"
    },
    "saml_integration_modal": {
      "acs_url": "ACS URL",
      "add_new_team": "Add a new Team",
      "add_user_role": "Add a New User Role",
      "associated_domains": "Associated domain(s)*",
      "associated_domains_description": "We use SAML domain authentication to verify your identity and ensure you belong to the correct organisation. This is crucial for secure access for users across multiple organisations. Please use the generated key to add to your DNS records.",
      "associated_domains_placeholder": "e.g. example.com",
      "audience": "SP ENTITY ID",
      "certificate": "X.509 CERTIFICATE",
      "certificate_placeholder": "Enter your X.509 CERTIFICATE",
      "copy_instructions": "Copy the Single Sign-On (SSO) URL, Identity Provider Issuer (Entity ID), and X.509 Certificate from your Organisations Identity Provider (IdP) and paste them into the corresponding fields below.",
      "custom_attribute_team": "TEAM",
      "custom_attribute_value": "CUSTOM ATTRIBUTE VALUE",
      "custom_attribute_value_placeholder": "Custom attribute value",
      "custom_attributes": "Custom Attribute Mappings (Optional)",
      "custom_attributes_details_a": "Create a custom attribute in your Identity Provider (IdP) to map your users to specific teams on our platform. Ensure this attribute is mapped to the corresponding team attribute in our system.",
      "domain": "Domain",
      "generate_scim_token": "Generate SCIM Token",
      "identity_id": "Identity Provider Issuer (Entity ID)",
      "identity_id_placeholder": "Enter your Identity ID",
      "instructions_a": "Please copy the provided ACS URL and SP Entity ID and paste them into the appropriate fields in your Organisations Identity Provider (IdP) configuration.",
      "integrate": "Integrate",
      "note": "Note:",
      "remove_integration": "Remove Integration",
      "scim_note": "Custom attributes must be setup to get attribute updates from your Identity Provider.",
      "scim_setup": "SCIM Setup",
      "scim_setup_description_a": "SCIM (System for Cross-domain Identity Management) is a standard protocol used to automate user provisioning, de-provisioning and attribute updates between your Identity Provider (IdP) and CisionOne. By setting up SCIM integration, you can streamline user management and ensure that user information is synchronised automatically.",
      "scim_setup_description_b": "Copy the hidden SCIM token below and paste it into the SCIM Token field in your IdP's application settings.",
      "scim_token": "SCIM Token",
      "select_team": "Select a Team",
      "select_user_role": "Select a User Role",
      "sso_url": "Single Sign-On (SSO) URL",
      "sso_url_placeholder": "Enter your Single Sign-On (SSO) URL",
      "status": "STATUS",
      "sub_title": "Configure SAML integration to allow users from your Organisation to log in to this service using their existing credentials from your Identity Provider (IdP).",
      "team_mappings": "Team Mappings",
      "title": "SAML Single Sign-On",
      "txt": "TXT",
      "unverified": "Unverified",
      "user_role_mappings": "User Role Mappings",
      "user_role_mappings_description": "Create a custom attribute in your Identity Provider (IdP) to map your users roles on our platform. Ensure this attribute is mapped to the corresponding user role attribute in our platform.",
      "user_role_mappings_note": "Note:",
      "user_role_mappings_note_description": "If you do not configure this, new users will be assigned to the default user roles.",
      "verified": "Verified",
      "verify_domains": "Verify Domains"
    },
    "saved_social_analyse_report_modal": {
      "confirm_title": "Are you sure you want to delete {reportName}",
      "find_report_placeholder": "Find a report",
      "no_reports_found": "No saved reports found",
      "title": "Open saved report"
    },
    "see_full_text_modal": {
      "word_count": "{wordCount} words"
    },
    "select_front_pages_modal": {
      "add_button": "Add",
      "add_button_label": "Add Front Page Source",
      "find_source_label": "Find Front Page Source:",
      "load_error": "Error loading Front Pages",
      "save_button": "Save and Insert",
      "saving": "Saving ...",
      "select_name_placeholder": "Example: The Australian",
      "title": "Select Front Pages"
    },
    "select_stock_prices_modal": {
      "load_error": "Error loading Stock Prices",
      "save_button": "Save and Insert",
      "saving": "Saving ...",
      "title": "Select Stock Prices"
    },
    "select_stock_symbol_modal": {
      "title": "Search Stock"
    },
    "select_top_trends_modal": {
      "load_error": "Error loading Leading News Stories",
      "one_day_button": "1-Day",
      "seven_day_button": "7-Days",
      "title": "Leading News Stories"
    },
    "select_twitter_trends_modal": {
      "load_error": "Error loading X {'|'} Twitter Trends",
      "title": "Select X {'|'} Twitter Trends"
    },
    "send_test_email_modal": {
      "add_email_heading": "Add Email Address",
      "select_content_range_label": "Set the Content Range",
      "title": "Send Test Report"
    },
    "share_filter_sets_modal": {
      "about": {
        "current_user_owner": "{firstName} {lastName} (you)",
        "label": "About Filter Set",
        "no_owner": "N/A",
        "owner_label": "Owner",
        "user_owner": "{firstName} {lastName}"
      },
      "access": {
        "label": "Who has access",
        "users_with_edit_permission": "Users with edit permission can edit the shared Filter Set.",
        "users_with_read_permission": "This Filter Set is shared by {firstName} {lastName}. You can view or remove the Filter Set.",
        "users_without_edit_permission": "Users without edit permission can only view the shared Filter Set."
      },
      "team_load_error": "Error loading team members",
      "title": "Share/Permission"
    },
    "share_instant_insights_report_modal": {
      "build_status_empty_message": "No changes made",
      "build_status_removed_message": "Dashboard unshared from {names}",
      "build_status_shared_message": "Dashboard shared with {names}",
      "description": "Choose the share method that best suits your needs.",
      "generate_read_only_link": "Generate Read-Only Link",
      "generating_link": "Generating...",
      "not_shared_text": "This dashboard is not currently shared.",
      "public_link_warning_message": "Turning off sharing will make this link inaccessible and a new read-only link will need to be generated.",
      "public_link_warning_title": "Turn off dashboard sharing",
      "read_only_link_button_label": "Generate",
      "read_only_link_copy_button_label": "Copy",
      "read_only_link_description": "Generate a read-only link to share this dashboard more broadly with audiences without access to the platform.",
      "read_only_link_disclaimer": "By generating this link, you/{organisation} agree not to post, share, email or otherwise distribute this content outside your organisation, including to Facebook, X {'|'} Twitter, LinkedIn or any other social or public network.",
      "read_only_link_input_placeholder": "Generate a read-only link",
      "read_only_link_preview_button_label": "Preview",
      "select_members_text": "Select the team members you'd like to share this dashboard with.",
      "share_with_team": "Share with Your Team",
      "shared_with_text": "This dashboard is currently shared with {count} team member | This dashboard is currently shared with {count} team members",
      "team_load_error": "Error loading team members",
      "team_share_description": "Share your dashboard with other users and manage their access. You can choose between read-only or editing permissions.",
      "title": "Share Dashboard",
      "turn_off": "Turn off"
    },
    "share_mention_modal": {
      "archived_content": "Archived Clip",
      "content_type_heading": "Select content type",
      "copy_link_button": "Copy Link",
      "delivered_subtext": "This Email Report will also be delivered to {email}",
      "full_content": "Full Broadcast",
      "include_note_label": "Include a Note",
      "private_link_heading": {
        "archived_content": "Private Link: archived",
        "basic": "Private Link",
        "full_content": "Private Link: full broadcast"
      },
      "recipients_heading": "Recipients",
      "select_source_label": "Source",
      "send_alert": "Media item shared!",
      "send_by_email_heading": "Send by Email",
      "subject_label": "Subject Line",
      "title": "Share {mentionType} Media Item"
    },
    "share_scheduled_report_specification_modal": {
      "build_status_empty_message": "No changes made",
      "build_status_removed_message": "Report unshared from {names}",
      "build_status_shared_message": "Report shared with {names}",
      "not_shared_text": "This report is not currently shared.",
      "select_members_text": "Select the team members you'd like to share this report with.",
      "shared_with_text": "This report is currently shared with {count} team member | This report is currently shared with {count} team members",
      "title": "Share Report"
    },
    "share_stream_group_modal": {
      "title": "Share Stream Group"
    },
    "short_cuts_modal": {
      "add_stream_shortcut": "Add a new {streamType}",
      "close_modal_shortcut": "Close any open windows",
      "display_launchpad_shortcut": "Display Launchpad",
      "display_list_view_shortcut": "Display List View",
      "display_stream_view_shortcut": "Display {streamType} view",
      "esc": "Esc",
      "left": "Left",
      "media_name": "Media",
      "mention_stream": "Mention Stream",
      "mention_streams_name": "Mention Streams",
      "next_stream_group_shortcut": "Move to the next {streamType} group",
      "next_stream_shortcut": "Move to the next {streamType}",
      "open_shortcuts_modal_shortcut": "Open the keyboard shortcuts window",
      "previous_stream_group_shortcut": "Move to the previous {streamType} group",
      "previous_stream_shortcut": "Move to the previous {streamType}",
      "right": "Right",
      "shift_down": "Shift + Down",
      "shift_up": "Shift + Up",
      "social_name": "Social",
      "social_stream": "Social Stream",
      "title": "Keyboard Shortcuts",
      "visit_social_analyse_page_shortcut": "Go to the Social Analyse page",
      "visit_social_engage_page_shortcut": "Go to the Social Engage page"
    },
    "social_engage_performance_download_modal": {
      "download_report": "Download report",
      "message": "Download a copy of the report as a {reportType}",
      "title": "Save Report"
    },
    "social_engage_post_reject_modal": {
      "reject_button": "Reject",
      "text": "{userName} has requested approval to publish this post.",
      "title": "Why are you rejecting this post?"
    },
    "social_engage_welcome_modal": {
      "add_button": "Add account",
      "text": "Connect a social account to post and measure performance across X {'|'} Twitter, LinkedIn, Facebook and Instagram.",
      "title": "Connect an account"
    },
    "social_stream_welcome_modal": {
      "add_button": "Add new Social Stream",
      "text": "To begin tracking social mentions you will need to create your first Social Stream.",
      "title": "Create a Social Stream"
    },
    "stream_allocation_reached_modal": {
      "account_manager_message": "Need help? Contact your Account Manager {linkText}",
      "customer_portal": "Customer Portal",
      "customer_portal_message": "Need help? Head to our {customerPortal} where you can access our {knowledgeBase} or raise a ticket with one of our support teams.",
      "customer_success_team_message": "Need help? Contact our Customer Success team {linkText}",
      "dedicated_support_team_message": "Need help? Contact our Dedicated Support team {linkText}",
      "knowledge_base": "Knowledge base",
      "link_text": "at {link}",
      "subject": "Social Stream Allocation Reached",
      "title": "Your Organisation has reached its allocation of {streamType}."
    },
    "stream_vs_stream_comparison_modal": {
      "description": "You can choose an earned Mention Stream for comparative analysis in Social Analyse",
      "stream_select_disabled_tooltip": "This Mention Stream is linked {newline}to a Social Stream already",
      "stream_select_label": "Choose a Mention Stream",
      "title": "Earned mention stream comparison:"
    },
    "streams_users_modal": {
      "access_heading": "Access",
      "collaborator": "Collaborator",
      "description": "View all users that have access to this stream",
      "owner": "Owner",
      "read_only": "View",
      "read_write": "Edit",
      "user_heading": "User"
    },
    "teams_allocation_reached_modal": {
      "account_manager_message": "Need help? Contact your Account Manager {linkText}",
      "customer_portal": "Customer Portal",
      "customer_portal_message": "Need help? Head to our {customerPortal} where you can access our {knowledgeBase} or raise a ticket with one of our support teams.",
      "customer_success_team_message": "Need help? Contact our Customer Success team {linkText}",
      "dedicated_support_team_message": "Need help? Contact our Dedicated Support team {linkText}",
      "knowledge_base": "Knowledge base",
      "link_text": "at {link}",
      "subject": "Team Allocation Reached",
      "title": "Your Organisation has reached its allocation of teams."
    },
    "teaser_modal": {
      "description": "Great to see you're interested in exploring {title}. Please let us know your contact details and any additional information or questions you may have below, and the team will be in touch with you.",
      "get_in_touch_button": "Get in Touch",
      "information_label": "Any additional information or questions:",
      "more_info_button": "More Info",
      "request_error": "Error submitting request.",
      "request_message": "Your request was submitted successfully. A member of our team will be in touch with you soon.",
      "request_title": "Request Submitted",
      "title": "{title} — Request Access",
      "welcome_message": "Hi {firstName},"
    },
    "transcript_download_confirm_modal": {
      "description": "Would you like to include thumbnails?",
      "title": "Download Transcript",
      "toggle_thumbnails_label": "Include thumbnails?"
    },
    "tveyes_player_modal": {
      "archive_text": "For long-term access to this clip,\"Archive\" it through the Editor below. If not archived, clip access will expire 28 days after airing.",
      "in_progress_text": "Sit tight. Your edited clip is still being processed. Please check back in a few minutes.",
      "load_error": "Error loading media requests",
      "player_iframe_fallback_name": "TVEyes",
      "player_iframe_title": "{name} player"
    },
    "two_factor_verify_code_modal": {
      "title": "Verify two-factor code delivery"
    },
    "user_import_modal": {
      "add_title": "Bulk Add Users",
      "confirm_add_title": "Confirm Bulk Add Users",
      "download_message": "Download and follow this {demo} as a guide",
      "duplicate_emails": "Duplicate Email | Duplicate Emails",
      "duplicate_mobile_numbers": "Duplicate Mobile Number | Duplicate Mobile Numbers",
      "first_name": "Invalid First Name",
      "import_error": "Unable to import the CSV, could not detect the correct columns.{newline}Please ensure your CSV has columns as seen in the template below.",
      "import_message": "Bulk add more than one user via CSV file.{newline}Upload CSV file below and send to us for approval.",
      "invalid_emails": "Invalid Email | Invalid Emails",
      "invalid_entries_message": "Invalid entries have been found in your imported CSV and highlighted in the table below. You can resolve each user by clicking on the invalid field. Once all users are valid you may continue.",
      "invalid_first_name": "Invalid First Name | Invalid First Names",
      "invalid_mobile_numbers": "Invalid Mobile Number | Invalid Mobile Numbers",
      "max_users_reached_message": "Entries exceed maximum user allowance. Please contact your Account Manager if you would like to add more.",
      "send_button": "Send for approval",
      "toggle_invalid_users_label": "Show only invalid users",
      "upload_button": "Upload CSV"
    },
    "user_managed_streams_modal": {
      "load_error": "There was a problem loading User Managed Streams",
      "no_streams_message": "No User Managed Streams found",
      "title": "Managed Mention Streams"
    },
    "user_preferences_modal": {
      "browser_currency_message": "We've detected your currency as {browserCurrency}. Please confirm it in the dropdown below.",
      "browser_language_message": "We've detected your language as {browserLanguage}. Please confirm it in the dropdown below.",
      "browser_timezone_message": "We've detected your timezone as {browserTimezone}. Please confirm it in the dropdown below.",
      "currency_title": "Currency",
      "language_title": "Language",
      "no_currency_found": "We couldn't detect your browser currency. Please select a currency from the list of supported currencies below.",
      "no_language_found": "We couldn't detect your browser language. Please select a language from the list of supported languages below.",
      "submit_button": "Set Preferences",
      "timezone_title": "Timezone",
      "title": "Set your Preferences",
      "update_error": "There was an error updating preferences.",
      "update_message": "Preferences updated"
    },
    "user_request_confirm_modal": {
      "message": "Changing the team for user {userName} will also update their Managed Mention Streams and primary Mention Stream.{newlines}Do you wish to continue?",
      "title": "Updating Team"
    },
    "user_request_confirm_team_update_modal": {
      "alerts": "Alerts",
      "insights": "Insights",
      "mention_streams": "Mention Streams",
      "message": "This will delete all data {userName} has created in {removedTeams} permanently.{removedItems}",
      "scheduled_reports": "Scheduled Reports",
      "title": "Are you sure you want to remove {userName} from {removedTeams}?",
      "what_will_be_deleted": "What will be deleted:"
    },
    "user_request_modal": {
      "add_button": "Add User",
      "add_title": "Add User",
      "edit_title": "Edit User",
      "email_address_label": "Email Address",
      "first_name_label": "First Name",
      "last_name_label": "Last name",
      "mobile_phone_label": "Mobile Phone",
      "mobile_phone_optional_label": "Mobile Phone (Optional)",
      "notes_label": "Notes (optional)",
      "select_team_label": "Team (optional)",
      "team_validation_error": "Must select at least 1 team",
      "team_workspaces_select_team_label": "Team",
      "update_button": "Update User",
      "update_error_title": "There was a problem updating user details"
    },
    "user_team_modal": {
      "add_members_label": "Add Members",
      "add_team_title": "Add a Team",
      "create_error_title": "There was a problem creating the team",
      "save_team_button": "Save Team",
      "submit_error_title": "There was a problem creating the team",
      "team_name_label": "Team Name",
      "title": "Add a Team",
      "unique_validation": "Must be unique",
      "update_error_title": "There was a problem updating the team",
      "update_team_title": "Update Team",
      "updating_team_message": "Changing the team for users will also update their Managed Mention Streams and primary Mention Stream. Do you wish to continue?",
      "updating_team_title": "Updating Team"
    },
    "user_timezone_modal": {
      "browser_timezone_message": "We've detected your timezone as {browserTimezone}. Please confirm it in the dropdown below.",
      "set_timezone_button": "Set Timezone",
      "title": "Set your Timezone",
      "update_error": "There was an error setting the timezone!",
      "update_message": "Timezone updated to {timezone}"
    },
    "users_allocation_reached_modal": {
      "account_manager_message": "Need help? Contact your Account Manager {linkText}",
      "customer_portal": "Customer Portal",
      "customer_portal_message": "Need help? Head to our {customerPortal} where you can access our {knowledgeBase} or raise a ticket with one of our support teams.",
      "customer_success_team_message": "Need help? Contact our Customer Success team {linkText}",
      "dedicated_support_team_message": "Need help? Contact our Dedicated Support team {linkText}",
      "knowledge_base": "Knowledge base",
      "link_text": "at {link}",
      "subject": "User Allocation Reached",
      "title": "Your Organisation has reached its allocation of users."
    },
    "users_without_other_teams_modal": {
      "message": "Before updating this group, the following users must be assigned to a new team: {blockingUsers}",
      "title": "Unable to update {teamName}"
    },
    "view_alert_modal": {
      "download_report": "Please click {link} to download your Report.",
      "expire_never": "will never expire.",
      "expire_on": "expired on {expiryDateString} at {expiryTime}",
      "expire_today": "will expire today at {expiryTime}",
      "expire_tomorrow": "will expire tomorrow at {expiryTime}",
      "expired_message": "Your Mention Stream {alertLabel} {expireTime}.",
      "expiry_changed_message": "Your Mention Stream {alertLabel} expiry has been changed and {expireTime}",
      "extend_alert_message": "The expiry of <strong>{alertLabel}</strong> has been extended by 3 days.",
      "extend_alert_title": "Mention Stream Expiry Extended",
      "extend_link_label": "Click here to extend the expiry by 3 days.",
      "here": "here",
      "hidden_message": "Once expired, the Mention Stream will be hidden from your account.",
      "title": "View Alert",
      "view_item_route": "View the item."
    },
    "view_mention_alert_modal": {
      "account_manager": "Account Manager",
      "allowance_text": "Please note, as {organisationName} does not have an allowance of {sourceFieldLabel} Instant Streaming built into the Service Level Agreement with {legalName}, you will be charged {cost} + @:tax according to the Media Item Rate Card for this item.",
      "increase_cap_text": "To increase or change your cap please contact your",
      "mention_title": "View {sourceFieldLabel} Item",
      "monthly_cap_text": "You're about to view a {sourceFieldLabel} Item on {platformName}. Please note that your organisation has a monthly cap and each time you view a {sourceFieldLabel} Item this will be deducted from your monthly cap. Once you or anyone else at your organisation has viewed a unique {sourceFieldLabel} Item you can go back and view it as many times as you want without this deducting from your monthly cap.",
      "title": "View {sourceFieldLabel} Item",
      "used_credits_text": "{usedCredits} of {credits} Items",
      "used_items_text": "{usedItems} Items",
      "used_text": "This month your organisation has used:",
      "view_mention_text": "You're about to view a {sourceFieldLabel} Item on {platformName}. Please note that your organisation doesn't have any {sourceFieldLabel} Item included and will incur a cost for this. Once you or anyone else at your organisation has viewed a unique {sourceFieldLabel} Item you can go back and view it as many times as you want without further charge."
    },
    "view_mention_detail_modal": {
      "aria_label": "Mention details for {sourceName}",
      "aria_label_fallback": "Mention details",
      "mention_translated": "Mention translated"
    },
    "view_transcript_modal": {
      "generate_transcript_tooltip": "Generate Transcript",
      "location_time_tooltip": "{location} Local Time",
      "time_range": "Between {after} and {before} Local Time",
      "your_time_tooltip": "Your Local Time"
    }
  },
  "monitoring_product_name": "Monitoring",
  "monthly_day_selector": {
    "custom": "Custom",
    "day_15": "Day 15",
    "first_day": "First day",
    "last_day": "Last day",
    "on_day": "On day",
    "select_day": "Please select a day"
  },
  "monthly_range_selector": {
    "custom": "Custom",
    "days": "Days",
    "hours": "Hours",
    "monthly_range_options": {
      "current": "This month",
      "last": "Last month"
    },
    "select_range": "Please select a range",
    "set_content_range": "Set content range"
  },
  "newspaper_form": {
    "outlet_search_description": "Search for an Outlet to link to the Source. Outlets must have an email address to appear in the list."
  },
  "oauth_login": {
    "mobile_cta": "Tap here to finish signing in"
  },
  "oauth_redirect": {
    "failed_message": "Looks like something didn't work. Please close this window and try again.",
    "redirecting_message": "Redirecting you back to {platformName}, please wait..."
  },
  "online_mention_card": {
    "author_not_found": "The author was not found",
    "potential_audience_reach": "{audience} Potential Audience Reach",
    "view_print_version": "View print version",
    "word_count": "· {wordCount} words"
  },
  "organisation_report": {
    "copy_to_spec": "Copy to spec",
    "filters": "Filters",
    "leave_dialog_message": "Any unsaved changes will be lost.",
    "leave_dialog_title": "Leave Report?",
    "load_error": "There was a problem loading the Curated Email Report. Please try again",
    "media_items_folder_label": "TV & Radio Media Items",
    "new_folder_label": "New Folder {folderLength}",
    "remove_dialog_message": "This Folder and all selections inside it will be lost.",
    "remove_dialog_title": "Are you sure?",
    "reset_dialog_message": "All the Folders and selections of this Email Report will be cleared.",
    "reset_dialog_title": "Clear Folders?",
    "save_alert": "Email Report saved.",
    "save_dialog_message": "Saving this report will override any changes made by other users.",
    "save_dialog_title": "Save Report?",
    "save_error_alert": "There was a problem saving your Email Report. Please try again.",
    "send_alert": "This Email Report has been enqueued and will be sent shortly.",
    "send_dialog_message": "This Curated Email Report will be sent to 1 recipient. |This Curated Email Report will be sent to {recipientsCount} recipients",
    "send_dialog_title": "Ready to send?",
    "send_error_alert": "There was a problem sending your Email Report. Please try again",
    "send_test_alert": "This Email Report has been sent as a test to '{testRecipient}'",
    "send_test_error_alert": "There was a problem sending the Test Email. Please try again",
    "sent_test": "Send test",
    "title": "Curated Email Report",
    "transcripts_folder_label": "TV & Radio Transcripts"
  },
  "organisation_report_action_sheet": {
    "edit_article": "Edit this Article",
    "move_after": "Move after...",
    "move_before": "Move before...",
    "move_to_folder": "Move to Folder",
    "remove_from_folder": "Remove from Folder",
    "toggle": "Toggle"
  },
  "organisation_report_aggregated_audience_widget": {
    "customer_article": "Customer article",
    "item_views": "Item Views",
    "title": "Daily Email Report Audience",
    "top_item_views": "Top Item Views"
  },
  "organisation_report_audience_detail": {
    "audience_analytics": "Audience Analytics",
    "audience_overview": "Audience Overview",
    "curated_email_report": "Curated Email Report",
    "no_data_available": "No Data Available",
    "view_report": "View Report"
  },
  "organisation_report_audience_detail_aggregate": {
    "generate_report": "Generate Report"
  },
  "organisation_report_audience_devices_chart": {
    "audience_using_question": "What devices are the audience using?",
    "no_devices_used_for_interactions": "We could not determine the devices used for these interactions. This could be because of the configuration of your Organisation's servers or other external factors.",
    "percentage": "{percentage}%"
  },
  "organisation_report_audience_locations": {
    "audience_located_question": "Where are the audience located?",
    "city": "City",
    "no_location_for_interactions": "We could not determine the location for these interactions. This could be because of the configuration of your Organisation's servers or other external factors.",
    "percentage": "{percentage}%",
    "users": "Users"
  },
  "organisation_report_audience_top_views_detail": {
    "highest_trending_items_question": "What are the highest trending items?",
    "highest_trending_items_question_aggregated": "What are the highest trending items for this report?",
    "no_data_available": "No clicked items data available",
    "views_count": "{itemViews} Views",
    "views_percentage": "{itemViewsPercentage}% View rate"
  },
  "organisation_report_builder": {
    "add_folder": "Add Folder",
    "apply_settings": "Apply Settings from Specification",
    "apply_settings_tooltip": "Prefill the form with settings from the Daily Briefing Specification, such as recipients, subject, send as, PDF options and Folders",
    "arrange_selections": "Arrange Selections",
    "background_colour": "Background Colour",
    "coverage_summary": "Coverage Summary",
    "defaults_to_brand_profile_setting": "Defaults to Brand Profile setting",
    "drag_items_here": "Drag Mentions here",
    "drag_reorder": "Drag and Reorder",
    "editor_placeholder": "Insert a coverage summary. This will appear beneath the current folder header.",
    "external_item_added_alert": "External item added",
    "external_item_save_error": "There was an issue saving your External Item.",
    "external_item_updated_alert": "External item updated",
    "folder_items": "({total} Items)",
    "header": "Header",
    "insert_external_item": "Insert External Item",
    "insert_external_item_shortened": "Insert Item",
    "media_items": "Media Items",
    "new_report_need_to_be_created": "A new report will need to be created to change the summary type.",
    "remove_folder": "Remove folder",
    "remove_named_folder": "Remove {label} folder",
    "remove_named_header": "Remove {label} header",
    "select_a_mention_stream": "Select a Mention Stream",
    "subtitle": "Subtitle",
    "summary_type": "Summarisation: {summaryType}",
    "text_colour": "Text Colour",
    "title": "Title"
  },
  "organisation_report_builder_folders_header": {
    "add_element": "Add Element",
    "add_folder": "Add Folder",
    "add_image": "Add Image",
    "arrange_selections": "Arrange Selections",
    "folder": "Folder",
    "header": "Header",
    "image": "Image",
    "table_of_contents": "Table of Contents",
    "table_of_contents_tooltip": "Empty folders are excluded from the Table of Contents by default. To include these, go to the next step and toggle the {toggle_message} option from the settings.",
    "text_box": "Text Box",
    "uploaded_image": "Uploaded Image",
    "view": "View"
  },
  "organisation_report_card": {
    "add_by": "Added by {createdBy}, {cretedAt}",
    "broadcast_date": "Broadcast at {date} {name}",
    "broadcast_name": "on {name}",
    "external_item_tooltip": "This is an External Item",
    "hide_content": "Hide content",
    "limit_reached": "Summarisation limit reached",
    "mention_author": "by {author}",
    "mention_keywords": "Mentions {keywords} around {date}",
    "mention_keywords_joiner": "and",
    "page_and_size": "Page {pageNumbers} {'|'} {size} cm2 on the page",
    "paper_page_and_size": "{pageNumbers} {'|'} {size} cm2 on the page",
    "show_content": "Show content",
    "summarised": "Summarised",
    "summarising": "Summarising",
    "word_count": "{wordCount} words"
  },
  "organisation_report_email_form": {
    "ai_summary_button": "Summarise",
    "ai_summary_description": "Here is the summary for the items below.",
    "ai_summary_error": "Error Summarising Report",
    "ai_summary_not_enough_mentions": "We couldn't generate a summary as there aren't enough Mentions.",
    "ai_summary_title": "AI Summary",
    "apply_settings_label": "Apply Settings from '{subject}' Specification",
    "brand_profile_heading": "Brand Profile",
    "content_date_heading": "Content Date",
    "content_date_placeholder": "Date",
    "content_title_heading": "Content Title",
    "content_title_placeholder": "Title",
    "coverage_summary_heading": "Coverage Summary",
    "coverage_summary_placeholder": "Insert a coverage summary. This will appear at the top of the Curated Email Report.",
    "csv_report_heading": "Include CSV report",
    "custom_label": "Custom",
    "custom_placeholder": "Custom name",
    "customise_options": "Customise options",
    "domain": "Domain",
    "expand_preview_tooltip": "Expand preview",
    "font_size_default": "Default",
    "font_size_heading": "Font Size",
    "font_size_large": "Large",
    "font_size_small": "Small",
    "footer_heading": "Footer",
    "footer_placeholder": "The Footer will appear at the bottom of the Curated Email Report after the selected mentions.",
    "include_disclaimer_heading": "Include Disclaimer",
    "language_dropdown_subtext": "This will populate your Curated Email Report in the chosen language.",
    "language_heading": "Language",
    "mention_display_condensed": "Condensed",
    "mention_display_heading": "Mention Display",
    "mention_display_images": "Images",
    "mention_display_normal": "Normal",
    "organisation_domain": "Organisation Domain",
    "other_options_heading": "Other options",
    "per_folder_heading": "Include per folder Print Clips PDF",
    "prefill_button": "Prefill from specification",
    "prefill_button_tooltip": "Prefill the form with settings from the Daily Briefing Specification, such as recipients, subject, send as, PDF options and Folders",
    "preview_heading": "Preview",
    "preview_subtext": "See what your Email Report will look like before sending",
    "recipients_heading": "Recipients",
    "recipients_subtext": "This Email Report will also be delivered to {email}",
    "select_print_only_label": "With Print Items only",
    "select_summary_label": "With Coverage Summary, Article summaries, TV/Radio Media Item links and Print Items",
    "send_as_heading": "Send as",
    "sender_email": "Sender email",
    "show_embedded_preview": "Show embedded preview",
    "streem_viewer_heading": "Enable {platformName} Viewer",
    "subject_heading": "Email Subject",
    "subject_placeholder": "Subject",
    "toggle_ai_summary": "Include AI Report Summary",
    "toggle_all_folders_label": "Include all folders even when there is no mention",
    "toggle_excerpts_label": "Display highlighted keyword excerpts",
    "toggle_keyword_count_label": "Display keyword count",
    "toggle_pdf_label": "Include PDF report",
    "toggle_restricted_content_label": "Show restricted content",
    "toggle_rss_label": "Display accessible RSS link",
    "toggle_secondary_pdf_label": "Include secondary PDF link with AFR Print Items (requires AFR subscription)",
    "toggle_show_ave": "Display Advertising Value Equivalency",
    "toggle_show_domain_authority": "Display Domain Authority",
    "toggle_show_impact_score": "Display Impact Score",
    "toggle_show_item_excerpt": "Display item excerpt",
    "toggle_show_potential_audience_reach": "Display Potential Audience Reach",
    "toggle_show_sentiment": "Display sentiment",
    "toggle_show_syndications": "Display syndications"
  },
  "organisation_report_mention_stream": {
    "mention_include": "This mention is included in {folders}",
    "source_version": "The {sourceLabel} version has been included in {folders}"
  },
  "organisation_report_multiple_users_alert": {
    "edited_by": "This report is currently being edited by {name} | This report is currently being edited by {name} and {total} others",
    "last_updated": "Last Updated: {lastUserActivityAt}",
    "refresh": "Refresh"
  },
  "organisation_report_notes_dropdown": {
    "label": "Notes"
  },
  "organisation_report_preview": {
    "email_preview_title": "Organisation report email preview",
    "preview_alert": "Something went wrong when loading this preview. Please try again"
  },
  "organisation_report_specifications": {
    "available_specifications": "Available specifications:",
    "content": "Content",
    "custom_sender": "Custom sender (\"{customSender}\")",
    "deliver_at": "Deliver at",
    "excerpts": "Excerpts",
    "exclusions": "Exclusions",
    "format": "Format",
    "inclusions": "Inclusions",
    "key_contacts": "Key contacts",
    "keyword_count": "Keyword Count",
    "notes": "Notes",
    "order": "Order",
    "organisation": "Organisation",
    "overview": "Overview",
    "products": "Products",
    "range": "Range",
    "range_hours": "{currentDay} - {range} hours",
    "recipients": "Recipients",
    "send_as": "Send as",
    "sources": "Sources",
    "summary": "Summary"
  },
  "organisation_report_status_widget": {
    "hide_additional_reports": "Hide additional reports",
    "show_additional_reports": "Show additional reports",
    "title": "Daily Email Report Delivery Status"
  },
  "organisation_report_stream": {
    "add_to_folder": "Add to Folder",
    "date_range_tooltip": "Select Date Range",
    "filter_mentions": "Filter mentions",
    "retry_loading_mentions": "Error Loading Mentions - Click to Retry",
    "toggle_mentions_select_label": "Select All ({total} selected)",
    "toggle_mentions_title": "Select/Unselect all mentions",
    "toggle_mentions_unselect_label": "Unselect All ({total} selected)",
    "total_mentions": "{totalMentions} total mentions"
  },
  "organisation_report_stream_notification_watcher": {
    "new_mentions": "1 new Mention | {total} new Mentions"
  },
  "organisation_report_stream_select": {
    "mention_streams": "Mention Streams",
    "no_results": "No results",
    "reporting": "Reporting",
    "reporting_streams": "Reporting Streams",
    "select_mention_stream": "Select a Mention Stream",
    "social_streams": "Social Streams",
    "tagged_streams": "Tagged Streams",
    "tv_media_items": "TV & Radio Media Items",
    "tv_transcripts": "TV & Radio Transcripts"
  },
  "organisation_report_summary_card": {
    "delayed_status": "Delayed",
    "delivered_status": "Delivered",
    "delivered_to_all_status": "Delivered to all recipients",
    "no_subject": "[No Subject]",
    "on_schedule_status": "On Schedule",
    "scheduled_at_message": "[Scheduled at {scheduledTime} {timezone}]",
    "view_online": "View Online"
  },
  "organisation_report_summary_type": {
    "article_summarisation_description": "Before you begin, please choose whether you would you like content to be summarised. When completed, each Media Item summary can be edited via the summary tag on each item.",
    "article_summarisation_title": "Article Summarisation",
    "long_summary": "Long Summary",
    "long_summary_subtext": "Content included in your report will be automatically summarised between between 70-120 words.",
    "new_report_need_to_be_created": "A new report will need to be created to change the summary type.",
    "no_summaries": "No Summaries",
    "no_summaries_subtext": "Media Items will not be summarised.",
    "short_summary": "Short Summary",
    "short_summary_subtext": "Content included in your report will be automatically summarised between 50-80 words."
  },
  "organisation_report_visibility": {
    "custom_description": "Select users within {0} can view and edit this report.",
    "custom_label": "Custom",
    "everyone_description": "All users within {0} can view and edit this report.",
    "everyone_label": "Everyone",
    "private_description": "Only you can view and edit this report.",
    "private_label": "Private",
    "select_users_heading": "Select Users",
    "selected_users_label": "{userName} | {userName}, +{total} Other",
    "share_with_options": {
      "descriptions": {
        "custom": "Select users within {name} can view and edit this report.",
        "everyone": "All users within {name} can view and edit this report.",
        "only_me": "Only you can view and edit this report.",
        "team": "All users within the {name} team can view and edit this report."
      },
      "labels": {
        "custom": "Custom",
        "everyone": "Everyone",
        "only_me": "Private",
        "team": "Team"
      }
    },
    "team_description": "All users within the {0} team can view and edit this report.",
    "team_label": "Team",
    "visibility_label": "Visibility"
  },
  "organisation_reports_table": {
    "action": "Actions",
    "created_by": "Created By",
    "delete_report": "Delete report",
    "duplicate_report": "Duplicate report",
    "duplicate_report_title": "Duplicate this report?",
    "edit_report": "Edit Report",
    "last_sent": "Last Sent",
    "no_subject": "No Subject",
    "preview_report": "Preview report",
    "recipient": "Recipients",
    "recipient_count": "{count} recipient | {count} recipients",
    "recipient_tooltip": "{distributionListName} (Distribution List) - [{recipientsLength} recipients]",
    "report_status": {
      "building": "Building",
      "delivered": "Delivered",
      "draft": "Draft",
      "error": "Error",
      "failed": "Failed",
      "scheduled": "Scheduled",
      "sending": "Sending",
      "sent": "Sent",
      "unknown": "Unknown"
    },
    "status": "Status",
    "subject": "Subject",
    "to": "To",
    "view_audience": "View audience"
  },
  "organisation_switcher": {
    "confirm_label": "Switch",
    "confirm_message": "Do you want to switch your active organisation to {name}?",
    "confirm_title": "Switch Organisation?"
  },
  "organisation_teams_selector": {
    "all_teams": "All Teams",
    "error_updating_integration": "There was an error updating the teams",
    "label": "Teams",
    "select_teams": "Select Teams",
    "teams_count": "{count} team | {count} teams",
    "visible_to_all_teams": "Visible to all teams"
  },
  "outreach": {
    "ai": {
      "ask_ai": "Ask AI",
      "change_tone": "Change Tone",
      "confirm_discard_response_confirm": "Discard",
      "confirm_discard_response_title": "Do you want to discard generated response?",
      "create_pitch": "Create AI-Powered Pitch",
      "create_without_contacts_error": "You cannot create a pitch without contacts",
      "discard_pitch": "Discard",
      "error_creating_pitch": "Error creating pitch",
      "error_generating_pitch": "Error generating pitch",
      "greeting": "Hi {name}",
      "minimum_words_required": "Minimum of {count} words required",
      "pitch_edit_placeholder": "Ask AI to edit your pitch",
      "pitch_prompt_description": "e.g. Acme Tech is introducing an innovative AI-powered virtual assistant designed for the healthcare industry",
      "pitch_prompt_placeholder": "Write a line or two about your pitch",
      "pitch_prompt_requirements": "* Minimum of 14 words required. Please avoid sharing any sensitive information in your prompts. {platformName} shares your prompts with OpenAI in order to enable your use of this tool and OpenAI will store your prompts for content moderation purposes.",
      "regenerate_pitch": "Regenerate Pitch",
      "saving_pitch": "Saving pitch",
      "tones": {
        "conversational": {
          "description": "This tone is used to establish a more relaxed and friendly relationship with the contact. It can be used when pitching a feature or human-interest story.",
          "title": "Professional"
        },
        "humorous": {
          "description": "This tone is used when the pitch or brand is playful, creative, or light-hearted. It is best suited for brands that want to convey a sense of humour or fun in their communications.",
          "title": "Humorous"
        },
        "informative": {
          "description": "This tone is best used when providing news updates or product launches. The focus is on providing facts and details, rather than trying to persuade the contact",
          "title": "Friendly"
        },
        "persuasive": {
          "description": "This tone is used to convince the contact to cover a story or event. The pitch should be framed in a way that highlights the newsworthiness of the story and why it is relevant to the contact's audience.",
          "title": "Persuasive"
        },
        "urgent": {
          "description": "This tone is used when the pitch contains breaking news or a time-sensitive event. The pitch should convey a sense of urgency and why it's essential for the contact to cover the story immediately.",
          "title": "Urgent"
        }
      },
      "try_again": "Try again",
      "unexpected_error": "An unexpected error occurred.  Please try again or contact support.",
      "use_pitch": "Use This Pitch",
      "words": "Words"
    },
    "contact": {
      "circulation": "Circulation",
      "unique_viewers": "Unique viewers per month"
    },
    "contact_fields": {
      "address": "Address",
      "email": "Email",
      "job_title": "Job Title",
      "owner": "Publisher"
    },
    "contact_sidebar": {
      "get_in_touch_button": "Get in touch",
      "restrict_message": "The comprehensive solution that joins the dots across your media activity. Outreach enables you to search and contact journalists and outlets, track activity, build media releases, and analyse performance, all within the {platformName} platform.",
      "title": "Outreach"
    },
    "contact_sort_options": {
      "circulation": "Circulation",
      "content_relevance": "Content Relevance",
      "frequency": "Frequency",
      "job_title": "Job Title",
      "media_type": "Media Type",
      "popularity": "Popularity",
      "popularity_influencer_tooltip": "Journalist popularity analyses multiple metrics including Circulation/UVPM, the Outlet type, the location of the Journalist relative to the country of the person searching, and the number of Journalists associated with their parent Outlet.",
      "popularity_outlet_tooltip": "Outlet popularity analyses multiple metrics including Circulation/UVPM, the Outlet type, the location of the Outlet relative to the country of the person searching, and the number of Journalists associated with this Outlet.",
      "relevance": "Relevance",
      "relevance_tooltip": "Relevance will sort the contacts based on how closely they match the search query."
    },
    "email_event_error_codes": {
      "code_452": "This message could not be delivered to the recipient. This usually occurs when the email account that you tried to reach is over their quota.",
      "code_498": "The email account you tried to reach does not exist. Please check for typos or unnecessary spaces, or check that the recipient still exists.",
      "code_550": "The email account you tried to reach does not exist. Please check for typos or unnecessary spaces, or check that the recipient still exists.",
      "code_552": "This message could not be delivered as the recipient's mailbox is full. Please try again later.",
      "code_554": "The recipient's mail server did not accept the email. This may occur for several reasons: the recipient email may be invalid, the recipient email may be blocked or suspended, or the sender's IP address may appear in a blocklist.",
      "code_602": "This message could not be delivered to the recipient after multiple attempts.",
      "code_605": "This email address is currently suppressed by our system from further delivery attempts. This usually occurs when the recipient's email provider returns an error during a previous delivery indicating that the email address does not exist.",
      "code_612": "Could not establish a connection with the mail server of this recipient. This usually occurs when the recipient's email service provider has received too many emails from this IP address over a short period."
    },
    "media_release": {
      "cancel": "Cancel",
      "confirm_delete_message": "You are about to permanently delete your draft {title}. Are you sure?",
      "confirm_delete_title": "Delete draft {title}",
      "confirm_send_now": "Are you sure you wish to send this to {total} recipients?",
      "confirm_unsaved_changes_message": "You have unsaved changes",
      "confirm_unsaved_changes_title": "Are you sure?",
      "create": "Create",
      "delete_draft": "Delete Draft",
      "deleting_error": "There was an error deleting the {title}",
      "delivered_success": "{title} successfully delivered to all recipients",
      "delivered_success_cancel": "Go back",
      "delivered_success_confirm": "Go to Report Analytics",
      "demo_mode": "Demo Mode:",
      "demo_mode_message": "{title} Emails will not be sent",
      "edit": "Edit",
      "loading_error": "Error loading {title}",
      "media_release_description": "Distribute a formal press release to a broad audience. Ideal for mass template announcements.",
      "media_release_title": "Media Release",
      "missing_body": "Missing Message Body",
      "missing_subject": "Missing Subject Line",
      "missing_subject_and_body": "Missing Subject Line and Message Body",
      "next_step": "Next",
      "open_in_new_tab": "Open in new tab",
      "personalised": "Personalised",
      "pitch_description": "Send personalised pitches, build relationships, and boost efficiency with our Al-powered pitching tool.",
      "pitch_title": "Pitch",
      "previous_step": "Previous",
      "recipient": {
        "biography": "Biography",
        "loading_error": "Error loading Contact",
        "media_outlets": "Media Outlets",
        "no_media_outlets": "No media outlets found for this contact.",
        "no_social_media": " No social media accounts found for this contact.",
        "social_media": "Social Media"
      },
      "save": "Save",
      "saved_success": "{title} Saved",
      "saving": "Saving ...",
      "saving_error": "There was an error saving the {title}",
      "schedule_later": "Schedule Later",
      "scheduled_success": "This {title} has been scheduled to send at {scheduledTime}",
      "send": "Send",
      "send_now": "Send Now",
      "send_test": "Send Test",
      "send_test_save_tooltip": "Save {title} to send test email.",
      "send_test_success": "This {title} has been sent as a test to {recipient}",
      "send_test_tooltip": "Send a test email before sending to all recipients.",
      "sending_test_error": "There was an error sending a test email"
    },
    "tooltips": {
      "media_release_upgrade": "Upgrade your Outreach service to distribute and analyse Media Releases.",
      "no_permission": "You do not have permission to access this",
      "search_only_upgrade": "Upgrade your Outreach service to create lists and distribute Media Releases."
    }
  },
  "outreach_activities": {
    "activities_export_error": "Error exporting activities CSV",
    "activities_heading": "Activities",
    "activities_tooltip": "A breakdown of all activities within your organisation. This includes an future activities, drafted and scheduled media releases.",
    "activity_deleted_error": "There was an error deleting the activity",
    "activity_deleted_message": "Activity deleted",
    "activity_duplicated_error": "There was an error duplicating the activity",
    "activity_duplicated_message": "Activity duplicated",
    "activity_timeline_header": "Activity Timeline",
    "activity_timeline_tooltip": "A breakdown of activities made by your organisation over the selected timeframe.",
    "create_activity_label": "Create Activity",
    "create_media_release_label": "Create Media Release",
    "download_csv_label": "Download CSV",
    "load_activities_error": "There was an error loading Activity",
    "load_analytics_error": "There was an error loading email analytics",
    "media_release_engagement_header": "Media Release Engagement",
    "media_release_engagement_tooltip": "A breakdown of media releases made by your organisation over the selected timeframe.",
    "pitch_engagement_header": "Pitch Engagement",
    "pitch_engagement_tooltip": "A breakdown of pitches made by your organisation over the selected timeframe."
  },
  "outreach_activity_add_title": "Create Activity",
  "outreach_activity_edit": {
    "assignees_empty_placeholder": "Type to find assignees",
    "assignees_label": "Add Assignees",
    "assignees_placeholder": "+ Add Assignee",
    "attachments_label": "Attachments",
    "contact_image": "Contact image",
    "contacts_description": "Search for individual Journalists or Outlets to add to your Activity.",
    "contacts_label": "Contacts",
    "created_by": "Created by {userName} on {date}",
    "date_time_label": "Date and Time",
    "edit_title": "Edit Activity",
    "load_activity_error": "There was an error loading Activity",
    "load_contact_error": "There was an error loading Contact",
    "notes_label": "Notes",
    "notes_placeholder": "Add Activity Notes",
    "private_label": "Private",
    "public_label": "Public",
    "remove_recipient": "Remove {name}",
    "save_activity_error": "There was an error saving Activity",
    "status_label": "Status",
    "tags_label": "Tags",
    "tags_placeholder": "+ Add a tag",
    "title_label": "Title",
    "title_placeholder": "Add Activity Title",
    "type_label": "Type",
    "visibility_label": "Visibility"
  },
  "outreach_activity_filters": {
    "activities_label": "Activities",
    "activity_timeline_label": "Activity Timeline",
    "assignees_label": "All Assignees | 1 Assignee selected | {count} Assignees selected",
    "assignees_placeholder": "All Assignees",
    "charts_label": "All Charts | 1 Chart selected | {count} Charts selected",
    "charts_placeholder": "Add/Remove Charts",
    "load_assignees_error": "There was an error loading Assignees",
    "load_tags_error": "There was an error loading Tags",
    "media_release_engagement_label": "Media Release Engagement",
    "statuses_label": "All Statuses | 1 Status selected | {count} Statuses selected",
    "statuses_placeholder": "All Statuses",
    "tags_label": "All Tags | 1 Tag selected | {count} Tags selected",
    "tags_placeholder": "All Tags",
    "types_label": "All Types | 1 Type selected | {count} Types selected",
    "types_placeholder": "All Types"
  },
  "outreach_activity_media_release_engagement": {
    "click_rate_chart_title": "Click Through Rate",
    "click_rate_chart_tooltip": "The total number of unique clicks for external links out of the total number of unique email deliveries.",
    "click_rate_clicked_label": "Clicked",
    "click_rate_not_clicked_label": "Not Clicked",
    "create_media_release_link": "Create a Media Release",
    "create_pitch_link": "Create a Pitch",
    "empty_table_message": "No Media Releases sent in the past 30 days.",
    "open_rate_chart_not_opened_label": "Not Opened",
    "open_rate_chart_opened_label": "Opened",
    "open_rate_chart_title": "Open Rate",
    "open_rate_chart_tooltip": "The total number of unique email opens out of total delivered recipients.",
    "pitches_empty_table_message": "No Pitches sent in the past 30 days."
  },
  "outreach_activity_table": {
    "columns": {
      "actions": "Actions",
      "assignee": "Assignee",
      "click_rate": "Click Rate",
      "contacts": "Contacts",
      "date": "Date",
      "open_rate": "Open Rate",
      "status": "Status",
      "tags": "Tags",
      "title": "Title",
      "type": "Type"
    },
    "create_activity_link": "Create an activity",
    "delete_activity_dialog_message": "You are about to delete this activity. Are you sure?",
    "delete_activity_dialog_title": "Delete Activity",
    "empty_table_message": "No activities meet this criteria.",
    "save_tags_error": "There was an error saving activity tags"
  },
  "outreach_activity_table_filters": {
    "draft_media_releases": "Draft media releases",
    "draft_pitches": "Draft pitches",
    "future_activities": "Future activities"
  },
  "outreach_activity_timeline": {
    "create_activity_link": "Create an activity",
    "empty_table_message": "No activities meet these criteria."
  },
  "outreach_contact": {
    "filter_by": "Filter by",
    "filter_by_sector": "Filter by this sector",
    "more_topics": "+{total} more",
    "outlets": "Outlets",
    "preview": "Preview",
    "sectors": "Sectors",
    "sectors_tooltip": "Sectors are specific industries or areas of interest journalists and outlets cover.",
    "undeliverable_email_help_article": "https://help.streem.com.au/en/articles/10472875-outreach-email-verification",
    "undeliverable_email_tooltip": "{email} is unable to be verified and emails will not be sent. Check for errors or click here for more information."
  },
  "outreach_contact_actions": {
    "add_private_data_label": "Add private data",
    "add_private_data_tooltip": "private data can only be added to 1 contact at a time",
    "add_to_list_label": "Add to list",
    "copy_emails_label": "Copy emails",
    "create_activity_label": "Create Activity",
    "create_activity_tooltip": "Activity can only be added to 1 contact at a time",
    "create_media_release_error": "Error creating Media Release",
    "create_media_release_label": "Create Media Release",
    "download_csv_label": "Download CSV",
    "select_a_contact_tooltip": "Select at least 1 contact",
    "select_contacts_tooltip": "Select fewer than {limit} contacts"
  },
  "outreach_contact_activities": {
    "activity_deleted_error": "There was an error deleting the activity",
    "activity_deleted_notification": "Activity deleted",
    "activity_duplicated_error": "There was an error duplicating the activity",
    "activity_duplicated_notification": "Activity duplicated",
    "create_activity_label": "Create Activity",
    "load_activities_error": "Error loading Activities",
    "title_placeholder": "Title"
  },
  "outreach_contact_connect_twitter": {
    "connect_label": "Connect X {'|'} Twitter",
    "integrate_body": "Integrate {platformName} with X {'|'} Twitter to understand what {newline} journalists are tweeting, re-tweeting and quoting in realtime.",
    "integrate_heading": "Integrate in one click",
    "load_integration_error": "There was an error loading the X {'|'} Twitter integration"
  },
  "outreach_contact_details": {
    "add_message": "Add private details for {contactName} which is visible across your organisation.",
    "address_heading": "Address",
    "address_line_1_placeholder": "Address Line 1",
    "address_line_2_placeholder": "Address Line 2",
    "country_placeholder": "Country",
    "last_update_by": "Last updated by {contactName} {date}.",
    "load_detail_error": "Error loading Private data",
    "notes_label": "Notes",
    "phone_label": "Phone",
    "postcode_label": "Postcode",
    "save_detail_error": "Error saving Private data",
    "save_detail_notification": "Private data saved",
    "suburb_placeholder": "Town/Suburb",
    "use_email_label": "Use this email for Media Releases",
    "use_email_tooltip": "The default email when sending media releases to {contactName}. Changes will apply from the next media release."
  },
  "outreach_contact_engagement": {
    "avg_engagement": "Average Engagement",
    "no_avg_engagement_tooltip": "This journalist's content doesn't generate enough engagement to show an average."
  },
  "outreach_contact_list_actions": {
    "delete_list_confirm_message": "You are about to delete this list and its contacts. Are you sure?",
    "delete_list_confirm_title": "Delete List",
    "delete_list_error": "There was an error deleting the contact list",
    "delete_list_label": "Delete {name}",
    "delete_list_notification": "Contact list deleted",
    "delete_list_tooltip": "Delete List",
    "duplicate_list_error": "There was an error duplicating the contact list",
    "duplicate_list_label": "Duplicate {name}",
    "duplicate_list_notification": "Contact List duplicated",
    "duplicate_list_tooltip": "Duplicate List",
    "edit_list_label": "Edit {name}",
    "edit_list_tooltip": "Edit List",
    "save_list_error": "There was an error saving the contact list"
  },
  "outreach_contact_list_items": {
    "see_all": "See All"
  },
  "outreach_contact_list_row": {
    "unknown": "Unknown"
  },
  "outreach_contact_list_selection": {
    "contacts": "{total} contact | {total} contacts",
    "lists_selected": "{total} List selected | {total} Lists selected",
    "load_contacts_error": "Error loading Contact Lists",
    "private": "Private"
  },
  "outreach_contact_lists": {
    "add_list_confirm_label": "Find Contacts",
    "add_list_confirm_message": "'{name}' was successfully created. You can add journalists and outlets to the list via the Contacts interface.",
    "add_list_confirm_title": "New List Created",
    "add_list_error": "Error creating contact list",
    "add_list_label": "Add New List",
    "add_tags_label": "Add Tags",
    "bulk_delete_confirm_message": "You are about to remove the selected list and its contacts. Once this list is deleted it cannot be recovered.<br><br>Are you sure you want to remove this list? | You are about to remove the selected lists and their contacts. Once these lists are deleted they cannot be recovered.<br><br>Are you sure you want to remove these lists?",
    "bulk_delete_confirm_title": "Remove {count} List | Remove {count} Lists",
    "bulk_delete_error": "There was an error deleting the selected contact list | There was an error deleting the selected contact lists",
    "bulk_delete_notification": "Contact list deleted | Contact lists deleted",
    "copy_email_error": "There was an error copying emails to the clipboard",
    "copy_emails_label": "Copy emails",
    "create_media_release_error": "Error building Media Release",
    "created_by_placeholder": "Created By",
    "download_csv_label": "Download CSV",
    "empty_list_table_message": "No lists found",
    "exclude_tags": "Exclude Tags",
    "export_confirm_title": "Exporting private contact data",
    "export_error": "Error exporting contacts CSV",
    "load_list_error": "Error loading contact lists",
    "no_contacts_to_suggest": "You need at least one recipient to generate journalist and outlet suggestions. Add one now to get started!",
    "no_valid_contacts_for_suggest": "Suggestions cannot be provided if your list only has private contacts. You need at least one contact added from the Search page to generate journalist and outlet suggestions. Add one now to get started!",
    "search_lists_placeholder": "Search lists",
    "select_a_contact_tooltip": "Select at least 1 contact",
    "select_contacts_tooltip": "Select fewer than {limit} contacts",
    "select_lists_placeholder": "Visibility",
    "send_media_release_label": "Send Media Release",
    "send_pitch_label": "Send Pitch",
    "send_pitch_tooltip": "Pitch one list at a time",
    "updated_by_placeholder": "Updated By"
  },
  "outreach_contact_lists_contacts": {
    "add_contacts_label": "Add Contacts",
    "add_to_list_label": "Add to List",
    "copy_emails_error": "There was an error copying emails to the clipboard",
    "copy_emails_label": "Copy emails",
    "created_by": "Created by {userName} on {date}",
    "download_csv_label": "Download CSV",
    "error": "Error",
    "export_contacts_error": "Error exporting contacts CSV",
    "export_dialog_title": "Exporting private contact data",
    "filters_label": "Filters",
    "hide_filters": "Hide filters",
    "list_count": "This list contains 1 contact. | This list contains {count} contacts.",
    "list_updated": "Last updated by {userName} {date}.",
    "load_contacts_error": "Error loading Contacts",
    "load_information_error": "There was an error loading contact list information",
    "load_select_all_contacts_error": "Failed to select all Contacts",
    "no_contacts_found": "No contacts found",
    "reindexing_notification": "We're updating this list with your latest changes. Your contacts will appear here in a moment…",
    "remove_contacts_confirm_message": "You are about to remove 1 contact from list {name}. Are you sure? | You are about to remove {count} contacts from list {name}. Are you sure?",
    "remove_contacts_confirm_title": "Remove contact | Remove contacts",
    "remove_contacts_error": "There was an error deleting contacts",
    "remove_contacts_notification": "Contacts removed",
    "remove_from_list_label": "Remove from List",
    "search_contacts_placeholder": "Search contacts",
    "select_a_contact_tooltip": "Select at least 1 contact",
    "select_all_contacts_label": "Select all Outlets",
    "select_all_journalists_label": "Select all Journalists",
    "select_contacts_tooltip": "Select fewer than {limit} contacts",
    "send_media_release_label": "Send Media Release",
    "send_pitch": "Send Pitch",
    "show_filters": "Show filters",
    "unknown": "Unknown",
    "unknown_information": "Unknown meta information"
  },
  "outreach_contact_lists_dropdown": {
    "label": "Contact List",
    "loading_error": "There was an error loading outreach lists. Please try again",
    "no_results": "No Results Found",
    "search_placeholder": "Search...",
    "select_one": "Select one"
  },
  "outreach_contact_lists_table": {
    "actions_title": "Actions",
    "caption": "Contact lists",
    "contacts_title": "Contacts",
    "created_by_title": "Created by",
    "last_updated_title": "Last updated",
    "media_releases_title": "Media Releases",
    "pitches_title": "Pitches",
    "tags": "Tags",
    "updated_by_title": "Updated by",
    "visibility_title": "Visibility"
  },
  "outreach_contact_mailing_lists": {
    "copy_emails_error": "There was an error copying emails to the clipboard",
    "copy_emails_label": "Copy emails",
    "create_media_release_error": "Error building Media Release",
    "download_csv_label": "Download CSV",
    "export_confirm_title": "Exporting private contact data",
    "export_error": "Error exporting contacts CSV",
    "load_lists_error": "There was an error loading mailing lists",
    "no_lists_found": "0 Mailing lists found.",
    "search_lists_placeholder": "Search mailing lists",
    "select_a_contact_tooltip": "Select at least 1 contact",
    "select_contacts_tooltip": "Select fewer than {limit} contacts",
    "send_media_release_label": "Send Media Release"
  },
  "outreach_contact_mailing_lists_contacts": {
    "copy_email_label": "Copy emails",
    "copy_emails_error": "There was an error copying emails to the clipboard",
    "create_media_release_error": "Error",
    "download_csv_label": "Download CSV",
    "export_dialog_title": "Exporting private contact data",
    "export_error": "Error exporting contacts CSV",
    "list_count": "This list contains 1 contact. | This list contains {count} contacts.",
    "load_contacts_error": "Error loading Contacts",
    "load_meta_information_error": "There was an error loading mailing list information",
    "load_select_all_contacts_error": "Failed to select all Contacts",
    "no_contacts": "No contacts found",
    "search_contacts_placeholder": "Search contacts",
    "select_a_contact_tooltip": "Select at least 1 contact",
    "select_all_journalists_label": "Select all Journalists",
    "select_all_outlets": "Select all Outlets",
    "select_fewer_contacts_tooltip": "Select fewer than {limit} contacts",
    "send_media_release_label": "Send Media Release",
    "unknown_information": "Unknown meta information"
  },
  "outreach_contact_mailing_lists_table": {
    "contact_title": "Contacts",
    "list_name_title": "List Name"
  },
  "outreach_contact_opted_out": {
    "badge": "This journalist has opted out",
    "legal_text": "This is a legal requirement which means we fully protect the rights of the Journalist, as well as maintaining the accuracy of our data for you.",
    "outlets": "Outlets:",
    "privacy_text": "{platformName} always strictly follows global Data Privacy regulations, including: the EU General Data Protection Regulation (GDPR), the UK Data Protection Act, the Californian Consumer Privacy Act, the Brazilian LGPD, and the Chinese PIPL.",
    "title": "This Journalist has chosen to Opt Out of {platformName}'s systems."
  },
  "outreach_contact_profile": {
    "add_private_data": "Add private data",
    "address": "Address",
    "bio": "Bio",
    "circulation": "Circulation",
    "circulation_tooltip": "Print circulations are sourced from a mix of third-party providers and direct research.",
    "dma": "DMA",
    "frequency": "Frequency",
    "language": "Language",
    "outlets": "Outlets",
    "private_data": "Private Data",
    "publisher": "Publisher",
    "saturday_circulation": "Saturday Circulation",
    "sectors": "Sectors",
    "sunday_circulation": "Sunday Circulation",
    "twitter_bio": "X {'|'} Twitter Bio",
    "undeliverable_email": "This email is unable to be verified and the original contact email will be used.",
    "update_label": "Have an update?",
    "uvpm_desktop": "Desktop UVPM",
    "uvpm_mobile": "Mobile UVPM",
    "uvpm_total": "Total UVPM",
    "uvpm_total_tooltip": "Outreach UVPM figures are populated via Similarweb and are refreshed monthly to reflect an average of recent UVPM metrics. This approach reduces month-to-month data fluctuation, which provides a representative view of overall audience."
  },
  "outreach_contact_profile_section": {
    "show_less": "Show less",
    "show_more": "Show more"
  },
  "outreach_contact_recent_articles_mention_volume": {
    "load_errror": "There was an error downloading the file"
  },
  "outreach_contact_recent_articles_mentions": {
    "no_results": "No data found. Try expanding your date range, keywords or filters.",
    "word_count": "· {count} words"
  },
  "outreach_contact_recent_articles_stats": {
    "total_mentions_title": "Total Mentions"
  },
  "outreach_contact_sidebar": {
    "about": "About",
    "articles": "Articles",
    "feed": "Feed",
    "full_profile": "View Full Profile",
    "lists": "Lists"
  },
  "outreach_contact_social_feed": {
    "no_username": "No X {'|'} Twitter Username found"
  },
  "outreach_contact_social_stats": {
    "avg_engagement": "Avg. Engagement",
    "avg_engagement_tooltip": "The average number of likes, shares, comments, upvotes, and pins this journalist's content receives on social media platforms (in the past year).",
    "top_reaction": "Top Reaction",
    "top_reaction_tooltip": "The top reaction this journalist's content typically receives across Facebook."
  },
  "outreach_contact_top_reaction": {
    "angry": "Angry",
    "description": "We've analysed over <strong>{total} reactions</strong> for this journalist's content. Of that amount, <strong>{percentage} were '{reaction}.'</strong>",
    "haha": "Haha",
    "love": "Love",
    "no_top_reaction_tooltip": "Due to low average engagement, there are no top reactions for this journalist's content.",
    "sad": "Sad",
    "top_reaction": "Top Reaction",
    "wow": "Wow"
  },
  "outreach_contact_totals": {
    "total_all": "{journalists} {joiner} {outlets} match your search.",
    "total_journalists": "{total} Journalist | {total} Journalists",
    "total_outlets": "1 Outlet | {total} Outlets"
  },
  "outreach_contact_twitter_engagement_metrics": {
    "followers": "Follower | Followers",
    "following": "Following",
    "profile": "{link} X {'|'} Twitter profile",
    "profile_username": "{username}'s",
    "tweets": "Tweet | Tweets",
    "user_lookup_error": "Error loading twitter user lookup"
  },
  "outreach_contact_twitter_post_card": {
    "quoted": "quoted",
    "replied": "replied",
    "retweeted": "retweeted"
  },
  "outreach_contact_twitter_posts": {
    "load_posts_error": "Error loading tweets"
  },
  "outreach_discover": {
    "ai_templates_description": "Click a template to get started with your search",
    "ai_templates_journalists": "Show me journalists that write about [topic] in [location]",
    "ai_templates_outlets": "Find outlets covering [industry] news in [region]",
    "ai_templates_tech_reporters": "Tech reporters based in [city]",
    "ai_templates_title": "AI Search Templates",
    "aria_ai_templates": "Open AI search templates",
    "aria_filter_chips": "Selected search filters",
    "aria_filter_chips_collapse": "Collapse selected search filters",
    "aria_filter_chips_expand": "Expand to see search filters",
    "aria_search_input": "Enter your search query",
    "aria_search_submit": "Discover contacts with AI",
    "article_relevance_tooltip": "Relevance will sort the articles based on how closely they match the search query.",
    "chips": {
      "address": "Address | Addresses",
      "circulation_range": "Circulation",
      "contact_lists": "List | Lists",
      "contact_locations": "Location | Locations",
      "contact_types": "Type | Types",
      "content_talking_about": "Talking About",
      "content_types": "Audience Type | Audience Types",
      "coverage_areas": "Coverage Area | Coverage Areas",
      "coverages": "News Focus | News Focuses",
      "designated_market_areas": "Designated Market Area | Designated Market Areas",
      "email": "Email | Emails",
      "frequencies": "Frequency | Frequencies",
      "job_title": "Job Title | Job Titles",
      "languages": "Language | Languages",
      "name": "Name | Names",
      "outlet_type_names": "Media Type | Media Types",
      "phone": "Phone | Phones",
      "profile": "Profile | Profiles",
      "publisher": "Publisher | Publishers",
      "socials": "Social Media",
      "tiers": "Tier | Tiers",
      "topics": "Topic | Topics"
    },
    "contacts_search_placeholder": "Search Name and Location",
    "no_results": "No results found. Try modifying your search.",
    "page_subtitle": "AI-powered search that transforms natural language prompts into accurate and refined journalist and outlet contact search results",
    "page_tip": "Try: Show me journalists writing about immigrants in New York with positive reviews",
    "recent_discoveries": "Recent Discovers",
    "recent_discoveries_empty_state": "Tell us what you're looking for. Discover takes care of the rest.",
    "recent_discoveries_results": "{count} result | {count} results",
    "total_articles": "{count} article matches your search | {count} articles match your search",
    "total_contacts": "{count} contact matches your search | {count} contacts match your search",
    "total_mentions": "Total Mentions",
    "view_recent_articles": "View recently matched articles"
  },
  "outreach_export_disclaimer": "{platformName} has automatically removed from your requested list all data subjects on our Global Address Blocklist (GAB), which manages and tracks opt-outs and erasures daily. This prevents you contacting them via {platformName}'s systems and is how we notify you of their requests. Please note that data subjects may be erased from or opted-out of {platformName}'s databases and/or communications from {platformName}'s customers at any time after you have downloaded a list. To ensure that you do not communicate with data subjects who are added to the GAB after you download a list, you should use the list on the same day that you download it. Any use of a contact after the day of download risks you communicate with a data subject that has been added to the GAB for which you will be responsible.",
  "outreach_influencer": {
    "about_tab": "About",
    "activity_tab": "Activity",
    "lists_tab": "Lists",
    "load_journalist_error": "Error loading Journalist",
    "private_data_tab": "Private data",
    "recent_articles_tab": "Recent Articles",
    "social_tab": "Social",
    "unsaved_changes_message": "You have unsaved changes made to {contactName}'s Private data. Do you wish to continue?",
    "unsaved_changes_title": "There are unsaved changes"
  },
  "outreach_launchpad_action_buttons": {
    "create_activity_label": "Create an Activity",
    "create_media_release_label": "Create a Media Release",
    "manage_brand_profiles_label": "Manage Brand Profiles",
    "manage_users_label": "Manage Users"
  },
  "outreach_launchpad_list_widget": {
    "new_lists": "New Lists",
    "top_lists": "Top Lists"
  },
  "outreach_launchpad_media_release_widget": {
    "clicks_title": "Clicks",
    "clicks_tooltip": "Unique clicks per Media Release.",
    "delivered_title": "Delivered",
    "delivered_tooltip": "All successful sends across all Media Releases. These are not unique.",
    "drafts_title": "Drafts",
    "last_30_days_label": "In the last 30 days",
    "media_release_clicks_tooltip": "Unique clicks per Media Release.",
    "media_release_delivered_tooltip": "All successful sends across all Media Releases. These are not unique.",
    "media_release_opens_tooltip": "Unique opens per Media Release.",
    "media_release_summary_header": "Media Release Summary",
    "media_release_title": "Media Releases",
    "media_release_tooltip": "Media Releases sent via Outreach.",
    "media_releases_title": "Media Releases",
    "media_releases_tooltip": "Media Releases sent via Outreach.",
    "opens_title": "Opens",
    "opens_tooltip": "Unique opens per Media Release.",
    "pitch_clicks_tooltip": "Unique clicks per Pitch.",
    "pitch_delivered_tooltip": "All successful sends across all Pitches. These are not unique.",
    "pitch_opens_tooltip": "Unique opens per Pitch.",
    "pitch_summary_header": "Pitch Summary",
    "pitch_title": "Pitches",
    "pitch_tooltip": "Pitches sent via Outreach.",
    "scheduled_title": "Scheduled"
  },
  "outreach_launchpad_new_list_table": {
    "contacts": "Contacts",
    "create_list_link": "Create a list",
    "date_created": "Date Created",
    "empty_state_message": "You currently have no public lists.",
    "load_lists_error": "There was an error loading new contact lists",
    "title": "Title"
  },
  "outreach_launchpad_quick_search": {
    "header": "Journalist or Outlet Name",
    "journalist_or_outlet_label": "Journalist or Outlet Name",
    "talking_about_label": "Talking about"
  },
  "outreach_launchpad_quick_search_talking_about": {
    "journalists_heading": "Journalists",
    "no_matches": "No journalists matching filter",
    "no_options": "No available options",
    "see_all_label": "See all",
    "upgrade_tooltip": "Upgrade your Outreach service to see all contacts."
  },
  "outreach_launchpad_recent_activity_widget": {
    "all_label": "All",
    "assigned_to_all_label": "Assigned to all",
    "assigned_to_me_label": "Assigned to me",
    "load_activities_error": "There was an error loading recent activity",
    "title": "Recent Activities"
  },
  "outreach_launchpad_table_empty_state": {
    "default_message": "No data available"
  },
  "outreach_launchpad_top_list_table": {
    "contact": "Contacts",
    "create_list_link": "Create a list",
    "empty_state_message": "You currently have no public lists.",
    "load_lists_error": "There was an error loading top contact lists",
    "media_releases": "Media Releases",
    "title": "Title"
  },
  "outreach_lists": {
    "contacts": "Contacts",
    "last_updated": "Last Updated",
    "lists_tab": "Lists",
    "load_lists_error": "Error loading Lists",
    "mailing_lists_tab": "Mailing Lists",
    "no_lists_found": "No Lists found",
    "private_contacts_tab": "Private Contacts",
    "remove_contact_confirm_title": "Remove {contactName} from {listName}?",
    "remove_contact_error": "There was an error removing contact from list",
    "remove_contact_notification": "Contact deleted",
    "remove_contact_tooltip": "Remove contact from this list.",
    "search_placeholder": "Search lists",
    "title": "Title"
  },
  "outreach_location_dropdown": {
    "load_countries_error": "Error loading locations",
    "load_exclusions_error": "Error loading location exclusions"
  },
  "outreach_location_selector": {
    "filter_contacts": "Filter Contacts in Outreach"
  },
  "outreach_media_release_analytics": {
    "download_csv_label": "Download CSV",
    "export_csv_error": "Error exporting Media Release CSV",
    "from": "From: {fromName}",
    "load_media_release_error": "There was an error loading Media Release",
    "media_release_sent": "This Media Release is currently being sent. Try refreshing this page in a couple of minutes.",
    "remove_contacts_label": "Remove Contacts from Lists",
    "reply_to": "Reply to: {replyTo}",
    "save_tags_error": "There was an error saving Media Release tags",
    "view_media_release_label": "View Media Release"
  },
  "outreach_outlet": {
    "about_tab": "About",
    "activity_tab": "Activity",
    "affiliated_media_count": "Displaying 1 Outlet | Displaying {total} Outlets",
    "affiliated_media_tab": "Affiliated Media",
    "clear_label": "Clear",
    "contacts_selected": "{total} contact selected | {total} contacts selected",
    "desks_tab": "Desks",
    "journalist_count": "Displaying 1 Journalist | Displaying {total} Journalists",
    "journalist_tab": "Journalists",
    "lists_tab": "Lists",
    "load_contacts_error": "Error loading Contacts",
    "load_outlet_error": "Error loading Outlet",
    "load_select_all_contacts_error": "Failed to select all Contacts",
    "no_affiliated_media_state": "No Affiliated Media found",
    "no_journalists_state": "No Journalists found",
    "no_private_contacts_state": "No Private Contacts found",
    "outlet_count": "Displaying 1 Outlet | Displaying {total} Outlets",
    "outlets_selected": "{total} Outlet selected | {total} Outlets selected",
    "private_contacts_count": "Displaying 1 Private Contact | Displaying {total} Private Contacts",
    "private_contacts_tab": "Private Contacts",
    "private_data_tab": "Private data",
    "unsaved_changes_message": "You have unsaved changes made to {contactName}'s Private data. Do you wish to continue?",
    "unsaved_changes_title": "There are unsaved changes",
    "view_label": "View"
  },
  "outreach_outlet_desks": {
    "add_to_list_label": "Add to list",
    "copy_confirm_title": "Exporting private contact data",
    "copy_emails_label": "Copy emails",
    "load_desks_error": "Error loading Desks",
    "load_select_all_desks_error": "Failed to select all Desks",
    "no_desks_found": "No Desks found",
    "select_a_desk_tooltip": "Select at least 1 desk",
    "total_desks": "Displaying 1 desk | Displaying {count} desks"
  },
  "outreach_pitch": {
    "create_pitch": "Create Pitch",
    "create_without_contacts_error": "You cannot create a pitch without contacts",
    "error_creating_pitch": "Error creating pitch"
  },
  "outreach_pitch_adhoc_recipient": {
    "description": "Custom recipient."
  },
  "outreach_pitch_ai": {
    "discard_response_title": "Do you want to discard generated response?",
    "error_generating_pitch": "Error generating pitch",
    "pitch_edit_placeholder": "Ask AI to edit your pitch",
    "saving_pitch": "Saving pitch..."
  },
  "outreach_pitch_ai_generate_menu": {
    "try_again": "Try again",
    "use_pitch": "Use This Pitch"
  },
  "outreach_pitch_ai_menu": {
    "ask_ai": "Ask AI",
    "regenerate_pitch": "Regenerate Pitch"
  },
  "outreach_pitch_ai_prompt_form": {
    "pitch_prompt_description": "e.g. Acme Tech is introducing an innovative AI-powered virtual assistant designed for the healthcare industry",
    "pitch_prompt_placeholder": "Write a line or two about your pitch",
    "pitch_prompt_requirements": "* Minimum of 14 words required. Please avoid sharing any sensitive information in your prompts. {platformName} shares your prompts with OpenAI in order to enable your use of this tool and OpenAI will store your prompts for content moderation purposes."
  },
  "outreach_pitch_ai_tone_menu": {
    "change_tone": "Change Tone"
  },
  "outreach_pitch_edit": {
    "confirm_skip_personalise_message": "Personalising your pitches will go a long way in maximising your outreach success.",
    "confirm_skip_personalise_title": "Looks like there are some pitches not personalised",
    "step_content": {
      "description": "We'll generate the first draft, which you can then customise.",
      "label": "Draft Pitch"
    },
    "step_personalise": {
      "confirm_skip_personalise_message": "Adding that personal touch and ensuring your pitches look great will go a long way in maximising your outreach success.",
      "confirm_skip_personalise_title": "Are you sure you want to skip personalisation?",
      "description": "Increase your chances of coverage and build stronger relationships.",
      "label": "Personalise Pitch",
      "personalise_question": "Want to personalise your pitch for each contact?",
      "single_pitch_description": "Write a single pitch, send it to all the contacts below.",
      "single_pitch_label": "One Pitch for All Contacts",
      "skip_personalisation_question": "Want to skip personalisation and send the same pitch to everyone?"
    },
    "step_recipients": {
      "label": "Recipients"
    },
    "step_send": {
      "label": "Send Pitch",
      "title_input_description": "Internal, will not be seen by recipients",
      "title_input_label": "Title"
    }
  },
  "outreach_pitch_private_recipient": {
    "job_title": "Job Title",
    "language": "Language",
    "no_data": "No notes have been added.",
    "notes": "Notes",
    "phone": "Phone",
    "private_contact": "Private Contact"
  },
  "outreach_pitch_step_content": {
    "confirm_edit_label": "Edit Pitch",
    "confirm_edit_message": "Edits to this pitch will not be reflected in already personalised pitches.",
    "confirm_edit_title": "Edit this pitch?"
  },
  "outreach_pitch_step_personalise": {
    "error_loading_recipients": "Error loading pitch recipients"
  },
  "outreach_pitch_step_recipients": {
    "confirm_remove_recipient_label": "Remove",
    "confirm_remove_recipient_message": "Removing this recipient will also delete the pitch.",
    "confirm_remove_recipient_title": "Do you want to remove this recipient?",
    "description": "Review and manage all recipients for this Pitch.",
    "error_removing_recipient": "Error removing recipient",
    "search_placeholder": "Search by name, email, or source",
    "title": "Recipient List"
  },
  "outreach_private_contacts": {
    "add_contact_error": "There was an error saving the contact list",
    "add_contacts_label": "Add Private Contact",
    "add_to_list_label": "Add to List",
    "all_lists": "All Lists",
    "bulk_add_contacts_label": "Import Private Contacts",
    "copy_emails_error": "There was an error copying emails to the clipboard",
    "copy_emails_label": "Copy emails",
    "delete_contacts": "Delete Private Contact | Delete Private Contacts",
    "delete_contacts_error": "There was an error deleting private contact | There was an error deleting private contacts",
    "delete_contacts_message": "Deleting this Private Contact will remove them from any Contact Lists or Media Release data they may be associated with. Are you sure? | Deleting 1 Private Contact will remove them from any Contact Lists or Media Release data they may be associated with. Are you sure? | Deleting {count} Private Contacts will remove them from any Contact Lists or Media Release data they may be associated with. Are you sure?",
    "delete_contacts_notification": "Private contact deleted | Private contacts deleted",
    "download_csv_label": "Download CSV",
    "exclude_lists": "Exclude Lists",
    "export_contacts_error": "Error exporting private contacts CSV",
    "invalid_emails_only": "Show invalid emails only",
    "load_contacts_error": "Error loading private contacts",
    "no_contacts_found": "No private contacts found",
    "search_label": "Search private contacts",
    "search_placeholder": "Search names",
    "select_a_contact": "Select at least 1 private contact",
    "select_contacts": "Select fewer than {limit} private contacts"
  },
  "outreach_private_contacts_table": {
    "job_title": "Job Title",
    "last_updated": "Last updated",
    "lists": "Lists",
    "outlet": "Outlet",
    "outlet_see_all": "See All ({count})"
  },
  "outreach_private_influencer_form": {
    "address_line1_label": "Address Line 1",
    "address_line2_label": "Address Line 2",
    "address_line3_label": "Address Line 3",
    "city_label": "City",
    "country_label": "Country",
    "county_label": "County",
    "email_address_label": "Email Address",
    "first_name_label": "First Name",
    "job_title_label": "Job title",
    "language_label": "Language",
    "last_name_label": "Last Name",
    "linkedin_label": "Linkedin Profile",
    "notes_label": "Notes",
    "outlet_cant_find": "Can't find what you're looking for?",
    "outlet_custom_placeholder": "Enter outlet name",
    "outlet_custom_tooltip": "Private Outlet",
    "outlet_label": "Outlet",
    "outlet_search_placeholder": "Search Outlet",
    "phone_label": "Phone",
    "postal_code_label": "Postal Code",
    "remove_custom_label": "Remove {name}",
    "remove_outlet_label": "Remove {name}",
    "salutation_label": "Salutation",
    "state_label": "State",
    "twitter_label": "X Profile"
  },
  "outreach_private_influencer_upload": {
    "download_sample_file": "Download Sample file",
    "upload_csv_columns": "Upload a CSV containing columns: salutation, first_name, last_name, email, phone, job_title, language, outlet and note.",
    "upload_csv_label": "Upload CSV",
    "upload_csv_required_fields": "first_name, last_name and email cannot be blank"
  },
  "outreach_profile": {
    "address_title": "Address:",
    "circulation_title": "Circulation:",
    "contact_addresses": "+{count} more",
    "contact_emails": "+{count} more",
    "contact_phones": "+{count} more",
    "frequency_title": "Frequency:",
    "language_title": "Language:",
    "outlets_title": "Outlets:",
    "publisher_title": "Publisher:",
    "sector_title": "Sector:",
    "twitter_bio_title": "X (Twitter) Bio:",
    "update_label": "Have an update?"
  },
  "outreach_recipient_dropdown": {
    "dropdown_text": "Select One",
    "input_placeholder": "Search...",
    "no_results": "No Results Found",
    "select_label": "Recipient List"
  },
  "outreach_record_selected_section": {
    "clear": "Clear",
    "contacts": "{count} contact selected | {count} contacts selected",
    "lists": "{count} list selected | {count} lists selected",
    "mailing_lists": "{count} Mailing Lists selected | {count} Mailing Lists selected",
    "private_influencers": "{count} private contact selected | {count} private contacts selected",
    "remove": "Remove",
    "view": "View",
    "warning_tooltip": "The first {limit} contacts have been selected."
  },
  "outreach_saved_search_save_modal": {
    "save_description": "Enter a name for this search to save it for future use.",
    "save_error": "Unable to save search",
    "save_input_label": "Search name",
    "save_success": "Saved search created",
    "save_title": "Save this search"
  },
  "outreach_saved_searches": {
    "current_aria_label": "Saved search: {name}",
    "delete_aria_label": "Delete saved search {name}",
    "delete_confirm_message": "Are you sure you want to delete \"{name}\"? This action cannot be undone.",
    "delete_confirm_title": "Delete Search",
    "delete_error": "Unable to delete saved search",
    "delete_success": "Saved search deleted",
    "edit_aria_label": "Edit saved search {name}",
    "last_saved": "Last saved: {date}",
    "leave_confirm_label": "Leave search",
    "leave_confirm_message": "You have unsaved changes. If you leave this page, your changes will be lost.",
    "leave_confirm_title": "Leave Outreach Search?",
    "list_aria_label": "Saved searches",
    "load_error": "Unable to load saved searches",
    "new_search": "New Search",
    "new_search_confirm_label": "Delete",
    "new_search_confirm_message": "You have unsaved changes. Are you sure you want to discard them?",
    "new_search_confirm_title": "Discard Unsaved Changes",
    "no_results": "No saved searches found",
    "open_button": "Open",
    "open_error": "Unable to open saved search",
    "open_saved_searches": "Open Saved Searches",
    "open_title": "Open Saved Search",
    "save_error": "Unable to update saved search",
    "save_input_label": "Search name",
    "search_placeholder": "Search saved searches",
    "select_aria_label": "Select saved search {name}",
    "select_prompt": "Select a saved search",
    "status_editing": "editing",
    "status_saved": "saved",
    "update_success": "Saved Search has been updated."
  },
  "outreach_search": {
    "advanced_keywords_deleted": "Advanced keyword search has been deleted.",
    "advanced_keywords_modal": {
      "add_keyword_set_tooltip": "Add a new set of keywords that can be searched in addition to any previous keyword sets",
      "add_new_keyword_set_aria_label": "Add new keyword set",
      "all_keyword_types": "All keyword types",
      "apply_search": "Apply Search",
      "confirm_delete_button": "Reset keywords",
      "confirm_delete_message": "Resetting your search will clear all keywords currently in use.",
      "delete_keyword_set_aria_label": "Delete keyword set {index}",
      "keyword_count": "{count} keyword | {count} keywords",
      "keyword_set_label": "Keyword Set {index}",
      "new_keyword_set": "New Keyword Set",
      "remove_keyword_rule_aria_label": "Remove keyword rule",
      "selected_keyword_types": "{count} selected",
      "title": "Advanced Keyword Search",
      "type_keyword_placeholder": "Type keyword and press Enter",
      "type_locations_placeholder": "Search Physical Locations",
      "type_sectors_placeholder": "Search Sectors"
    },
    "advanced_keywords_tooltip": "Customise your keywords for a more powerful search",
    "all_results_tab": "All Results",
    "clear_all": "Clear all",
    "filters_heading": "Filters",
    "filters_toggle_label": "Toggle filters",
    "journalists_tab": "Journalists",
    "keyword_search": "Keyword Search",
    "load_contacts_error": "Error loading Contacts",
    "load_select_all_contacts_error": "Failed to select all Contacts",
    "location_filter_disabled": "Physical Location filter is disabled while advanced search filters are applied.",
    "outlets_tab": "Outlets",
    "physical_location": "Physical Location",
    "remove_keyword_tag_aria_label": "Remove keyword {tag}",
    "search_all": "Search all",
    "search_all_tooltip": "Search all of these keywords together",
    "search_any": "Search any",
    "search_any_tooltip": "Search any of these keywords",
    "search_contacts": "Search contacts",
    "search_type": "Search Type",
    "sector_filter_disabled": "Sectors filter is disabled while advanced search filters are applied.",
    "sectors": "Sectors",
    "simple_search_disabled": "Simple search is disabled while advanced search filters are applied.",
    "talking_about": "Talking About",
    "total_all": "{journalists} {joiner} {outlets} match your search.",
    "total_journalists": "{total} Journalist | {total} Journalists",
    "total_outlets": "1 Outlet | {total} Outlets"
  },
  "outreach_search_dropdown": {
    "keyword_types_label": "Keyword Types",
    "select_all_label": "Select All",
    "talking_about_label": "Talking About"
  },
  "outreach_search_filters": {
    "card_title": {
      "audience_type": "Audience Type | {count} Audience Type | {count} Audience Type",
      "coverage_area": "Coverage Areas | {count} Coverage Area | {count} Coverage Areas",
      "designated_market_area": "Designated Market Areas | {count} Designated Market Area | {count} Designated Market Areas",
      "frequency": "Frequencies | {count} Frequency | {count} Frequencies",
      "language": "Languages | {count} Language | {count} Languages",
      "list": "Lists | {count} List | {count} Lists",
      "media_type": "Media Type | {count} Media Type | {count} Media Type",
      "physical_location": "Physical Locations | {count} Physical Location | {count} Physical Locations",
      "sector": "Sectors | {count} Sector | {count} Sectors",
      "social_media": "Social Media | {count} Social Media | {count} Social Media",
      "tiers": "Tiers | {count} Tier | {count} Tiers"
    },
    "circulation_placeholder": "Any",
    "circulation_title": "Circulation",
    "media_types": {
      "blog": "Blog",
      "bureau": "Bureau",
      "magazine": "Magazine",
      "news_service_syndicate": "News Service/Syndicate",
      "newsletter": "Newsletter",
      "newspaper": "Newspaper",
      "podcast": "Podcast",
      "radio_network_station": "Radio Network/Station",
      "radio_show": "Radio Show",
      "social": "Social",
      "television_network_station": "Television Network/Station",
      "television_show": "Television Show",
      "website": "Website"
    },
    "news_focus_title": "News Focus",
    "talking_about_placeholder": "Article Keywords and Tweets",
    "talking_about_search_all_label": "Search all",
    "talking_about_search_all_tooltip": "Search for all of these keywords and tweets",
    "talking_about_search_any_label": "Search any",
    "talking_about_search_any_tooltip": "Search for any of these keywords and tweets",
    "talking_about_title": "Talking About"
  },
  "outreach_search_tab": {
    "clear_selection_dialog_title": "Are you sure?",
    "no_results": "Your search didn't return any results.{newline}Try expanding your filters, or reset your search.",
    "selection_clear": "Clear",
    "selection_total": "{total} contact selected | {total} contacts selected",
    "selection_view": "View",
    "sort_by_label": "Sort by:",
    "update_label": "Have an update?",
    "warning_tooltip": "The first {limit} contacts returned in your search have been selected."
  },
  "outreach_suggested_contacts": {
    "description": "Here are additional Journalists and Outlets similar to {name} you might find relevant."
  },
  "pagination": {
    "next_page": "Next Page",
    "page_of_total": "Page {page} of {totalPages}",
    "page_size_label": "{pageSize} / page",
    "previous_page": "Previous Page"
  },
  "paper_article_preview": {
    "download_article_pdf": "Download Article PDF",
    "download_pdf_error": "There was an error downloading the Article PDF",
    "load_article_error": "There was an error loading the article",
    "pdf_image": "PDF image",
    "read_on_afr": "Read on AFR with subscription",
    "view_article_pdf": "View Article PDF"
  },
  "password_back_button": {
    "arrow_back_button": "arrow back button",
    "go_back": "Go back"
  },
  "password_reset": {
    "changing_pin": "Changing PIN",
    "common_pin": "This PIN is too common. Please choose a different PIN",
    "pin_not_changed": "Your PIN has not been changed",
    "reset_pin_error": "Error requesting PIN Reset. Please try again",
    "sending_verification_code": "Sending verification code",
    "validation_code": "Validating code"
  },
  "password_reset_change_form": {
    "4_digits": "PIN must be 4 digits",
    "cancel_pin_reset": "Cancel PIN reset",
    "confirm_new_pin": "Confirm new PIN",
    "different_digits": "PIN must be different digits",
    "enter_new_pin": "Please enter a new PIN below",
    "new_pin": "New PIN",
    "new_pin_confirmation": "New PIN Confirmation",
    "only_digits": "PIN Must contain only digits",
    "pin_must_match": "PIN must match, try again",
    "pin_saved": "Your new PIN has been saved",
    "reset_pin": "Reset your PIN",
    "save_pin": "Save PIN",
    "sign_in_with_new_pin": "Sign in with your new PIN",
    "success": "Success!",
    "thanks_for_confirming": "Hi {name}, thanks for confirming it's you."
  },
  "password_reset_step_1_form": {
    "cancel_pin_reset": "Cancel PIN reset",
    "look_in_spam_folder_account_details": "Take a look in your spam folder, just in case. If it’s not there, double check your account details and press Resend.",
    "look_in_spam_folder_phone_number": "Take a look in your spam folder, just in case. If it’s not there, double check your phone number and press Resend.",
    "password_reset": "password reset",
    "receive_mail": "Didn’t receive the email?",
    "receive_sms": "Didn’t receive the SMS?",
    "resend_code": "Resend code",
    "reset_pin": "Reset your PIN",
    "send_code": "Send code",
    "sign_in_to_platform_with_email": "Enter the email address you use to sign-in to {platformName}",
    "sign_in_to_platform_with_mobile": "Enter the mobile number you use to sign-in to {platformName}",
    "verification_code": "We'll send a verification code to you via:"
  },
  "password_reset_step_2_form": {
    "code_invalid_or_expired": "The code is invalid or expired. Please try again",
    "enter_code": "Enter code",
    "enter_verification_code": "Enter verification code",
    "get_verification_code": "Didn’t get the verification code?",
    "please_wait": "please wait ({resendTimeout})",
    "receive_verification_code": "Didn’t receive the verification code?",
    "resend_code": "Resend Code",
    "reset_pin": "Reset your PIN",
    "send_again": "Send again",
    "validate_code": "Validate code",
    "verification_code": "Verification code",
    "verification_code_sent": "A verification code has been sent to {emailOrPhone}"
  },
  "phone_country_code": "+61",
  "planhat": {
    "error_message": "Unable to redirect to the customer portal. Please try again."
  },
  "player_popout_buttons": {
    "expand_player": "Expand player",
    "next_item_in_playlist": "Next Item In Playlist",
    "next_item_in_queue": "Next item in queue",
    "pause": "Pause",
    "play": "Play",
    "play_or_pause": "Toggle play or pause",
    "previous_item_in_playlist": "Previous Item In Playlist",
    "previous_item_in_queue": "Previous item in queue",
    "shrink_player": "Shrink player",
    "thirty_seconds_back": "30 Seconds Back",
    "thirty_seconds_back_aria": "Go back 30 seconds",
    "thirty_seconds_forward": "30 Seconds Forward"
  },
  "player_popout_controls": {
    "close_player": "Close player",
    "playing": "Playing",
    "playlist_count": "playlist ({playerlistCount})",
    "playlist_queued": "{playerlistCount} queued",
    "queue": "Queue",
    "toggle_playlist": "Toggle playlist",
    "toggle_volume": "Toggle volume"
  },
  "player_popout_interface": {
    "duration_restriction": "Due to licensing restrictions imposed on all Media Monitoring Organisations and this program not being of news and current affairs nature, we’ve restricted the duration of content that can be viewed for this item. If you believe this to be an error please request the Media Item and note the issue and we will resolve it immediately. Alternatively please contact your Account Manager directly."
  },
  "player_popout_list": {
    "clear_list": "Clear list",
    "clear_queue": "Clear Queue",
    "close_playlist": "Close playlist",
    "lists_in_queue": "{lists} in Queue",
    "play_item": "Play Item",
    "queue_is_empty": "Your queue is empty",
    "remove_from_list": "Remove from List",
    "remove_item": "Remove item"
  },
  "player_popout_list_item": {
    "mentions": "Mentions {keywords}",
    "queue_is_empty": "Your queue is empty",
    "radio_clip": "Radio clip",
    "tv_clip": "TV clip"
  },
  "player_popout_tv_card_control": {
    "clip_preview": "Clip preview"
  },
  "player_popout_volume": {
    "adjust_volume": "Adjust Volume",
    "toggle_volume": "Toggle volume"
  },
  "podcast_mention_card_fragments_dropdown": {
    "hide_fragments": "Hide {fragmentLength} matches",
    "play_audio_from": " Play audio from {fragmentStartTime}",
    "show_fragments": "Show {fragmentLength} matches"
  },
  "podcast_player": {
    "load_podcast_fragments_error": "There was an error loading podcast fragments",
    "load_podcast_information_error": "There was an error loading podcast information"
  },
  "potential_audience_reach_widget": {
    "desktop": "Desktop",
    "label": "Potential Audience Reach",
    "mobile": "Mobile",
    "short_label": "Audience",
    "total_reach": "Total Reach"
  },
  "preview_mention_alert_collapsible_header": {
    "account_manager": "Account Manager",
    "additional_cost": "An additional per item cost will apply. To confirm this cost please contact your {accountManager}.",
    "change_cap_message": "To increase or change your cap please contact your {accountManager}.",
    "monthly_cap_exceeded": "Your organisation has exceeded its monthly cap of {sourceFieldLabel} Items.",
    "monthly_cap_text": "Please note that your organisation has a monthly cap and each time you view a {sourceFieldLabel} Item this will be deducted from your monthly cap. Once you or anyone else at your organisation has viewed a unique {sourceFieldLabel} Item you can go back and view it as many times as you want without this deducting from your monthly cap."
  },
  "preview_player": {
    "play": "Play",
    "preview": "Preview"
  },
  "print_mention_card": {
    "potential_audience_reach": "{audience} Potential Audience Reach",
    "view_online_version": "View online version",
    "word_count": "· {wordCount} words {pageNumbers}"
  },
  "product_menu": {
    "aria_label": "Product menu",
    "intercom_launcher_aria_label": "Help and support"
  },
  "program_timeline": {
    "no_program_information": "No program information"
  },
  "progress_bar": {
    "label": "Progress"
  },
  "progress_steps": {
    "label": "Progress"
  },
  "query_editor": {
    "date_range_string": "over the {dateRange}",
    "enter_fullscreen": "Enter Fullscreen",
    "error_in_query": "There is an error in your query. Please modify before saving.",
    "exit_fullscreen": "Exit Fullscreen",
    "mode": {
      "and_detail": "matches the left and right side of the operator",
      "atleast_detail": "matches if found n number of times",
      "first_detail": "matches within the first n number of words",
      "near_detail": "matches the left and right side of the operator within n number of words",
      "not_detail": "does not match anything proceeding the operator",
      "notes_detail": "add notes about the query",
      "notes_label": "/* Notes */",
      "notes_placeholder": "Notes",
      "or_detail": "matches either the left or right side of the operator",
      "unless_detail": "negates the NOT operator when used within it"
    },
    "nested_snippet_save_error": "This query contains references to other keyword snippets. Remove them before saving.",
    "no_media_types_selected": "No media types selected",
    "query_label": "Query",
    "query_valid": "Query valid",
    "refresh_count_error": "There was an unknown error",
    "results_filtered_message": "{resultCount} results were filtered out for the below query.",
    "results_found_message": "{resultCount} results were found for the below query {dateRange}.",
    "validating_query": "Validating query..."
  },
  "query_editor_help_button": {
    "boolean_operators_link": "How Do Boolean Operators Work?",
    "editor_subtext": "Use the boolean operators AND, OR, NOT as well as brackets and double quotes to define the Query."
  },
  "query_snippets": {
    "cannot_delete_dialog": {
      "message_monitoring": "{label} is currently applied to {count} Mention Stream. Please remove the Keyword Snippet from this Stream before deleting it. | {label} is currently applied to {count} Mention Streams. Please remove the Keyword Snippet from these Streams before deleting it.",
      "message_social": "{label} is currently applied to {count} Social Stream. Please remove the Keyword Snippet from this Stream before deleting it. | {label} is currently applied to {count} Social Streams. Please remove the Keyword Snippet from these Streams before deleting it.",
      "title": "Cannot Delete Keyword Snippet"
    },
    "common": {
      "linked_streams_loading_error": "There was an error loading linked streams.",
      "snippet_created": "\"{querySnippetLabel}\" has been created.",
      "snippet_saving_error": "There was an error saving keyword snippet",
      "snippet_updated": "\"{querySnippetLabel}\" has been updated.",
      "snippets_loading_error": "There was an error loading keyword snippets"
    },
    "create_snippet_from_query": {
      "snippet_contains_reference_tooltip": "A keyword snippet is already applied. Remove it before creating a new one.",
      "turn_into_keyword_snippet": "Turn into Keyword Snippet"
    },
    "delete_query_snippet_modal": {
      "banner_message": "You can remove/revoke your own access from the keyword snippet and transfer it to your colleague.",
      "confirm_delete": "Remove snippet",
      "confirm_transfer": "Confirm changes",
      "new_owner_placeholder": "Select a new owner",
      "select_new_owner": "Select a new owner",
      "title": "Delete {label}",
      "transfer_ownership_message": "Transfer ownership of Keyword Snippet"
    },
    "query_snippet_edit": {
      "coverage_preview": "Coverage Preview:",
      "coverage_preview_initial_message": "Build a query using the form on the left and click {previewButtonLabel} to see the resulting coverage."
    },
    "query_snippet_edit_form": {
      "banner_monitoring": "Monitoring Keyword Snippet",
      "banner_social": "Social Keyword Snippet",
      "no_nested_snippets": "There can be no keyword snippets applied when creating/editing a keyword snippet",
      "warning_monitoring": "Updating a keyword snippet will have a cascading effect on any Mention Stream it belongs to.",
      "warning_social": "Updating a keyword snippet will have a cascading effect on any Social Stream it belongs to."
    },
    "query_snippet_group": {
      "group_existing": "Existing Group",
      "group_loading_error": "There was an error loading keyword snippets group",
      "group_new": "New Group",
      "group_new_placeholder": "Create a new group",
      "group_select_placeholder": "Select a group"
    },
    "query_snippet_linked_streams_modal": {
      "edit_confirmation_title": "Edit Keyword Snippet",
      "edit_confirmation_warning": "By updating this Keyword Snippet, you will be updating all connected Mention Streams and Reports. Please review carefully before proceeding.",
      "group_column": "Group",
      "header": {
        "mention_streams": "{streamsCount} Mention Stream | {streamsCount} Mention Streams",
        "mention_streams_and_reports": "Mention Stream and Scheduled Report ({streamsCount})",
        "social_streams": "{streamsCount} Social Stream | {streamsCount} Social Streams"
      },
      "no_reports": "No scheduled reports",
      "scheduled_reports_column": "Scheduled Reports",
      "stream_column_monitoring": "Mention Stream",
      "stream_column_social": "Social Stream",
      "subtext": {
        "edit_confirmation": "Below Mention Stream(s) and report(s) contains the selected Keyword Snippet.",
        "mention_streams": "The following Mention Streams contain the selected Keyword Snippet.",
        "social_streams": "The following Social Streams contain the selected Keyword Snippet."
      }
    },
    "query_snippets_list": {
      "banner_description_monitoring": "Save your Boolean queries for quick access and reuse across Mention Streams",
      "banner_description_social": "Save your Boolean queries for quick access and reuse across Social Streams",
      "new_snippet": "New Keyword Snippet",
      "share_snippet": "Share {querySnippetName}",
      "snippet_duplicated": "\"{querySnippetLabel}\" has been duplicated.",
      "snippet_duplicating_error": "There was an error duplicating the keyword snippet",
      "snippet_shared": "\"{querySnippetLabel}\" has been shared.",
      "snippet_sharing_error": "There was an error sharing this keyword snippet",
      "sort_by_label": "Sort by:"
    },
    "query_snippets_selection_modal": {
      "boolean_preview_aria_label": "Keyword Snippet Boolean Query, read-only",
      "built_using": "This keyword snippet was built using {queryType}.",
      "built_using_boolean": "Boolean",
      "empty_state_description": "Select a keyword snippet from the dropdown above to get started.",
      "empty_state_title": "Nothing to display yet",
      "must_not_subtitle": "these keywords",
      "must_not_title": "Not",
      "must_subtitle": "of these keywords",
      "must_title": "Must include all",
      "select_label": "Select Keyword Snippet",
      "select_placeholder": "Select 1 Keyword Snippet",
      "should_subtitle": "of these keywords",
      "should_title": "And any",
      "title": "Insert/Manage Keyword Snippet"
    },
    "query_snippets_table": {
      "actions_column_header": "Actions",
      "no_results": "No Results",
      "owner_label": "Owner",
      "row": {
        "actions_label": "Query snippet actions",
        "no_streams": "No streams",
        "shared_status": "Shared keyword snippet",
        "streams_count_monitoring": "{count} Mention Stream | {count} Mention Streams",
        "streams_count_social": "{count} Social Stream | {count} Social Streams"
      },
      "streams_label_monitoring": "Mention Streams",
      "streams_label_social": "Social Streams"
    },
    "removal_actions": {
      "delete_error": "There was an error deleting the keyword snippet",
      "delete_success": "Keyword Snippet successfully deleted",
      "remove_access_error": "There was an error removing this keyword snippet from your list",
      "remove_access_success": "Keyword Snippet removed from your list.",
      "transfer_ownership_error": "There was an error transferring keyword snippet ownership",
      "transfer_ownership_success": "Keyword Snippet ownership transferred."
    },
    "remove_access_dialog": {
      "message": "Removing this Keyword Snippet will remove it from your list.",
      "title": "Remove Keyword Snippet?"
    },
    "share_query_snippets_modal": {
      "about_current_user_owner": "{firstName} {lastName} (you)",
      "about_label": "About Keyword Snippet",
      "about_no_owner": "N/A",
      "about_owner_label": "Owner",
      "about_user_owner": "{firstName} {lastName}",
      "access_label": "Who has access",
      "access_users_with_edit_permission": "Users with edit permission can edit the shared Keyword Snippet.",
      "access_users_with_read_permission": "This Keyword Snippet is shared by {firstName} {lastName}. You can view or remove the Keyword Snippet.",
      "access_users_with_read_permission_no_owner": "This Keyword Snippet has been shared with you. You can view or remove the Keyword Snippet.",
      "access_users_without_edit_permission": "Users without edit permission can only view the shared Keyword Snippet.",
      "team_load_error": "Error loading team members",
      "title": "Share/Permission"
    }
  },
  "radio_clips_table": {
    "open_full_player": "Go to full player page"
  },
  "range_picker_action_sheet": {
    "back_label": "BACK",
    "done_label": "DONE"
  },
  "rate_card_overview": {
    "copyright": "Copyright {legalName}, 2014-{currentYear}",
    "no_feature_account_manager_description": "No rate card available, please contact your Account Manager.",
    "no_feature_customer_success_description": "No rate card available, please contact our Customer Success team at {email}.",
    "no_feature_dedicated_support_description": "No rate card available, please contact your Dedicated Support team.",
    "payment": "Payment",
    "payment_subtext": "The costs incurred in requesting additional Media Items or Transcripts are billed in addition to your monthly {platformName} Service Level Agreement (SLA) and are itemised and billed in a separate invoice. All Media Items remain the legal property of their respective owners and are covered by relevant content and licensing agreements. TV and Radio downloads are intended for internal use only and may not be shared publicly on social media or to parties outside of the customer. This Rate Card is valid as at {today} and may be subject to change.",
    "rate_card_subtext": "{organisationName}'s Service Level Agreement (SLA) contains a fixed allowance of included Media Items or Transcripts. You can check historic use via the {usagePage}. If you wish to request additional Media Items or Transcripts in excess of this allowance, the following rates apply:",
    "rate_card_title": "Media Item Rate Card",
    "rates_table": {
      "instant_edit_media": {
        "format": ".MP4/.AAC via email and download link",
        "item": "Instant Edit Media Item"
      },
      "instant_edit_media_transcript": {
        "format": "Word (.docx) via email and download link",
        "item": "Instant Edit Transcript"
      },
      "radio": {
        "format": ".AAC via email and download link",
        "item": "Radio Media Item Download"
      },
      "title": {
        "format": "Format + Delivery",
        "item": "Item",
        "price": "Price (excl. @:tax)"
      },
      "transcription": {
        "format": "PDF and Word (.docx) via email and download link",
        "item": "Transcription",
        "price": "{currency} / min"
      },
      "tv": {
        "format": ".MP4 via email and download link",
        "item": "TV Media Item Download"
      }
    },
    "usage_page": "Usage Page"
  },
  "react_score_expandable": {
    "controversy": {
      "sub_title": "Filter Mention Stream by controversy",
      "title": "Controversy",
      "tooltip": "Controversy: is comprised of a weighted average from our Hyperpartisanship, Satire, Controversy and Fake News models"
    },
    "emotionality": {
      "sub_title": "Filter Mention Stream by emotionality",
      "title": "Emotionality",
      "tooltip": "Emotionality: is comprised of a weighted average from our Sentiment, Emotion, Sarcasm and Subjectivity models"
    },
    "harm": {
      "sub_title": "Filter Mention Stream by harm",
      "title": "Harm",
      "tooltip": "Harm: is comprised of a weighted average from our Racism, Sexism, Hate Speech, Insult, Obscenity, Toxicity, and Threat models"
    },
    "react_categories_button": "React categories",
    "react_score_average": {
      "sub_title": "Filter Mention Stream with a react score average",
      "title": "React Score Average",
      "tooltip": "React Score is used to bring quantitative, contextual analysis to media content. The score is comprised of analysis using AI models to measure 17 different indicators of brand react."
    },
    "react_score_average_button": "React score average",
    "react_score_grouped_into_4": "React score models are grouped into 4 higher level categories for ease of analysis: controversy, emotionality, harm & spam",
    "spam": {
      "sub_title": "Filter Mention Stream by spam",
      "title": "Spam",
      "tooltip": "Spam: is comprised of a weighted average from our Clickbait and Spam models"
    }
  },
  "react_score_widget": {
    "high_risk": "High risk",
    "react_score": "React Score",
    "react_score_subtext": "Your React Score is an average score calculated from the above categories, that allows you to identify harmful media content in realtime.",
    "stats_label": {
      "controversy": "Controversy",
      "emotionality": "Emotionality",
      "harmful": "Harmful",
      "spam": "Spam"
    }
  },
  "report_filters_keywords": {
    "comma_separated": "Comma Separated",
    "exclude_keywords": "Exclude Keywords",
    "include_keywords": "Include Keywords"
  },
  "report_filters_toggle": {
    "include_external_items": "Include External Items",
    "max": "Max",
    "min": "Min",
    "only_external_items": "Only show External Items",
    "page_number": "Page Number",
    "word_count": "Word Count"
  },
  "report_limit_alert": {
    "exceeds_limit_message": "The selected coverage exceeds the PDF limit ({formattedMaximumMentionCount} items).",
    "generate_report_message": "You can still generate the report, however only the first {formattedMaximumMentionCount} items will appear. Charts are not impacted by the limit."
  },
  "report_output_selector": {
    "charts_label": "Charts only",
    "charts_mentions_label": "Charts and Mentions",
    "heading": "Output",
    "mentions_label": "Mentions only"
  },
  "report_sort_order_selector": {
    "label": "Sort by {sortPicker} in {orderPicker} order",
    "order_by": "Order By",
    "sort_by": "Sort By"
  },
  "report_summary": {
    "label": "Add a Summary"
  },
  "report_type_selector": {
    "csv_label": "CSV/Excel",
    "heading": "Format",
    "pdf_csv_label": "PDF and CSV/Excel",
    "pdf_label": "PDF"
  },
  "reports": {
    "audience_reports_tab": "Audience reports",
    "build_new_report": "Build New Report",
    "curated_email_report": "Curated Email Report",
    "curated_email_report_description": "An Email Report that includes selected media coverage.",
    "curated_email_report_tab": "Curated Email Reports",
    "instant_insights_report_tab": "Instant Insights Reports",
    "mention_stream_report": "Mention Stream Report",
    "mention_stream_report_description": "A PDF or CSV/Excel Report that includes all your media coverage and analysis.",
    "mention_stream_report_tab": "Mention Stream Reports",
    "scheduled": {
      "senders": {
        "organisation": "Organisation"
      }
    },
    "scheduled_report": "Scheduled Report",
    "scheduled_report_description": "A Scheduled Email Report that includes pre-selected media coverage.",
    "scheduled_report_tab": "Scheduled Reports",
    "tagged_mention_reports_tab": "Tagged Mention Reports",
    "tagged_mentions_report": "Tagged Mentions Report",
    "tagged_mentions_report_description": "An Email Report that includes tagged media items."
  },
  "request_mentions": {
    "error_loading_mention_ids": "Error loading Mention IDs"
  },
  "resources": {
    "media_release": {
      "status_label_scheduled_at": "Scheduled for {date}",
      "status_label_scheduled_at_draft": "Draft - Scheduled for {date}",
      "status_label_sent": "Sent at {date}",
      "statuses": {
        "draft": "Draft",
        "error": "Error",
        "scheduled": "Scheduled",
        "sending": "Sending",
        "sent": "Sent"
      }
    },
    "outreach_activity": {
      "media_release": "Media Release"
    },
    "outreach_communication": {
      "statuses": {
        "cancelled": "Cancelled",
        "complete": "Complete",
        "declined": "Declined",
        "open": "Open"
      },
      "types": {
        "call": "Call",
        "email": "Email",
        "event": "Event",
        "external_media_release": "External Media Release",
        "interview": "Interview",
        "meeting": "Meeting",
        "other": "Other"
      }
    },
    "scheduled_report_specification_schedule": {
      "day": "{period} Day | {period} Days",
      "delivery_days_every_day": "Every day",
      "delivery_days_fortnightly": "Fortnightly on {formattedDate}",
      "delivery_days_monthly": "Monthly on day {days}",
      "delivery_days_once": "Once only",
      "delivery_days_weekly": "Weekly on {days}",
      "delivery_time": "{from} to {to} {tz}",
      "hour": "{period} Hour | {period} Hours",
      "last_month": "Last month",
      "this_month": "This month",
      "weekdays": "Weekdays",
      "weekends": "Weekends"
    }
  },
  "risk_range_selector": {
    "high": "High",
    "low": "Low",
    "sub_title": "{subTitlePrefix} between {min} to {max}"
  },
  "routes": {
    "account": "Account",
    "add_social_stream": "Add a Social Stream",
    "alerts": "Alerts",
    "bookmarks_report_create": "Create Report",
    "brand_profile_create": "Create Brand Profile",
    "brand_profile_edit": "Edit Brand Profile",
    "brand_profiles": "Brand Profiles",
    "buttons": {
      "action_sheet_article": "Open Article actionsheet",
      "action_sheet_caption": "Open Caption actionsheet",
      "action_sheet_magazine_article": "Open Magazine Article actionsheet",
      "action_sheet_mention_details": "Open Mention Details actionsheet",
      "action_sheet_paper_article": "Open Paper Article actionsheet",
      "action_sheet_podcast_episode": "Open Podcast Episode actionsheet",
      "action_sheet_radio_clip": "Open Radio Clip actionsheet",
      "action_sheet_tv_logo_appearance": "Open TV Logo appearance actionsheet",
      "action_sheet_tv_super": "Open TV Super actionsheet",
      "add_mention_stream": "Add Mention Stream",
      "close_mention_stream_notification": "Close Mention Stream Notification",
      "close_social_stream": "Close Social Stream",
      "edit_bookmark_stream": "Edit Tagged Folder",
      "edit_mention_stream": "Edit Mention Stream",
      "edit_social_stream": "Edit Social Stream",
      "filter": "Open filters",
      "set_tracked_publishers": "Set Tracked Publishers"
    },
    "clients": "Clients",
    "create_media_release": "Create Media Release",
    "crm_activities": "Activities",
    "crm_closed_enquiries": "Closed Enquiries",
    "crm_open_enquiries": "Open Enquiries",
    "csl": "CSL",
    "csl_portal": "CSL portal",
    "curated_email_report": "Curated Email Report",
    "curated_email_report_audience": "Curated Email Report Audience Overview",
    "curated_email_report_audience_overview": "Audience Overview",
    "daily_highlights": "Daily Highlights",
    "distribution_lists": "Distribution Lists",
    "document_title": "{page} {'|'} {app}",
    "domains": "Email Setup",
    "edit_media_release": "Edit Media Release",
    "edit_pitch": "Edit Pitch",
    "edit_social_stream": "Edit Social Stream",
    "external_item_create": "Add External Item",
    "external_item_edit": "Edit External Item",
    "filter_sets": "Filter Sets",
    "front_pages": "Front Pages",
    "help": "Help",
    "insights_archived": "Archived",
    "insights_dashboard": "Dashboard",
    "insights_dashboard_chart": "Chart",
    "insights_dashboard_new": "New Dashboard",
    "insights_dashboards": "Dashboards",
    "insights_downloads": "Downloads",
    "insights_schedules": "Schedules",
    "insights_shared": "Shared",
    "insights_starred": "Starred",
    "instant_insights": "Instant Insights",
    "integrations": "Integrations",
    "launchpad": "Launchpad",
    "listen": "Listen",
    "login": "Login",
    "magazine_item": "Magazine Item",
    "media": "Media",
    "media_and_transcripts": "Media & Transcripts",
    "media_item": "Media Item",
    "mention_stream_create": "Add a Mention Stream",
    "mention_stream_edit": "Edit Mention Stream",
    "mention_stream_notification": "Mention Stream Notification",
    "mention_stream_report": "Mention Stream Report",
    "mention_stream_report_create": "Create Report",
    "mention_streams": "Mention Streams",
    "metric_editor": "Metric Editor",
    "notification_create": "Create New Notification",
    "notification_edit": "Edit Notification",
    "notifications": "Notifications",
    "online_item": "Online Item",
    "organisation": "Organisation",
    "outreach_activities": "Activities",
    "outreach_contacts": "Contacts",
    "outreach_create_activity": "Create Activity",
    "outreach_edit_activity": "Edit Activity",
    "outreach_launchpad": "Launchpad",
    "outreach_lists": "Lists",
    "preferences": "Preferences",
    "print_item": "Print Item",
    "profile": "Profile",
    "query_snippet_create": "Add a Keyword Snippet",
    "query_snippet_edit": "Edit a Keyword Snippet",
    "query_snippet_view": "View a Keyword Snippet",
    "query_snippets": "Keyword Snippets",
    "rate_card": "Rate Card",
    "reports": "Reports",
    "scheduled_report": "Scheduled Report",
    "security": "Security",
    "shared": "Shared",
    "shared_social_streams": "Shared Social Streams",
    "shared_streams": "Shared Streams",
    "social_account_management": "Account Management",
    "social_analyse": "Analyse",
    "social_calendar": "Calendar",
    "social_compose_post": "Compose Post",
    "social_group_edit": "Edit Social Group",
    "social_performance": "Performance",
    "social_report_create": "Create Report",
    "social_reports": "Reports",
    "social_scheduled_report": "Scheduled Report",
    "social_scheduled_report_new": "Scheduled Report",
    "social_stream_create": "Add a Social Stream",
    "social_stream_edit": "Edit Social Stream",
    "social_stream_notification": "Social Stream Notification",
    "social_streams": "Social Streams",
    "stream_group_edit": "Edit Group",
    "tagged_folder_edit": "Edit Tagged Folder",
    "tagged_folders": "Tagged Folders",
    "tagged_folders_report": "Tagged Folders Report",
    "team": "Team",
    "teams": "Teams",
    "usage": "Usage",
    "users": "Users"
  },
  "saml_integration": {
    "enable_updates_description": "Configure SAML integration to allow users to log in to this service using their existing credentials from your Identity Provider (IdP).",
    "load_integration_error": "There was an error loading the SAML integration",
    "manage_integration_button": "Manage Integration",
    "remove_integration_error": "There was an error removing the SAML integration",
    "saml": "SAML Single Sign-On",
    "saml_integration": "Integrate SAML",
    "save_integration_error": "There was an error saving the SAML integration",
    "save_integration_success": "SAML integration saved successfully"
  },
  "saml_login": {
    "button_text": "Single Sign-On",
    "description_a": "Single sign-on allows you to log in to the {platformName} Dashboard using your organisation’s identity provider.",
    "description_b": "Please reach out to your organisation administrator if you are unsure whether your organisation supports Single Sign-On.",
    "error_message": "SAML SSO authentication failed. Please try again or contact your system administrator.",
    "header": "Sign-in to continue",
    "input_placeholder": "Your corporate email"
  },
  "scheduled_report": {
    "confirm_delete_title": "Permanently delete this report?",
    "confirm_message": "You have unsaved changes",
    "confirm_title": "Are you sure?",
    "content_description": "Add Mention Streams",
    "content_label": "Content",
    "create_description": "Set Preferences",
    "create_label": "Create",
    "delete_error": "There was an error deleting this scheduled report",
    "deliver_alert": "Test email will be delivered shortly.",
    "deliver_error": "Unable to send",
    "disable_alert": "Report disabled",
    "disable_error": "Error disabling report",
    "dismiss_label": "Dismiss",
    "draft": "Draft",
    "draft_tooltip": "This report is currently in draft mode, add a schedule to finish the setup",
    "edit_title": "Edit Scheduled Report",
    "enable_alert": "Report enabled",
    "enable_error": "Error enabling report",
    "load_error": "There was an error loading this page. Please try again.",
    "new_title": "New Scheduled Report",
    "owned_by": "Owned by {userName}",
    "pause_label": "Pause",
    "pause_tooltip": "Your report is currently active, you may click here to pause it",
    "resume_label": "Resume",
    "resume_tooltip": "Your report is currently paused, you may click here to resume it",
    "save_close_button": "Save and Close",
    "save_fail_message": "There was an error saving this report.",
    "save_success_message": "Report saved successfully",
    "schedule_and_save": "Schedule and Save",
    "schedule_label": "Schedule",
    "share_denied_tooltip": "You don't have permission to share this report.",
    "share_save_error": "There was a problem saving the Scheduled Report Specification",
    "share_tooltip": "Share report"
  },
  "scheduled_report_builder": {
    "add_folder_label": "Add a new Folder",
    "advanced_options_heading": "Advanced Options",
    "drag_tooltip": "Drag to move",
    "excluded_source_filters_error": "There was an error fetching the Excluded Sources Filters.",
    "media_type_subtext": "Select the order in which content should be ordered within Folders.",
    "move_to_bottom": "Move to Bottom",
    "move_to_top": "Move to Top",
    "remove_dialog_title": "Are you sure?",
    "sorting_heading": "Sorting",
    "sorting_subtext": "Select a preferred sorting option.",
    "source_filters_error": "There was an error fetching the Sources Filters.",
    "toggle_media_type_label": "Arrange content by Media Type"
  },
  "scheduled_report_builder_section": {
    "average_daily_mentions": "Average Daily Mentions",
    "contact_owner_tooltip": "Please contact the owner to make changes",
    "filter_media_types": "Filter Media Types",
    "filter_media_types_tooltip": "Click to toggle preferred Media Types on/off",
    "filter_social_platforms": "Filter Social Platforms",
    "filter_social_platforms_tooltip": "Social platforms configured for this stream",
    "folder_position": "Folder Name {position}",
    "folder_subtext": "The Folder name will appear at the top of each section of the report",
    "mention_stream": "Mention Stream",
    "mention_streams_subtext": "Select Mention Streams to appear within this Folder",
    "missing_media_types_error": "Missing media types",
    "missing_rules_error": "Missing rules",
    "social_stream": "Social Stream",
    "social_stream_subtext": "Select a Social Stream to appear within this folder",
    "social_stream_validation_message": "Please select a Social Stream",
    "stream_validation_message": "Please select a mention stream",
    "top_100_mentions_note": "Only the top 100 mentions will be included in the report for each folder"
  },
  "scheduled_report_builder_section_rule": {
    "error": "Please select a media type",
    "social_error": "Please select a social platform"
  },
  "scheduled_report_schedule": {
    "days_heading": "Set the days of the week",
    "delivered_on": "The next report will be delivered on {nextReportDate}",
    "delivery_heading": "Delivery Date and Time",
    "send_test_button": "Send Test",
    "set_day_heading": "Set the day",
    "time_day_heading": "Time and Day"
  },
  "scheduled_report_scheduler": {
    "are_you_sure": "Are you sure?",
    "fortnightly_label": "Fortnightly",
    "frequency_heading": "Set Delivery Frequency",
    "monthly_label": "Monthly",
    "new_schedule_button": "Add a new Schedule",
    "once_label": "Once",
    "weekly_label": "Weekly"
  },
  "scheduled_report_settings": {
    "advanced_options_heading": "Advanced Options",
    "brand_profile_heading": "Brand Profile",
    "custom": "Custom",
    "email_domain_heading": "Domain",
    "font_size_heading": "Font Size",
    "footer_heading": "Footer",
    "footer_placeholder": "Enter footer text",
    "footer_subtext": "Custom Footer text will appear at the bottom of every report beneath the coverage.",
    "header_heading": "Header",
    "header_placeholder": "Enter header text",
    "header_subtext": "Custom Header text will appear at the top of every report above the coverage.",
    "include_date": "Include Date",
    "include_mention_count": "Include Mention Count",
    "language_dropdown_subtext": "This will populate your Scheduled Report in the chosen language.",
    "layout_heading": "Layout",
    "load_brand_profiles_error": "There was a problem loading Brand Profiles.",
    "organisation_domain": "Organisation Domain",
    "recipients_heading": "Recipients",
    "recipients_subtext": "Add recipients from an existing distribution list or manually add emails.",
    "select_domain": "Select a domain",
    "select_sender_email": "Select a sender email",
    "send_as_heading": "Send As",
    "send_as_subtext": "The 'Send As' field will display as the 'From' name for report recipients.",
    "sender_email": "Sender Email",
    "title_subject_heading": "Title and Subject Line",
    "title_subject_subtext": "The title will display in the subject line of the email and at the top of the report.",
    "toggle_ai_summary_label": "Include AI Report Summary",
    "toggle_ai_summary_subtext": "{aiAssistant} will generate a summary based on content from your selected Mention Streams. Due to the additional processing time, this may slightly extend your report's scheduled delivery time.",
    "toggle_condense_mentions_label": "Condense multiple Mentions",
    "toggle_condense_mentions_subtext": "If a Mention matches multiple Folders in this report, only include it once in the first Folder.",
    "toggle_condense_tv_radio_mentions_label": "Condense multiple Mentions (TV and Radio)",
    "toggle_condense_tv_radio_mentions_subtext": "Only include the first time your keywords are mentioned in a TV/Radio program.",
    "toggle_highlights_labels": "Include Daily Highlights",
    "toggle_keyword_count_label": "Display Keyword Count",
    "toggle_keyword_count_subtext": "The Mention card will display the number of times each keyword was mentioned in the coverage.",
    "toggle_keyword_excerpts_label": "Display highlighted Keyword Excerpts",
    "toggle_keyword_excerpts_subtext": "Include highlighted text excerpts of each keyword match for additional context.",
    "toggle_large_label": "Large",
    "toggle_media_transcripts_label": "Include Media Items and Transcripts",
    "toggle_media_transcripts_subtext": "Include any Media Items and Transcripts that match the report parameters.",
    "toggle_no_content_label": "Hide Folders with no content",
    "toggle_no_content_subtext": "Only display Folders that contain content.",
    "toggle_pdf_report_label": "Include PDF report",
    "toggle_pdf_report_subtext": "A PDF version of your report will be available via hyperlink.",
    "toggle_potential_audience_reach_label": "Display Potential Audience Reach",
    "toggle_potential_audience_reach_subtext": "Include Potential Audience of each mention",
    "toggle_prefer_online_label": "Preference Online Mentions",
    "toggle_prefer_online_subtext": "Displays Online Mentions instead of Print Mentions when the Print Mention has a related Online Mention with matching keywords.",
    "toggle_print_clips_pdf_report_label": "Include Print PDF Clippings",
    "toggle_print_clips_pdf_report_subtext": "Include Print Items on the PDF version of your report.",
    "toggle_regular_label": "Regular",
    "toggle_restricted_content_label": "Show Restricted Content",
    "toggle_restricted_content_subtext": "Includes links & any article body text to UK (NLA & CLA) copyrightable material.",
    "toggle_send_email_label": "Send email even when there is no Mention",
    "toggle_send_email_subtext": "Receive an empty report if there is no coverage that matches the report parameters.",
    "toggle_small_label": "Small",
    "user": "User"
  },
  "scheduled_report_settings_layout_option": {
    "condensed": "Condensed",
    "header": "Header",
    "regular": "Regular"
  },
  "scheduled_reports": {
    "daily_highlights_description": "Include Front Page and Back Page summaries of leading Print newspapers, summarised by {platformName}'s curation team."
  },
  "scheduled_reports_table": {
    "action": "Actions",
    "delivery_day": "Delivery Days",
    "delivery_time": "Delivery Time",
    "draft": "Draft",
    "duplicate_report": "Duplicate report",
    "duplicate_report_description": "Rename the new report",
    "duplicate_report_error": "There was a problem duplicating the Scheduled Report Specification",
    "duplicate_report_title": "Duplicate Scheduled Report",
    "edit_report": "Edit report",
    "filter_by_owner": "Filter by owner",
    "filter_by_stream": "Filter by stream",
    "filter_by_subject": "Filter by subject",
    "last_delivered": "Last delivered: {reportLastDelivered} - click to view",
    "loading_error": "There was an error loading scheduled reports. Please try again.",
    "manage_recipients": "Click to manage recipients",
    "mention_stream": "Mention Stream",
    "owner": "Owner",
    "plus_more": "+ {count} more",
    "recipient_label": "{distributionListName} (Distribution List) - [{recipientsLength} recipients]",
    "share_report": "Share report",
    "show_inactive_report": "Show inactive reports",
    "social_streams": "Social Streams",
    "specification_error": "There was a problem saving the Scheduled Report Specification",
    "subject": "Subject",
    "timeframe": "Timeframe",
    "update_recipient_error": "There was an error updating recipients"
  },
  "search_placeholder": "Search Coverage",
  "search_placeholder_old": "Search Coverage or Journalists",
  "security_form": {
    "confirm_new_pin": "Confirm new PIN",
    "current_pin": "Current PIN",
    "error_update_alert": "Error updating PIN",
    "invalid_current_message": "Current PIN Invalid",
    "new_pin": "New PIN",
    "no_match_message": "Passwords do not match",
    "save_form": "Save form",
    "section_title": "Reset PIN",
    "size_message": "The new PIN must be 4 characters long",
    "update_alert": "PIN Updated"
  },
  "select_stock_symbol": {
    "asx_label": "Australian Stock Exchange (ASX)",
    "lse_label": "London Stock Exchange (LSE)",
    "nasdaq_label": "NASDAQ Stock Exchange (NASDAQ)",
    "nyse_label": "New York Stock Exchange (NYSE)",
    "nzx_label": "New Zealand Stock Exchange (NZX)",
    "par_label": "Pan-European Stock Exchange (PAR)",
    "search_add_button": "Search for or Add Stock",
    "search_empty": "Stock not found for symbol: \"{query}\"",
    "search_error": "Error finding stock",
    "search_loading": "Loading...",
    "select_stock_exchange_label": "Select Stock Exchange",
    "stock_symbol_label": "Enter Stock Symbol",
    "stock_symbol_placeholder": "Example @:stock_symbol_placeholder"
  },
  "select_user_dropdown": {
    "filter_by_user": "Filter by user",
    "load_users_error": "There was an error loading users"
  },
  "sentiment": {
    "balanced": "Balanced",
    "balanced_abbreviation": "Balanced",
    "negative": "Negative",
    "negative_abbreviation": "Negative",
    "none": "No Rating",
    "none_abbreviation": "No Rating",
    "positive": "Positive",
    "positive_abbreviation": "Positive",
    "trending_negative": "Trending Negative",
    "trending_negative_abbreviation": "T. Negative",
    "trending_positive": "Trending Positive",
    "trending_positive_abbreviation": "T. Positive"
  },
  "sentiment_expandable": {
    "sentiment": "Sentiment"
  },
  "sentiment_picker": {
    "item_automatically_rated_as": "This item has been automatically rated as {label}",
    "last_rated_by": "Last rated by {userName}, {latestRating}",
    "select_sentiment_rating": "Select sentiment rating",
    "toggle_sentiment": "Toggle sentiment"
  },
  "sentiment_widget": {
    "automated": "(Automated)",
    "heading": "Sentiment",
    "sentiment_rating": "Sentiment Rating"
  },
  "services": {
    "features": {
      "feature_unavailable_description": "This feature is not available for your organisation. Please get in touch with your Account Manager to upgrade your subscription.",
      "feature_unavailable_title": "{featureName} Unavailable",
      "minute": "minute | minutes"
    }
  },
  "share_with_users_selector": {
    "access_levels": {
      "collaborator": "can edit",
      "edit": "Edit",
      "mixed": "mixed access",
      "read_only": "read-only",
      "read_write": "can edit",
      "view": "Shared"
    },
    "edit": "Edit",
    "no_team_users": "No users found in the {teamName} team",
    "no_users": "No users found",
    "select_access_level": "Select access level",
    "view_only": "View only"
  },
  "shared_status_button": {
    "off": "Off",
    "on": "On",
    "sharing": "Sharing: {status}",
    "turning_off": "Turning off sharing..."
  },
  "shared_with_users_selector": {
    "access_levels": {
      "edit": "Edit",
      "read_only": "View",
      "read_write": "Edit",
      "view": "Shared"
    }
  },
  "sign_in_with_google_button": {
    "sign_in_with_google": "Sign in with Google"
  },
  "sign_in_with_microsoft_button": {
    "sign_in_with_microsoft": "Sign in with Microsoft"
  },
  "sign_in_with_saml_button": {
    "sign_in_with_saml": "Sign in with SAML"
  },
  "similar_mentions": {
    "chart_title": "Number of Similar Mentions Over the Last Six Days",
    "load_similar_mentions_error": "There was an error loading Similar Mentions.",
    "mentions_from": "Mentions from {range}",
    "no_similar_mentions_found": "No similar mentions found",
    "word_count": "{wordCount} words"
  },
  "simple_time_picker": {
    "default_placeholder": "Select time",
    "every_15_minutes_label": "Every 15 minutes",
    "every_2_hours_label": "Every 2 hours",
    "every_30_minutes_label": "Every 30 minutes",
    "every_hour_label": "Every hour",
    "finish_sending_heading": "Finish sending at",
    "recurring_schedules_label": "Set up recurring Schedules",
    "report_wont_recur": "The report will currently not recur",
    "send_at_label": "Send at",
    "send_every_heading": "Send Every",
    "start_sending_label": "Start sending at"
  },
  "skilljar": {
    "error_message": "Unable to redirect to the learning platform. Please try again."
  },
  "slack_integration": {
    "enable_updates_description": "Edit your Mention Streams to enable updates to your Slack Channels",
    "remove_integration_alert": "Remove Slack Integration?",
    "remove_integration_button": "Remove Integration",
    "set_up_analytics_alert": "{clickHere} to learn how to set up a Slack integration for {platformName}.",
    "slack": "Slack",
    "slack_integration_suggestion": "Integrate {platformName} into your Slack so that your team never misses a notification"
  },
  "social": {
    "engage_post_types": {
      "carousel": "Carousel Post",
      "image": "Image",
      "job": "Job Post",
      "link_preview": "Link Preview",
      "multiple_attachments": "Multiple Attachments",
      "quote_tweet": "Quote Tweet",
      "reel": "Reel",
      "reply_tweet": "Reply Tweet",
      "shared": "Shared Post",
      "streem": "Streem Social Post",
      "text": "Text",
      "video": "Video"
    }
  },
  "social_alt_text_input": {
    "alt_text_placeholder": "Enter alt-text for your image here",
    "alt_text_too_long": "This alt-text is too long for: {platform}. Please edit to continue.",
    "character_count": "Characters: {count}/{limit}",
    "limit_tooltip": "{platform} has a {limit} character limit for alt-text.",
    "no_limit": "No character limit"
  },
  "social_alt_text_modal": {
    "alt_text_for_image": "Alternate text for image",
    "alt_text_for_platform": "Alt Text for {platform}",
    "apply_to_all_platforms": "Apply to all social media platforms",
    "title": "Add Alt Text",
    "unsaved_changes_message": "You have unsaved changes. Are you sure you want to close without saving?",
    "unsaved_changes_title": "Unsaved Changes"
  },
  "social_amplify_icon": {
    "not_enough_social_data": " - not enough social data available",
    "not_enough_social_data_recent_article": " - recently published article, not enough social data available",
    "social_amplify": "Social Amplify"
  },
  "social_amplify_popup": {
    "amplification_by_platform_subtext": "Shows the amplification of the item by social platform.",
    "amplification_by_platform_title": "Amplification by Platform",
    "realtime_social_amplification_subtext": "Shows the realtime social amplification of the items as it’s shared and engaged.",
    "social_amplify": "Social Amplify",
    "social_amplify_tooltip": "Social Amplify displays the total number of social interactions, when they occurred, and on which social network they happened. This allows you to track the lifespan of an Online story across various social media platforms.",
    "total_interactions": "Total Interactions: {total}",
    "trend_with_date": "Trend ({dateRangeLabel})"
  },
  "social_analyse_add_chart_dropdown": {
    "select_chart": "Select Chart",
    "select_chart_description": "Select the chart you wish to add to your dashboard"
  },
  "social_analyse_chart_form": {
    "select_at_least_one_stream": "Select at least one Social Stream",
    "select_comparison_streams": "Select at least ({count}) Social Streams to compare.",
    "select_social_platforms": "Select Social Platforms",
    "select_social_platforms_description": "Select the Social Platforms you wish to include in your chart",
    "select_social_streams": "Select Social Streams",
    "select_social_streams_description": "Select the Social Streams you wish to include in your chart"
  },
  "social_analyse_chart_sidebar": {
    "add": "Add a Social Analyse Chart",
    "edit": "Edit Social Analyse Chart"
  },
  "social_analyse_charts": {
    "blogs": "Blogs",
    "comparison_social_and_earned_mentions": "Comparison of social and earned mentions over time. Social volumes are impacted by dashboard filters.",
    "competitor_benchmark": "Share Of Voice Timeline",
    "coverage_volume": "Mentions Timeline",
    "coverage_volume_and_analytics_timeline": "Mentions & Website Traffic Timeline",
    "coverage_volume_breakdown": "Mentions By Platform",
    "emoji_count": "Emoji Count",
    "emoji_mentions": "{emoji} Mentions",
    "emojis_based_on_frequency": "Display up to 7 emojis that appeared the most across all mentions for a selected Social Stream.",
    "facebook_users_with_the_most_likes": "Facebook Pages with the most page likes that appeared in a selected Social Stream.",
    "forums": "Forums",
    "hashtags_based_on_frequency": "Display up to 30 hashtags based on their frequency across all X {'|'} Twitter, Facebook, Instagram and Youtube mentions for a selected Social Stream.",
    "instagram_users_with_highest_followings": "Instagram users with the highest followings that appeared in a selected Social Stream.",
    "key_bluesky_influencers": "Bluesky Influencers",
    "key_instagram_influencers": "Instagram Influencers",
    "key_twitter_influencers": "X {'|'} Twitter Influencers",
    "key_youtube_influencers": "YouTube Influencers",
    "keywords_based_on_frequency": "Display up to 30 keywords based on their frequency across all mentions for a selected Social Stream.",
    "leading_hashtags": "Leading Hashtags",
    "mentions_by": "Mentions by {username}",
    "mentions_by_platform": "Hourly or Daily mentions, broken down by social platform.",
    "mentions_by_platform_with_metrics": "Hourly or Daily mentions, broken down by social platform and the Users metric from Google Analytics.",
    "mentions_by_sentiment": "Fluctuations in negative, trending negative, balanced, trending positive and positive coverage over time.",
    "sentiment_breakdown": "Sentiment Breakdown",
    "sentiment_timeline": "Sentiment Timeline",
    "set_up_google_analytics": "Set up a Google Analytics Integration →",
    "share_of_voice": "Share Of Voice",
    "social_items": "{valueWithSuffix} Social Item | {valueWithSuffix} Social Items",
    "social_mentions_by_platform": "Total social mentions for a time period, broken down by social platform.",
    "social_mentions_by_sentiment": "Total social mentions for a time period, broken down by 5 sentiment ratings.",
    "social_subtitle_posts": "{socialSubtitle} posts",
    "stream_vs_stream": "Social vs Earned Media",
    "top_bluesky_posts": "Top Bluesky Posts",
    "top_facebook_pages": "Top Facebook Pages",
    "top_facebook_posts": "Top Facebook Posts",
    "top_instagram_posts": "Top Instagram Posts",
    "top_linkedin_posts": "Top LinkedIn Posts",
    "top_tiktok_videos": "Top TikTok Videos",
    "top_tweets": "Top Tweets",
    "top_youtube_videos": "Top YouTube Videos",
    "twitter_users_with_highest_followings": "X {'|'} Twitter users with the highest followings that appeared in a selected Social Stream.",
    "user_rated_sentiment": "Sentiment",
    "word_cloud": "Themes"
  },
  "social_analyse_top_platform_posts_tooltip": {
    "current_followers_count": "Number of current followers",
    "platform_description_mapping": {
      "attachedMedia": "Attached Media",
      "facebook": {
        "comments": "Comments",
        "description": "Posts that had the highest total engagement",
        "likes": "Reactions",
        "shares": "Shares"
      },
      "twitter": {
        "comments": "Replies",
        "description": "Tweets that had the highest total engagement",
        "likes": "Likes",
        "shares": "Retweets & Shares"
      }
    }
  },
  "social_engage_account_card": {
    "last_updated": "Last Updated: {timeAgo}",
    "refreshed_at": "Expires at: {timeAgo}"
  },
  "social_engage_account_limit_alert": {
    "connection_remaining": "{count} account connection remaining. | {count} account connections remaining.",
    "exhausted": "All connections exhausted. Please contact your {contact} to allocate more account integrations.",
    "exhausted_contact": "Account Manager",
    "organisation_has_reached_allocation": "Your organisation has reached its allocation of connected accounts. Contact {contact}{lineBreak} to upgrade your plan."
  },
  "social_engage_account_teams": {
    "all_teams": "All Teams",
    "error_updating_integration": "There was an error updating integration",
    "select_teams": "Select Teams",
    "teams_count": "{count} team | {count} teams",
    "visible_to_all_teams": "Visible to all teams"
  },
  "social_engage_accounts_dropdown": {
    "account_selected_count": "{count} Account selected | {count} Accounts selected",
    "no_accounts_connected": "No Accounts Connected",
    "select_accounts": "Select Accounts",
    "select_at_least_one_account": "Please select at least one account."
  },
  "social_engage_accounts_selector": {
    "add_account": "Add account",
    "all_accounts": "All Accounts",
    "all_platform_label": "All {platformLabel}"
  },
  "social_engage_compose": {
    "approve_post": {
      "confirm_label": "Review Post",
      "message": "{requesterName} has requested approval to publish this post.",
      "title": "Your approval has been requested"
    },
    "confirm_delete": {
      "confirm_label": "Delete with approval",
      "message": "Deleting will remove all published posts from their platform's except for instagram profiles",
      "title": "Are you sure you want to delete this post?"
    },
    "confirm_unpublish": {
      "confirm_label": "Remove with approval",
      "message": "This will remove the post from the following profiles:",
      "title": "Are you sure you want to remove this post?"
    },
    "delete_request": {
      "message": "{requesterName} has requested to delete the post. This will remove it from all platforms and from {platformName}.",
      "title": "A request to delete a live post has been made"
    },
    "dont_save": "Don't save",
    "error_scheduling_post": "Error scheduling post",
    "loading_post_error": "Error loading post",
    "make_changes": "Make Changes",
    "post_saved": "Post saved",
    "post_scheduled": "Post scheduled",
    "post_section_label": {
      "compose_post": "Compose post:",
      "new_post": "New post:",
      "pending_post": "Pending post:",
      "published_post": "Published post:",
      "scheduled_post": "Scheduled post:"
    },
    "post_updated": "Post updated",
    "posting_disabled": "Posting is disabled when accessing Engage via Admin.",
    "preview": "Preview:",
    "reject_button": "Reject",
    "rejection_error": "There was an error rejecting the post",
    "return_to_draft": {
      "confirm_label": "Return to draft",
      "message": "Returning the post to draft will cancel any pending posts and it will need to be rescheduled before it can be sent.",
      "title": "Are you sure you want to return to draft?"
    },
    "save_as_draft": "Save as Draft",
    "save_button_label": {
      "default": {
        "immediate_and_is_approver": "Post now",
        "immediate_and_is_not_approver": "Post now with approval",
        "not_immediate_and_is_approver": "Schedule post",
        "not_immediate_and_is_not_approver": "Schedule post with approval"
      },
      "error": {
        "remove_failed_posts": "Remove failed posts",
        "retry_failed_posts": "Retry failed posts"
      },
      "live": {
        "not_unlocked": "Post published",
        "unlocked_and_is_approver": "Update",
        "unlocked_and_is_not_approver": "Update with approval"
      },
      "pending_approval": {
        "immediate_and_is_approver": "Approve and post now",
        "is_not_approver": "Pending approval",
        "not_immediate_and_is_approver": "Approve and schedule post"
      },
      "queued": "Scheduled post"
    },
    "save_draft_before_leaving": "Would you like to save a draft before leaving?",
    "saving_post_error": "Error saving post",
    "success_delete_alert": "Delete request submitted successfully",
    "success_delete_error": "An error occurred submitting the request to delete",
    "unable_to_load_credits": "Unable to load credits",
    "unpublish_or_delete": "Unpublish or Delete",
    "unpublish_request": {
      "message": "{requesterName} has requested approval for removal of the post from the following profiles:",
      "title": "A request for a change on a live post has been made"
    },
    "unpublish_success_alert": "Unpublish request submitted successfully",
    "unpublish_success_error": "An error occurred submitting the request to unpublish",
    "update_your_integrations": "Update your integrations",
    "validation_error": "Validation Error",
    "warn_account": {
      "message": "You must select at least one account to publish a post.",
      "title": "Account required."
    },
    "warn_attachment": {
      "message_part_1": "Posting to Instagram requires an attached image.",
      "message_part_2": "Please upload an attachment or save as a draft.",
      "title": "Attachment required."
    },
    "warn_content_length": {
      "message_part_1": "Your message is too long to publish to {platform}.",
      "message_part_2": "Please select the relevant preview and 'Edit now' to shorten.",
      "title": "Message is too long."
    },
    "warn_expired": {
      "expired_integrations": "We cannot determine whether your integration will be active on the scheduled date as it is beyond the validity of your current token. Make sure to refresh your integration regularly in order to avoid any failures.",
      "new_post": "You have expired integrations in this post. {update} your integration access to continue posting.",
      "new_post_contact_supervisor": "You have expired integrations in this post. Please contact your supervisor (any super user) to update those integrations.",
      "update_link": "Update"
    },
    "warning_text": {
      "default": "Compose post",
      "error": {
        "is_live_posts": "This post failed to be published on some platforms",
        "is_not_live_posts": "This post failed to publish"
      },
      "live": "This post is currently live. Unpublish any account by removing the account profile or you can delete the post entirely.",
      "pending_approval": "This post is currently pending approval.",
      "queued": "This post is currently being posted and cannot be edited. Check back in a few minutes.",
      "rejected": "This post has been rejected.",
      "scheduled": "This post is currently scheduled to publish."
    }
  },
  "social_engage_compose_activity": {
    "activity": "Activity",
    "label": "{eventType} by {username}",
    "tooltip": {
      "post_failed": "Post failed to publish to {socialPlatform} account {account}",
      "post_published": "Post published to {socialPlatform} account {account}",
      "post_removed": "Post removed from {socialPlatform} account {account}"
    }
  },
  "social_engage_compose_file_upload": {
    "alternative_text": "Alternative text",
    "attachment": "Attachment",
    "edit_alternative_text": "Edit alternative text",
    "hidden_warnings": "+ {numberOfHiddenWarning} more warnings",
    "insert_external_item": "Insert External Item",
    "remove_attachment": "Remove attachment",
    "upload": "Upload"
  },
  "social_engage_compose_form": {
    "access_has_expired": "This integration's access has expired. Please refresh access via settings to resolve before publishing this post.",
    "add_account": "Add Account",
    "advise_expired_integrations": "You can either safely remove the failed platforms from this post by clicking the remove button or you can update the expired integrations {here}.",
    "advise_expired_integrations_update_link": "here",
    "attach_media": "Attach Media",
    "deleted_from_instagram": "Instagram profiles will need to be deleted directly from Instagram.",
    "error_publishing_post": "Error publishing post: {error}",
    "live_on": "Live on {date}",
    "message": "Message",
    "optimal_times_error": "There was an error loading optimal times.",
    "post_title": "Post Title",
    "posts_can_be_deleted": "Posts can be deleted by clicking removing the account profiles below.",
    "publish_pending": "Publish Pending...",
    "safely_remove_failed_platforms": "You can safely remove failed platforms from this post by clicking the remove button.",
    "select_and_search": "Select and search to add",
    "tags_to_filter": "Tags can be used to filter posts in Calendar and Performance",
    "titles_only_used_as_identification": "Titles are only used as identification. They will not show up in a published post.",
    "write_message_here": "Write a message here"
  },
  "social_engage_compose_image_grid": {
    "attachment": "Attachment"
  },
  "social_engage_compose_panel_edit_content": {
    "different_message": "Want a different message for {socialLabel}?",
    "edit_now": "Edit now",
    "loading_facebook_pages_error": "There was an error loading the Facebook pages",
    "loading_linkedin_handles_error": "There was an error loading the Linkedin company handles",
    "message_too_long": "The message is too long for {socialLabel}.",
    "original_message_too_long": "The original message is too long for {socialLabel}.",
    "update_custom_message": "Want to update your custom message for {socialLabel}?",
    "use_name_when_tagging": "When tagging, use the name as it appears in the {socialLabel} page URL, seen in bold below: {lineBreak}linkedin.com/company/{name}"
  },
  "social_engage_compose_preview_panel": {
    "icon": "Icon",
    "message_too_long": "Message is too long to be posted on {platformLabel}",
    "post_may_appear_different": "Social networks regularly make updates to formatting, so your post may appear slightly different when published."
  },
  "social_engage_compose_profiles_autocomplete_list": {
    "platform_page": "· {platform} page"
  },
  "social_engage_compose_store": {
    "most_restrictive_platform": "Most restrictive platform: {platforms_sentence}",
    "unknown_platform": "Unknown platform"
  },
  "social_engage_compose_tags": {
    "loading_tags_error": "There was an error loading tags",
    "start_typing_to_select": "Start typing to select",
    "tags": "Tags"
  },
  "social_engage_compose_timing": {
    "individual_post_time_per_account": "Individual post time per account",
    "individual_posts_with_unique_times": "Individual posts will be created for accounts with unique post times.",
    "post_now": "Post now",
    "schedule_post": "Schedule post",
    "timing": "Timing"
  },
  "social_engage_compose_upload_options": {
    "add_options": "+ Add {option}"
  },
  "social_engage_facebook_post_preview": {
    "1_hour": "1h ·",
    "comments_count": "{count} comments",
    "likes": "Likes",
    "shares_count": "{count} shares"
  },
  "social_engage_instagram_preview": {
    "liked_by": "Liked by {streemau} and {others}",
    "others_count": "{count} others",
    "view_all_comments": "View all {count} comments"
  },
  "social_engage_linkedin_preview": {
    "1_day": "1d •",
    "comment": "Comment",
    "followers_count": "2,369 followers",
    "like": "Like",
    "like_and_comment_counts": "{likeCount} • {commentCount} comments"
  },
  "social_engage_optimal_times": {
    "date_label": "{weekday} {date} at {time}",
    "not_enough_historical_posts": "Not enough historical posts{lineBreak}to make a recommendation.",
    "optimal_times": "Optimal times",
    "optimal_times_tooltip": "Calculated using performance data from the past 30 days, for the selected account(s)."
  },
  "social_engage_post_performance_empty_state": {
    "adjusting_your_search": "Try adjusting your search or filter {lineBreak} to find what you’re looking for.",
    "compose_post": "Compose post",
    "no_posts_found": "No posts found",
    "no_published_posts": "You currently have no published posts"
  },
  "social_engage_post_performance_filters": {
    "clicks": "Total Clicks",
    "comments": "Comments",
    "download_report": "Download Report",
    "engagement_rate": "Engagement Rate",
    "expired_integrations": "Integrations of {account_list} accounts have expired. Contact your supervisor to update those integrations.",
    "expired_integrations_list_expired_accounts": "these",
    "expired_integrations_super_user": "Integrations of {account_list} accounts have expired. {update} to refresh your integrations to avoid missing any content.",
    "expired_integrations_super_user_update": "Click here",
    "impressions": "Impressions",
    "likes": "Reactions",
    "no_tags_selected": "No tags selected",
    "numbers_of_tags_selected": "{count} tag selected | {count} tags selected",
    "performance": "Total Engagement",
    "platform_posted_user": "Platform Posted",
    "reach": "Reach",
    "report_too_large": "File size too large.",
    "report_type": "Report Type",
    "scheduled_at": "Publish Date",
    "shares": "Shares",
    "title_search": "Title Search",
    "try_reducing_reporting_period": "Try reducing your reporting period or selecting fewer accounts.",
    "upgrade_to_paid_plan": "Upgrade to a paid plan to download PDF reports."
  },
  "social_engage_post_performance_media": {
    "no_media": "No media"
  },
  "social_engage_post_performance_page": {
    "engage": "Engage",
    "error_creating_report": "There was an error creating the report",
    "error_loading_posts": "There was an error loading posts",
    "generating_pdf_report_cancel_label": "Ok",
    "generating_pdf_report_confirm_label": "View Reports",
    "generating_pdf_report_message": "Your report is now building. It will appear in Reports when it's ready.",
    "generating_pdf_report_title": "Generating Engage Performance PDF Report",
    "post_performance": "Post Performance",
    "publish_date": "Publish Date",
    "summary": "Summary"
  },
  "social_engage_post_performance_post": {
    "comments": "Comments",
    "engagement_rate": "Engagement Rate",
    "impressions": "Impressions",
    "reach": "Reach",
    "reactions": "Reactions",
    "shares": "Shares",
    "total_clicks": "Total Clicks",
    "total_engagement": "Total Engagement"
  },
  "social_engage_post_performance_report_splash": {
    "engage": "Engage",
    "example_report": "Example Report",
    "platforms": "LinkedIn, X {'|'} Twitter, Facebook and Instagram",
    "post_or_account": "post, account, or platform level",
    "social_engage_splash": "Social Engage Splash",
    "social_platforms": "Generate reports for owned media across {platforms}. Understand the reach and engagement of your content at a {postOrAccount}.",
    "upgrade_now": "Upgrade Now"
  },
  "social_engage_post_performance_reports": {
    "actions": "Actions",
    "delete_report": "Delete report",
    "engage_performance_pdf_report": "Engage Performance PDF Report",
    "error_creating_report": "There was an error creating your report. Please contact your account manager for assistance.",
    "error_loading_reports": "There was an error loading reports",
    "from": "From",
    "permanently_delete_report": "Permanently delete this report?",
    "processing": "Processing",
    "regenerate_report": "Regenerate report",
    "report_type": "Report Type",
    "requested": "Requested",
    "social_platforms": "Social Platforms",
    "status": "Status",
    "to": "To",
    "view_online": "View Online"
  },
  "social_engage_post_performance_summary": {
    "engagement_rate": "Engagement Rate",
    "error_loading_engagement_data": "Error loading Engagement data",
    "previous_period": "Previous period:",
    "total_engagement": "Total Engagement",
    "total_impressions": "Total Impressions",
    "total_posts": "Total Posts"
  },
  "social_engage_post_performance_table_total_row": {
    "no_instagram_data": "We can't serve Instagram data at the moment."
  },
  "social_engage_post_tags": {
    "no_tags": "No tags",
    "number_of_tags": "{numberOfTags} tags",
    "start_typing": "Start typing to create a tag",
    "update_tag_error": "There was an error updating tag"
  },
  "social_engage_scheduler": {
    "compose_post": "Compose post",
    "confirm_delete": {
      "message": "Deleting will remove all published posts from their platform's except for instagram profiles",
      "title": "Are you sure you want to delete this post?"
    },
    "confirm_native_post_deletion": {
      "message": "This will remove the post from the following profiles:",
      "title": "Are you sure you want to remove this post?"
    },
    "delete_post": {
      "alert": "Post deleted successfully",
      "error": "An error occurred submitting the request to delete"
    },
    "drafts": "Drafts",
    "error_loading_posts": "There was an error loading posts",
    "failed": "Failed",
    "lastest": "Lastest",
    "month": "Month",
    "most_recent": "Most Recent",
    "next_active_view": "Next {activeView}",
    "previous_active_view": "Previous {activeView}",
    "scheduled": "Scheduled",
    "sent": "Sent",
    "today": "TODAY",
    "waiting_approval": "Waiting Approval",
    "week": "Week"
  },
  "social_engage_scheduler_cell_over": {
    "post": "+ Post",
    "schedule_post": "+ Schedule post"
  },
  "social_engage_scheduler_filter": {
    "accounts": "Accounts",
    "filters": "Filters",
    "post_status": "Post Status"
  },
  "social_engage_scheduler_month": {
    "hidden_posts_count": "+ {numberOfHiddenPosts} more"
  },
  "social_engage_scheduler_no_posts": {
    "compose_post": "Compose post",
    "no_posts": "You currently don’t have any posts"
  },
  "social_engage_scheduler_post_header": {
    "post_cant_be_deleted": "{postStatus} posts can't be deleted. Please edit the post for more options.",
    "statuses": {
      "draft": "In draft",
      "error": "Error",
      "no_approval": "No approval",
      "partially_sent": "Partially Sent",
      "pending": "Approval pending",
      "queued": "Processing",
      "scheduled": "Ready",
      "sent": "Sent",
      "unsent": "Unsent"
    }
  },
  "social_engage_scheduler_preview": {
    "account": "Account"
  },
  "social_engage_select_platform": {
    "authorisation_steps_subtext": "In order to link your social accounts with {platformName} so we can manage posts on your behalf, please connect below and follow the log in and authorisation steps.",
    "connect_profile": "Connect a profile",
    "facebook_description": "Facebook pages",
    "instagram_description": "Instagram business accounts",
    "linkedin_description": "LinkedIn company pages",
    "manage_account_profiles": "Manage account profiles",
    "step_2_connect": "Step 2. Select the type of Social Platform you want to connect",
    "step_2_manage": "Step 2. Select the type of Social Platform you want to manage",
    "tiktok_description": "TikTok personal or business accounts",
    "twitter_description": "X {'|'} Twitter profiles"
  },
  "social_engage_settings": {
    "account_saved_successfully": "Account saved successfully | Accounts saved successfully",
    "error_archiving_integrations": "Error archiving integrations",
    "integrations_archived_successfully": "Integrations archived successfully",
    "unable_to_load_data": "Error loading Social Integrations.",
    "unable_to_save_error": "Unable to save selected accounts"
  },
  "social_engage_settings_layout": {
    "go_back": "Go back"
  },
  "social_engage_settings_manage_accounts": {
    "access_requirement": {
      "facebook": "has moderator access to at least one Facebook Page",
      "instagram": "has moderator access to at least one Facebook Page with an associated Instagram Business account",
      "linkedin": "has content admin access to at least one LinkedIn company page",
      "tiktok": "is a valid TikTok Business account",
      "twitter": "is a valid X {'|'} Twitter account"
    },
    "accounts_access_expired_at": "This account's access expired at {date}, please update it to avoid problems posting.",
    "accounts_foud": "{platform} accounts found",
    "add_another_account": "Want to add another account not listed?",
    "an_error_occurred": "An error occurred:{lineBreak} {errorMessage}",
    "connect_other_account": "Connect other account",
    "connected_accounts": "Connected {platform} Accounts",
    "connecting_accounts_error": "Error connecting {platform} accounts",
    "ensure_access_requirement": "Please ensure the account {accessRequirement}.",
    "found_following_associated_account": "{platformName} found the following associated account/s not already connected.{lineBreak}Selected accounts will be added to Engage.",
    "no_authorised_account": "{platformName} could not find an authorised account with your login.",
    "save_changes": "Save changes",
    "select_accounts_to_update": "Select which {platform} accounts to update",
    "selected_accounts_access_refresh": "Selected accounts will have their access refreshed.",
    "social_account_management": "Social Account Management",
    "try_again": "Please go back and try again.",
    "try_another_account": "Would you like try another account?",
    "update_connected_accounts": "View and update connected {platform} accounts",
    "update_platform_accounts": "Update {platform} accounts"
  },
  "social_engage_settings_options": {
    "connect_account_profiles": "Connect account profiles",
    "disconnect_accounts": "Disconnect accounts",
    "manage_account_profiles": "Manage account profiles",
    "social_account_management": "Social Account Management"
  },
  "social_engage_settings_remove_accounts": {
    "confirm_remove": {
      "confirm_label": "Disconnect account | Disconnect accounts",
      "message": "This account will be removed from any un-published post. Are you sure you want to disconnect it? | These accounts will be removed from any un-published post. Are you sure you want to disconnect them?",
      "title": "Are you sure you want to disconnect?"
    },
    "disconnect_account_profile": "Disconnect an account profile",
    "disconnect_account_profile_subtext": "Disconnecting a profile will not remove existing posts from this account. {lineBreak}Any unpublished, unsheduled post will have the disconnected profile removed.",
    "disconnect_accounts": "Disconnect accounts",
    "draft_posts_tooltip": "There are draft posts for this account. Removing this account will remove it from these draft or pending approval posts.",
    "posts_scheduled_tooltip": "There are posts scheduled for this account. Please remove this account from scheduled posts before deleting."
  },
  "social_engage_tweet_preview": {
    "40_minutes": "· 40m",
    "comments_count": "{count} comment | {count} comments",
    "likes_count": "{count} like | {count} likes",
    "retweets_count": "{count} retweet | {count} retweets"
  },
  "social_hydration_banner": {
    "fetching_content": "Sit tight! We are fetching new {platforms} content for all your Social Streams.",
    "instagram": "Instagram",
    "tiktok": "TikTok"
  },
  "social_impact_expandable": {
    "minimum_followers": "Minimum Followers",
    "verified": "Verified"
  },
  "social_impact_score_widget": {
    "comments": "Comments",
    "impact_score": "Impact Score",
    "likes": "Likes"
  },
  "social_integration_cards": {
    "connect_page": "Connect Page",
    "connecting": "Connecting",
    "expired_integration_count": "{count} integration has expired. Please manage your integration and update it to avoid any issues with your posts. | {count} integrations have expired. Please manage your integrations and update them to avoid any issues with your posts.",
    "facebook": "Facebook",
    "facebook_description": "Connect to any Facebook pages.",
    "instagram": "Instagram",
    "instagram_description": "Connect to any Instagram business accounts.",
    "instagram_no_connections": "Your team does not have access to any integrations and cannot manage any connections. Ask your administrator to give your team access to an integration to get started.",
    "integration_count": "{count} Integration | {count} Integrations",
    "linkedin": "LinkedIn",
    "linkedin_description": "Connect to any LinkedIn company pages.",
    "manage_connections": "Manage Connections",
    "manage_integrations": "Manage Integrations",
    "no_business_accounts": "All connected accounts are personal accounts. Management and monitoring of hashtags is only available for business accounts.",
    "tiktok": "TikTok",
    "tiktok_description": "Manage your personal or business accounts.",
    "twitter": "X / Twitter account",
    "twitter_description": "Connect to any X/Twitter profiles."
  },
  "social_integration_existing_list": {
    "connect_account_description": "Connect an account to start monitoring {type}",
    "sort_by": "Sort by"
  },
  "social_integration_refresh_integration_list": {
    "accounts_found_description": "{platformName} has found the following associated account/s not already connected. Select accounts and grant access to use them in Engage.",
    "accounts_found_title": "{type} accounts found",
    "connected_accounts_description": "Selected accounts will have their access refreshed",
    "connected_accounts_title": "Connected {type} Accounts",
    "no_existing_accounts": "No existing {type} accounts found.",
    "no_existing_accounts_description": "This is possible if you are not an administrator of the current integrations.",
    "no_new_accounts": "No additional {type} accounts found."
  },
  "social_integration_refresh_integrations": {
    "add_accounts": "Add Accounts",
    "existing_integrations": "Existing Integrations"
  },
  "social_integration_row": {
    "business_account": "Business Account",
    "disabled_text": "You have exhausted your allocated integrations.",
    "engage": "Engage",
    "expired_at": "Expired at: {timeAgo}",
    "expires_at": "Expires at: {timeAgo}",
    "last_updated": "Last Updated: {timeAgo}",
    "listen": "Listen",
    "never_expires": "Expires at: -",
    "personal_account": "Personal Account",
    "social_product_updated": "Preferences saved."
  },
  "social_integration_row_action_sheet": {
    "remove_integration": "Remove Integration"
  },
  "social_mention_card": {
    "author_image": "Author image",
    "commented": "commented",
    "comments_count": "{commentsCount} Comments",
    "followers": "Followers",
    "impact_score_proportional": "Impact score proportional to upvotes for a post.",
    "likes_count": "{likesCount} Likes",
    "replied": "replied",
    "save_sentiment_rating_error": "There was an issue saving this Sentiment Rating. Please try again.",
    "social_impact_score": "Impact score is the potential impact a post from this user has on being viewed, shared or retweeted.",
    "subreddit_followers": "Subreddit Followers",
    "views": "Views"
  },
  "social_mention_card_attached_media_asset": {
    "attachment": "Attachment",
    "gif": "GIF"
  },
  "social_mention_card_exorde_reddit_post": {
    "comment_karma": "Author Comment Karma",
    "comments": "Author Comment Count",
    "followers": "Followers",
    "post_karma": "Author Post Karma",
    "posts": "Author Post Count"
  },
  "social_mention_card_follower_count": {
    "follower_count": "{followerCount} Followers"
  },
  "social_mention_card_instagram": {
    "hashtag": "Hashtag",
    "post": "Post"
  },
  "social_mention_card_tiktok": {
    "hashtag": "Hashtag",
    "post": "Post"
  },
  "social_mention_card_tweet": {
    "replied": "replied",
    "retweeted": "retweeted"
  },
  "social_mention_engagement_sentiment": {
    "automatically_rated_as": "This item has been automatically rated as {sentiment}."
  },
  "social_platform_selector": {
    "placeholder": "Select Media Types"
  },
  "social_platforms_expandable": {
    "platform_cannot_be_selected": "{platformLabel} cannot be selected when filtering by Verified or Minimum Followers."
  },
  "social_product_name": "{platformName} Social",
  "social_product_short_name": "Social",
  "social_report": {
    "additional_filters": "Additional Filters",
    "choose_social_stream": "Choose a Social Stream",
    "display_charts_and_mentions": "Display Charts and Mentions",
    "display_charts_only": "Display Charts Only",
    "display_mentions_only": "Display Mentions Only",
    "generate_report": "Generate {format} Report",
    "generate_social_stream_report": "Generate a Social Stream Report by choosing a format, report type and applying any necessary filters.",
    "mention_count": "{labelText} ({totalMentionCount} items)",
    "retrieving_counts_error": "There was an error retrieving Social Stream counts",
    "save_dialog": {
      "cancel_label": "OK",
      "confirm_label": "View Reports",
      "error": "There was an error generating the report",
      "message": "Your report is now building. It will appear in Reports when it's ready.",
      "title": "Generating Social Stream Report"
    },
    "social_platforms": "Social Platforms",
    "social_stream": "Social Stream",
    "social_stream_report": "Social Stream Report"
  },
  "social_report_filter": {
    "arrange_by_platform": "Arrange content by social platform",
    "arrange_by_platform_subtext": "Select the order in which content should be ordered within folders",
    "collapse_syndicated": "Group syndicated Mentions together",
    "collapse_syndicated_subtext": "Identical items will be combined into a single Mention.",
    "comma_separated": "Comma Separated",
    "excluded_keywords": "Excluded Keywords",
    "keywords": "Keywords"
  },
  "social_report_warning": {
    "platforms_not_available": "Youtube, Reddit, Blogs and Forums are not available when filtering for minimum followers or verified."
  },
  "social_reports": {
    "engage_performance_report": "Engage Performance Report",
    "new_report_button": "New Report",
    "scheduled_report": "Scheduled Report",
    "scheduled_reports_tab": "Scheduled Reports",
    "social_analytics_report": "Social Analytics Report",
    "social_stream_report": "Social Stream Report"
  },
  "social_scheduled_report": {
    "content_description": "Add Social Streams",
    "edit_title": "Edit Social Scheduled Report",
    "new_title": "New Social Scheduled Report",
    "schedule_and_save": "Schedule and Save"
  },
  "social_stream": {
    "edit_social_stream": "Edit Social Stream",
    "error_loading_mentions": "Error Loading Mentions - Click to Retry",
    "expiry_has_extended_message": "The expiry of {streamLabel} has been extended by 3 days.",
    "expiry_has_extended_title": "{streamTypeLabel} Expiry Extended",
    "filter_mentions": "Filter Mentions",
    "generate_report": "Generate Report",
    "no_social_item_found": "No Social Item found",
    "no_social_items_since": "No Social Items since {date}.",
    "search_earlier_content": "Search earlier content.",
    "select_date_range": "Select Date Range",
    "social_items_since": "Social Items since {date}."
  },
  "social_stream_create_column": {
    "create_social_stream": "Create Social Stream",
    "new_social_stream_button": "Create a New Social Stream"
  },
  "social_stream_hydration_watcher": {
    "finding_more_content": "Hold tight, we are finding more content for you"
  },
  "social_stream_reports": {
    "actions": "Actions",
    "csv_excel": "CSV/Excel",
    "delete_report": "Delete report",
    "error_creating_report": "There was an error creating your report. Please contact your account manager for assistance.",
    "from": "From",
    "pdf_building": "PDF Building",
    "permanently_delete_report": "Permanently delete this report?",
    "processing": "Processing",
    "regenerate_report": "Regenerate report (Only available to Admins)",
    "report": "Report",
    "report_type": "Report Type",
    "requested": "Requested",
    "status": "Status",
    "to": "To",
    "view_online": "View Online",
    "xlsx": "XLSX"
  },
  "social_streams": {
    "no_shared_social_streams": "You currently have no Shared Social Streams."
  },
  "social_tab_analyse": {
    "add_social_stream": "Add Social Stream",
    "before_leaving": {
      "message": "By leaving this page, any edits made to your analytics will not be saved.",
      "title": "Unsaved Social Analytics"
    },
    "create_social_stream_label": "Create a social stream",
    "deleting_report_error": "There was an error deleting the report",
    "download_pdf": "Download PDF",
    "download_xlsx": "Download XLSX",
    "finding_more_content_for_you": "Hold tight, we are finding more content for you. {lineBreak}You can keep using {platformName} until we're ready.",
    "generating_report_error": "There was an error generating the report",
    "loading_social_reports_error": "There was an error loading Social Reports",
    "new": "New",
    "no_charts_selected": " You don’t have any charts selected. {lineBreak}Add a chart to start social analysis or open a saved report.",
    "no_social_streams": "You currently have no Social Streams to analyse. {lineBreak}Create a Social Stream",
    "no_social_streams_selected": "You don’t have any Social Streams selected. {lineBreak}Add a Social Stream to start social analysis or open a saved report.",
    "open": "Open",
    "report_is_being_generated": "A {type} report is being generated and we will notify you when ready",
    "saved_report_successfully": "Saved {reportName} successfully",
    "saving_report_error": "There was an error saving the report",
    "select_date_range": "Select Date Range",
    "select_up_to": "SELECT UP TO 6",
    "share_report_modal": {
      "confirm_label": "Download {typeText}",
      "message": "Download a copy of the report as a {typeText}",
      "title": "Save Report"
    },
    "social_platform_selected": "{count} Social Platform selected | {count} Social Platform selected",
    "social_stream_selected": "{count} Social Stream selected | {count} Social Streams selected",
    "untitled": "Untitled"
  },
  "social_tab_engage": {
    "load_integration_error": "There was an error loading integrations"
  },
  "social_tab_monitor": {
    "add_social_stream": "Add Social Stream"
  },
  "social_view_count_widget": {
    "followers_label": "Followers",
    "views_label": "Views"
  },
  "sort_order_picker": {
    "default_sort_by_label": "Sort by",
    "order_by_label": "Order by"
  },
  "sorting_expandable": {
    "add_sorting": "Add sorting",
    "sort_by": "Sort by",
    "sort_by_ordinal": "{ordinal} Sort by"
  },
  "source_field_labels": {
    "magazine": "Magazine",
    "online": "Online",
    "podcast": "Podcast",
    "print": "Print",
    "radio": "Radio",
    "social": "Influencer Social",
    "tv": "TV"
  },
  "source_filters": {
    "category_title": "Category",
    "character_limit": "Must be a least {characters} characters",
    "clear_all": "Clear all",
    "content_type_title": "Content Type",
    "edit_stream_heading": "Can't find what you are looking for?",
    "edit_stream_label": "Edit your Mention Stream",
    "keyword_placeholder": "Type keyword and press enter",
    "keyword_title": "Keyword",
    "location_title": "Location",
    "media_type_title": "Media Type",
    "read_only": "Cannot use filters since the Mention Stream is read-only.",
    "sector_title": "Sector",
    "source_group_title": "Source Group"
  },
  "source_list": {
    "edit_stream_heading": "Can't find what you are looking for?",
    "edit_stream_label": "Edit your Mention Stream",
    "expand_search": "Try expanding your filters, or reset your search.",
    "load_error": "Error loading Sources",
    "search_empty": "Your search didn't return any results.",
    "show_results": "Select filters to show results",
    "sort_by_button": "Sort by {field}",
    "sort_by_label": "Sort by:"
  },
  "source_list_topics": {
    "sectors": "Sectors",
    "see_all": "See All ({totalTopics})"
  },
  "source_selection": {
    "category_heading": "Category",
    "medium_heading": "Medium",
    "sector_heading": "Sector",
    "source_group_heading": "Source Group"
  },
  "sources_expandable": {
    "authors": "Authors",
    "categories": "Categories",
    "excluded_sources": "Excluded sources",
    "excluded_sources_not_available": "Excluded sources not available when sources are selected.",
    "metro": "Metro",
    "national": "National",
    "regional": "Regional",
    "sources_not_available": "Sources not available when excluded sources are selected.",
    "tiers": "Tiers"
  },
  "splashscreen": {
    "platform_logo": "{platformName} Logo"
  },
  "stock_symbol_placeholder": "NAB, or XAO",
  "stream": {
    "social_suffix": "(Social)"
  },
  "stream_edit_notifications": {
    "add_notification": "Add notification"
  },
  "stream_filtering": {
    "author": "Author",
    "content": "Content",
    "filtering_by": "Filtering by {category}",
    "handle": "/Handle",
    "keywords": "Keywords",
    "locations": "Locations",
    "media": "Media",
    "metrics": "Metrics",
    "other": "Other",
    "react_score": "React Score",
    "social_platforms": "Social Platforms",
    "sort_options": "Sort Options",
    "sources": "Sources",
    "tags": "Tags"
  },
  "stream_filters_applied": {
    "filters_applied": "Filter Set Applied"
  },
  "stream_filters_audience": {
    "audience": "Audience",
    "desktop": "Desktop",
    "devices_description": "Potential Audience Reach models are grouped into 2 devices for ease of analysis: Mobile & Desktop.",
    "devices_tab": "Devices",
    "mobile": "Mobile",
    "title": "Potential Audience Reach",
    "tooltip": "Potential Audience Reach is a metric to assess the 'reach' or 'spread' of media content",
    "total_tab": "Total"
  },
  "stream_filters_authors": {
    "author": "Author",
    "load_authors_error": "Error loading Authors"
  },
  "stream_filters_content": {
    "clear_all": "Clear all",
    "exclude": "Exclude",
    "excluded_not_available": "Exclude not available when Include selected.",
    "include": "Include",
    "included_not_available": "Include not available when Exclude selected.",
    "page_number": "Page Number",
    "word_count": "Word Count"
  },
  "stream_filters_content_types": {
    "heading": "Content Types",
    "license": {
      "cla": "CLA",
      "nla": "NLA"
    }
  },
  "stream_filters_impact_score": {
    "label": "Impact Score",
    "range_options": {
      "average": "Medium (201-350)",
      "excellent": "High (350+)",
      "low": "Low (0-200)"
    },
    "tooltip": "Impact score gives you a quick indication of an items significance by using proprietary technology and algorithms to blend together several industry metrics (Domain Authority, Sentiment, Potential Audience Reach, etc) into one clear value."
  },
  "stream_filters_keywords": {
    "advanced_keywords": "Advanced Search",
    "advanced_search_options": "Advanced Search Options",
    "boolean_query": "Boolean Query",
    "boolean_query_preview": "Boolean Query Preview",
    "boolean_query_preview_description": "You can copy this preview to create your own boolean query in the boolean tab",
    "comma_separated": "Comma Separated",
    "excluded_keywords": "Excluded Keywords",
    "keywords": "Keywords",
    "keywords_title": "I'm looking for coverage on these topics",
    "simple_boolean_error": "Invalid Boolean Query"
  },
  "stream_filters_languages": {
    "language": "Language"
  },
  "stream_filters_media": {
    "apply_all": "Apply to all Media Types applicable",
    "filter_coverage": "Filter {medium} Coverage",
    "impact_threshold": "Impact Threshold",
    "impact_threshold_max_placeholder": "Max (100)",
    "impact_threshold_min_placeholder": "Min (0)",
    "include_international_plus": "Include InternationalPlus sources"
  },
  "stream_filters_media_categories": {
    "category": "Category"
  },
  "stream_filters_media_domain_authority": {
    "label": "Domain Authority",
    "range_options": {
      "average": "Average ({min}-{max})",
      "excellent": "Excellent ({min}-{max})",
      "good": "Good ({min}-{max})",
      "low": "Low ({min}-{max})",
      "strong": "Strong ({min}-{max})"
    },
    "tooltip": "Domain Authority predicts the 'strength' of a website and how it compares to other websites. The scores range from one to 100, with higher scores corresponding to a greater likelihood of ranking. Domain Authority is provided by Moz."
  },
  "stream_filters_media_locations": {
    "continent": "Continent",
    "exclude": "Exclude",
    "include": "Include",
    "location": "Location",
    "search_location": "Search location"
  },
  "stream_filters_metrics": {
    "advertising_value_equivalency": "Advertising Value Equivalency",
    "advertising_value_equivalency_tooltip": "An estimation of the monetary value of media coverage using an equivalent rate paid for advertising in any given media type.",
    "react_score": "React Score"
  },
  "stream_filters_other": {
    "exclude_external_items": "Exclude External Items",
    "exclude_external_items_tooltip": "Upon enabling this, external coverage added will be excluded.",
    "include_newswire_content": "Display Newswire Content",
    "include_newswire_content_tooltip": "Upon enabling this, press release content will be included.",
    "only_external_items": "Only show External Items",
    "only_external_items_tooltip": "Upon enabling this, only external coverage added will be included. All other coverage will be excluded."
  },
  "stream_filters_reports": {
    "metro": "Metro",
    "national": "National",
    "regional": "Regional",
    "sorting": "Sorting",
    "tier": "Tier {tier}",
    "tiers": "Tiers"
  },
  "stream_filters_sentiment": {
    "label": "Sentiment",
    "tooltip": "Sentiment is used to gauge the general tone of a piece of a coverage. All content goes through an AI model and gets a score which is then translated as the sentiment of that coverage."
  },
  "stream_filters_tags": {
    "tag": "Tag"
  },
  "stream_group": {
    "are_you_sure": "Are you sure?",
    "edit_group": "Edit Group",
    "full_access_to_edit": "Users with \"Edit\" privileges will have full access to edit the group and gain access to Mention Streams with an \"Edit\" privilege. Users with \"View\" privileges to this group will be able to see all mention streams and gain access to them with a \"View\" privilege.",
    "general": "General",
    "group_is_being_shared_by": "This Group is being shared by {userName} with {accessLevel} privileges",
    "remove_group_message": {
      "is_shared_with_me": "This action will remove you from this Shared Stream Group.",
      "message": "Removing this Group will also remove it for {count} users in your organisation.",
      "title": "Remove this Stream Group?"
    },
    "remove_shared_stream_group": "Remove this Shared Stream Group",
    "remove_stream_group": "Remove this Stream Group",
    "share_group": "Share {groupLabel}",
    "share_with_user": "Share with User | Share with Users"
  },
  "stream_group_label": {
    "add_label": "Add a label",
    "colour_helps_identify_group": "Adding a colour helps to identify your Group",
    "group_color": "Group Colour",
    "group_label": "Group label",
    "label": "Label",
    "mention_stream_colour": "Mention Stream Colour"
  },
  "stream_notification": {
    "add_notification": "Add Notification",
    "create_notification_for": "Create new notification for {streamLabel}",
    "edit_notification_for": "Edit notification for {streamLabel}",
    "loading_notification_error": "There was an error loading the notification",
    "save_notification": "Save Notification",
    "saving_notification_error": "There was an error saving the notification"
  },
  "stream_notification_form": {
    "average_daily_mentions": "In the last 30 days, this {sourceStream} has had an average of {count} daily mentions.",
    "count_error": "There was an error retrieving daily mention counts",
    "failed_to_load": "Failed to load notification",
    "help_article_link": "Help Article.",
    "notification_type_title": "Notification Type",
    "progress_steps": {
      "customise": "Customise",
      "delivery": "Delivery",
      "select_notification_type": "Select notification type"
    },
    "standard_notification_label": "New Mention",
    "standard_notification_subtext": "Triggers a notification for every new mention",
    "volume_notification_label": "Spike in Volume Notification",
    "volume_notification_subtext": "Triggers a notification when there is an increase in typical hourly mentions. See {helpArticle}"
  },
  "stream_notification_form_customise_options": {
    "advanced_filters_label": "Advanced Filters",
    "filter_set_applied_mobile_message": "A filter set has been applied to this notification: {label}",
    "filters_applied_mobile_message": "Advanced filters have been applied to this notification",
    "load_filter_set_error": "There was an error loading the filter set",
    "spike_in_negative_sentiment_label": "Negative Sentiment",
    "spike_in_positive_sentiment_label": "Positive Sentiment",
    "spike_in_social_shares_label": "Social Shares",
    "spike_in_volume_label": "Volume",
    "spike_type_subtext": "Measuring types of spikes in the platform with the default being volume.",
    "spike_type_title": "Spike Type"
  },
  "stream_notification_form_delivery_options": {
    "custom": "Custom",
    "delivery_label": "Delivery",
    "delivery_subtext": "Send notifications via the following delivery methods",
    "email_domain_heading": "Domain",
    "email_label": "Email",
    "email_tooltip": "Email cannot be selected when {enabledIntegrations} is enabled",
    "microsoft_teams_label": "Microsoft Teams",
    "microsoft_teams_tooltip": "Microsoft Teams cannot be selected when mobile/email are enabled",
    "mobile_label": "Mobile",
    "mobile_tooltip": "Mobile cannot be selected when {enabledIntegrations} are enabled",
    "react_notify_label": "Only notify me about mentions when a react score category is {highRisk}",
    "recipients_heading": "Recipients",
    "recipients_subtext": "Add recipients from an existing distribution list or manually add emails.",
    "select_domain": "Select a domain",
    "select_sender_email": "Select a sender email",
    "send_as_heading": "Send As",
    "send_as_subtext": "The 'Send As' field will display as the 'From' name for report recipients.",
    "sender_email": "Sender Email",
    "senders": {
      "custom": "Custom",
      "organisation": "Organisation",
      "organisation_domain": "Organisation Domain",
      "user": "User"
    },
    "slack_label": "Slack",
    "slack_tooltip": "Slack cannot be selected when mobile/email are enabled"
  },
  "stream_notification_form_mention_type": {
    "average_daily_mentions": "In the last 30 days, this {sourceStream} has had an average of {count} daily mentions.",
    "count_error": "There was an error retrieving daily mention counts",
    "help_article_link": "Help Article.",
    "notification_type_title": "Notification Type",
    "spike_notification_label": "Spike",
    "spike_notification_subtext": "Triggers a notification when there is a spike in typical hourly mentions. See {helpArticle}",
    "standard_notification_label": "New Mention",
    "standard_notification_subtext": "Triggers a notification for every new mention"
  },
  "stream_notification_spike_slider": {
    "label": "Spike Size Threshold",
    "size": {
      "large": "Large",
      "medium": "Medium",
      "small": "Small"
    },
    "subtext": "Choose how sensitive the spike notification should be. Sensitivity is based on typical hour activity patterns. Click {link} to see details.",
    "validation_spike_threshold_range": "Must be between {min} and {max}"
  },
  "stream_notification_spike_type": {
    "negative_sentiment": "Negative Sentiment",
    "positive_sentiment": "Positive Sentiment",
    "social_shares": "Social Shares",
    "volume": "Volume"
  },
  "stream_notification_subscribe": {
    "call_to_action": "You can close this window or {prompt}",
    "description": "You’ll receive New Mention Alert emails from {appName}.",
    "header": "Thank you, your alert has been saved.",
    "prompt": "open {appName}"
  },
  "stream_notification_unsubscribe": {
    "call_to_action": "You can close this window or {prompt}",
    "description": "You’ll no longer receive New Mention Alert emails from {appName}. If you change your mind, please reach out to your team member to resubscribe.",
    "header": "You’ve unsubscribed.",
    "prompt": "open {appName}"
  },
  "stream_notifications": {
    "add_notification_label": "Add notification",
    "load_notifications_error": "There was an error loading Notifications",
    "status_label": "Notifications are {status}",
    "status_off": "OFF",
    "status_off_subtext": "Resume all active notifications and begin receiving them in your Email, Mobile or other communication channels.",
    "status_on": "ON",
    "status_on_subtext": "Suspend receiving notifications in your Email, Mobile or other communication channels.",
    "title": "Notifications",
    "update_notifications_error": "There was an error updating notification settings"
  },
  "stream_notifications_actions": {
    "update_notification_error": "There was an error updating the notification"
  },
  "stream_notifications_card": {
    "action_delete": "Delete",
    "action_edit": "Edit",
    "action_pause": "Pause",
    "action_resume": "Resume",
    "delivery_label": "Delivery:",
    "manage_recipients": "Manage recipients",
    "media_type_label": "Media type:",
    "notification_type_label": "Notification type:",
    "recipients": "Recipients",
    "slack_channel": "Slack channel",
    "spike_type": "Spike",
    "standard_type": "New Mention"
  },
  "stream_notifications_edit": {
    "create_new_notification": "Create new notification",
    "create_notification_error": "There was an error creating the notification",
    "create_notification_for": "Create a notification for {streamLabel}",
    "edit_notification_for": "Edit notification for {streamLabel}",
    "load_notification_error": "There was an error loading the notification"
  },
  "stream_notifications_form_header": {
    "choose_stream": "Choose a {sourceStream}",
    "launchpad_label": "Launchpad",
    "mention_type_heading": "Mention type:"
  },
  "stream_notifications_form_title": {
    "create_notification_title": "Create new notification",
    "create_stream_notification_title": "Create a notification for {streamLabel}",
    "edit_stream_notification_title": "Edit notification for {streamLabel}"
  },
  "stream_notifications_general": {
    "add_notification_label": "Add notification"
  },
  "stream_notifications_grid": {
    "empty_state": "You have no notifications configured for this",
    "remove_notification_error": "There was an error deleting the notification",
    "remove_notification_prompt": "Are you sure you want to delete this notification?"
  },
  "stream_notifications_standard_fields": {
    "ai_summary_label": "Include AI Summary",
    "ai_summary_subtext": "Cision AI will generate a summary of Online and Print content based on your selected Mention Streams.",
    "delivery_label": "Delivery",
    "delivery_subtext": "Send notifications via the following delivery methods",
    "email_label": "Email",
    "email_tooltip": "Email cannot be selected when {enabledIntegrations} is enabled",
    "high_react_tooltip": "This will filter notifications to only notify new mentions when a risk category (Harm, Controversy, Emotionality, Spam) has a react score over 75",
    "high_risk": "High Risk",
    "high_risk_label": "Filter by high risk media",
    "microsoft_teams_label": "Microsoft Teams",
    "microsoft_teams_tooltip": "Microsoft Teams cannot be selected when mobile/email are enabled",
    "mobile_label": "Mobile",
    "mobile_tooltip": "Mobile cannot be selected when {enabledIntegrations} are enabled",
    "react_notify_label": "Only notify me about mentions when a react score category is {highRisk}",
    "slack_label": "Slack",
    "slack_tooltip": "Slack cannot be selected when mobile/email are enabled",
    "social_platforms_label": "Social Platforms"
  },
  "stream_notifications_standard_fields_channel": {
    "channel_id_placeholder": "Enter Slack Channel ID",
    "load_error": "Unable to load Slack Channels: {errorMessage}",
    "load_single_channel_error": "Unable to load channel",
    "no_channels_found": "No channels found",
    "placeholder": "Select {integration} channel"
  },
  "stream_notifications_table": {
    "actions_table": "Actions",
    "confirm_archive_title": "Are you sure you want to delete this notification?",
    "delete_notification_error": "There was an error deleting the notification",
    "delivery_title": "Delivery",
    "empty_notifications": "You currently have no notifications",
    "empty_stream_notifications": "You have no notifications configured for this {streamLabel}",
    "global_title": "Media Types / Social Platforms",
    "mentions_title": "Mentions",
    "notification_type_title": "Notification Type",
    "recipients_title": "Recipients",
    "slack_channel": "Slack channel",
    "social_platforms_title": "Social Platforms",
    "stream_name_title": "Stream Name",
    "stream_type_title": "Stream Type"
  },
  "stream_notifications_table_grid": {
    "add_notification": "Add notification"
  },
  "stream_notifications_table_row": {
    "all_label": "All",
    "high_risk_label": "High Risk",
    "manage_recipients": "Click to manage recipients",
    "mention": "Mention",
    "recipients": "The number of recipients of notification: {recipientNumber}",
    "spike_type": "Spike",
    "standard_type": "New Mention",
    "updating_recipients_error": "There was an error while updating the recipients"
  },
  "stream_notifications_toast": {
    "paused": "Notification has been paused.",
    "resumed": "Notification has been resumed.",
    "tap_pause": "Tap pause to suspend.",
    "tap_resume": "Tap play to resume."
  },
  "stream_picker": {
    "confirm": "Confirm",
    "keyword_search_placeholder": "Search keywords or Mention Streams",
    "max_selected": "SELECT UP TO {maxSelected}",
    "min_selected": "Please select at least {minSelected} option.",
    "select_mention_stream": "Select Mention Stream | Select Mention Streams",
    "select_social_stream": "Select Social Stream | Select Social Streams",
    "selected_mention_stream": "{count} Mention Stream selected | {count} Mention Streams selected",
    "selected_social_stream": "{count} Social Stream selected | {count} Social Streams selected",
    "shared_report_streams": "Shared Report Streams",
    "social_tagged": "Social Tagged"
  },
  "stream_settings": {
    "add_stream": "Add a {streamTypeLabel}",
    "add_to_shared_group": "Add {streamTypeLabel} to a shared group",
    "add_to_shared_group_message": "Are you sure you want to change groups? Changing groups to a shared group will automatically grant access to this stream for all users who have group access to the new group.",
    "automatically_shared": "{streamTypeLabel} Automatically Shared",
    "automatically_shared_message": "This {streamTypeLabel} has been shared to {userCount} users in your organisation.",
    "be_removed_question": "Are you sure you want to be removed from this Shared {streamTypeLabel}?",
    "customer_portal": "Customer Portal",
    "find_out_more": "Find out more.",
    "general": "General",
    "help_centre": "{platformName} help centre",
    "knowledge_base": "Knowledge base",
    "load_stream_error": "There was a problem loading your {streamTypeLabel}, please try again.",
    "manually_rate_mentions": "You can manually rate Mentions that appear within this {streamTypeLabel} on a 5-point scale. {findOutMore}",
    "mention_stream": "Mention Stream",
    "notifications": "Notifications",
    "ok": "Ok",
    "remove_from_shared_group": "Remove {streamTypeLabel} from a shared group",
    "remove_from_shared_group_message": "Are you sure you want to change groups? Changing groups from a shared group will remove access to this stream for users in your organisation if they don't have access to the new group.",
    "remove_shared_stream": "Remove Shared {streamTypeLabel}",
    "remove_shared_stream_message": "Removing this {streamTypeLabel} will also remove it for {userCount} users in your organisation.",
    "remove_shared_stream_question": "Are you sure you want to remove this Shared {streamTypeLabel}?",
    "remove_stream": "Remove {streamTypeLabel}",
    "remove_stream_error": "There was a problem removing your {streamTypeLabel}, please try again.",
    "remove_stream_question": "Are you sure you want to remove this {streamTypeLabel}?",
    "remove_this_shared_stream": "Remove this Shared {streamTypeLabel}",
    "remove_this_stream": "Remove this {streamTypeLabel}",
    "select_media_type": "Please select a Media Type",
    "share_stream": "Share {streamLabel}",
    "share_with_user": "Share with {newShareCount} User | Share with {newShareCount} Users",
    "social_platforms": "Social Platforms",
    "stream_being_shared": "This {streamTypeLabel} is being shared by {userName} with {accessLevel} privileges",
    "stream_being_shared_by": "This {streamTypeLabel} is being shared with {accessLevel} privileges",
    "stream_has_been_removed": "{streamTypeLabel} {streamLabel} has been removed",
    "stream_saving_error": "There was a problem saving your {streamTypeLabel}, please try again.",
    "stream_sharing_error": "There was a problem sharing your {streamTypeLabel}, please try again.",
    "stream_sharing_success": "{streamTypeLabel} sharing updated successfully"
  },
  "stream_settings_bookmark": {
    "confirm_label": "Share with {count} User | Share with {count} Users",
    "general": "General",
    "remove_from_shared": "Are you sure you want to be removed from this Shared {streamTypeLabel}?",
    "remove_stream": "Are you sure you want to remove this {streamTypeLabel}?",
    "remove_stream_title": "Remove {streamTypeLabel}",
    "share": "Share",
    "share_stream_title": "Share {streamLabel}",
    "shared_with_me": "This {streamTypeLabel} is being shared by {userName} with {accessLevel} privileges.",
    "tagged_folder_deleted": "Tagged Folder deleted",
    "tagged_folder_id": "Tagged Folder ID: {id}",
    "tagged_folder_updated": "Tagged Folder updated"
  },
  "stream_settings_brief": {
    "keywords": "Keywords",
    "managed_by_account_manager": "This {streamTypeLabel} is managed by your Account Manager",
    "managed_by_customer_success_team": "This Mention Stream is managed by {platformName}'s Customer Success Team.",
    "managed_by_dedicated_support_team": "This Mention Stream is managed by {platformName}'s Dedicated Support Team.",
    "other_keyword": "+ {count} other keyword | + {count} other keywords",
    "stream_contains": "This {streamTypeLabel} contains:",
    "user_card_subtitle": "To make changes to this {streamTypeLabel}, contact your Account Manager {accountManager}."
  },
  "stream_settings_excluded_mentions": {
    "remove_mentions": "Remove mentions",
    "removed_mentions": "Removed Mentions",
    "review_list_of_mentions": "Review a full list of mentions that have been removed by members of your team.",
    "view_removed_mentions": "View Removed Mentions ({total})"
  },
  "stream_settings_expiry": {
    "expiry": "Expiry",
    "expiry_subtext": "Select a time frame for this {streamTypeLabel} to auto-expire if you don't want to keep it permanently."
  },
  "stream_settings_filters_sources": {
    "add_source_names_to_display": "Add source names to only display coverage from these sources.",
    "add_source_names_to_exclude": "Add source names to exclude coverage from these sources.",
    "authors": "Authors",
    "categories": "Categories",
    "exclude_sources": "Exclude sources",
    "excluded_sources_not_available": "Excluded sources not available when sources are selected.",
    "include_sources": "Include Sources",
    "metro": "Metro",
    "national": "National",
    "regional": "Regional",
    "sources_not_available": "Sources not available when excluded sources are selected.",
    "tiers": "Tiers"
  },
  "stream_settings_general_tab": {
    "action_will_permanently_remove": "This action will permanently remove this {streamTypeLabel}.",
    "action_will_remove": "This action will remove you from this Shared {streamTypeLabel}.",
    "all_keywords": "All Keywords together",
    "auto_expire_selection": "You can select a time for this {streamTypeLabel} to auto-expire if you don't want to keep it permanently.",
    "boolean_query": "A Boolean query",
    "build_stream": "Build a {streamTypeLabel} using",
    "case_sensitive": "Case-sensitive",
    "color_for_stream": "Colour for this {streamTypeLabel}",
    "colour": "Colour:",
    "contact_account_manager": "To make changes to this {streamTypeLabel}, contact your Account Manager {accountManager}.",
    "default_sentiment_rating": "Default Sentiment Rating",
    "enter_label_before_saving": "Please enter a label before saving.",
    "exclude_keyword": "Exclude following Keyword(s):",
    "existing_group": "An existing Group",
    "expiry": "Expiry",
    "find_out_more": "Find out more here.",
    "group": "Group:",
    "group_label": "Label for this Group:",
    "included_sources": "Included Sources",
    "keyword_query": "One or several Keywords",
    "label": "label",
    "label_for_stream": "Label for this {streamTypeLabel}",
    "load_excluded_mentions_error": "Unable to load excluded mentions",
    "manually_rate_mentions": "Once enabled, you can manually rate Mentions that appear within this {streamTypeLabel} on a 5-point scale.",
    "match_content": "Match content that mentions:",
    "new_group": "A new Group",
    "no_mentions_were_found": "No mentions were found over the last 30 days.",
    "one_keyword": "At least one Keyword",
    "other_keyword": "+ {count} other keyword | + {count} other keywords",
    "place_into": "Place this {streamTypeLabel} into:",
    "place_into_new_group": "Place this {streamTypeLabel} into a new Group",
    "primary_stream": "This is your primary {streamTypeLabel}",
    "remove_mentions": "Remove mentions",
    "remove_shared_stream": "Remove this Shared {streamTypeLabel}",
    "remove_stream": "Remove this {streamTypeLabel}",
    "remove_stream_dialog": {
      "be_removed_message": "Are you sure you want to be removed from this Shared {streamTypeLabel}?",
      "remove_message": "Are you sure you want to remove this {streamTypeLabel}?",
      "title": "Permanently Remove {streamTypeLabel}"
    },
    "removed_mentions": "Removed Mentions ({count})",
    "select_group_before_saving": "Please select a group before saving.",
    "stream_contains": "This {streamTypeLabel} contains:",
    "stream_managed_by_account_manager": "This {streamTypeLabel} is managed by your Account Manager"
  },
  "stream_settings_group": {
    "existing_group": "Existing Group",
    "group": "Group",
    "group_label": "Group Label",
    "move_to_existing_group": "Move to an existing Group",
    "new_group": "New Group"
  },
  "stream_settings_group_tab": {
    "colour_for_group": "Colour for this Group",
    "create_new_group": "Or create a new Group",
    "move_stream": "Move this {streamTypeLabel} to the following Group"
  },
  "stream_settings_label": {
    "field_heading": "{streamTypeLabel} Name",
    "label": "Label",
    "placeholder": "Add an easy recognisable label"
  },
  "stream_settings_linked_stream": {
    "choose_mention_stream": "Choose a Mention Stream",
    "choose_social_stream": "Choose Social Stream",
    "linked_mention_stream": "Linked Mention Stream",
    "linked_mention_stream_subtext": "You can choose a Mention Stream for comparative analysis with this Social Stream in Social Analyse.",
    "linked_social_stream": "Linked Social Stream",
    "linked_social_stream_subtext": "You can choose a Social Stream for comparative analysis with this Mention Stream in Instant Insights.",
    "mention_stream_already_linked": "This Mention Stream is linked to a Social Stream already.",
    "social_stream_already_linked": "This Social Stream is linked to a Mention Stream already."
  },
  "stream_settings_message_customer_success": "Need help? Contact {customerSuccessEmailLink} between 9AM-5PM Monday-Friday or check our guides in the {helpCentreLink}.",
  "stream_settings_message_dedicated_support": "Need help? Contact {dedicateSupportEmailLink} or check our guides in the {helpCentreLink}.",
  "stream_settings_message_social": "Need help? Contact our Customer Success team at {streemSocialEmailLink}.",
  "stream_settings_message_traditional": "Need help? Contact your account manager {accountManagerContactPopup} for more details or help.",
  "stream_settings_query": {
    "add_label_placeholder": "Add a label",
    "boolean_label": "Boolean Query",
    "boolean_query_preview": "Boolean Query Preview",
    "boolean_query_preview_aria_label": "Boolean Query Preview, read-only",
    "boolean_query_preview_description": "You can copy this preview to create your own boolean query in the boolean tab",
    "build_using": "Build Using",
    "coverage_on_topics": "I'm looking for coverage on these topics",
    "input_label": "{streamTypeLabel} Name",
    "keywords_label": "Keyword/s",
    "label": "Label",
    "query_label": "Query",
    "query_snippet": "Keyword Snippet"
  },
  "stream_settings_query_filter_insert": {
    "convert_error": "Failed to convert the filter to a boolean query. Please try again.",
    "keyword_placeholder": "Enter a keyword...",
    "title": "Add to query"
  },
  "stream_settings_rating": {
    "default_sentiment_rating_field_heading": "Default Sentiment Rating",
    "enabled_sentiment_field_heading": "Enable Sentiment Rating",
    "find_out_more": "Find out more here.",
    "subtext": "Once enabled, you can manually rate Mentions that appear within this {streamTypeLabel} on a 5-point scale."
  },
  "stream_settings_shared_tab": {
    "user_edit_priviledges_line_1": "Users with edit privileges can edit, move or remove themselves from the shared {streamTypeLabel}.",
    "user_edit_priviledges_line_2": "Users without edit privileges can only move or remove themselves from the shared {streamTypeLabel}."
  },
  "stream_settings_simple_boolean": {
    "error_message": "You need at least one keyword here."
  },
  "stream_settings_simple_boolean_section": {
    "at_least_label": "At Least {value} Times:",
    "author_label": "Author:",
    "case_sensitive_label": "Case Sensitive:",
    "first_label": "First {value} Words:",
    "keyword_placeholder": "Type a keyword and press Enter.",
    "medium_label": "Medium ({medium}):",
    "must_full_title": "{title} {subtitle}",
    "must_not_full_title": "{title} {subtitle}",
    "must_not_subtitle": "these terms",
    "must_not_title": "Not",
    "must_subtitle": "of these terms",
    "must_title": "Must include all",
    "platform_label": "Platform ({platform}):",
    "should_full_title": "{title} {subtitle}",
    "should_subtitle": "of these terms",
    "should_title": "And any",
    "title_label": "Title:"
  },
  "stream_settings_simple_boolean_selector": {
    "at_least_description": "{mentioned} {limit} {times}",
    "at_least_description_mentioned": "I want the keyword mentioned at least",
    "at_least_description_times": "times.",
    "at_least_label": "At Least",
    "at_least_tooltip_1": "The At Least operator captures content where keywords are mentioned the specified amount of times.",
    "at_least_tooltip_2": "For example, if you would like to see mentions of \"Apple\" at least 3 times.",
    "author_label": "Author",
    "author_tooltip_1": "The Author operator targets articles tagged with the specified authors.",
    "author_tooltip_2": "For example, if you would only like to see articles written by John Smith, you would put \"John Smith\" after the author operator.",
    "author_tooltip_override": "Upon using this operator, it will override any authors set in the Content filters",
    "case_sensitive_label": "Case Sensitive",
    "case_sensitive_tooltip_1": "The Case Sensitive operator searches for keywords matching the exact letter case you provide.",
    "case_sensitive_tooltip_2": "For example, if you would like to see mentions of \"Apple\" instead of \"apple\".",
    "first_description": "{mentioned} {limit} {words}",
    "first_description_mentioned": "I want the keyword when mentioned within the first",
    "first_description_words": "words.",
    "first_label": "First",
    "first_tooltip_1": "The First operator will limit results to articles containing keyword mentions within the first specified amount of words.",
    "first_tooltip_2": "For example, if you would like to see mentions of \"Apple\" within the first 20 words.",
    "keyword_label": "Keyword",
    "media_type_description": "I want the keyword when mentioned in these specific media types",
    "media_type_label": "Media Type",
    "media_type_tooltip_1": "The Media type operator searches for keywords within specific media type.",
    "media_type_tooltip_2": "For example, if you you would like to see mentions of \"Apple\" only in Online or Print.",
    "media_type_tooltip_override": "Upon using this operator, it will override any media type filters",
    "query_snippets_label": "Keyword Snippets",
    "search_tooltip": "Refine your search using specific filters.",
    "social_platform_description": "I want the keyword when mentioned in these specific social platforms",
    "social_platform_label": "Social Platform",
    "title_tooltip_1": "The Title operator searches for keywords within the headline of an article.",
    "title_tooltip_2": "For example, if you would like to see headline mentions of \"Apple\"."
  },
  "stream_settings_simple_boolean_tag": {
    "at_least_label": "At Least {value} Times",
    "author_label": "Author",
    "case_sensitive_label": "Case Sensitive",
    "first_label": "First {value} Words",
    "medium_label": "Medium ({medium})",
    "platform_label": "Platform ({platform})",
    "title_label": "Title"
  },
  "stream_sharing_search_input": {
    "placeholder": "Filter by name or team",
    "placeholder_team_hidden": "Filter by name",
    "teams": "Teams"
  },
  "stream_type": {
    "mentionStream": "Mention Streams",
    "socialStream": "Social Streams"
  },
  "stream_type_labels": {
    "0": "Mention Stream",
    "1": "Tagged Folder",
    "2": "Reporting Stream",
    "3": "Social Stream",
    "4": "Mention Stream"
  },
  "stream_vs_stream_widget": {
    "comparing_linked_mention_stream": "Comparing with linked Mention Stream '{comparisonStreamLabel}'.",
    "no_linked_mention_stream": "No linked Mention Stream."
  },
  "streams": {
    "create_mention_stream_button": "Create a New Mention Stream in this Group",
    "create_mention_stream_label": "Create Mention Stream",
    "no_shared_streams": "You currently have no Shared Streams.",
    "settings": {
      "color": {
        "description": "Adding a colour helps to group and locate your {streamType}.",
        "label": "{streamType} Colour"
      }
    }
  },
  "streams_by_group_picker": {
    "pick_a_group": "Pick a group",
    "primary_mention_stream": "Primary Mention Stream"
  },
  "streams_layout": {
    "list_view": "List View",
    "stream_view": "Mention Stream View"
  },
  "streams_management": {
    "group_removed": "Group removed",
    "media": {
      "add_stream_button": "New Mention Stream",
      "group_shared": "Mention Stream Group sharing updated successfully",
      "stream_shared": "Mention Stream sharing updated successfully",
      "streams_left": "{slotsAvailable} mention streams left",
      "title": "Mention Streams"
    },
    "remove_group": "Remove Group",
    "remove_group_message": "Are you sure you want to remove this group?",
    "remove_stream": "Remove {streamTypeLabel}",
    "remove_stream_message": "Are you sure you want to remove this {streamTypeLabel}?",
    "social": {
      "add_stream_button": "New Social Stream",
      "group_shared": "Social Stream Group sharing updated successfully",
      "stream_shared": "Social Stream sharing updated successfully",
      "streams_left": "{slotsAvailable} social streams left",
      "title": "Social Streams"
    },
    "streams_table": {
      "delete_group": "Delete group",
      "delete_stream": "Delete stream",
      "owner": "Owner",
      "query": "Query",
      "share_group": "Share group",
      "share_stream": "Share stream",
      "shared_with": "Shared with",
      "team": "Team"
    },
    "streeam_removed": "{streamTypeLabel} removed"
  },
  "streams_usage_table": {
    "load_stream_error": "There was an error loading {streamType}",
    "mention_stream": "Mention Stream",
    "no_stream": "No {streamTabLabel}.",
    "search_stream_placeholder": "Search stream or user",
    "social_stream": "Social Stream",
    "user_access": "User Access"
  },
  "sub_title": {
    "local_time": "{timezoneCity} local time",
    "page_number": ", Page {number}",
    "page_numbers": " , {pageNumbers} {'•'} ",
    "word_count": "{'•'} {wordCount} words"
  },
  "suggested_contacts_assistant_options": {
    "suggest_journalist": "Suggest Journalists and Outlets"
  },
  "suggested_keywords_ai_controls": {
    "suggest_button": "Suggest"
  },
  "suggested_keywords_ai_keyword": {
    "add_keyword_aria_label": "Add keyword to {label}",
    "edit_keyword_aria_label": "Edit keyword in {label}",
    "keywords_placeholder": "Enter keywords separated by commas",
    "topics_label": "I'm looking for {coverageLabel} on these topics"
  },
  "suggested_keywords_ai_suggestions": {
    "add_suggestion": "Add keyword suggestion",
    "error_loading_suggestions": "We're experiencing a temporary issue. Please try your request again.",
    "loading_keyword_suggestion": "Just a moment...",
    "no_suggestions": "No Results found for your request. Could you provide more details?",
    "remove_suggestion": "Remove keyword suggestion",
    "safety_violation_error": "We couldn't process this request because some content may be restricted, unsafe, or sensitive. Are there any other keywords I can help suggest?"
  },
  "syndications": {
    "advertising_value_equivalency": "Advertising Value Equivalency",
    "followers": "Followers",
    "potential_audience_reach": "Potential Audience Reach",
    "source": "Source",
    "syndicated_item_tooltip": "This syndicated item also matches this Mention Stream's keywords and filters",
    "unable_to_load_syndications": "Unable to load syndications"
  },
  "table_sort_order": {
    "sort_button_label": "Sort by {label}"
  },
  "tag": {
    "remove_label": "Remove {label}"
  },
  "tagged_mention_reports_table": {
    "action": "Actions",
    "delete_report": "Delete report",
    "delete_report_title": "Permanently delete this report?",
    "download": "Download",
    "folder": "Folders",
    "no_subject": "No Subject",
    "non_applicable": "N/A",
    "range": "Range",
    "sent": "Sent",
    "status": "Status",
    "subject": "Subject",
    "to": "To",
    "type": "Type"
  },
  "tagged_mentions_report": {
    "checked_mentions": "{count} / {total} mentions",
    "coverage_heading": "Select and order tagged coverage",
    "generate_csv_report": "Generate CSV/Excel Report (1 mention) | Generate CSV/Excel Report ({count} mentions)",
    "highlighted_excerpts_label": "Display highlighted keyword excerpts",
    "highlighted_excerpts_subtext": "This will highlight the matching keyword in each piece of coverage in the PDF report",
    "include_pdf_label": "Include Print PDF Articles",
    "include_pdf_subtext": "Include a downloadable PDF version of all Print articles",
    "language_dropdown_subtext": "This will populate your Tagged Mentions Report in the chosen language.",
    "recipients_label": "Recipients",
    "recipients_subtext": "This Email Report will also be delivered to {email}",
    "reorder_folders": "Click and drag to reorder folders",
    "report_options_heading": "Report Options",
    "restricted_content_label": "Show Restricted Content",
    "restricted_content_subtext": "Includes Links & any article body text to UK (NLA & CLA) copyrightable material",
    "send_as_heading": "Send as",
    "send_tagged_label": "Send Tagged Report (1 mention) | Send Tagged Report ({count} mentions)",
    "subject_aria_label": "Subject",
    "subject_label": "Subject Line",
    "summary_heading": "Add a Summary",
    "title": "Tagged Folders Report"
  },
  "tagged_mentions_reports_table": {
    "folder_count": "{count} folder | {count} folders",
    "recipient_count": "{count} recipient | {count} recipients"
  },
  "tags": {
    "label": "No tags | 1 tag | {count} tags",
    "list_label": "No lists | 1 list | {count} lists",
    "start_typing": "Start typing to create a tag"
  },
  "tax": "GST",
  "team_overview": {
    "loading_failed": "Loading failed"
  },
  "team_picker": {
    "current_selection_label": "Team Workspaces, current selection {organisation} {team}",
    "errors": {
      "updating_team_preference": "Error updating team preference"
    },
    "team_workspaces": "Team Workspaces"
  },
  "team_selector": {
    "all_teams": "All Teams"
  },
  "teams_management": {
    "add_team_button": "Add Team",
    "delete_team_error_title": "There was a problem deleting {teamName}",
    "max_teams_modal_message": "Your organisation has reached their maximum teams allowance. Please contact your Account Manager if you would like to add more.",
    "max_teams_modal_title": "Maximum Teams Reached",
    "team_created_message": "{teamName} has been created",
    "team_deleted_message": "{teamName} has been deleted",
    "team_updated_message": "{teamName} has been updated",
    "teams_left": "teams left",
    "update_team_error_title": "There was a problem updating {teamName}",
    "users": "Users"
  },
  "teams_management_table": {
    "add_team_button": "Add Team",
    "delete_team": "Delete team",
    "mention_streams": "Mention Streams",
    "social_streams": "Social Streams",
    "update_team": "Update team",
    "users": "Users"
  },
  "third_party_auth_facebook_or_instagram_account": {
    "error_authenticating_facebook": "Error authenticating with Facebook",
    "error_rate_limit": "Too many attempts. Please try again in a short while.",
    "error_retrieving_pages": "Error retrieving eligible Facebook pages",
    "getting_profiles": "Getting profiles...",
    "logging_in": "Logging in..."
  },
  "third_party_auth_google_analytics_account": {
    "authorise_platform": "Authorise {platformName}",
    "fetching_google_analytics_status_error": "An error occurred fetching Google Analytics status",
    "not_integrated": "Google Analytics account not connected",
    "start_google_analytics_authorisation_error": "A problem occurred trying to start Google Analytics authorisation"
  },
  "third_party_auth_linkedin_account": {
    "authorise_platform": "Authorise {platformName}",
    "fetching_linkedin_companies_error": "An error occurred fetching LinkedIn companies",
    "getting_profiles": "Getting profiles...",
    "logging_in": "Logging in...",
    "start_linkedin_authorisation_error": "A problem occurred trying to start LinkedIn authorisation"
  },
  "third_party_auth_tiktok_account": {
    "authorise_platform": "Authorise {platformName}",
    "fetching_tiktok_profile_error": "An error occurred fetching TikTok Profile",
    "getting_profiles": "Getting profiles...",
    "logging_in": "Logging in...",
    "start_tiktok_authorisation_error": "A problem occurred trying to start TikTok authorisation"
  },
  "third_party_auth_twitter_account": {
    "authorise_platform": "Authorise {platformName}",
    "fetching_twitter_profile_error": "An error occurred fetching X {'|'} Twitter Profile",
    "getting_profiles": "Getting profiles...",
    "logging_in": "Logging in...",
    "start_twitter_authorisation_error": "A problem occurred trying to start  X {'|'} Twitter authorisation"
  },
  "tier_filters": {
    "select_tiers": "Select Tiers"
  },
  "tier_radio_selector": {
    "all": "All",
    "tier": "Tier",
    "tier_1": "Tier 1"
  },
  "timezone_dropdown": {
    "default_label": "Select Timezone",
    "label": "Time Zone",
    "placeholder": "Select a time zone"
  },
  "tiny_mce_editor": {
    "errors": {
      "image_upload_failed": "There was an error uploading the image"
    },
    "menu": {
      "add_placeholder": "Add Placeholder",
      "der_tools": "Advanced Tools"
    }
  },
  "tld": "com.au",
  "top_articles_metric_dropdown": {
    "advertisement_rate": "AVE",
    "audience": "Audience Reach",
    "description": "Select the metric to display in the chart",
    "domain_authority": "Domain Authority",
    "impact_score": "Impact",
    "placeholder": "Select Metric",
    "sentiment_negative": "Negative Sentiment",
    "sentiment_positive": "Positive Sentiment",
    "social_shares": "Social Shares",
    "title": "Select Metric"
  },
  "transcript_request_card": {
    "cancel_request": "Cancel request",
    "cancel_request_description": "Are you sure you want to cancel this Transcript Request?",
    "cancel_request_title": "Cancel Transcript Request",
    "created_by": "Created by {name}",
    "download_word": "Download WORD",
    "pdf": "PDF",
    "pdf_download": "PDF download",
    "processing_status": "Status: Processing",
    "requested_by": "Requested by {name}",
    "see_more": "See more",
    "unable_to_complete_request": "Unable to complete this request.",
    "word_docx": "WORD (.docx)"
  },
  "transcript_request_mention_card": {
    "pdf_download": "PDF download",
    "station_image": "Station image",
    "word_download": "Word download"
  },
  "transcript_requests_tab": {
    "download_pdf": "Download PDF",
    "export_error": "Export Failed {error}",
    "load_error": "Failed to retrieve transcript requests",
    "no_requested_transcripts": "You have no requested Transcripts.",
    "pagination_label": "{start} - {end} of {totalCount}",
    "remove_transcript_error": "Failed to remove transcript request",
    "results": "Results {paginationLabel}"
  },
  "translation_description": {
    "translated_from": "Translated from {fromLanguage}"
  },
  "translation_error": {
    "failed_to_translate": "Failed to translate."
  },
  "translation_loader": {
    "translating_mention": "Translating Mention"
  },
  "tv_mention_card": {
    "play_from_start": "Play From Start",
    "view_transcript": "View Full Transcript"
  },
  "tv_mention_transcript": {
    "automated_transcript_disclaimer": "* This instantly-available transcript is compiled using a combination of technologies. Please note, {platformName} offers verbatim, human generated Transcription services at an additional cost. Please contact your dedicated Account Manager for more information.",
    "no_automated_transcript_disclaimer": "* No automated transcript available for this time on this channel. Please note, {platformName} offers verbatim, human generated Transcription services at an additional cost. Please contact your dedicated Account Manager for more information.",
    "source_local_time": "{location} Local Time",
    "thumbnail_image": "Thumbnail image",
    "your_local_time": "Your Local Time"
  },
  "tv_preview": {
    "logo_on_screen": "Logo On Screen:",
    "text_on_screen": "Text On Screen:"
  },
  "tv_segment_mention_card": {
    "tv_thumbnails": "TV thumbnails"
  },
  "twitter_integration": {
    "archive_integration_error": "Error archiving integration",
    "archive_integration_success": "Integration archived successfully",
    "disconnect_account_alert": "Are you sure you want to disconnect?",
    "disconnect_account_button": "Disconnect account",
    "disconnect_account_subtext": "This account {integrationLabel} will be removed. Are you sure you want to disconnect it?",
    "expired_account_tooltip": "This account's access expired at {date}, please update it to avoid problems fetching tweets.",
    "last_updated": "Last Updated: {date}",
    "load_integration_error": "There was an error loading the twitter integration",
    "remove_integration_button": "Remove Integration",
    "save_selected_accounts_error": "Unable to save selected accounts",
    "twitter": "X {'|'} Twitter",
    "twitter_integration_suggestion": "Integrate {platformName} with X {'|'} Twitter to understand what journalists are tweeting, re-tweeting and quoting in realtime. This integration is shared by your organisation and does not allow engagement or posting on behalf of this account.",
    "update_account_button": "Click to update account"
  },
  "two_factor_carrier_options": {
    "email_subtext": "Verification codes will be sent to your email address.",
    "phone_number_missing_message": "Please ensure that a phone number is set up correctly",
    "qr_code_subtext": "Use an app or password manager to generate verification codes.",
    "sms_subtext": "Verification codes code will be sent to your mobile phone."
  },
  "two_factor_form": {
    "confirmation_alert_error": "Error enabling two-factor authentication",
    "confirmation_alert_label": "Change two-factor code delivery",
    "confirmation_alert_subtext": "If you continue, old settings and codes will no longer work.",
    "description": "Please select a way you prefer to protect your information",
    "enable_toggle_label": "Enable Two-factor Authentication",
    "error_update_alert": "Error updating two-factor authentication",
    "section_title": "Two-Factor Authentication",
    "setup_cancelled_message": "If you experience problems, please contact your account manager.",
    "setup_cancelled_strong_message": "If two-factor authentication was previously enabled, you may no longer receive two-factor codes correctly.",
    "setup_cancelled_title": "Two-factor setup cancelled",
    "update_alert": "Two-factor authentication updated!",
    "verify_modal_error": "Error disabling two-factor authentication",
    "verify_modal_label": "Verify Two-factor code to disable",
    "verify_modal_subtext": "To disable two-factor authentication, please enter your two-factor code sent by email, sms, or in an authenticator app."
  },
  "two_factor_login_form": {
    "assistance": "For assistance contact us on {mail}",
    "assistance_with_phone": "For assistance contact us on {phone} or {mail}",
    "contact_account_manager": "Please contact your dedicated Account Manager directly, or contact us via one of the following:",
    "contact_for_assistance": "Contact us for assistance",
    "here_to_help": "We're here to help!",
    "trouble_getting_code": "Having trouble getting your code?"
  },
  "two_factor_setup_wizard": {
    "enable_two_factor_error": "Error enabling two-factor authentication",
    "enable_two_factor_success": "Two factor authentication enabled!",
    "select_to_protect_information": "Please select a way you prefer to protect your information",
    "two_factor_auth": "Two Factor Authentication",
    "udpate_two_factor_error": "Error updating two factor authentication",
    "verify_code": "Verify Two-Factor Code"
  },
  "two_factor_verify_code_template": {
    "code_label": "Code:",
    "description": "A code will be delivered to you by {carrierLabel}. Enter the code provided to finish setting up two-factor authentication:",
    "mobile": {
      "qr_code_description": "Please {tapHere} to setup your code in an authenticator app. Then enter the code in the space below:",
      "qr_code_description_link_text": "tap here",
      "uri_button": "Tap here to copy"
    },
    "qr_code_description": "Please scan the below QR code in an authenticator app of your choice, then enter the code provided to finish setting up two-factor authentication",
    "uri_button": "Copy URI to Clipboard",
    "uri_label": "Need the URI itself?"
  },
  "universal_player_control_widget": {
    "add_to_queue": "Add to Queue",
    "pause": "Pause",
    "play": "Play",
    "queue": "Queue",
    "remove_from_queue": "Remove from Queue"
  },
  "universal_search": {
    "after_to_before": "{afterLabel} to {beforeLabel}",
    "filter_options": "Filter Options",
    "mention_streams_group": "Mention Streams Group",
    "no_coverage_try_list": "We couldn't locate any coverage matching your search criteria. Try:{lineBreak}- Adjusting the date{lineBreak}- Selecting another Group of Mention Streams{lineBreak}- Selecting a different Media Type{lineBreak}",
    "reset": "RESET",
    "sources": "Sources"
  },
  "universal_search_actionsheet_filters": {
    "add_filter": "Add Filter",
    "done": "DONE",
    "filter_options": "Filter Options",
    "filters_applied": "Filters Applied",
    "reset_filters": "RESET FILTERS"
  },
  "universal_search_actionsheet_select_media_types": {
    "back": "BACK",
    "done": "DONE"
  },
  "universal_search_actionsheet_select_source_filter": {
    "back": "BACK",
    "done": "DONE",
    "sources": "Sources"
  },
  "universal_search_dropdown": {
    "all_label": "Available Content",
    "label": "Search scope",
    "streams_label": "Coverage"
  },
  "universal_search_input": {
    "recent_searches": "Recent Searches",
    "remove_recent_search": "Remove recent search {query}",
    "search_coverage": "Search coverage across this Mention Stream Group"
  },
  "upgrade_bar": {
    "new_version_of_platform": "There is a new version of {platformName} available. Please click here to reload."
  },
  "upload_and_crop_dialog": {
    "image_uploaded": "Image uploaded !",
    "saving_image_error": "There was an error saving the image !",
    "upload": "Upload",
    "upload_and_crop": "Upload & Crop"
  },
  "upsell_card": {
    "ai_visibility": {
      "description": "Monitor how your brand appears in AI-generated responses and track visibility, sentiment, and share of voice across major LLMs.",
      "tab_label": "AI Visibility",
      "title": "AI Visibility"
    },
    "get_in_touch": "Get in touch",
    "monitoring": {
      "description": "Get comprehensive and realtime Print, Online, TV, Radio and Podcast media monitoring that enables media teams to monitor, analyse, and respond as news happens.",
      "tab_label": "Monitoring",
      "title": "Monitoring"
    },
    "more_info": "More info",
    "outreach": {
      "description": "The comprehensive solution that joins the dots across your media activity. Outreach enables you to search and contact journalists and outlets, track activity, build media releases, and analyse performance, all within the {platformName} platform.",
      "tab_label": "Outreach",
      "title": "Outreach"
    },
    "social": {
      "description": "Combine your traditional and social media monitoring in one platform with {platformName} Social deep social listening, analysis and engagement tools. {platformName} Social includes three tools: Listen (social listening), Analyse (insights and reporting) and Engage (connect your owned social accounts to post and report on your social media).",
      "tab_label": "Social",
      "title": "Social"
    }
  },
  "url": {
    "outreach_help_articles": {
      "name": "View Outreach Help Articles"
    }
  },
  "usage_overview": {
    "account_limits_message": "If you are concerned about your organisation limits or would like to upgrade or downgrade your limits, please contact your Account Manager:",
    "active_users": "Active Users",
    "ai_visibility_description": "0 answers left | 1 answer left | {formattedCount} answers left",
    "ai_visibility_period": "Resets {period}",
    "ai_visibility_title": "AI Visibility",
    "allowance_footnote": "Please note that your allowances are averaged over the course of your contract lifetime.",
    "allowance_support": {
      "main": "If you are concerned about your allowance or would like to discuss ways to manage your consumption, please contact {supportContact}",
      "support_contact_case_1": "your dedicated Account Manager",
      "support_contact_case_2": "the Customer Success team {email}.",
      "support_contact_case_3": "the Dedicated Support team by {contact}."
    },
    "instant_edit_media_item_label": "Instant Edit Media Items",
    "instant_edit_transcript_label": "Instant Edit Transcripts",
    "mention_streams": "Mention Streams",
    "mention_streams_left": "{userSlotsAvailable} mention streams left",
    "no_usage_over_time_message": "{organisationName} hasn't used any {usageType} yet.",
    "organisation_limits": "Organisation Limits",
    "print_label": "Print",
    "print_label_text": "Print Items",
    "sla_limited_use": "{organisationName}’s Service Level Agreement (SLA) doesn’t include any {usageType}, which means that {organisationName} will be billed at the current Rate Card price for any additional use. You can view the current Rate Card {here}.",
    "sla_limited_use_with_credits_line_1": "{organisationName} has used {totalUsedCredits} of {usageType} included in the current Service Level Agreement (SLA) with {platformName}.",
    "sla_limited_use_with_credits_line_2": {
      "main": "{organisationNamePart} exhausted the total contract allowance, you’ll be billed at the current Rate Card price for any additional use. You can view the current Rate Card {here}.",
      "organisation_name_part_case_1": "As {organisationName} has now",
      "organisation_name_part_case_2": "Once {organisationName} has"
    },
    "sla_unlimited_use": "{organisationName}’s Service Level Agreement (SLA) includes unlimited {usageType}, subject to fair use.",
    "social_streams": "Social Streams",
    "social_streams_left": "{userSlotsAvailable} social streams left",
    "teams": "Teams",
    "teams_left": "{userSlotsAvailable} teams left",
    "total_usage": "Total Usage",
    "transcripts_label": "Transcripts",
    "tv_radio_label": "TV/Radio Media Items",
    "usage_loading_error": "There was an error loading usage. Please, try again.",
    "usage_over_time": "Usage over time",
    "user_and_teams": "Users and Teams",
    "users": "Users",
    "users_left": "{userSlotsAvailable} users left"
  },
  "user_card": {
    "contact_account_manager": "Contact your account{lineBreak}manager",
    "user_picture": "User picture"
  },
  "user_management": {
    "add_user_button": "Add User",
    "bulk_request_user_alert_message": "A bulk request for {usersLength} {messageUsers} has been received and awaiting approval. You will receive an email when the {messageUsers} {messageReady} ready",
    "bulk_request_user_error_title": "There was an error requesting bulk users",
    "button_dropdown_options": {
      "export": "Export Users",
      "import": "Bulk Add Users",
      "team": "Add a Team"
    },
    "deactivated_users_toggle": "Show Deactivated Users",
    "deactivation": {
      "alert_error_message": "There was an error requesting deactivation for {userName}",
      "alert_message": " A deactivation request for {userName} has been received and awaiting approval. You will receive an email when they have been deactivated",
      "confirm_label": "Deactivate {userName}",
      "title": "Confirm Deactivation"
    },
    "load_organisation_usage_error": "There was an error loading organisation usage",
    "load_requests_error": "There was an error loading pending requests",
    "load_team_error": "There was an error loading user team",
    "max_users_modal_message": "Your organisation has reached their maximum user allowance. Please contact your Account Manager if you would like to add more.",
    "max_users_modal_title": "Maximum Users Reached",
    "notes": "Notes",
    "notify_additional_recipients": "Notify additional recipients",
    "phone_number": "Phone Number",
    "reactivation": {
      "alert_error_message": "There was an error requesting activation for {userName}",
      "alert_message": "Reactivation request for {userName} has been received and awaiting approval. You will receive an email when the user is ready",
      "confirm_label": "Reactivate {userName}",
      "email": "Email:",
      "first_name": "First Name:",
      "last_name": "Last Name:",
      "mobile_phone": "Mobile Phone:",
      "notes": "Notes:",
      "team": "Team:",
      "title": "Confirm Reactivation"
    },
    "request_team_alert_message": "A new team {name} has been created",
    "request_user_alert_message": "A new user request for {userFirstName} {userLastName} has been received and awaiting approval. You will receive an email when the user is ready.",
    "request_user_error_title": "There was an error requesting a user for {userFirstName} {userLastName}",
    "reset_pin": "Reset PIN",
    "reset_pin_confirmation_error": "There was an error when resetting user PIN.",
    "reset_pin_confirmation_message": "Reset PIN email sent",
    "reset_pin_message": "Are you sure you want to Reset PIN for {userFirstName} {userLastName}? They will receive an email with a secure link to set a new PIN. The link expires within 12 hours.",
    "user_updated_alert_message": "{userFirstName} {userLastName} has been updated",
    "users_left": "users left"
  },
  "user_management_table": {
    "actions": "Actions",
    "mention_streams": "Mention Streams",
    "mobile_phone": "Mobile Phone",
    "social_streams": "Social Streams"
  },
  "user_management_table_row_actions": {
    "activation_pending": "Activation Pending",
    "deactivate_user": "Deactivate User",
    "deactivation_pending": "Deactivation Pending",
    "new_user_pending": "New User Pending",
    "reactivate_user": "Reactivate User",
    "reset_pin": "Reset User PIN",
    "update_user": "Update User",
    "view_managed_mention_streams": "View Managed Mention Streams"
  },
  "user_phone_number": {
    "country_code": "Country Code",
    "mobile_number": "Mobile Number"
  },
  "user_preferences_form": {
    "auto_refresh_label": "Automatically reload all Streams to display new Mentions as they arrive",
    "auto_refresh_streams": "Auto-refresh",
    "launchpad_beta": "Launchpad Beta",
    "launchpad_beta_confirm_label": "Confirm",
    "launchpad_beta_confirm_message": "The platform will now reload with the selected Launchpad. This may take a few moments.{newline}Click confirm to reload.",
    "launchpad_beta_confirm_title": "Launchpad Beta",
    "launchpad_beta_label": "Enhance your experience with the new Launchpad",
    "save_preferences": "Save Preferences",
    "update_preferences_error": "Error updating user preferences",
    "update_preferences_success": "User preferences updated!"
  },
  "validations": {
    "is_color": "Must be a valid colour",
    "is_email": "Must be a valid email address",
    "is_instagram_hashtag": "Instagram hashtag is invalid",
    "is_instagram_username": "Instagram username is invalid",
    "is_number": "Must be a valid number",
    "is_phone_number": "Must be a valid phone number",
    "is_url": "Must be a valid URL",
    "is_valid_domain": "Must be a valid domain",
    "is_valid_email_domain": "Email does not match sending domain",
    "is_youtube_channel_url": "YouTube channel name is invalid",
    "maximum_length": "Must be no more than {maxCharacters} characters",
    "maximum_number": "Must be no more than {maximumNumber}",
    "minimum_image_size": {
      "load_error": "Could not load image.",
      "min_width": "Image is not within the required pixel format. Use another image with a minimum pixel size of {minWidth}px in width",
      "min_width_min_height": "Image is not within the required pixel format. Use another image with a minimum pixel size of {minWidth}px x {minHeight}px"
    },
    "minimum_length": "Must be more than {minCharacters} characters",
    "no_special_characters": "Must not have any special characters",
    "not_blank": "Must not be blank",
    "undeliverable_email": "This email is unable to be verified and emails will not be sent. Check for errors or click here for more information."
  },
  "view_public_holidays": {
    "label": "View NSW holidays"
  },
  "weekly_day_selector": {
    "select_day": "Please select a day"
  }
}
